import _slicedToArray from "C:\\Users\\michael.HOME\\projects\\mydsl\\packages\\app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "C:\\Users\\michael.HOME\\projects\\mydsl\\packages\\app\\node_modules\\@babel\\runtime/helpers/esm/taggedTemplateLiteral";
import _regeneratorRuntime from "C:\\Users\\michael.HOME\\projects\\mydsl\\packages\\app\\node_modules\\@babel\\runtime/regenerator";
import _assertThisInitialized from "C:\\Users\\michael.HOME\\projects\\mydsl\\packages\\app\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";
import _get from "C:\\Users\\michael.HOME\\projects\\mydsl\\packages\\app\\node_modules\\@babel\\runtime/helpers/esm/get";
import _possibleConstructorReturn from "C:\\Users\\michael.HOME\\projects\\mydsl\\packages\\app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\michael.HOME\\projects\\mydsl\\packages\\app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\michael.HOME\\projects\\mydsl\\packages\\app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _toConsumableArray from "C:\\Users\\michael.HOME\\projects\\mydsl\\packages\\app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "C:\\Users\\michael.HOME\\projects\\mydsl\\packages\\app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\michael.HOME\\projects\\mydsl\\packages\\app\\node_modules\\@babel\\runtime/helpers/esm/createClass";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  mutation ($args: DeleteLangInput!) {\n    deleteLang(args: $args) \n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  mutation createLang($args: CreateLangInput!) {\n    createLang(args: $args) {\n      id\n\t\t\tcid\n      name\n      namespace\n      version\n\t\t\t\n    }    \n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral([" \n  query langs($pageSize: Int, $after: Int) {\n    langs(pageSize: $pageSize, after: $after) {\n      cursor\n      hasMore\n      langs {\n\t\t\t\tid\n\t\t\t\tcid\n        name \n        namespace\n        version\n        \n      }\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral([" \n  query lang($args: QueryLangInput!, $types: [ModelType], $filter: FilterOptions) {\n    lang(args: $args, filter: $filter) {\n      models(types: $types, filter: $filter) {\n        model { \n\t\t\t\t\tid\n          type\n          data\n          diagram \n        } \n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import * as t from "react";
import { createContext as e, createElement as n, Component as i, forwardRef as r, cloneElement as o, isValidElement as a, Children as s, createRef as c, useRef as u, useEffect as l, useContext as d, useState as h, Fragment as p, useCallback as f } from "react";
import m from "classnames";
import { findDOMNode as _ } from "react-dom";
import { GraphLib as g, Editor as v, EditorDsl as y } from "my-dsl-graph";
import { createDecorator as b, RawContextKey as E, INotificationService as C, Emitter as A, Severity as T, registerAction as I, ContextKeyExpr as O, TreeViewFocusContextKey as S, dispose as w, IInstantiationService as x, IConfigurationService as N, ContextKeyService as R, createWorkbenchVsCode as L, ServiceCollection as D, IContextKeyService as k, SyncDescriptor as P, IKeybindingService as F, StandaloneKeybindingService as M, IMenuService as H, errorHandler as B } from "my-dsl-vscode";
import { Observable as V } from "apollo-client/util/Observable";
import j from "zen-observable";
import { Section as U, Bar as G, Container as z } from "react-simple-resizer";
import { element as K } from "prop-types";

var _q = function q() {
  return (_q = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    W = e({
  onTabInteraction: function onTabInteraction(t) {},
  registerTab: function registerTab(t) {},
  unregisterTab: function unregisterTab(t) {}
}),
    X = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'],
    Y = X.join(","),
    $ = "undefined" == typeof Element ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;

function Q(t, e) {
  e = e || {};
  var n,
      i,
      r,
      o = [],
      a = [],
      s = t.querySelectorAll(Y);

  for (e.includeContainer && $.call(t, Y) && (s = Array.prototype.slice.apply(s)).unshift(t), n = 0; n < s.length; n++) {
    Z(i = s[n]) && (0 === (r = et(i)) ? o.push(i) : a.push({
      documentOrder: n,
      tabIndex: r,
      node: i
    }));
  }

  return a.sort(nt).map(function (t) {
    return t.node;
  }).concat(o);
}

function Z(t) {
  return !(!J(t) || function (t) {
    return function (t) {
      return it(t) && "radio" === t.type;
    }(t) && !function (t) {
      if (!t.name) return !0;

      var e = function (t) {
        for (var e = 0; e < t.length; e++) {
          if (t[e].checked) return t[e];
        }
      }(t.ownerDocument.querySelectorAll('input[type="radio"][name="' + t.name + '"]'));

      return !e || e === t;
    }(t);
  }(t) || et(t) < 0);
}

function J(t) {
  return !(t.disabled || function (t) {
    return it(t) && "hidden" === t.type;
  }(t) || function (t) {
    return null === t.offsetParent || "hidden" === getComputedStyle(t).visibility;
  }(t));
}

Q.isTabbable = function (t) {
  if (!t) throw new Error("No node provided");
  return !1 !== $.call(t, Y) && Z(t);
}, Q.isFocusable = function (t) {
  if (!t) throw new Error("No node provided");
  return !1 !== $.call(t, tt) && J(t);
};
var tt = X.concat("iframe").join(",");

function et(t) {
  var e = parseInt(t.getAttribute("tabindex"), 10);
  return isNaN(e) ? function (t) {
    return "true" === t.contentEditable;
  }(t) ? 0 : t.tabIndex : e;
}

function nt(t, e) {
  return t.tabIndex === e.tabIndex ? t.documentOrder - e.documentOrder : t.tabIndex - e.tabIndex;
}

function it(t) {
  return "INPUT" === t.tagName;
}

var rt,
    ot = Q,
    at = function at() {
  for (var t = {}, e = 0; e < arguments.length; e++) {
    var n = arguments[e];

    for (var i in n) {
      st.call(n, i) && (t[i] = n[i]);
    }
  }

  return t;
},
    st = Object.prototype.hasOwnProperty;

var ct,
    ut = (ct = [], {
  activateTrap: function activateTrap(t) {
    if (ct.length > 0) {
      var e = ct[ct.length - 1];
      e !== t && e.pause();
    }

    var n = ct.indexOf(t);
    -1 === n ? ct.push(t) : (ct.splice(n, 1), ct.push(t));
  },
  deactivateTrap: function deactivateTrap(t) {
    var e = ct.indexOf(t);
    -1 !== e && ct.splice(e, 1), ct.length > 0 && ct[ct.length - 1].unpause();
  }
});

function lt(t) {
  return setTimeout(t, 0);
}

var dt = function dt(t, e) {
  var n = document,
      i = "string" == typeof t ? n.querySelector(t) : t,
      r = at({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0
  }, e),
      o = {
    firstTabbableNode: null,
    lastTabbableNode: null,
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1
  },
      a = {
    activate: function activate(t) {
      if (!o.active) {
        _(), o.active = !0, o.paused = !1, o.nodeFocusedBeforeActivation = n.activeElement;
        var e = t && t.onActivate ? t.onActivate : r.onActivate;
        return e && e(), c(), a;
      }
    },
    deactivate: s,
    pause: function pause() {
      !o.paused && o.active && (o.paused = !0, u());
    },
    unpause: function unpause() {
      o.paused && o.active && (o.paused = !1, _(), c());
    }
  };
  return a;

  function s(t) {
    if (o.active) {
      clearTimeout(rt), u(), o.active = !1, o.paused = !1, ut.deactivateTrap(a);
      var e = t && void 0 !== t.onDeactivate ? t.onDeactivate : r.onDeactivate;
      return e && e(), (t && void 0 !== t.returnFocus ? t.returnFocus : r.returnFocusOnDeactivate) && lt(function () {
        g(o.nodeFocusedBeforeActivation);
      }), a;
    }
  }

  function c() {
    if (o.active) return ut.activateTrap(a), rt = lt(function () {
      g(d());
    }), n.addEventListener("focusin", p, !0), n.addEventListener("mousedown", h, {
      capture: !0,
      passive: !1
    }), n.addEventListener("touchstart", h, {
      capture: !0,
      passive: !1
    }), n.addEventListener("click", m, {
      capture: !0,
      passive: !1
    }), n.addEventListener("keydown", f, {
      capture: !0,
      passive: !1
    }), a;
  }

  function u() {
    if (o.active) return n.removeEventListener("focusin", p, !0), n.removeEventListener("mousedown", h, !0), n.removeEventListener("touchstart", h, !0), n.removeEventListener("click", m, !0), n.removeEventListener("keydown", f, !0), a;
  }

  function l(t) {
    var e = r[t],
        i = e;
    if (!e) return null;
    if ("string" == typeof e && !(i = n.querySelector(e))) throw new Error("`" + t + "` refers to no known node");
    if ("function" == typeof e && !(i = e())) throw new Error("`" + t + "` did not return a node");
    return i;
  }

  function d() {
    var t;
    if (!(t = null !== l("initialFocus") ? l("initialFocus") : i.contains(n.activeElement) ? n.activeElement : o.firstTabbableNode || l("fallbackFocus"))) throw new Error("You can't have a focus-trap without at least one focusable element");
    return t;
  }

  function h(t) {
    i.contains(t.target) || (r.clickOutsideDeactivates ? s({
      returnFocus: !ot.isFocusable(t.target)
    }) : t.preventDefault());
  }

  function p(t) {
    i.contains(t.target) || t.target instanceof Document || (t.stopImmediatePropagation(), g(o.mostRecentlyFocusedNode || d()));
  }

  function f(t) {
    if (!1 !== r.escapeDeactivates && function (t) {
      return "Escape" === t.key || "Esc" === t.key || 27 === t.keyCode;
    }(t)) return t.preventDefault(), void s();
    (function (t) {
      return "Tab" === t.key || 9 === t.keyCode;
    })(t) && function (t) {
      if (_(), t.shiftKey && t.target === o.firstTabbableNode) return t.preventDefault(), void g(o.lastTabbableNode);
      t.shiftKey || t.target !== o.lastTabbableNode || (t.preventDefault(), g(o.firstTabbableNode));
    }(t);
  }

  function m(t) {
    r.clickOutsideDeactivates || i.contains(t.target) || (t.preventDefault(), t.stopImmediatePropagation());
  }

  function _() {
    var t = ot(i);
    o.firstTabbableNode = t[0] || d(), o.lastTabbableNode = t[t.length - 1] || d();
  }

  function g(t) {
    t !== n.activeElement && (t && t.focus ? (t.focus(), o.mostRecentlyFocusedNode = t, function (t) {
      return t.tagName && "input" === t.tagName.toLowerCase() && "function" == typeof t.select;
    }(t) && t.select()) : g(d()));
  }
},
    ht = function ht(t) {
  return t.replace(/([A-Z])/g, function (t) {
    return "-" + t.toLowerCase();
  });
},
    _pt = function pt() {
  return (_pt = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    ft = function ft(t) {
  process && process.env && "production" !== process.env.NODE_ENV && console.warn("RMWC Deprecation Warning: " + t);
},
    mt = function mt(t, e, n) {
  for (var i in t = _pt({}, t), e) {
    var r = e[i],
        o = void 0,
        a = function a(t) {
      return t;
    };

    if (Array.isArray(r) ? (o = r[0], a = r[1]) : o = r, void 0 !== t[i]) {
      if ("" === o) ft((n || "") + " component prop '" + i + "' has been removed from and is no longer a valid prop.");else {
        t[o] = a(t[i]);
        var s = "";
        t[o] !== t[i] && (s = " The old value has also been converted from '" + t[i] + "' to '" + t[o] + "'"), ft((n || "") + " component prop '" + i + "' has been replaced with '" + o + "'. " + s);
      }
      delete t[i];
    }
  }

  return t;
},
    _t = function _t(t, e) {
  var n;
  return function () {
    var i = this,
        r = arguments;
    null !== n && clearTimeout(n), n = setTimeout(function () {
      n = null, t.apply(i, r);
    }, e);
  };
},
    gt = {
  blur: "onBlur",
  cancel: "onCancel",
  click: "onClick",
  close: "onClose",
  contextmenu: "onContextMenu",
  copy: "onCopy",
  cut: "onCut",
  auxclick: "onAuxClick",
  doubleclick: "onDoubleClick",
  dragend: "onDragEnd",
  dragstart: "onDragStart",
  drop: "onDrop",
  focus: "onFocus",
  input: "onInput",
  invalid: "onInvalid",
  keydown: "onKeyDown",
  keypress: "onKeyPress",
  keyup: "onKeyUp",
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  paste: "onPaste",
  pause: "onPause",
  play: "onPlay",
  pointercancel: "onPointerCancel",
  pointerdown: "onPointerDown",
  pointerup: "onPointerUp",
  ratechange: "onRateChange",
  reset: "onReset",
  seeked: "onSeeked",
  submit: "onSubmit",
  touchcancel: "onTouchCancel",
  touchend: "onTouchEnd",
  touchstart: "onTouchStart",
  volumechange: "onVolumeChange",
  abort: "onAbort",
  animationend: "onAnimationEnd",
  animationiteration: "onAnimationIteration",
  animationstart: "onAnimationStart",
  canplay: "onCanPlay",
  canplaythrough: "onCanPlayThrough",
  drag: "onDrag",
  dragenter: "onDragEnter",
  dragexit: "onDragExit",
  dragleave: "onDragLeave",
  dragover: "onDragOver",
  durationchange: "onDurationChange",
  emptied: "onEmptied",
  encrypted: "onEncrypted",
  ended: "onEnded",
  error: "onError",
  gotpointercapture: "onGotPointerCapture",
  load: "onLoad",
  loadeddata: "onLoadedData",
  loadedmetadata: "onLoadedMetadata",
  loadstart: "onLoadStart",
  lostpointercapture: "onLostPointerCapture",
  mousemove: "onMouseMove",
  mouseout: "onMouseOut",
  mouseover: "onMouseOver",
  playing: "onPlaying",
  pointermove: "onPointerMove",
  pointerout: "onPointerOut",
  pointerover: "onPointerOver",
  progress: "onProgress",
  scroll: "onScroll",
  seeking: "onSeeking",
  stalled: "onStalled",
  suspend: "onSuspend",
  timeupdate: "onTimeUpdate",
  toggle: "onToggle",
  touchmove: "onTouchMove",
  transitionend: "onTransitionEnd",
  waiting: "onWaiting",
  wheel: "onWheel",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  pointerenter: "onPointerEnter",
  pointerleave: "onPointerLeave",
  change: "onChange",
  select: "onSelect",
  beforeinput: "onBeforeInput",
  compositionend: "onCompositionEnd",
  compositionstart: "onCompositionStart",
  compositionupdate: "onCompositionUpdate"
},
    vt = function vt(t, e) {
  if (t instanceof Element) {
    if (t && t.closest) return t.closest(e);

    for (var n = t; n;) {
      if (yt(n, e)) return n;
      n = n.parentElement;
    }
  }

  return null;
},
    yt = function yt(t, e) {
  return (t.matches || t.webkitMatchesSelector || t.msMatchesSelector).call(t, e);
},
    bt = function bt(t) {
  return t + "-" + ("test" === process.env.NODE_ENV ? "test" : (Math.random() + Math.random() + 1).toString(36).substring(2));
},
    Et = function () {
  var _t2 = function t(e, n) {
    return (_t2 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var n in e) {
        e.hasOwnProperty(n) && (t[n] = e[n]);
      }
    })(e, n);
  };

  return function (e, n) {
    function i() {
      this.constructor = e;
    }

    _t2(e, n), e.prototype = null === n ? Object.create(n) : (i.prototype = n.prototype, new i());
  };
}(),
    Ct = function Ct(t, e) {
  var n = "function" == typeof Symbol && t[Symbol.iterator];
  if (!n) return t;
  var i,
      r,
      o = n.call(t),
      a = [];

  try {
    for (; (void 0 === e || e-- > 0) && !(i = o.next()).done;) {
      a.push(i.value);
    }
  } catch (t) {
    r = {
      error: t
    };
  } finally {
    try {
      i && !i.done && (n = o.return) && n.call(o);
    } finally {
      if (r) throw r.error;
    }
  }

  return a;
},
    At = function At() {
  for (var t = [], e = 0; e < arguments.length; e++) {
    t = t.concat(Ct(arguments[e]));
  }

  return t;
},
    Tt = function (t) {
  function e() {
    var e = null !== t && t.apply(this, arguments) || this;
    return e.array = [], e;
  }

  return Et(e, t), e.prototype.push = function () {
    for (var t, e = [], n = 0; n < arguments.length; n++) {
      e[n] = arguments[n];
    }

    var i = (t = this.array).push.apply(t, At(e));
    return this.trigger("change"), i;
  }, e;
}(function () {
  function t() {
    this.events_ = {};
  }

  return t.prototype.on = function (t, e) {
    this.events_ = this.events_ || {}, this.events_[t] = this.events_[t] || [], this.events_[t].push(e);
  }, t.prototype.off = function (t, e) {
    this.events_ = this.events_ || {}, t in this.events_ != !1 && this.events_[t].splice(this.events_[t].indexOf(e), 1);
  }, t.prototype.trigger = function (t) {
    for (var e = [], n = 1; n < arguments.length; n++) {
      e[n - 1] = arguments[n];
    }

    if (this.events_ = this.events_ || {}, t in this.events_ != !1) for (var i = 0; i < this.events_[t].length; i++) {
      this.events_[t][i].apply(this, Array.prototype.slice.call(arguments, 1));
    }
  }, t;
}()),
    It = function () {
  var _t3 = function t(e, n) {
    return (_t3 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var n in e) {
        e.hasOwnProperty(n) && (t[n] = e[n]);
      }
    })(e, n);
  };

  return function (e, n) {
    function i() {
      this.constructor = e;
    }

    _t3(e, n), e.prototype = null === n ? Object.create(n) : (i.prototype = n.prototype, new i());
  };
}(),
    _Ot = function Ot() {
  return (_Ot = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    St = function St(t, e) {
  var n = "function" == typeof Symbol && t[Symbol.iterator];
  if (!n) return t;
  var i,
      r,
      o = n.call(t),
      a = [];

  try {
    for (; (void 0 === e || e-- > 0) && !(i = o.next()).done;) {
      a.push(i.value);
    }
  } catch (t) {
    r = {
      error: t
    };
  } finally {
    try {
      i && !i.done && (n = o.return) && n.call(o);
    } finally {
      if (r) throw r.error;
    }
  }

  return a;
},
    wt = function wt() {
  for (var t = [], e = 0; e < arguments.length; e++) {
    t = t.concat(St(arguments[e]));
  }

  return t;
},
    xt = function xt(t) {
  return gt[t] || t;
},
    Nt = function () {
  function t(t) {
    this._classes = new Set(), this._events = {}, this._style = {}, this._props = {}, this._ref = null, this._onChange = null, this._onChange = t, this.onChange = this.onChange.bind(this), this.addClass = this.addClass.bind(this), this.removeClass = this.removeClass.bind(this), this.hasClass = this.hasClass.bind(this), this.setProp = this.setProp.bind(this), this.getProp = this.getProp.bind(this), this.removeProp = this.removeProp.bind(this), this.setStyle = this.setStyle.bind(this), this.addEventListener = this.addEventListener.bind(this), this.removeEventListener = this.removeEventListener.bind(this), this.setRef = this.setRef.bind(this);
  }

  return t.prototype.onChange = function () {
    this._onChange && this._onChange();
  }, t.prototype.destroy = function () {
    this._onChange = null, this._ref = null, this._events = {}, this._style = {}, this._props = {}, this._classes = new Set();
  }, t.prototype.addClass = function (t) {
    this._classes.has(t) || (this._classes.add(t), this.onChange());
  }, t.prototype.removeClass = function (t) {
    this._classes.has(t) && (this._classes.delete(t), this.onChange());
  }, t.prototype.hasClass = function (t) {
    return this._classes.has(t);
  }, t.prototype.setProp = function (t, e) {
    this._props[t] !== e && (this._props[t] = e, this.onChange());
  }, t.prototype.getProp = function (t) {
    return this._props[t];
  }, t.prototype.removeProp = function (t) {
    void 0 !== this._props[t] && (delete this._props[t], this.onChange());
  }, t.prototype.props = function (t) {
    var e = this,
        n = t.className,
        i = void 0 === n ? "" : n,
        r = t.style,
        o = void 0 === r ? {} : r,
        a = Object.entries(t).reduce(function (t, n) {
      var i = St(n, 2),
          r = i[0],
          o = i[1],
          a = e._events[r];

      if ("function" == typeof o && "function" == typeof a) {
        t[r] = function (t) {
          return a(t), o(t);
        };
      }

      return t;
    }, _Ot({}, this._events)),
        s = m(i, wt(this._classes)),
        c = _Ot({}, this._style, o);

    return _Ot({}, t, this._props, a, {
      style: c,
      className: s
    });
  }, t.prototype.setStyle = function (t, e) {
    t = t.startsWith("--") ? t : t.replace(/(-[a-z])/g, function (t) {
      return t.toUpperCase().replace("-", "");
    }), this._style[t] !== e && (this._style[t] = e, this.onChange());
  }, t.prototype.addEventListener = function (t, e) {
    var n = xt(t);
    this._events[n] !== e && (this._events[n] = e, this.onChange());
  }, t.prototype.removeEventListener = function (t, e) {
    var n = xt(t);
    this._events[n] && (delete this._events[n], this.onChange());
  }, t.prototype.setRef = function (t) {
    t && (this._ref = t);
  }, Object.defineProperty(t.prototype, "ref", {
    get: function get() {
      return this._ref;
    },
    enumerable: !0,
    configurable: !0
  }), t;
}(),
    Rt = function (t) {
  function e(e) {
    var n = t.call(this, e) || this;
    return n.elements = {}, n.constructor.shouldDebounce ? n.update = _t(n.update.bind(n), 0) : n.update = n.update.bind(n), n;
  }

  return It(e, t), e.prototype.componentDidMount = function () {
    this.foundation = this.getDefaultFoundation(), this.foundation.init(), this.sync(this.props, {});
  }, e.prototype.componentDidUpdate = function (t) {
    this.sync(this.props, t);
  }, e.prototype.componentWillUnmount = function () {
    this.foundation && this.foundation.destroy(), this.foundation = void 0, Object.values(this.elements).forEach(function (t) {
      return t.destroy();
    });
  }, e.prototype.createElement = function (t) {
    var e = new Nt(this.update);
    return this.elements[t] = e, e;
  }, e.prototype.update = function () {
    this.foundation && this.setState({});
  }, e.prototype.sync = function (t, e) {}, e.prototype.syncProp = function (t, e, n) {
    (void 0 !== t || void 0 !== e && void 0 === t) && t !== e && n();
  }, e.prototype.getDefaultFoundation = function () {
    return {
      init: function init() {},
      destroy: function destroy() {}
    };
  }, e.prototype.emit = function (t, e, n) {
    var i;
    void 0 === n && (n = !1), i = new CustomEvent(t, {
      detail: e,
      bubbles: n
    }), Object.defineProperty(i, "target", {
      value: e,
      writable: !1
    }), Object.defineProperty(i, "currentTarget", {
      value: e,
      writable: !1
    });
    var r = t;
    return this.foundation && this.props[r] && this.props[r](i), i;
  }, e.shouldDebounce = !1, e;
}(i),
    _Lt = function Lt() {
  return (_Lt = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    Dt = function Dt(t, e) {
  var n = {};

  for (var i in t) {
    Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
  }

  if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
    var r = 0;

    for (i = Object.getOwnPropertySymbols(t); r < i.length; r++) {
      e.indexOf(i[r]) < 0 && (n[i[r]] = t[i[r]]);
    }
  }

  return n;
},
    kt = function kt(t, e) {
  var n = "function" == typeof Symbol && t[Symbol.iterator];
  if (!n) return t;
  var i,
      r,
      o = n.call(t),
      a = [];

  try {
    for (; (void 0 === e || e-- > 0) && !(i = o.next()).done;) {
      a.push(i.value);
    }
  } catch (t) {
    r = {
      error: t
    };
  } finally {
    try {
      i && !i.done && (n = o.return) && n.call(o);
    } finally {
      if (r) throw r.error;
    }
  }

  return a;
},
    Pt = function Pt() {
  for (var t = [], e = 0; e < arguments.length; e++) {
    t = t.concat(kt(arguments[e]));
  }

  return t;
},
    Ft = function Ft(t, e, n, i) {
  var r = m.apply(void 0, Pt([n], i ? function (t) {
    return "string" == typeof t && t.includes(" ") && ft("Theme no longer accepts a string of theme names with spaces. Please pass them as an array instead."), (Array.isArray(t) ? t : t.split(" ")).map(function (t) {
      return t.includes("-") && ft("Theme properties need to be passed as camelCase. Please convert " + t + " to " + t.replace(/-([a-z])/g, function (t, e) {
        return e.toUpperCase();
      })), "mdc-theme--" + ht(t);
    });
  }(i) : [], "function" == typeof e ? e(t) : e));
  t.className = r;
},
    Mt = function Mt(t) {
  var e = t.displayName,
      i = t.classNames,
      o = void 0 === i ? [] : i,
      a = t.tag,
      s = void 0 === a ? "div" : a,
      c = t.deprecate,
      u = t.defaultProps,
      l = t.consumeProps,
      d = void 0 === l ? [] : l,
      h = t.render,
      p = r(function (t, i) {
    var r = t.className,
        a = t.theme,
        u = t.tag,
        l = Dt(t, ["className", "theme", "tag"]);
    Ft(l, o, r, a);

    var p = function (t, e, n) {
      return "string" != typeof e ? (t.tag = n, e) : n || e;
    }(l, s, u);

    c && (l = mt(l, c, e)), function (t, e) {
      e.forEach(function (e) {
        delete t[e];
      });
    }(l, d);
    var f = l;
    return h ? h(f, i, p) : n(p, _Lt({}, f, {
      ref: i
    }));
  });
  return p.displayName = e, p.defaultProps = u, p;
},
    Ht = dt,
    _Bt = function Bt(t, e) {
  return (_Bt = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (t, e) {
    t.__proto__ = e;
  } || function (t, e) {
    for (var n in e) {
      e.hasOwnProperty(n) && (t[n] = e[n]);
    }
  })(t, e);
};

function Vt(t, e) {
  function n() {
    this.constructor = t;
  }

  _Bt(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
}

var _jt = function jt() {
  return (_jt = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
};

function Ut(t, e) {
  var n = {};

  for (var i in t) {
    Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
  }

  if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
    var r = 0;

    for (i = Object.getOwnPropertySymbols(t); r < i.length; r++) {
      e.indexOf(i[r]) < 0 && (n[i[r]] = t[i[r]]);
    }
  }

  return n;
}

function Gt(t, e, n, i) {
  var r,
      o = arguments.length,
      a = o < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, n) : i;
  if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(t, e, n, i);else for (var s = t.length - 1; s >= 0; s--) {
    (r = t[s]) && (a = (o < 3 ? r(a) : o > 3 ? r(e, n, a) : r(e, n)) || a);
  }
  return o > 3 && a && Object.defineProperty(e, n, a), a;
}

function zt(t, e) {
  return function (n, i) {
    e(n, i, t);
  };
}

function Kt(t, e, n, i) {
  return new (n || (n = Promise))(function (r, o) {
    function a(t) {
      try {
        c(i.next(t));
      } catch (t) {
        o(t);
      }
    }

    function s(t) {
      try {
        c(i.throw(t));
      } catch (t) {
        o(t);
      }
    }

    function c(t) {
      t.done ? r(t.value) : new n(function (e) {
        e(t.value);
      }).then(a, s);
    }

    c((i = i.apply(t, e || [])).next());
  });
}

function qt(t) {
  var e = "function" == typeof Symbol && t[Symbol.iterator],
      n = 0;
  return e ? e.call(t) : {
    next: function next() {
      return t && n >= t.length && (t = void 0), {
        value: t && t[n++],
        done: !t
      };
    }
  };
}

function Wt(t, e) {
  var n = "function" == typeof Symbol && t[Symbol.iterator];
  if (!n) return t;
  var i,
      r,
      o = n.call(t),
      a = [];

  try {
    for (; (void 0 === e || e-- > 0) && !(i = o.next()).done;) {
      a.push(i.value);
    }
  } catch (t) {
    r = {
      error: t
    };
  } finally {
    try {
      i && !i.done && (n = o.return) && n.call(o);
    } finally {
      if (r) throw r.error;
    }
  }

  return a;
}

function Xt() {
  for (var t = [], e = 0; e < arguments.length; e++) {
    t = t.concat(Wt(arguments[e]));
  }

  return t;
}

var Yt = function () {
  function t(t) {
    void 0 === t && (t = {}), this.adapter_ = t;
  }

  return Object.defineProperty(t, "cssClasses", {
    get: function get() {
      return {};
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(t, "strings", {
    get: function get() {
      return {};
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(t, "numbers", {
    get: function get() {
      return {};
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(t, "defaultAdapter", {
    get: function get() {
      return {};
    },
    enumerable: !0,
    configurable: !0
  }), t.prototype.init = function () {}, t.prototype.destroy = function () {}, t;
}(),
    $t = function () {
  function t(t, e) {
    for (var n = [], i = 2; i < arguments.length; i++) {
      n[i - 2] = arguments[i];
    }

    this.root_ = t, this.initialize.apply(this, Xt(n)), this.foundation_ = void 0 === e ? this.getDefaultFoundation() : e, this.foundation_.init(), this.initialSyncWithDOM();
  }

  return t.attachTo = function (e) {
    return new t(e, new Yt({}));
  }, t.prototype.initialize = function () {
    for (var t = [], e = 0; e < arguments.length; e++) {
      t[e] = arguments[e];
    }
  }, t.prototype.getDefaultFoundation = function () {
    throw new Error("Subclasses must override getDefaultFoundation to return a properly configured foundation class");
  }, t.prototype.initialSyncWithDOM = function () {}, t.prototype.destroy = function () {
    this.foundation_.destroy();
  }, t.prototype.listen = function (t, e) {
    this.root_.addEventListener(t, e);
  }, t.prototype.unlisten = function (t, e) {
    this.root_.removeEventListener(t, e);
  }, t.prototype.emit = function (t, e, n) {
    var i;
    void 0 === n && (n = !1), "function" == typeof CustomEvent ? i = new CustomEvent(t, {
      bubbles: n,
      detail: e
    }) : (i = document.createEvent("CustomEvent")).initCustomEvent(t, n, !1, e), this.root_.dispatchEvent(i);
  }, t;
}();

function Qt(t, e) {
  if (t.closest) return t.closest(e);

  for (var n = t; n;) {
    if (Zt(n, e)) return n;
    n = n.parentElement;
  }

  return null;
}

function Zt(t, e) {
  return (t.matches || t.webkitMatchesSelector || t.msMatchesSelector).call(t, e);
}

var Jt,
    te = {
  ANIMATING: "mdc-tab-scroller--animating",
  SCROLL_AREA_SCROLL: "mdc-tab-scroller__scroll-area--scroll",
  SCROLL_TEST: "mdc-tab-scroller__test"
},
    ee = {
  AREA_SELECTOR: ".mdc-tab-scroller__scroll-area",
  CONTENT_SELECTOR: ".mdc-tab-scroller__scroll-content"
},
    ne = function () {
  return function (t) {
    this.adapter_ = t;
  };
}(),
    ie = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return Vt(e, t), e.prototype.getScrollPositionRTL = function () {
    var t = this.adapter_.getScrollAreaScrollLeft(),
        e = this.calculateScrollEdges_().right;
    return Math.round(e - t);
  }, e.prototype.scrollToRTL = function (t) {
    var e = this.calculateScrollEdges_(),
        n = this.adapter_.getScrollAreaScrollLeft(),
        i = this.clampScrollValue_(e.right - t);
    return {
      finalScrollPosition: i,
      scrollDelta: i - n
    };
  }, e.prototype.incrementScrollRTL = function (t) {
    var e = this.adapter_.getScrollAreaScrollLeft(),
        n = this.clampScrollValue_(e - t);
    return {
      finalScrollPosition: n,
      scrollDelta: n - e
    };
  }, e.prototype.getAnimatingScrollPosition = function (t) {
    return t;
  }, e.prototype.calculateScrollEdges_ = function () {
    return {
      left: 0,
      right: this.adapter_.getScrollContentOffsetWidth() - this.adapter_.getScrollAreaOffsetWidth()
    };
  }, e.prototype.clampScrollValue_ = function (t) {
    var e = this.calculateScrollEdges_();
    return Math.min(Math.max(e.left, t), e.right);
  }, e;
}(ne),
    re = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return Vt(e, t), e.prototype.getScrollPositionRTL = function (t) {
    var e = this.adapter_.getScrollAreaScrollLeft();
    return Math.round(t - e);
  }, e.prototype.scrollToRTL = function (t) {
    var e = this.adapter_.getScrollAreaScrollLeft(),
        n = this.clampScrollValue_(-t);
    return {
      finalScrollPosition: n,
      scrollDelta: n - e
    };
  }, e.prototype.incrementScrollRTL = function (t) {
    var e = this.adapter_.getScrollAreaScrollLeft(),
        n = this.clampScrollValue_(e - t);
    return {
      finalScrollPosition: n,
      scrollDelta: n - e
    };
  }, e.prototype.getAnimatingScrollPosition = function (t, e) {
    return t - e;
  }, e.prototype.calculateScrollEdges_ = function () {
    var t = this.adapter_.getScrollContentOffsetWidth();
    return {
      left: this.adapter_.getScrollAreaOffsetWidth() - t,
      right: 0
    };
  }, e.prototype.clampScrollValue_ = function (t) {
    var e = this.calculateScrollEdges_();
    return Math.max(Math.min(e.right, t), e.left);
  }, e;
}(ne),
    oe = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return Vt(e, t), e.prototype.getScrollPositionRTL = function (t) {
    var e = this.adapter_.getScrollAreaScrollLeft();
    return Math.round(e - t);
  }, e.prototype.scrollToRTL = function (t) {
    var e = this.adapter_.getScrollAreaScrollLeft(),
        n = this.clampScrollValue_(t);
    return {
      finalScrollPosition: n,
      scrollDelta: e - n
    };
  }, e.prototype.incrementScrollRTL = function (t) {
    var e = this.adapter_.getScrollAreaScrollLeft(),
        n = this.clampScrollValue_(e + t);
    return {
      finalScrollPosition: n,
      scrollDelta: e - n
    };
  }, e.prototype.getAnimatingScrollPosition = function (t, e) {
    return t + e;
  }, e.prototype.calculateScrollEdges_ = function () {
    return {
      left: this.adapter_.getScrollContentOffsetWidth() - this.adapter_.getScrollAreaOffsetWidth(),
      right: 0
    };
  }, e.prototype.clampScrollValue_ = function (t) {
    var e = this.calculateScrollEdges_();
    return Math.min(Math.max(e.right, t), e.left);
  }, e;
}(ne),
    ae = function (t) {
  function e(n) {
    var i = t.call(this, _jt({}, e.defaultAdapter, n)) || this;
    return i.isAnimating_ = !1, i;
  }

  return Vt(e, t), Object.defineProperty(e, "cssClasses", {
    get: function get() {
      return te;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "strings", {
    get: function get() {
      return ee;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultAdapter", {
    get: function get() {
      return {
        eventTargetMatchesSelector: function eventTargetMatchesSelector() {
          return !1;
        },
        addClass: function addClass() {},
        removeClass: function removeClass() {},
        addScrollAreaClass: function addScrollAreaClass() {},
        setScrollAreaStyleProperty: function setScrollAreaStyleProperty() {},
        setScrollContentStyleProperty: function setScrollContentStyleProperty() {},
        getScrollContentStyleValue: function getScrollContentStyleValue() {
          return "";
        },
        setScrollAreaScrollLeft: function setScrollAreaScrollLeft() {},
        getScrollAreaScrollLeft: function getScrollAreaScrollLeft() {
          return 0;
        },
        getScrollContentOffsetWidth: function getScrollContentOffsetWidth() {
          return 0;
        },
        getScrollAreaOffsetWidth: function getScrollAreaOffsetWidth() {
          return 0;
        },
        computeScrollAreaClientRect: function computeScrollAreaClientRect() {
          return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            width: 0,
            height: 0
          };
        },
        computeScrollContentClientRect: function computeScrollContentClientRect() {
          return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            width: 0,
            height: 0
          };
        },
        computeHorizontalScrollbarHeight: function computeHorizontalScrollbarHeight() {
          return 0;
        }
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.init = function () {
    var t = this.adapter_.computeHorizontalScrollbarHeight();
    this.adapter_.setScrollAreaStyleProperty("margin-bottom", -t + "px"), this.adapter_.addScrollAreaClass(e.cssClasses.SCROLL_AREA_SCROLL);
  }, e.prototype.getScrollPosition = function () {
    if (this.isRTL_()) return this.computeCurrentScrollPositionRTL_();
    var t = this.calculateCurrentTranslateX_();
    return this.adapter_.getScrollAreaScrollLeft() - t;
  }, e.prototype.handleInteraction = function () {
    this.isAnimating_ && this.stopScrollAnimation_();
  }, e.prototype.handleTransitionEnd = function (t) {
    var n = t.target;
    this.isAnimating_ && this.adapter_.eventTargetMatchesSelector(n, e.strings.CONTENT_SELECTOR) && (this.isAnimating_ = !1, this.adapter_.removeClass(e.cssClasses.ANIMATING));
  }, e.prototype.incrementScroll = function (t) {
    if (0 !== t) return this.isRTL_() ? this.incrementScrollRTL_(t) : void this.incrementScroll_(t);
  }, e.prototype.scrollTo = function (t) {
    if (this.isRTL_()) return this.scrollToRTL_(t);
    this.scrollTo_(t);
  }, e.prototype.getRTLScroller = function () {
    return this.rtlScrollerInstance_ || (this.rtlScrollerInstance_ = this.rtlScrollerFactory_()), this.rtlScrollerInstance_;
  }, e.prototype.calculateCurrentTranslateX_ = function () {
    var t = this.adapter_.getScrollContentStyleValue("transform");
    if ("none" === t) return 0;
    var e = /\((.+?)\)/.exec(t);
    if (!e) return 0;
    var n = Wt(e[1].split(","), 6),
        i = (n[0], n[1], n[2], n[3], n[4]);
    n[5];
    return parseFloat(i);
  }, e.prototype.clampScrollValue_ = function (t) {
    var e = this.calculateScrollEdges_();
    return Math.min(Math.max(e.left, t), e.right);
  }, e.prototype.computeCurrentScrollPositionRTL_ = function () {
    var t = this.calculateCurrentTranslateX_();
    return this.getRTLScroller().getScrollPositionRTL(t);
  }, e.prototype.calculateScrollEdges_ = function () {
    return {
      left: 0,
      right: this.adapter_.getScrollContentOffsetWidth() - this.adapter_.getScrollAreaOffsetWidth()
    };
  }, e.prototype.scrollTo_ = function (t) {
    var e = this.getScrollPosition(),
        n = this.clampScrollValue_(t),
        i = n - e;
    this.animate_({
      finalScrollPosition: n,
      scrollDelta: i
    });
  }, e.prototype.scrollToRTL_ = function (t) {
    var e = this.getRTLScroller().scrollToRTL(t);
    this.animate_(e);
  }, e.prototype.incrementScroll_ = function (t) {
    var e = this.getScrollPosition(),
        n = t + e,
        i = this.clampScrollValue_(n),
        r = i - e;
    this.animate_({
      finalScrollPosition: i,
      scrollDelta: r
    });
  }, e.prototype.incrementScrollRTL_ = function (t) {
    var e = this.getRTLScroller().incrementScrollRTL(t);
    this.animate_(e);
  }, e.prototype.animate_ = function (t) {
    var n = this;
    0 !== t.scrollDelta && (this.stopScrollAnimation_(), this.adapter_.setScrollAreaScrollLeft(t.finalScrollPosition), this.adapter_.setScrollContentStyleProperty("transform", "translateX(" + t.scrollDelta + "px)"), this.adapter_.computeScrollAreaClientRect(), requestAnimationFrame(function () {
      n.adapter_.addClass(e.cssClasses.ANIMATING), n.adapter_.setScrollContentStyleProperty("transform", "none");
    }), this.isAnimating_ = !0);
  }, e.prototype.stopScrollAnimation_ = function () {
    this.isAnimating_ = !1;
    var t = this.getAnimatingScrollPosition_();
    this.adapter_.removeClass(e.cssClasses.ANIMATING), this.adapter_.setScrollContentStyleProperty("transform", "translateX(0px)"), this.adapter_.setScrollAreaScrollLeft(t);
  }, e.prototype.getAnimatingScrollPosition_ = function () {
    var t = this.calculateCurrentTranslateX_(),
        e = this.adapter_.getScrollAreaScrollLeft();
    return this.isRTL_() ? this.getRTLScroller().getAnimatingScrollPosition(e, t) : e - t;
  }, e.prototype.rtlScrollerFactory_ = function () {
    var t = this.adapter_.getScrollAreaScrollLeft();
    this.adapter_.setScrollAreaScrollLeft(t - 1);
    var e = this.adapter_.getScrollAreaScrollLeft();
    if (e < 0) return this.adapter_.setScrollAreaScrollLeft(t), new re(this.adapter_);
    var n = this.adapter_.computeScrollAreaClientRect(),
        i = this.adapter_.computeScrollContentClientRect(),
        r = Math.round(i.right - n.right);
    return this.adapter_.setScrollAreaScrollLeft(t), r === e ? new oe(this.adapter_) : new ie(this.adapter_);
  }, e.prototype.isRTL_ = function () {
    return "rtl" === this.adapter_.getScrollContentStyleValue("direction");
  }, e;
}(Yt);

function se(t, e) {
  if (void 0 === e && (e = !0), e && void 0 !== Jt) return Jt;
  var n = t.createElement("div");
  n.classList.add(te.SCROLL_TEST), t.body.appendChild(n);
  var i = n.offsetHeight - n.clientHeight;
  return t.body.removeChild(n), e && (Jt = i), i;
}

var ce,
    ue,
    le = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return Vt(e, t), e.attachTo = function (t) {
    return new e(t);
  }, e.prototype.initialize = function () {
    this.area_ = this.root_.querySelector(ae.strings.AREA_SELECTOR), this.content_ = this.root_.querySelector(ae.strings.CONTENT_SELECTOR);
  }, e.prototype.initialSyncWithDOM = function () {
    var t = this;
    this.handleInteraction_ = function () {
      return t.foundation_.handleInteraction();
    }, this.handleTransitionEnd_ = function (e) {
      return t.foundation_.handleTransitionEnd(e);
    }, this.area_.addEventListener("wheel", this.handleInteraction_), this.area_.addEventListener("touchstart", this.handleInteraction_), this.area_.addEventListener("pointerdown", this.handleInteraction_), this.area_.addEventListener("mousedown", this.handleInteraction_), this.area_.addEventListener("keydown", this.handleInteraction_), this.content_.addEventListener("transitionend", this.handleTransitionEnd_);
  }, e.prototype.destroy = function () {
    t.prototype.destroy.call(this), this.area_.removeEventListener("wheel", this.handleInteraction_), this.area_.removeEventListener("touchstart", this.handleInteraction_), this.area_.removeEventListener("pointerdown", this.handleInteraction_), this.area_.removeEventListener("mousedown", this.handleInteraction_), this.area_.removeEventListener("keydown", this.handleInteraction_), this.content_.removeEventListener("transitionend", this.handleTransitionEnd_);
  }, e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new ae({
      eventTargetMatchesSelector: function eventTargetMatchesSelector(t, e) {
        return Zt(t, e);
      },
      addClass: function addClass(e) {
        return t.root_.classList.add(e);
      },
      removeClass: function removeClass(e) {
        return t.root_.classList.remove(e);
      },
      addScrollAreaClass: function addScrollAreaClass(e) {
        return t.area_.classList.add(e);
      },
      setScrollAreaStyleProperty: function setScrollAreaStyleProperty(e, n) {
        return t.area_.style.setProperty(e, n);
      },
      setScrollContentStyleProperty: function setScrollContentStyleProperty(e, n) {
        return t.content_.style.setProperty(e, n);
      },
      getScrollContentStyleValue: function getScrollContentStyleValue(e) {
        return window.getComputedStyle(t.content_).getPropertyValue(e);
      },
      setScrollAreaScrollLeft: function setScrollAreaScrollLeft(e) {
        return t.area_.scrollLeft = e;
      },
      getScrollAreaScrollLeft: function getScrollAreaScrollLeft() {
        return t.area_.scrollLeft;
      },
      getScrollContentOffsetWidth: function getScrollContentOffsetWidth() {
        return t.content_.offsetWidth;
      },
      getScrollAreaOffsetWidth: function getScrollAreaOffsetWidth() {
        return t.area_.offsetWidth;
      },
      computeScrollAreaClientRect: function computeScrollAreaClientRect() {
        return t.area_.getBoundingClientRect();
      },
      computeScrollContentClientRect: function computeScrollContentClientRect() {
        return t.content_.getBoundingClientRect();
      },
      computeHorizontalScrollbarHeight: function computeHorizontalScrollbarHeight() {
        return se(document);
      }
    });
  }, e.prototype.getScrollPosition = function () {
    return this.foundation_.getScrollPosition();
  }, e.prototype.getScrollContentWidth = function () {
    return this.content_.offsetWidth;
  }, e.prototype.incrementScroll = function (t) {
    this.foundation_.incrementScroll(t);
  }, e.prototype.scrollTo = function (t) {
    this.foundation_.scrollTo(t);
  }, e;
}($t),
    de = {
  BG_FOCUSED: "mdc-ripple-upgraded--background-focused",
  FG_ACTIVATION: "mdc-ripple-upgraded--foreground-activation",
  FG_DEACTIVATION: "mdc-ripple-upgraded--foreground-deactivation",
  ROOT: "mdc-ripple-upgraded",
  UNBOUNDED: "mdc-ripple-upgraded--unbounded"
},
    he = {
  VAR_FG_SCALE: "--mdc-ripple-fg-scale",
  VAR_FG_SIZE: "--mdc-ripple-fg-size",
  VAR_FG_TRANSLATE_END: "--mdc-ripple-fg-translate-end",
  VAR_FG_TRANSLATE_START: "--mdc-ripple-fg-translate-start",
  VAR_LEFT: "--mdc-ripple-left",
  VAR_TOP: "--mdc-ripple-top"
},
    pe = {
  DEACTIVATION_TIMEOUT_MS: 225,
  FG_DEACTIVATION_MS: 150,
  INITIAL_ORIGIN_SCALE: .6,
  PADDING: 10,
  TAP_DELAY_MS: 300
};

function fe(t, e) {
  if (void 0 === t && (t = window), void 0 === e && (e = !1), void 0 === ue || e) {
    var n = !1;

    try {
      t.document.addEventListener("test", function () {}, {
        get passive() {
          return n = !0;
        }

      });
    } catch (t) {}

    ue = n;
  }

  return !!ue && {
    passive: !0
  };
}

var me = ["touchstart", "pointerdown", "mousedown", "keydown"],
    _e = ["touchend", "pointerup", "mouseup", "contextmenu"],
    ge = [],
    ve = function (t) {
  function e(n) {
    var i = t.call(this, _jt({}, e.defaultAdapter, n)) || this;
    return i.activationAnimationHasEnded_ = !1, i.activationTimer_ = 0, i.fgDeactivationRemovalTimer_ = 0, i.fgScale_ = "0", i.frame_ = {
      width: 0,
      height: 0
    }, i.initialSize_ = 0, i.layoutFrame_ = 0, i.maxRadius_ = 0, i.unboundedCoords_ = {
      left: 0,
      top: 0
    }, i.activationState_ = i.defaultActivationState_(), i.activationTimerCallback_ = function () {
      i.activationAnimationHasEnded_ = !0, i.runDeactivationUXLogicIfReady_();
    }, i.activateHandler_ = function (t) {
      return i.activate_(t);
    }, i.deactivateHandler_ = function () {
      return i.deactivate_();
    }, i.focusHandler_ = function () {
      return i.handleFocus();
    }, i.blurHandler_ = function () {
      return i.handleBlur();
    }, i.resizeHandler_ = function () {
      return i.layout();
    }, i;
  }

  return Vt(e, t), Object.defineProperty(e, "cssClasses", {
    get: function get() {
      return de;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "strings", {
    get: function get() {
      return he;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "numbers", {
    get: function get() {
      return pe;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultAdapter", {
    get: function get() {
      return {
        addClass: function addClass() {},
        browserSupportsCssVars: function browserSupportsCssVars() {
          return !0;
        },
        computeBoundingRect: function computeBoundingRect() {
          return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            width: 0,
            height: 0
          };
        },
        containsEventTarget: function containsEventTarget() {
          return !0;
        },
        deregisterDocumentInteractionHandler: function deregisterDocumentInteractionHandler() {},
        deregisterInteractionHandler: function deregisterInteractionHandler() {},
        deregisterResizeHandler: function deregisterResizeHandler() {},
        getWindowPageOffset: function getWindowPageOffset() {
          return {
            x: 0,
            y: 0
          };
        },
        isSurfaceActive: function isSurfaceActive() {
          return !0;
        },
        isSurfaceDisabled: function isSurfaceDisabled() {
          return !0;
        },
        isUnbounded: function isUnbounded() {
          return !0;
        },
        registerDocumentInteractionHandler: function registerDocumentInteractionHandler() {},
        registerInteractionHandler: function registerInteractionHandler() {},
        registerResizeHandler: function registerResizeHandler() {},
        removeClass: function removeClass() {},
        updateCssVariable: function updateCssVariable() {}
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.init = function () {
    var t = this,
        n = this.supportsPressRipple_();

    if (this.registerRootHandlers_(n), n) {
      var i = e.cssClasses,
          r = i.ROOT,
          o = i.UNBOUNDED;
      requestAnimationFrame(function () {
        t.adapter_.addClass(r), t.adapter_.isUnbounded() && (t.adapter_.addClass(o), t.layoutInternal_());
      });
    }
  }, e.prototype.destroy = function () {
    var t = this;

    if (this.supportsPressRipple_()) {
      this.activationTimer_ && (clearTimeout(this.activationTimer_), this.activationTimer_ = 0, this.adapter_.removeClass(e.cssClasses.FG_ACTIVATION)), this.fgDeactivationRemovalTimer_ && (clearTimeout(this.fgDeactivationRemovalTimer_), this.fgDeactivationRemovalTimer_ = 0, this.adapter_.removeClass(e.cssClasses.FG_DEACTIVATION));
      var n = e.cssClasses,
          i = n.ROOT,
          r = n.UNBOUNDED;
      requestAnimationFrame(function () {
        t.adapter_.removeClass(i), t.adapter_.removeClass(r), t.removeCssVars_();
      });
    }

    this.deregisterRootHandlers_(), this.deregisterDeactivationHandlers_();
  }, e.prototype.activate = function (t) {
    this.activate_(t);
  }, e.prototype.deactivate = function () {
    this.deactivate_();
  }, e.prototype.layout = function () {
    var t = this;
    this.layoutFrame_ && cancelAnimationFrame(this.layoutFrame_), this.layoutFrame_ = requestAnimationFrame(function () {
      t.layoutInternal_(), t.layoutFrame_ = 0;
    });
  }, e.prototype.setUnbounded = function (t) {
    var n = e.cssClasses.UNBOUNDED;
    t ? this.adapter_.addClass(n) : this.adapter_.removeClass(n);
  }, e.prototype.handleFocus = function () {
    var t = this;
    requestAnimationFrame(function () {
      return t.adapter_.addClass(e.cssClasses.BG_FOCUSED);
    });
  }, e.prototype.handleBlur = function () {
    var t = this;
    requestAnimationFrame(function () {
      return t.adapter_.removeClass(e.cssClasses.BG_FOCUSED);
    });
  }, e.prototype.supportsPressRipple_ = function () {
    return this.adapter_.browserSupportsCssVars();
  }, e.prototype.defaultActivationState_ = function () {
    return {
      activationEvent: void 0,
      hasDeactivationUXRun: !1,
      isActivated: !1,
      isProgrammatic: !1,
      wasActivatedByPointer: !1,
      wasElementMadeActive: !1
    };
  }, e.prototype.registerRootHandlers_ = function (t) {
    var e = this;
    t && (me.forEach(function (t) {
      e.adapter_.registerInteractionHandler(t, e.activateHandler_);
    }), this.adapter_.isUnbounded() && this.adapter_.registerResizeHandler(this.resizeHandler_)), this.adapter_.registerInteractionHandler("focus", this.focusHandler_), this.adapter_.registerInteractionHandler("blur", this.blurHandler_);
  }, e.prototype.registerDeactivationHandlers_ = function (t) {
    var e = this;
    "keydown" === t.type ? this.adapter_.registerInteractionHandler("keyup", this.deactivateHandler_) : _e.forEach(function (t) {
      e.adapter_.registerDocumentInteractionHandler(t, e.deactivateHandler_);
    });
  }, e.prototype.deregisterRootHandlers_ = function () {
    var t = this;
    me.forEach(function (e) {
      t.adapter_.deregisterInteractionHandler(e, t.activateHandler_);
    }), this.adapter_.deregisterInteractionHandler("focus", this.focusHandler_), this.adapter_.deregisterInteractionHandler("blur", this.blurHandler_), this.adapter_.isUnbounded() && this.adapter_.deregisterResizeHandler(this.resizeHandler_);
  }, e.prototype.deregisterDeactivationHandlers_ = function () {
    var t = this;
    this.adapter_.deregisterInteractionHandler("keyup", this.deactivateHandler_), _e.forEach(function (e) {
      t.adapter_.deregisterDocumentInteractionHandler(e, t.deactivateHandler_);
    });
  }, e.prototype.removeCssVars_ = function () {
    var t = this,
        n = e.strings;
    Object.keys(n).forEach(function (e) {
      0 === e.indexOf("VAR_") && t.adapter_.updateCssVariable(n[e], null);
    });
  }, e.prototype.activate_ = function (t) {
    var e = this;

    if (!this.adapter_.isSurfaceDisabled()) {
      var n = this.activationState_;

      if (!n.isActivated) {
        var i = this.previousActivationEvent_;
        if (!(i && void 0 !== t && i.type !== t.type)) n.isActivated = !0, n.isProgrammatic = void 0 === t, n.activationEvent = t, n.wasActivatedByPointer = !n.isProgrammatic && void 0 !== t && ("mousedown" === t.type || "touchstart" === t.type || "pointerdown" === t.type), void 0 !== t && ge.length > 0 && ge.some(function (t) {
          return e.adapter_.containsEventTarget(t);
        }) ? this.resetActivationState_() : (void 0 !== t && (ge.push(t.target), this.registerDeactivationHandlers_(t)), n.wasElementMadeActive = this.checkElementMadeActive_(t), n.wasElementMadeActive && this.animateActivation_(), requestAnimationFrame(function () {
          ge = [], n.wasElementMadeActive || void 0 === t || " " !== t.key && 32 !== t.keyCode || (n.wasElementMadeActive = e.checkElementMadeActive_(t), n.wasElementMadeActive && e.animateActivation_()), n.wasElementMadeActive || (e.activationState_ = e.defaultActivationState_());
        }));
      }
    }
  }, e.prototype.checkElementMadeActive_ = function (t) {
    return void 0 === t || "keydown" !== t.type || this.adapter_.isSurfaceActive();
  }, e.prototype.animateActivation_ = function () {
    var t = this,
        n = e.strings,
        i = n.VAR_FG_TRANSLATE_START,
        r = n.VAR_FG_TRANSLATE_END,
        o = e.cssClasses,
        a = o.FG_DEACTIVATION,
        s = o.FG_ACTIVATION,
        c = e.numbers.DEACTIVATION_TIMEOUT_MS;
    this.layoutInternal_();
    var u = "",
        l = "";

    if (!this.adapter_.isUnbounded()) {
      var d = this.getFgTranslationCoordinates_(),
          h = d.startPoint,
          p = d.endPoint;
      u = h.x + "px, " + h.y + "px", l = p.x + "px, " + p.y + "px";
    }

    this.adapter_.updateCssVariable(i, u), this.adapter_.updateCssVariable(r, l), clearTimeout(this.activationTimer_), clearTimeout(this.fgDeactivationRemovalTimer_), this.rmBoundedActivationClasses_(), this.adapter_.removeClass(a), this.adapter_.computeBoundingRect(), this.adapter_.addClass(s), this.activationTimer_ = setTimeout(function () {
      return t.activationTimerCallback_();
    }, c);
  }, e.prototype.getFgTranslationCoordinates_ = function () {
    var t,
        e = this.activationState_,
        n = e.activationEvent;
    return {
      startPoint: t = {
        x: (t = e.wasActivatedByPointer ? function (t, e, n) {
          if (!t) return {
            x: 0,
            y: 0
          };
          var i,
              r,
              o = e.x,
              a = e.y,
              s = o + n.left,
              c = a + n.top;

          if ("touchstart" === t.type) {
            var u = t;
            i = u.changedTouches[0].pageX - s, r = u.changedTouches[0].pageY - c;
          } else {
            var l = t;
            i = l.pageX - s, r = l.pageY - c;
          }

          return {
            x: i,
            y: r
          };
        }(n, this.adapter_.getWindowPageOffset(), this.adapter_.computeBoundingRect()) : {
          x: this.frame_.width / 2,
          y: this.frame_.height / 2
        }).x - this.initialSize_ / 2,
        y: t.y - this.initialSize_ / 2
      },
      endPoint: {
        x: this.frame_.width / 2 - this.initialSize_ / 2,
        y: this.frame_.height / 2 - this.initialSize_ / 2
      }
    };
  }, e.prototype.runDeactivationUXLogicIfReady_ = function () {
    var t = this,
        n = e.cssClasses.FG_DEACTIVATION,
        i = this.activationState_,
        r = i.hasDeactivationUXRun,
        o = i.isActivated;
    (r || !o) && this.activationAnimationHasEnded_ && (this.rmBoundedActivationClasses_(), this.adapter_.addClass(n), this.fgDeactivationRemovalTimer_ = setTimeout(function () {
      t.adapter_.removeClass(n);
    }, pe.FG_DEACTIVATION_MS));
  }, e.prototype.rmBoundedActivationClasses_ = function () {
    var t = e.cssClasses.FG_ACTIVATION;
    this.adapter_.removeClass(t), this.activationAnimationHasEnded_ = !1, this.adapter_.computeBoundingRect();
  }, e.prototype.resetActivationState_ = function () {
    var t = this;
    this.previousActivationEvent_ = this.activationState_.activationEvent, this.activationState_ = this.defaultActivationState_(), setTimeout(function () {
      return t.previousActivationEvent_ = void 0;
    }, e.numbers.TAP_DELAY_MS);
  }, e.prototype.deactivate_ = function () {
    var t = this,
        e = this.activationState_;

    if (e.isActivated) {
      var n = _jt({}, e);

      e.isProgrammatic ? (requestAnimationFrame(function () {
        return t.animateDeactivation_(n);
      }), this.resetActivationState_()) : (this.deregisterDeactivationHandlers_(), requestAnimationFrame(function () {
        t.activationState_.hasDeactivationUXRun = !0, t.animateDeactivation_(n), t.resetActivationState_();
      }));
    }
  }, e.prototype.animateDeactivation_ = function (t) {
    var e = t.wasActivatedByPointer,
        n = t.wasElementMadeActive;
    (e || n) && this.runDeactivationUXLogicIfReady_();
  }, e.prototype.layoutInternal_ = function () {
    var t = this;
    this.frame_ = this.adapter_.computeBoundingRect();
    var n = Math.max(this.frame_.height, this.frame_.width);
    this.maxRadius_ = this.adapter_.isUnbounded() ? n : Math.sqrt(Math.pow(t.frame_.width, 2) + Math.pow(t.frame_.height, 2)) + e.numbers.PADDING, this.initialSize_ = Math.floor(n * e.numbers.INITIAL_ORIGIN_SCALE), this.fgScale_ = "" + this.maxRadius_ / this.initialSize_, this.updateLayoutCssVars_();
  }, e.prototype.updateLayoutCssVars_ = function () {
    var t = e.strings,
        n = t.VAR_FG_SIZE,
        i = t.VAR_LEFT,
        r = t.VAR_TOP,
        o = t.VAR_FG_SCALE;
    this.adapter_.updateCssVariable(n, this.initialSize_ + "px"), this.adapter_.updateCssVariable(o, this.fgScale_), this.adapter_.isUnbounded() && (this.unboundedCoords_ = {
      left: Math.round(this.frame_.width / 2 - this.initialSize_ / 2),
      top: Math.round(this.frame_.height / 2 - this.initialSize_ / 2)
    }, this.adapter_.updateCssVariable(i, this.unboundedCoords_.left + "px"), this.adapter_.updateCssVariable(r, this.unboundedCoords_.top + "px"));
  }, e;
}(Yt),
    ye = function (t) {
  function e() {
    var e = null !== t && t.apply(this, arguments) || this;
    return e.disabled = !1, e;
  }

  return Vt(e, t), e.attachTo = function (t, n) {
    void 0 === n && (n = {
      isUnbounded: void 0
    });
    var i = new e(t);
    return void 0 !== n.isUnbounded && (i.unbounded = n.isUnbounded), i;
  }, e.createAdapter = function (t) {
    return {
      addClass: function addClass(e) {
        return t.root_.classList.add(e);
      },
      browserSupportsCssVars: function browserSupportsCssVars() {
        return function (t, e) {
          void 0 === e && (e = !1);
          var n = t.CSS,
              i = ce;
          if ("boolean" == typeof ce && !e) return ce;
          if (!n || "function" != typeof n.supports) return !1;
          var r = n.supports("--css-vars", "yes"),
              o = n.supports("(--css-vars: yes)") && n.supports("color", "#00000000");
          return i = !(!r && !o || function (t) {
            var e = t.document,
                n = e.createElement("div");
            n.className = "mdc-ripple-surface--test-edge-var-bug", e.body.appendChild(n);
            var i = t.getComputedStyle(n),
                r = null !== i && "solid" === i.borderTopStyle;
            return n.parentNode && n.parentNode.removeChild(n), r;
          }(t)), e || (ce = i), i;
        }(window);
      },
      computeBoundingRect: function computeBoundingRect() {
        return t.root_.getBoundingClientRect();
      },
      containsEventTarget: function containsEventTarget(e) {
        return t.root_.contains(e);
      },
      deregisterDocumentInteractionHandler: function deregisterDocumentInteractionHandler(t, e) {
        return document.documentElement.removeEventListener(t, e, fe());
      },
      deregisterInteractionHandler: function deregisterInteractionHandler(e, n) {
        return t.root_.removeEventListener(e, n, fe());
      },
      deregisterResizeHandler: function deregisterResizeHandler(t) {
        return window.removeEventListener("resize", t);
      },
      getWindowPageOffset: function getWindowPageOffset() {
        return {
          x: window.pageXOffset,
          y: window.pageYOffset
        };
      },
      isSurfaceActive: function isSurfaceActive() {
        return Zt(t.root_, ":active");
      },
      isSurfaceDisabled: function isSurfaceDisabled() {
        return Boolean(t.disabled);
      },
      isUnbounded: function isUnbounded() {
        return Boolean(t.unbounded);
      },
      registerDocumentInteractionHandler: function registerDocumentInteractionHandler(t, e) {
        return document.documentElement.addEventListener(t, e, fe());
      },
      registerInteractionHandler: function registerInteractionHandler(e, n) {
        return t.root_.addEventListener(e, n, fe());
      },
      registerResizeHandler: function registerResizeHandler(t) {
        return window.addEventListener("resize", t);
      },
      removeClass: function removeClass(e) {
        return t.root_.classList.remove(e);
      },
      updateCssVariable: function updateCssVariable(e, n) {
        return t.root_.style.setProperty(e, n);
      }
    };
  }, Object.defineProperty(e.prototype, "unbounded", {
    get: function get() {
      return Boolean(this.unbounded_);
    },
    set: function set(t) {
      this.unbounded_ = Boolean(t), this.setUnbounded_();
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.activate = function () {
    this.foundation_.activate();
  }, e.prototype.deactivate = function () {
    this.foundation_.deactivate();
  }, e.prototype.layout = function () {
    this.foundation_.layout();
  }, e.prototype.getDefaultFoundation = function () {
    return new ve(e.createAdapter(this));
  }, e.prototype.initialSyncWithDOM = function () {
    var t = this.root_;
    this.unbounded = "mdcRippleIsUnbounded" in t.dataset;
  }, e.prototype.setUnbounded_ = function () {
    this.foundation_.setUnbounded(Boolean(this.unbounded_));
  }, e;
}($t),
    be = {
  ACTIVE: "mdc-tab-indicator--active",
  FADE: "mdc-tab-indicator--fade",
  NO_TRANSITION: "mdc-tab-indicator--no-transition"
},
    Ee = {
  CONTENT_SELECTOR: ".mdc-tab-indicator__content"
},
    Ce = function (t) {
  function e(n) {
    return t.call(this, _jt({}, e.defaultAdapter, n)) || this;
  }

  return Vt(e, t), Object.defineProperty(e, "cssClasses", {
    get: function get() {
      return be;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "strings", {
    get: function get() {
      return Ee;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultAdapter", {
    get: function get() {
      return {
        addClass: function addClass() {},
        removeClass: function removeClass() {},
        computeContentClientRect: function computeContentClientRect() {
          return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            width: 0,
            height: 0
          };
        },
        setContentStyleProperty: function setContentStyleProperty() {}
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.computeContentClientRect = function () {
    return this.adapter_.computeContentClientRect();
  }, e;
}(Yt),
    Ae = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return Vt(e, t), e.prototype.activate = function () {
    this.adapter_.addClass(Ce.cssClasses.ACTIVE);
  }, e.prototype.deactivate = function () {
    this.adapter_.removeClass(Ce.cssClasses.ACTIVE);
  }, e;
}(Ce),
    Te = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return Vt(e, t), e.prototype.activate = function (t) {
    if (t) {
      var e = this.computeContentClientRect(),
          n = t.width / e.width,
          i = t.left - e.left;
      this.adapter_.addClass(Ce.cssClasses.NO_TRANSITION), this.adapter_.setContentStyleProperty("transform", "translateX(" + i + "px) scaleX(" + n + ")"), this.computeContentClientRect(), this.adapter_.removeClass(Ce.cssClasses.NO_TRANSITION), this.adapter_.addClass(Ce.cssClasses.ACTIVE), this.adapter_.setContentStyleProperty("transform", "");
    } else this.adapter_.addClass(Ce.cssClasses.ACTIVE);
  }, e.prototype.deactivate = function () {
    this.adapter_.removeClass(Ce.cssClasses.ACTIVE);
  }, e;
}(Ce),
    Ie = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return Vt(e, t), e.attachTo = function (t) {
    return new e(t);
  }, e.prototype.initialize = function () {
    this.content_ = this.root_.querySelector(Ce.strings.CONTENT_SELECTOR);
  }, e.prototype.computeContentClientRect = function () {
    return this.foundation_.computeContentClientRect();
  }, e.prototype.getDefaultFoundation = function () {
    var t = this,
        e = {
      addClass: function addClass(e) {
        return t.root_.classList.add(e);
      },
      removeClass: function removeClass(e) {
        return t.root_.classList.remove(e);
      },
      computeContentClientRect: function computeContentClientRect() {
        return t.content_.getBoundingClientRect();
      },
      setContentStyleProperty: function setContentStyleProperty(e, n) {
        return t.content_.style.setProperty(e, n);
      }
    };
    return this.root_.classList.contains(Ce.cssClasses.FADE) ? new Ae(e) : new Te(e);
  }, e.prototype.activate = function (t) {
    this.foundation_.activate(t);
  }, e.prototype.deactivate = function () {
    this.foundation_.deactivate();
  }, e;
}($t),
    Oe = {
  ACTIVE: "mdc-tab--active"
},
    Se = {
  ARIA_SELECTED: "aria-selected",
  CONTENT_SELECTOR: ".mdc-tab__content",
  INTERACTED_EVENT: "MDCTab:interacted",
  RIPPLE_SELECTOR: ".mdc-tab__ripple",
  TABINDEX: "tabIndex",
  TAB_INDICATOR_SELECTOR: ".mdc-tab-indicator"
},
    we = function (t) {
  function e(n) {
    var i = t.call(this, _jt({}, e.defaultAdapter, n)) || this;
    return i.focusOnActivate_ = !0, i;
  }

  return Vt(e, t), Object.defineProperty(e, "cssClasses", {
    get: function get() {
      return Oe;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "strings", {
    get: function get() {
      return Se;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultAdapter", {
    get: function get() {
      return {
        addClass: function addClass() {},
        removeClass: function removeClass() {},
        hasClass: function hasClass() {
          return !1;
        },
        setAttr: function setAttr() {},
        activateIndicator: function activateIndicator() {},
        deactivateIndicator: function deactivateIndicator() {},
        notifyInteracted: function notifyInteracted() {},
        getOffsetLeft: function getOffsetLeft() {
          return 0;
        },
        getOffsetWidth: function getOffsetWidth() {
          return 0;
        },
        getContentOffsetLeft: function getContentOffsetLeft() {
          return 0;
        },
        getContentOffsetWidth: function getContentOffsetWidth() {
          return 0;
        },
        focus: function focus() {}
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.handleClick = function () {
    this.adapter_.notifyInteracted();
  }, e.prototype.isActive = function () {
    return this.adapter_.hasClass(Oe.ACTIVE);
  }, e.prototype.setFocusOnActivate = function (t) {
    this.focusOnActivate_ = t;
  }, e.prototype.activate = function (t) {
    this.adapter_.addClass(Oe.ACTIVE), this.adapter_.setAttr(Se.ARIA_SELECTED, "true"), this.adapter_.setAttr(Se.TABINDEX, "0"), this.adapter_.activateIndicator(t), this.focusOnActivate_ && this.adapter_.focus();
  }, e.prototype.deactivate = function () {
    this.isActive() && (this.adapter_.removeClass(Oe.ACTIVE), this.adapter_.setAttr(Se.ARIA_SELECTED, "false"), this.adapter_.setAttr(Se.TABINDEX, "-1"), this.adapter_.deactivateIndicator());
  }, e.prototype.computeDimensions = function () {
    var t = this.adapter_.getOffsetWidth(),
        e = this.adapter_.getOffsetLeft(),
        n = this.adapter_.getContentOffsetWidth(),
        i = this.adapter_.getContentOffsetLeft();
    return {
      contentLeft: e + i,
      contentRight: e + i + n,
      rootLeft: e,
      rootRight: e + t
    };
  }, e;
}(Yt),
    xe = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return Vt(e, t), e.attachTo = function (t) {
    return new e(t);
  }, e.prototype.initialize = function (t, e) {
    void 0 === t && (t = function t(_t4, e) {
      return new ye(_t4, e);
    }), void 0 === e && (e = function e(t) {
      return new Ie(t);
    }), this.id = this.root_.id;

    var n = this.root_.querySelector(we.strings.RIPPLE_SELECTOR),
        i = _jt({}, ye.createAdapter(this), {
      addClass: function addClass(t) {
        return n.classList.add(t);
      },
      removeClass: function removeClass(t) {
        return n.classList.remove(t);
      },
      updateCssVariable: function updateCssVariable(t, e) {
        return n.style.setProperty(t, e);
      }
    }),
        r = new ve(i);

    this.ripple_ = t(this.root_, r);
    var o = this.root_.querySelector(we.strings.TAB_INDICATOR_SELECTOR);
    this.tabIndicator_ = e(o), this.content_ = this.root_.querySelector(we.strings.CONTENT_SELECTOR);
  }, e.prototype.initialSyncWithDOM = function () {
    var t = this;
    this.handleClick_ = function () {
      return t.foundation_.handleClick();
    }, this.listen("click", this.handleClick_);
  }, e.prototype.destroy = function () {
    this.unlisten("click", this.handleClick_), this.ripple_.destroy(), t.prototype.destroy.call(this);
  }, e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new we({
      setAttr: function setAttr(e, n) {
        return t.root_.setAttribute(e, n);
      },
      addClass: function addClass(e) {
        return t.root_.classList.add(e);
      },
      removeClass: function removeClass(e) {
        return t.root_.classList.remove(e);
      },
      hasClass: function hasClass(e) {
        return t.root_.classList.contains(e);
      },
      activateIndicator: function activateIndicator(e) {
        return t.tabIndicator_.activate(e);
      },
      deactivateIndicator: function deactivateIndicator() {
        return t.tabIndicator_.deactivate();
      },
      notifyInteracted: function notifyInteracted() {
        return t.emit(we.strings.INTERACTED_EVENT, {
          tabId: t.id
        }, !0);
      },
      getOffsetLeft: function getOffsetLeft() {
        return t.root_.offsetLeft;
      },
      getOffsetWidth: function getOffsetWidth() {
        return t.root_.offsetWidth;
      },
      getContentOffsetLeft: function getContentOffsetLeft() {
        return t.content_.offsetLeft;
      },
      getContentOffsetWidth: function getContentOffsetWidth() {
        return t.content_.offsetWidth;
      },
      focus: function focus() {
        return t.root_.focus();
      }
    });
  }, Object.defineProperty(e.prototype, "active", {
    get: function get() {
      return this.foundation_.isActive();
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "focusOnActivate", {
    set: function set(t) {
      this.foundation_.setFocusOnActivate(t);
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.activate = function (t) {
    this.foundation_.activate(t);
  }, e.prototype.deactivate = function () {
    this.foundation_.deactivate();
  }, e.prototype.computeIndicatorClientRect = function () {
    return this.tabIndicator_.computeContentClientRect();
  }, e.prototype.computeDimensions = function () {
    return this.foundation_.computeDimensions();
  }, e.prototype.focus = function () {
    this.root_.focus();
  }, e;
}($t),
    Ne = {
  ARROW_LEFT_KEY: "ArrowLeft",
  ARROW_RIGHT_KEY: "ArrowRight",
  END_KEY: "End",
  ENTER_KEY: "Enter",
  HOME_KEY: "Home",
  SPACE_KEY: "Space",
  TAB_ACTIVATED_EVENT: "MDCTabBar:activated",
  TAB_SCROLLER_SELECTOR: ".mdc-tab-scroller",
  TAB_SELECTOR: ".mdc-tab"
},
    Re = {
  ARROW_LEFT_KEYCODE: 37,
  ARROW_RIGHT_KEYCODE: 39,
  END_KEYCODE: 35,
  ENTER_KEYCODE: 13,
  EXTRA_SCROLL_AMOUNT: 20,
  HOME_KEYCODE: 36,
  SPACE_KEYCODE: 32
},
    Le = new Set();

Le.add(Ne.ARROW_LEFT_KEY), Le.add(Ne.ARROW_RIGHT_KEY), Le.add(Ne.END_KEY), Le.add(Ne.HOME_KEY), Le.add(Ne.ENTER_KEY), Le.add(Ne.SPACE_KEY);
var De = new Map();
De.set(Re.ARROW_LEFT_KEYCODE, Ne.ARROW_LEFT_KEY), De.set(Re.ARROW_RIGHT_KEYCODE, Ne.ARROW_RIGHT_KEY), De.set(Re.END_KEYCODE, Ne.END_KEY), De.set(Re.HOME_KEYCODE, Ne.HOME_KEY), De.set(Re.ENTER_KEYCODE, Ne.ENTER_KEY), De.set(Re.SPACE_KEYCODE, Ne.SPACE_KEY);

var ke,
    Pe,
    Fe = function (t) {
  function e(n) {
    var i = t.call(this, _jt({}, e.defaultAdapter, n)) || this;
    return i.useAutomaticActivation_ = !1, i;
  }

  return Vt(e, t), Object.defineProperty(e, "strings", {
    get: function get() {
      return Ne;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "numbers", {
    get: function get() {
      return Re;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultAdapter", {
    get: function get() {
      return {
        scrollTo: function scrollTo() {},
        incrementScroll: function incrementScroll() {},
        getScrollPosition: function getScrollPosition() {
          return 0;
        },
        getScrollContentWidth: function getScrollContentWidth() {
          return 0;
        },
        getOffsetWidth: function getOffsetWidth() {
          return 0;
        },
        isRTL: function isRTL() {
          return !1;
        },
        setActiveTab: function setActiveTab() {},
        activateTabAtIndex: function activateTabAtIndex() {},
        deactivateTabAtIndex: function deactivateTabAtIndex() {},
        focusTabAtIndex: function focusTabAtIndex() {},
        getTabIndicatorClientRectAtIndex: function getTabIndicatorClientRectAtIndex() {
          return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            width: 0,
            height: 0
          };
        },
        getTabDimensionsAtIndex: function getTabDimensionsAtIndex() {
          return {
            rootLeft: 0,
            rootRight: 0,
            contentLeft: 0,
            contentRight: 0
          };
        },
        getPreviousActiveTabIndex: function getPreviousActiveTabIndex() {
          return -1;
        },
        getFocusedTabIndex: function getFocusedTabIndex() {
          return -1;
        },
        getIndexOfTabById: function getIndexOfTabById() {
          return -1;
        },
        getTabListLength: function getTabListLength() {
          return 0;
        },
        notifyTabActivated: function notifyTabActivated() {}
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.setUseAutomaticActivation = function (t) {
    this.useAutomaticActivation_ = t;
  }, e.prototype.activateTab = function (t) {
    var e,
        n = this.adapter_.getPreviousActiveTabIndex();
    this.indexIsInRange_(t) && t !== n && (-1 !== n && (this.adapter_.deactivateTabAtIndex(n), e = this.adapter_.getTabIndicatorClientRectAtIndex(n)), this.adapter_.activateTabAtIndex(t, e), this.scrollIntoView(t), this.adapter_.notifyTabActivated(t));
  }, e.prototype.handleKeyDown = function (t) {
    var e = this.getKeyFromEvent_(t);
    if (void 0 !== e) if (this.isActivationKey_(e) || t.preventDefault(), this.useAutomaticActivation_) {
      if (this.isActivationKey_(e)) return;
      var n = this.determineTargetFromKey_(this.adapter_.getPreviousActiveTabIndex(), e);
      this.adapter_.setActiveTab(n), this.scrollIntoView(n);
    } else {
      var i = this.adapter_.getFocusedTabIndex();
      if (this.isActivationKey_(e)) this.adapter_.setActiveTab(i);else {
        n = this.determineTargetFromKey_(i, e);
        this.adapter_.focusTabAtIndex(n), this.scrollIntoView(n);
      }
    }
  }, e.prototype.handleTabInteraction = function (t) {
    this.adapter_.setActiveTab(this.adapter_.getIndexOfTabById(t.detail.tabId));
  }, e.prototype.scrollIntoView = function (t) {
    if (this.indexIsInRange_(t)) return 0 === t ? this.adapter_.scrollTo(0) : t === this.adapter_.getTabListLength() - 1 ? this.adapter_.scrollTo(this.adapter_.getScrollContentWidth()) : this.isRTL_() ? this.scrollIntoViewRTL_(t) : void this.scrollIntoView_(t);
  }, e.prototype.determineTargetFromKey_ = function (t, e) {
    var n = this.isRTL_(),
        i = this.adapter_.getTabListLength() - 1,
        r = t;
    return e === Ne.END_KEY ? r = i : e === Ne.ARROW_LEFT_KEY && !n || e === Ne.ARROW_RIGHT_KEY && n ? r -= 1 : e === Ne.ARROW_RIGHT_KEY && !n || e === Ne.ARROW_LEFT_KEY && n ? r += 1 : r = 0, r < 0 ? r = i : r > i && (r = 0), r;
  }, e.prototype.calculateScrollIncrement_ = function (t, e, n, i) {
    var r = this.adapter_.getTabDimensionsAtIndex(e),
        o = r.contentLeft - n - i,
        a = r.contentRight - n - Re.EXTRA_SCROLL_AMOUNT,
        s = o + Re.EXTRA_SCROLL_AMOUNT;
    return e < t ? Math.min(a, 0) : Math.max(s, 0);
  }, e.prototype.calculateScrollIncrementRTL_ = function (t, e, n, i, r) {
    var o = this.adapter_.getTabDimensionsAtIndex(e),
        a = r - o.contentLeft - n,
        s = r - o.contentRight - n - i + Re.EXTRA_SCROLL_AMOUNT,
        c = a - Re.EXTRA_SCROLL_AMOUNT;
    return e > t ? Math.max(s, 0) : Math.min(c, 0);
  }, e.prototype.findAdjacentTabIndexClosestToEdge_ = function (t, e, n, i) {
    var r = e.rootLeft - n,
        o = e.rootRight - n - i,
        a = r + o;
    return r < 0 || a < 0 ? t - 1 : o > 0 || a > 0 ? t + 1 : -1;
  }, e.prototype.findAdjacentTabIndexClosestToEdgeRTL_ = function (t, e, n, i, r) {
    var o = r - e.rootLeft - i - n,
        a = r - e.rootRight - n,
        s = o + a;
    return o > 0 || s > 0 ? t + 1 : a < 0 || s < 0 ? t - 1 : -1;
  }, e.prototype.getKeyFromEvent_ = function (t) {
    return Le.has(t.key) ? t.key : De.get(t.keyCode);
  }, e.prototype.isActivationKey_ = function (t) {
    return t === Ne.SPACE_KEY || t === Ne.ENTER_KEY;
  }, e.prototype.indexIsInRange_ = function (t) {
    return t >= 0 && t < this.adapter_.getTabListLength();
  }, e.prototype.isRTL_ = function () {
    return this.adapter_.isRTL();
  }, e.prototype.scrollIntoView_ = function (t) {
    var e = this.adapter_.getScrollPosition(),
        n = this.adapter_.getOffsetWidth(),
        i = this.adapter_.getTabDimensionsAtIndex(t),
        r = this.findAdjacentTabIndexClosestToEdge_(t, i, e, n);

    if (this.indexIsInRange_(r)) {
      var o = this.calculateScrollIncrement_(t, r, e, n);
      this.adapter_.incrementScroll(o);
    }
  }, e.prototype.scrollIntoViewRTL_ = function (t) {
    var e = this.adapter_.getScrollPosition(),
        n = this.adapter_.getOffsetWidth(),
        i = this.adapter_.getTabDimensionsAtIndex(t),
        r = this.adapter_.getScrollContentWidth(),
        o = this.findAdjacentTabIndexClosestToEdgeRTL_(t, i, e, n, r);

    if (this.indexIsInRange_(o)) {
      var a = this.calculateScrollIncrementRTL_(t, o, e, n, r);
      this.adapter_.incrementScroll(a);
    }
  }, e;
}(Yt),
    Me = Fe.strings,
    He = 0,
    Be = (function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  Vt(e, t), e.attachTo = function (t) {
    return new e(t);
  }, Object.defineProperty(e.prototype, "focusOnActivate", {
    set: function set(t) {
      this.tabList_.forEach(function (e) {
        return e.focusOnActivate = t;
      });
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "useAutomaticActivation", {
    set: function set(t) {
      this.foundation_.setUseAutomaticActivation(t);
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.initialize = function (t, e) {
    void 0 === t && (t = function t(_t5) {
      return new xe(_t5);
    }), void 0 === e && (e = function e(t) {
      return new le(t);
    }), this.tabList_ = this.instantiateTabs_(t), this.tabScroller_ = this.instantiateTabScroller_(e);
  }, e.prototype.initialSyncWithDOM = function () {
    var t = this;
    this.handleTabInteraction_ = function (e) {
      return t.foundation_.handleTabInteraction(e);
    }, this.handleKeyDown_ = function (e) {
      return t.foundation_.handleKeyDown(e);
    }, this.listen(we.strings.INTERACTED_EVENT, this.handleTabInteraction_), this.listen("keydown", this.handleKeyDown_);

    for (var e = 0; e < this.tabList_.length; e++) {
      if (this.tabList_[e].active) {
        this.scrollIntoView(e);
        break;
      }
    }
  }, e.prototype.destroy = function () {
    t.prototype.destroy.call(this), this.unlisten(we.strings.INTERACTED_EVENT, this.handleTabInteraction_), this.unlisten("keydown", this.handleKeyDown_), this.tabList_.forEach(function (t) {
      return t.destroy();
    }), this.tabScroller_ && this.tabScroller_.destroy();
  }, e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new Fe({
      scrollTo: function scrollTo(e) {
        return t.tabScroller_.scrollTo(e);
      },
      incrementScroll: function incrementScroll(e) {
        return t.tabScroller_.incrementScroll(e);
      },
      getScrollPosition: function getScrollPosition() {
        return t.tabScroller_.getScrollPosition();
      },
      getScrollContentWidth: function getScrollContentWidth() {
        return t.tabScroller_.getScrollContentWidth();
      },
      getOffsetWidth: function getOffsetWidth() {
        return t.root_.offsetWidth;
      },
      isRTL: function isRTL() {
        return "rtl" === window.getComputedStyle(t.root_).getPropertyValue("direction");
      },
      setActiveTab: function setActiveTab(e) {
        return t.foundation_.activateTab(e);
      },
      activateTabAtIndex: function activateTabAtIndex(e, n) {
        return t.tabList_[e].activate(n);
      },
      deactivateTabAtIndex: function deactivateTabAtIndex(e) {
        return t.tabList_[e].deactivate();
      },
      focusTabAtIndex: function focusTabAtIndex(e) {
        return t.tabList_[e].focus();
      },
      getTabIndicatorClientRectAtIndex: function getTabIndicatorClientRectAtIndex(e) {
        return t.tabList_[e].computeIndicatorClientRect();
      },
      getTabDimensionsAtIndex: function getTabDimensionsAtIndex(e) {
        return t.tabList_[e].computeDimensions();
      },
      getPreviousActiveTabIndex: function getPreviousActiveTabIndex() {
        for (var e = 0; e < t.tabList_.length; e++) {
          if (t.tabList_[e].active) return e;
        }

        return -1;
      },
      getFocusedTabIndex: function getFocusedTabIndex() {
        var e = t.getTabElements_(),
            n = document.activeElement;
        return e.indexOf(n);
      },
      getIndexOfTabById: function getIndexOfTabById(e) {
        for (var n = 0; n < t.tabList_.length; n++) {
          if (t.tabList_[n].id === e) return n;
        }

        return -1;
      },
      getTabListLength: function getTabListLength() {
        return t.tabList_.length;
      },
      notifyTabActivated: function notifyTabActivated(e) {
        return t.emit(Me.TAB_ACTIVATED_EVENT, {
          index: e
        }, !0);
      }
    });
  }, e.prototype.activateTab = function (t) {
    this.foundation_.activateTab(t);
  }, e.prototype.scrollIntoView = function (t) {
    this.foundation_.scrollIntoView(t);
  }, e.prototype.getTabElements_ = function () {
    return [].slice.call(this.root_.querySelectorAll(Me.TAB_SELECTOR));
  }, e.prototype.instantiateTabs_ = function (t) {
    return this.getTabElements_().map(function (e) {
      return e.id = e.id || "mdc-tab-" + ++He, t(e);
    });
  }, e.prototype.instantiateTabScroller_ = function (t) {
    var e = this.root_.querySelector(Me.TAB_SCROLLER_SELECTOR);
    return e ? t(e) : null;
  };
}($t), function () {
  var _t6 = function t(e, n) {
    return (_t6 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var n in e) {
        e.hasOwnProperty(n) && (t[n] = e[n]);
      }
    })(e, n);
  };

  return function (e, n) {
    function i() {
      this.constructor = e;
    }

    _t6(e, n), e.prototype = null === n ? Object.create(n) : (i.prototype = n.prototype, new i());
  };
}()),
    _Ve = function Ve() {
  return (_Ve = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    je = function je(t, e) {
  var n = {};

  for (var i in t) {
    Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
  }

  if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
    var r = 0;

    for (i = Object.getOwnPropertySymbols(t); r < i.length; r++) {
      e.indexOf(i[r]) < 0 && (n[i[r]] = t[i[r]]);
    }
  }

  return n;
},
    Ue = Mt({
  displayName: "TabScroller",
  classNames: ["mdc-tab-scroller"]
}),
    Ge = Mt({
  displayName: "TabScrollerScrollArea",
  classNames: ["mdc-tab-scroller__scroll-area"]
}),
    ze = Mt({
  displayName: "TabScrollerScrollContent",
  classNames: ["mdc-tab-scroller__scroll-content"]
}),
    Ke = function (t) {
  function e(e) {
    var n = t.call(this, e) || this;
    return n.root = n.createElement("root"), n.area = n.createElement("area"), n.content = n.createElement("content"), n.handleInteraction = n.handleInteraction.bind(n), n.handleTransitionEnd = n.handleTransitionEnd.bind(n), n;
  }

  return Be(e, t), e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new ae({
      eventTargetMatchesSelector: function eventTargetMatchesSelector(t, e) {
        return yt(t, e);
      },
      addClass: function addClass(e) {
        return t.root.addClass(e);
      },
      removeClass: function removeClass(e) {
        return t.root.removeClass(e);
      },
      addScrollAreaClass: function addScrollAreaClass(e) {
        return t.area.addClass(e);
      },
      setScrollAreaStyleProperty: function setScrollAreaStyleProperty(e, n) {
        return t.area.setStyle(e, n);
      },
      setScrollContentStyleProperty: function setScrollContentStyleProperty(e, n) {
        return t.content.setStyle(e, n);
      },
      getScrollContentStyleValue: function getScrollContentStyleValue(e) {
        return t.content.ref && window.getComputedStyle(t.content.ref).getPropertyValue(e) || "none";
      },
      setScrollAreaScrollLeft: function setScrollAreaScrollLeft(e) {
        return t.area.ref && (t.area.ref.scrollLeft = e);
      },
      getScrollAreaScrollLeft: function getScrollAreaScrollLeft() {
        return t.area.ref ? t.area.ref.scrollLeft : 0;
      },
      getScrollContentOffsetWidth: function getScrollContentOffsetWidth() {
        return t.content.ref ? t.content.ref.offsetWidth : 0;
      },
      getScrollAreaOffsetWidth: function getScrollAreaOffsetWidth() {
        return t.area.ref ? t.area.ref.offsetWidth : 0;
      },
      computeScrollAreaClientRect: function computeScrollAreaClientRect() {
        return t.area.ref ? t.area.ref.getBoundingClientRect() : {};
      },
      computeScrollContentClientRect: function computeScrollContentClientRect() {
        return t.content.ref ? t.content.ref.getBoundingClientRect() : {};
      },
      computeHorizontalScrollbarHeight: function computeHorizontalScrollbarHeight() {
        return se(document);
      }
    });
  }, e.prototype.getScrollPosition = function () {
    return this.foundation.getScrollPosition();
  }, e.prototype.getScrollContentWidth = function () {
    return this.content.ref ? this.content.ref.offsetWidth : 0;
  }, e.prototype.incrementScroll = function (t) {
    this.foundation.incrementScroll(t);
  }, e.prototype.scrollTo = function (t) {
    this.foundation.scrollTo(t);
  }, e.prototype.handleInteraction = function () {
    this.foundation.handleInteraction();
  }, e.prototype.handleTransitionEnd = function (t) {
    this.foundation.handleTransitionEnd(t);
  }, e.prototype.render = function () {
    var t = this.props,
        e = t.children,
        i = je(t, ["children"]);
    return n(Ue, _Ve({}, this.root.props(i), {
      ref: this.root.setRef
    }), n(Ge, _Ve({}, this.area.props({}), {
      ref: this.area.setRef,
      onWheel: this.handleInteraction,
      onTouchStart: this.handleInteraction,
      onPointerDown: this.handleInteraction,
      onMouseDown: this.handleInteraction,
      onKeyDown: this.handleInteraction
    }), n(ze, _Ve({}, this.content.props({}), {
      ref: this.content.setRef,
      onTransitionEnd: this.handleTransitionEnd
    }), e)));
  }, e;
}(Rt),
    qe = function () {
  var _t7 = function t(e, n) {
    return (_t7 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var n in e) {
        e.hasOwnProperty(n) && (t[n] = e[n]);
      }
    })(e, n);
  };

  return function (e, n) {
    function i() {
      this.constructor = e;
    }

    _t7(e, n), e.prototype = null === n ? Object.create(n) : (i.prototype = n.prototype, new i());
  };
}(),
    _We = function We() {
  return (_We = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    Xe = function Xe(t, e) {
  var n = {};

  for (var i in t) {
    Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
  }

  if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
    var r = 0;

    for (i = Object.getOwnPropertySymbols(t); r < i.length; r++) {
      e.indexOf(i[r]) < 0 && (n[i[r]] = t[i[r]]);
    }
  }

  return n;
},
    Ye = function Ye(t, e) {
  var n = "function" == typeof Symbol && t[Symbol.iterator];
  if (!n) return t;
  var i,
      r,
      o = n.call(t),
      a = [];

  try {
    for (; (void 0 === e || e-- > 0) && !(i = o.next()).done;) {
      a.push(i.value);
    }
  } catch (t) {
    r = {
      error: t
    };
  } finally {
    try {
      i && !i.done && (n = o.return) && n.call(o);
    } finally {
      if (r) throw r.error;
    }
  }

  return a;
},
    $e = Mt({
  displayName: "TabBarRoot",
  tag: "nav",
  classNames: function classNames(t) {
    return ["mdc-tab-bar", {
      "mdc-tab-scroller__scroll-frame__tabs": t.isTabScroller
    }];
  },
  consumeProps: ["isTabScroller"]
}),
    Qe = function (t) {
  function e(e) {
    var n = t.call(this, e) || this;
    return n.root = n.createElement("root"), n.currentActiveTabIndex = n.props.activeTabIndex || 0, n.tabScroller = null, n.tabList = [], n.contextApi = {
      onTabInteraction: function onTabInteraction(t) {
        return n.handleTabInteraction(t);
      },
      registerTab: function registerTab(t) {
        return n.tabList.push(t);
      },
      unregisterTab: function unregisterTab(t) {
        return n.tabList.splice(n.tabList.indexOf(t), 1);
      }
    }, n.handleKeyDown = n.handleKeyDown.bind(n), n.handleTabInteraction = n.handleTabInteraction.bind(n), n;
  }

  return qe(e, t), e.prototype.componentDidMount = function () {
    t.prototype.componentDidMount.call(this);
    var e = window.document.activeElement,
        n = Ye([window.scrollX, window.scrollY], 2),
        i = n[0],
        r = n[1];
    this.foundation.adapter_.activateTabAtIndex(this.props.activeTabIndex || 0, this.foundation.adapter_.getTabIndicatorClientRectAtIndex(void 0)), this.foundation.scrollIntoView(this.props.activeTabIndex || 0), e && e.focus(), window.scrollTo(i, r);
  }, e.prototype.activateTab = function (t) {
    var e = this,
        n = this.foundation;
    this.currentActiveTabIndex = t;
    var i = n.adapter_.getPreviousActiveTabIndex();
    n.indexIsInRange_(t) && t !== i && (n.adapter_.notifyTabActivated(t), setTimeout(function () {
      e.props.activeTabIndex === t || void 0 === e.props.activeTabIndex ? (n.adapter_.deactivateTabAtIndex(i), n.adapter_.activateTabAtIndex(t, n.adapter_.getTabIndicatorClientRectAtIndex(i)), n.scrollIntoView(t)) : e.currentActiveTabIndex = i;
    }));
  }, e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new Fe({
      scrollTo: function scrollTo(e) {
        t.tabScroller && t.tabScroller.scrollTo(e);
      },
      incrementScroll: function incrementScroll(e) {
        return t.tabScroller && t.tabScroller.incrementScroll(e);
      },
      getScrollPosition: function getScrollPosition() {
        return t.tabScroller ? t.tabScroller.getScrollPosition() : 0;
      },
      getScrollContentWidth: function getScrollContentWidth() {
        return t.tabScroller ? t.tabScroller.getScrollContentWidth() : 0;
      },
      getOffsetWidth: function getOffsetWidth() {
        return t.root.ref ? t.root.ref.offsetWidth : 0;
      },
      isRTL: function isRTL() {
        return !!t.root.ref && "rtl" === window.getComputedStyle(t.root.ref).getPropertyValue("direction");
      },
      setActiveTab: function setActiveTab(e) {
        return t.activateTab(e);
      },
      activateTabAtIndex: function activateTabAtIndex(e, n) {
        t.tabList[e] && t.tabList[e].activate(n);
      },
      deactivateTabAtIndex: function deactivateTabAtIndex(e) {
        return t.tabList[e] && t.tabList[e].deactivate();
      },
      focusTabAtIndex: function focusTabAtIndex(e) {
        return t.tabList[e].focus();
      },
      getTabIndicatorClientRectAtIndex: function getTabIndicatorClientRectAtIndex(e) {
        return t.tabList[e] && t.tabList[e].computeIndicatorClientRect();
      },
      getTabDimensionsAtIndex: function getTabDimensionsAtIndex(e) {
        return t.tabList[e] && t.tabList[e].computeDimensions();
      },
      getPreviousActiveTabIndex: function getPreviousActiveTabIndex() {
        for (var e = 0; e < t.tabList.length; e++) {
          if (t.tabList[e].active) return e;
        }

        return -1;
      },
      getFocusedTabIndex: function getFocusedTabIndex() {
        var e = t.getTabElements(),
            n = document.activeElement;
        return e ? e.indexOf(n) : -1;
      },
      getIndexOfTabById: function getIndexOfTabById(e) {
        for (var n = 0; n < t.tabList.length; n++) {
          if (t.tabList[n].id === e) return n;
        }

        return -1;
      },
      getTabListLength: function getTabListLength() {
        return t.tabList.length;
      },
      notifyTabActivated: function notifyTabActivated(e) {
        return t.emit("onActivate", {
          index: e
        }, !0);
      }
    });
  }, e.prototype.sync = function (t, e) {
    t.activeTabIndex !== e.activeTabIndex && t.activeTabIndex !== this.currentActiveTabIndex && "number" == typeof t.activeTabIndex && this.activateTab(t.activeTabIndex);
  }, e.prototype.getTabElements = function () {
    return [].slice.call(this.root.ref && this.root.ref.querySelectorAll(Fe.strings.TAB_SELECTOR));
  }, e.prototype.handleTabInteraction = function (t) {
    this.foundation.handleTabInteraction(t);
  }, e.prototype.handleKeyDown = function (t) {
    this.props.onKeyDown && this.props.onKeyDown(t), this.foundation.handleKeyDown(t);
  }, e.prototype.render = function () {
    var t = this,
        e = this.props,
        i = e.children,
        r = (e.activeTabIndex, e.onActivate, Xe(e, ["children", "activeTabIndex", "onActivate"]));
    return n(W.Provider, {
      value: this.contextApi
    }, n($e, _We({}, r, {
      ref: this.root.setRef,
      onKeyDown: this.handleKeyDown
    }), n(Ke, {
      ref: function ref(e) {
        return t.tabScroller = e;
      }
    }, i)));
  }, e.displayName = "TabBar", e;
}(Rt),
    Ze = {
  ACTIVE: "mdc-tab-indicator--active",
  FADE: "mdc-tab-indicator--fade",
  NO_TRANSITION: "mdc-tab-indicator--no-transition"
},
    Je = {
  CONTENT_SELECTOR: ".mdc-tab-indicator__content"
},
    tn = function (t) {
  function e(n) {
    return t.call(this, _jt({}, e.defaultAdapter, n)) || this;
  }

  return Vt(e, t), Object.defineProperty(e, "cssClasses", {
    get: function get() {
      return Ze;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "strings", {
    get: function get() {
      return Je;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultAdapter", {
    get: function get() {
      return {
        addClass: function addClass() {},
        removeClass: function removeClass() {},
        computeContentClientRect: function computeContentClientRect() {
          return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            width: 0,
            height: 0
          };
        },
        setContentStyleProperty: function setContentStyleProperty() {}
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.computeContentClientRect = function () {
    return this.adapter_.computeContentClientRect();
  }, e;
}(Yt),
    en = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return Vt(e, t), e.prototype.activate = function () {
    this.adapter_.addClass(tn.cssClasses.ACTIVE);
  }, e.prototype.deactivate = function () {
    this.adapter_.removeClass(tn.cssClasses.ACTIVE);
  }, e;
}(tn),
    nn = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return Vt(e, t), e.prototype.activate = function (t) {
    if (t) {
      var e = this.computeContentClientRect(),
          n = t.width / e.width,
          i = t.left - e.left;
      this.adapter_.addClass(tn.cssClasses.NO_TRANSITION), this.adapter_.setContentStyleProperty("transform", "translateX(" + i + "px) scaleX(" + n + ")"), this.computeContentClientRect(), this.adapter_.removeClass(tn.cssClasses.NO_TRANSITION), this.adapter_.addClass(tn.cssClasses.ACTIVE), this.adapter_.setContentStyleProperty("transform", "");
    } else this.adapter_.addClass(tn.cssClasses.ACTIVE);
  }, e.prototype.deactivate = function () {
    this.adapter_.removeClass(tn.cssClasses.ACTIVE);
  }, e;
}(tn),
    rn = (function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  Vt(e, t), e.attachTo = function (t) {
    return new e(t);
  }, e.prototype.initialize = function () {
    this.content_ = this.root_.querySelector(tn.strings.CONTENT_SELECTOR);
  }, e.prototype.computeContentClientRect = function () {
    return this.foundation_.computeContentClientRect();
  }, e.prototype.getDefaultFoundation = function () {
    var t = this,
        e = {
      addClass: function addClass(e) {
        return t.root_.classList.add(e);
      },
      removeClass: function removeClass(e) {
        return t.root_.classList.remove(e);
      },
      computeContentClientRect: function computeContentClientRect() {
        return t.content_.getBoundingClientRect();
      },
      setContentStyleProperty: function setContentStyleProperty(e, n) {
        return t.content_.style.setProperty(e, n);
      }
    };
    return this.root_.classList.contains(tn.cssClasses.FADE) ? new en(e) : new nn(e);
  }, e.prototype.activate = function (t) {
    this.foundation_.activate(t);
  }, e.prototype.deactivate = function () {
    this.foundation_.deactivate();
  };
}($t), function () {
  var _t8 = function t(e, n) {
    return (_t8 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var n in e) {
        e.hasOwnProperty(n) && (t[n] = e[n]);
      }
    })(e, n);
  };

  return function (e, n) {
    function i() {
      this.constructor = e;
    }

    _t8(e, n), e.prototype = null === n ? Object.create(n) : (i.prototype = n.prototype, new i());
  };
}()),
    _on = function on() {
  return (_on = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    an = function (t) {
  function e() {
    var e = null !== t && t.apply(this, arguments) || this;
    return e.root = e.createElement("root"), e.content = e.createElement("content"), e;
  }

  return rn(e, t), e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new nn({
      addClass: function addClass(e) {
        t.root.addClass(e);
      },
      removeClass: function removeClass(e) {
        t.root.removeClass(e);
      },
      computeContentClientRect: function computeContentClientRect() {
        return t.content.ref ? t.content.ref.getBoundingClientRect() : {};
      },
      setContentStyleProperty: function setContentStyleProperty(e, n) {
        t.content.setStyle(e, n);
      }
    });
  }, e.prototype.activate = function (t) {
    this.foundation.activate(t);
  }, e.prototype.deactivate = function () {
    this.foundation.deactivate();
  }, e.prototype.computeContentClientRect = function () {
    return this.foundation.computeContentClientRect();
  }, e.prototype.render = function () {
    return n("span", _on({}, this.root.props({
      className: "mdc-tab-indicator"
    })), n("span", _on({
      ref: this.content.setRef
    }, this.content.props({}), {
      className: "mdc-tab-indicator__content mdc-tab-indicator__content--underline"
    })));
  }, e;
}(Rt),
    _sn = function sn() {
  return (_sn = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    cn = e({
  ripple: !0,
  icon: {
    icon: "",
    basename: "material-icons",
    prefix: "",
    strategy: "auto",
    render: void 0
  }
}),
    un = function un() {
  return function (t) {
    return r(function (e, i) {
      return n(cn.Consumer, null, function (r) {
        return n(t, _sn({}, e, {
          providerContext: r,
          ref: i
        }));
      });
    });
  };
},
    _ln = function ln() {
  return (_ln = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    dn = function dn(t, e) {
  var n = {};

  for (var i in t) {
    Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
  }

  if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
    var r = 0;

    for (i = Object.getOwnPropertySymbols(t); r < i.length; r++) {
      e.indexOf(i[r]) < 0 && (n[i[r]] = t[i[r]]);
    }
  }

  return n;
},
    hn = function hn(t, e, n) {
  return "auto" === (e = e || n || "auto") ? function (t) {
    return "string" == typeof t && t.includes("/") ? "url" : a(t) ? "component" : "ligature";
  }(t) : e;
},
    pn = {
  ligature: function ligature(t) {
    var e = t.content,
        i = dn(t, ["content"]);
    return n(fn, _ln({}, i), e);
  },
  className: function className(t) {
    t.content;
    var e = dn(t, ["content"]);
    return n(fn, _ln({}, e));
  },
  url: function url(t) {
    var e = t.content,
        i = dn(t, ["content"]);
    return n(fn, _ln({}, i, {
      className: m(i.className, "rmwc-icon--image"),
      style: _ln({}, i.style, {
        backgroundImage: "url(" + e + ")"
      })
    }));
  },
  component: function component(t) {
    var e = t.content,
        i = dn(t, ["content"]);

    if ("svg" === e.type) {
      var r = e.props,
          o = r.children,
          a = dn(r, ["children"]);
      return n(fn, _ln({}, a, i, {
        tag: "svg"
      }), o);
    }

    return n(fn, _ln({}, i), e);
  },
  auto: void 0
},
    fn = Mt({
  displayName: "IconRoot",
  tag: "i"
}),
    mn = un()(function (t) {
  var e,
      n = t.icon,
      i = t.iconOptions,
      r = t.providerContext,
      s = dn(t, ["icon", "iconOptions", "providerContext"]);

  if (i) {
    var c = _ln({
      content: "string" == typeof n ? n : "<MyComponent {...}/>"
    }, i);

    ft("Icon component prop 'iconOptions' is deprecated. You options should now be passed directly to the 'icon' prop. I.E. icon={" + JSON.stringify(c) + "}");
  }

  var u = _ln({}, function (t) {
    return a(t) || t && "object" != typeof t ? {
      icon: t
    } : t;
  }(n), i),
      l = u.icon,
      d = u.strategy,
      h = u.prefix,
      p = u.basename,
      f = u.render,
      _ = u.size,
      g = dn(u, ["icon", "strategy", "prefix", "basename", "render", "size"]),
      v = r.icon || {},
      y = v.basename,
      b = void 0 === y ? null : y,
      E = v.prefix,
      C = void 0 === E ? null : E,
      A = v.strategy,
      T = void 0 === A ? null : A,
      I = v.render,
      O = void 0 === I ? null : I,
      S = l,
      w = hn(S, d || null, T || null),
      x = void 0 === p ? b : p,
      N = "className" === w && "string" == typeof l ? "" + String(h || C) + l : null,
      R = "custom" === w ? f || O : !!w && pn[w] || null;

  if (!R) return console.error("Icon: rendering not implemented for " + String(w) + "."), null;
  var L = R(_ln({}, s, g, {
    content: S,
    className: m("rmwc-icon", x, s.className, g.className, N, (e = {}, e["rmwc-icon--size-" + (_ || "")] = !!_, e))
  }));
  return L.props.children && L.props.children.type && ["Avatar", "Icon"].includes(L.props.children.type.displayName) ? o(L.props.children, _ln({}, L.props.children.props, L.props, {
    children: L.props.children.props.children,
    className: m(L.props.className, L.props.children.props.className)
  })) : L;
});

function _n(t, e) {
  void 0 === e && (e = !1);
  var n = t.CSS,
      i = ke;
  if ("boolean" == typeof ke && !e) return ke;
  if (!(n && "function" == typeof n.supports)) return !1;
  var r = n.supports("--css-vars", "yes"),
      o = n.supports("(--css-vars: yes)") && n.supports("color", "#00000000");
  return i = !(!r && !o) && !function (t) {
    var e = t.document,
        n = e.createElement("div");
    n.className = "mdc-ripple-surface--test-edge-var-bug", e.body.appendChild(n);
    var i = t.getComputedStyle(n),
        r = null !== i && "solid" === i.borderTopStyle;
    return n.parentNode && n.parentNode.removeChild(n), r;
  }(t), e || (ke = i), i;
}

function gn(t, e) {
  if (void 0 === t && (t = window), void 0 === e && (e = !1), void 0 === Pe || e) {
    var n = !1;

    try {
      t.document.addEventListener("test", function () {}, {
        get passive() {
          return n = !0;
        }

      });
    } catch (t) {}

    Pe = n;
  }

  return !!Pe && {
    passive: !0
  };
}

mn.displayName = "Icon";

var vn,
    yn = {
  BG_FOCUSED: "mdc-ripple-upgraded--background-focused",
  FG_ACTIVATION: "mdc-ripple-upgraded--foreground-activation",
  FG_DEACTIVATION: "mdc-ripple-upgraded--foreground-deactivation",
  ROOT: "mdc-ripple-upgraded",
  UNBOUNDED: "mdc-ripple-upgraded--unbounded"
},
    bn = {
  VAR_FG_SCALE: "--mdc-ripple-fg-scale",
  VAR_FG_SIZE: "--mdc-ripple-fg-size",
  VAR_FG_TRANSLATE_END: "--mdc-ripple-fg-translate-end",
  VAR_FG_TRANSLATE_START: "--mdc-ripple-fg-translate-start",
  VAR_LEFT: "--mdc-ripple-left",
  VAR_TOP: "--mdc-ripple-top"
},
    En = {
  DEACTIVATION_TIMEOUT_MS: 225,
  FG_DEACTIVATION_MS: 150,
  INITIAL_ORIGIN_SCALE: .6,
  PADDING: 10,
  TAP_DELAY_MS: 300
},
    Cn = ["touchstart", "pointerdown", "mousedown", "keydown"],
    An = ["touchend", "pointerup", "mouseup", "contextmenu"],
    Tn = [],
    In = function (t) {
  function e(n) {
    var i = t.call(this, _jt({}, e.defaultAdapter, n)) || this;
    return i.activationAnimationHasEnded_ = !1, i.activationTimer_ = 0, i.fgDeactivationRemovalTimer_ = 0, i.fgScale_ = "0", i.frame_ = {
      width: 0,
      height: 0
    }, i.initialSize_ = 0, i.layoutFrame_ = 0, i.maxRadius_ = 0, i.unboundedCoords_ = {
      left: 0,
      top: 0
    }, i.activationState_ = i.defaultActivationState_(), i.activationTimerCallback_ = function () {
      i.activationAnimationHasEnded_ = !0, i.runDeactivationUXLogicIfReady_();
    }, i.activateHandler_ = function (t) {
      return i.activate_(t);
    }, i.deactivateHandler_ = function () {
      return i.deactivate_();
    }, i.focusHandler_ = function () {
      return i.handleFocus();
    }, i.blurHandler_ = function () {
      return i.handleBlur();
    }, i.resizeHandler_ = function () {
      return i.layout();
    }, i;
  }

  return Vt(e, t), Object.defineProperty(e, "cssClasses", {
    get: function get() {
      return yn;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "strings", {
    get: function get() {
      return bn;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "numbers", {
    get: function get() {
      return En;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultAdapter", {
    get: function get() {
      return {
        addClass: function addClass() {},
        browserSupportsCssVars: function browserSupportsCssVars() {
          return !0;
        },
        computeBoundingRect: function computeBoundingRect() {
          return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            width: 0,
            height: 0
          };
        },
        containsEventTarget: function containsEventTarget() {
          return !0;
        },
        deregisterDocumentInteractionHandler: function deregisterDocumentInteractionHandler() {},
        deregisterInteractionHandler: function deregisterInteractionHandler() {},
        deregisterResizeHandler: function deregisterResizeHandler() {},
        getWindowPageOffset: function getWindowPageOffset() {
          return {
            x: 0,
            y: 0
          };
        },
        isSurfaceActive: function isSurfaceActive() {
          return !0;
        },
        isSurfaceDisabled: function isSurfaceDisabled() {
          return !0;
        },
        isUnbounded: function isUnbounded() {
          return !0;
        },
        registerDocumentInteractionHandler: function registerDocumentInteractionHandler() {},
        registerInteractionHandler: function registerInteractionHandler() {},
        registerResizeHandler: function registerResizeHandler() {},
        removeClass: function removeClass() {},
        updateCssVariable: function updateCssVariable() {}
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.init = function () {
    var t = this,
        n = this.supportsPressRipple_();

    if (this.registerRootHandlers_(n), n) {
      var i = e.cssClasses,
          r = i.ROOT,
          o = i.UNBOUNDED;
      requestAnimationFrame(function () {
        t.adapter_.addClass(r), t.adapter_.isUnbounded() && (t.adapter_.addClass(o), t.layoutInternal_());
      });
    }
  }, e.prototype.destroy = function () {
    var t = this;

    if (this.supportsPressRipple_()) {
      this.activationTimer_ && (clearTimeout(this.activationTimer_), this.activationTimer_ = 0, this.adapter_.removeClass(e.cssClasses.FG_ACTIVATION)), this.fgDeactivationRemovalTimer_ && (clearTimeout(this.fgDeactivationRemovalTimer_), this.fgDeactivationRemovalTimer_ = 0, this.adapter_.removeClass(e.cssClasses.FG_DEACTIVATION));
      var n = e.cssClasses,
          i = n.ROOT,
          r = n.UNBOUNDED;
      requestAnimationFrame(function () {
        t.adapter_.removeClass(i), t.adapter_.removeClass(r), t.removeCssVars_();
      });
    }

    this.deregisterRootHandlers_(), this.deregisterDeactivationHandlers_();
  }, e.prototype.activate = function (t) {
    this.activate_(t);
  }, e.prototype.deactivate = function () {
    this.deactivate_();
  }, e.prototype.layout = function () {
    var t = this;
    this.layoutFrame_ && cancelAnimationFrame(this.layoutFrame_), this.layoutFrame_ = requestAnimationFrame(function () {
      t.layoutInternal_(), t.layoutFrame_ = 0;
    });
  }, e.prototype.setUnbounded = function (t) {
    var n = e.cssClasses.UNBOUNDED;
    t ? this.adapter_.addClass(n) : this.adapter_.removeClass(n);
  }, e.prototype.handleFocus = function () {
    var t = this;
    requestAnimationFrame(function () {
      return t.adapter_.addClass(e.cssClasses.BG_FOCUSED);
    });
  }, e.prototype.handleBlur = function () {
    var t = this;
    requestAnimationFrame(function () {
      return t.adapter_.removeClass(e.cssClasses.BG_FOCUSED);
    });
  }, e.prototype.supportsPressRipple_ = function () {
    return this.adapter_.browserSupportsCssVars();
  }, e.prototype.defaultActivationState_ = function () {
    return {
      activationEvent: void 0,
      hasDeactivationUXRun: !1,
      isActivated: !1,
      isProgrammatic: !1,
      wasActivatedByPointer: !1,
      wasElementMadeActive: !1
    };
  }, e.prototype.registerRootHandlers_ = function (t) {
    var e = this;
    t && (Cn.forEach(function (t) {
      e.adapter_.registerInteractionHandler(t, e.activateHandler_);
    }), this.adapter_.isUnbounded() && this.adapter_.registerResizeHandler(this.resizeHandler_)), this.adapter_.registerInteractionHandler("focus", this.focusHandler_), this.adapter_.registerInteractionHandler("blur", this.blurHandler_);
  }, e.prototype.registerDeactivationHandlers_ = function (t) {
    var e = this;
    "keydown" === t.type ? this.adapter_.registerInteractionHandler("keyup", this.deactivateHandler_) : An.forEach(function (t) {
      e.adapter_.registerDocumentInteractionHandler(t, e.deactivateHandler_);
    });
  }, e.prototype.deregisterRootHandlers_ = function () {
    var t = this;
    Cn.forEach(function (e) {
      t.adapter_.deregisterInteractionHandler(e, t.activateHandler_);
    }), this.adapter_.deregisterInteractionHandler("focus", this.focusHandler_), this.adapter_.deregisterInteractionHandler("blur", this.blurHandler_), this.adapter_.isUnbounded() && this.adapter_.deregisterResizeHandler(this.resizeHandler_);
  }, e.prototype.deregisterDeactivationHandlers_ = function () {
    var t = this;
    this.adapter_.deregisterInteractionHandler("keyup", this.deactivateHandler_), An.forEach(function (e) {
      t.adapter_.deregisterDocumentInteractionHandler(e, t.deactivateHandler_);
    });
  }, e.prototype.removeCssVars_ = function () {
    var t = this,
        n = e.strings;
    Object.keys(n).forEach(function (e) {
      0 === e.indexOf("VAR_") && t.adapter_.updateCssVariable(n[e], null);
    });
  }, e.prototype.activate_ = function (t) {
    var e = this;

    if (!this.adapter_.isSurfaceDisabled()) {
      var n = this.activationState_;

      if (!n.isActivated) {
        var i = this.previousActivationEvent_;
        if (!(i && void 0 !== t && i.type !== t.type)) n.isActivated = !0, n.isProgrammatic = void 0 === t, n.activationEvent = t, n.wasActivatedByPointer = !n.isProgrammatic && void 0 !== t && ("mousedown" === t.type || "touchstart" === t.type || "pointerdown" === t.type), void 0 !== t && Tn.length > 0 && Tn.some(function (t) {
          return e.adapter_.containsEventTarget(t);
        }) ? this.resetActivationState_() : (void 0 !== t && (Tn.push(t.target), this.registerDeactivationHandlers_(t)), n.wasElementMadeActive = this.checkElementMadeActive_(t), n.wasElementMadeActive && this.animateActivation_(), requestAnimationFrame(function () {
          Tn = [], n.wasElementMadeActive || void 0 === t || " " !== t.key && 32 !== t.keyCode || (n.wasElementMadeActive = e.checkElementMadeActive_(t), n.wasElementMadeActive && e.animateActivation_()), n.wasElementMadeActive || (e.activationState_ = e.defaultActivationState_());
        }));
      }
    }
  }, e.prototype.checkElementMadeActive_ = function (t) {
    return void 0 === t || "keydown" !== t.type || this.adapter_.isSurfaceActive();
  }, e.prototype.animateActivation_ = function () {
    var t = this,
        n = e.strings,
        i = n.VAR_FG_TRANSLATE_START,
        r = n.VAR_FG_TRANSLATE_END,
        o = e.cssClasses,
        a = o.FG_DEACTIVATION,
        s = o.FG_ACTIVATION,
        c = e.numbers.DEACTIVATION_TIMEOUT_MS;
    this.layoutInternal_();
    var u = "",
        l = "";

    if (!this.adapter_.isUnbounded()) {
      var d = this.getFgTranslationCoordinates_(),
          h = d.startPoint,
          p = d.endPoint;
      u = h.x + "px, " + h.y + "px", l = p.x + "px, " + p.y + "px";
    }

    this.adapter_.updateCssVariable(i, u), this.adapter_.updateCssVariable(r, l), clearTimeout(this.activationTimer_), clearTimeout(this.fgDeactivationRemovalTimer_), this.rmBoundedActivationClasses_(), this.adapter_.removeClass(a), this.adapter_.computeBoundingRect(), this.adapter_.addClass(s), this.activationTimer_ = setTimeout(function () {
      return t.activationTimerCallback_();
    }, c);
  }, e.prototype.getFgTranslationCoordinates_ = function () {
    var t,
        e = this.activationState_,
        n = e.activationEvent;
    return {
      startPoint: t = {
        x: (t = e.wasActivatedByPointer ? function (t, e, n) {
          if (!t) return {
            x: 0,
            y: 0
          };
          var i,
              r,
              o = e.x,
              a = e.y,
              s = o + n.left,
              c = a + n.top;

          if ("touchstart" === t.type) {
            var u = t;
            i = u.changedTouches[0].pageX - s, r = u.changedTouches[0].pageY - c;
          } else {
            var l = t;
            i = l.pageX - s, r = l.pageY - c;
          }

          return {
            x: i,
            y: r
          };
        }(n, this.adapter_.getWindowPageOffset(), this.adapter_.computeBoundingRect()) : {
          x: this.frame_.width / 2,
          y: this.frame_.height / 2
        }).x - this.initialSize_ / 2,
        y: t.y - this.initialSize_ / 2
      },
      endPoint: {
        x: this.frame_.width / 2 - this.initialSize_ / 2,
        y: this.frame_.height / 2 - this.initialSize_ / 2
      }
    };
  }, e.prototype.runDeactivationUXLogicIfReady_ = function () {
    var t = this,
        n = e.cssClasses.FG_DEACTIVATION,
        i = this.activationState_,
        r = i.hasDeactivationUXRun,
        o = i.isActivated;
    (r || !o) && this.activationAnimationHasEnded_ && (this.rmBoundedActivationClasses_(), this.adapter_.addClass(n), this.fgDeactivationRemovalTimer_ = setTimeout(function () {
      t.adapter_.removeClass(n);
    }, En.FG_DEACTIVATION_MS));
  }, e.prototype.rmBoundedActivationClasses_ = function () {
    var t = e.cssClasses.FG_ACTIVATION;
    this.adapter_.removeClass(t), this.activationAnimationHasEnded_ = !1, this.adapter_.computeBoundingRect();
  }, e.prototype.resetActivationState_ = function () {
    var t = this;
    this.previousActivationEvent_ = this.activationState_.activationEvent, this.activationState_ = this.defaultActivationState_(), setTimeout(function () {
      return t.previousActivationEvent_ = void 0;
    }, e.numbers.TAP_DELAY_MS);
  }, e.prototype.deactivate_ = function () {
    var t = this,
        e = this.activationState_;

    if (e.isActivated) {
      var n = _jt({}, e);

      e.isProgrammatic ? (requestAnimationFrame(function () {
        return t.animateDeactivation_(n);
      }), this.resetActivationState_()) : (this.deregisterDeactivationHandlers_(), requestAnimationFrame(function () {
        t.activationState_.hasDeactivationUXRun = !0, t.animateDeactivation_(n), t.resetActivationState_();
      }));
    }
  }, e.prototype.animateDeactivation_ = function (t) {
    var e = t.wasActivatedByPointer,
        n = t.wasElementMadeActive;
    (e || n) && this.runDeactivationUXLogicIfReady_();
  }, e.prototype.layoutInternal_ = function () {
    var t = this;
    this.frame_ = this.adapter_.computeBoundingRect();
    var n = Math.max(this.frame_.height, this.frame_.width);
    this.maxRadius_ = this.adapter_.isUnbounded() ? n : Math.sqrt(Math.pow(t.frame_.width, 2) + Math.pow(t.frame_.height, 2)) + e.numbers.PADDING, this.initialSize_ = Math.floor(n * e.numbers.INITIAL_ORIGIN_SCALE), this.fgScale_ = "" + this.maxRadius_ / this.initialSize_, this.updateLayoutCssVars_();
  }, e.prototype.updateLayoutCssVars_ = function () {
    var t = e.strings,
        n = t.VAR_FG_SIZE,
        i = t.VAR_LEFT,
        r = t.VAR_TOP,
        o = t.VAR_FG_SCALE;
    this.adapter_.updateCssVariable(n, this.initialSize_ + "px"), this.adapter_.updateCssVariable(o, this.fgScale_), this.adapter_.isUnbounded() && (this.unboundedCoords_ = {
      left: Math.round(this.frame_.width / 2 - this.initialSize_ / 2),
      top: Math.round(this.frame_.height / 2 - this.initialSize_ / 2)
    }, this.adapter_.updateCssVariable(i, this.unboundedCoords_.left + "px"), this.adapter_.updateCssVariable(r, this.unboundedCoords_.top + "px"));
  }, e;
}(Yt),
    On = (function (t) {
  function e() {
    var e = null !== t && t.apply(this, arguments) || this;
    return e.disabled = !1, e;
  }

  Vt(e, t), e.attachTo = function (t, n) {
    void 0 === n && (n = {
      isUnbounded: void 0
    });
    var i = new e(t);
    return void 0 !== n.isUnbounded && (i.unbounded = n.isUnbounded), i;
  }, e.createAdapter = function (t) {
    return {
      addClass: function addClass(e) {
        return t.root_.classList.add(e);
      },
      browserSupportsCssVars: function browserSupportsCssVars() {
        return _n(window);
      },
      computeBoundingRect: function computeBoundingRect() {
        return t.root_.getBoundingClientRect();
      },
      containsEventTarget: function containsEventTarget(e) {
        return t.root_.contains(e);
      },
      deregisterDocumentInteractionHandler: function deregisterDocumentInteractionHandler(t, e) {
        return document.documentElement.removeEventListener(t, e, gn());
      },
      deregisterInteractionHandler: function deregisterInteractionHandler(e, n) {
        return t.root_.removeEventListener(e, n, gn());
      },
      deregisterResizeHandler: function deregisterResizeHandler(t) {
        return window.removeEventListener("resize", t);
      },
      getWindowPageOffset: function getWindowPageOffset() {
        return {
          x: window.pageXOffset,
          y: window.pageYOffset
        };
      },
      isSurfaceActive: function isSurfaceActive() {
        return Zt(t.root_, ":active");
      },
      isSurfaceDisabled: function isSurfaceDisabled() {
        return Boolean(t.disabled);
      },
      isUnbounded: function isUnbounded() {
        return Boolean(t.unbounded);
      },
      registerDocumentInteractionHandler: function registerDocumentInteractionHandler(t, e) {
        return document.documentElement.addEventListener(t, e, gn());
      },
      registerInteractionHandler: function registerInteractionHandler(e, n) {
        return t.root_.addEventListener(e, n, gn());
      },
      registerResizeHandler: function registerResizeHandler(t) {
        return window.addEventListener("resize", t);
      },
      removeClass: function removeClass(e) {
        return t.root_.classList.remove(e);
      },
      updateCssVariable: function updateCssVariable(e, n) {
        return t.root_.style.setProperty(e, n);
      }
    };
  }, Object.defineProperty(e.prototype, "unbounded", {
    get: function get() {
      return Boolean(this.unbounded_);
    },
    set: function set(t) {
      this.unbounded_ = Boolean(t), this.setUnbounded_();
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.activate = function () {
    this.foundation_.activate();
  }, e.prototype.deactivate = function () {
    this.foundation_.deactivate();
  }, e.prototype.layout = function () {
    this.foundation_.layout();
  }, e.prototype.getDefaultFoundation = function () {
    return new In(e.createAdapter(this));
  }, e.prototype.initialSyncWithDOM = function () {
    var t = this.root_;
    this.unbounded = "mdcRippleIsUnbounded" in t.dataset;
  }, e.prototype.setUnbounded_ = function () {
    this.foundation_.setUnbounded(Boolean(this.unbounded_));
  };
}($t), function () {
  var _t9 = function t(e, n) {
    return (_t9 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var n in e) {
        e.hasOwnProperty(n) && (t[n] = e[n]);
      }
    })(e, n);
  };

  return function (e, n) {
    function i() {
      this.constructor = e;
    }

    _t9(e, n), e.prototype = null === n ? Object.create(n) : (i.prototype = n.prototype, new i());
  };
}()),
    _Sn = function Sn() {
  return (_Sn = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    wn = function wn(t, e) {
  var n = {};

  for (var i in t) {
    Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
  }

  if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
    var r = 0;

    for (i = Object.getOwnPropertySymbols(t); r < i.length; r++) {
      e.indexOf(i[r]) < 0 && (n[i[r]] = t[i[r]]);
    }
  }

  return n;
},
    xn = e({}),
    Nn = function (t) {
  function e(e) {
    var n = t.call(this, e) || this;
    return n.root = n.createElement("root"), n.surface = n.createElement("surface"), n.isTouched = !1, n.handleFocus = n.handleFocus.bind(n), n.handleBlur = n.handleBlur.bind(n), n.handleMouseDown = n.handleMouseDown.bind(n), n.handleMouseUp = n.handleMouseUp.bind(n), n.handleTouchStart = n.handleTouchStart.bind(n), n.handleTouchEnd = n.handleTouchEnd.bind(n), n.handleKeyDown = n.handleKeyDown.bind(n), n.handleKeyUp = n.handleKeyUp.bind(n), n;
  }

  return On(e, t), e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new In({
      browserSupportsCssVars: function browserSupportsCssVars() {
        return _n(window);
      },
      isUnbounded: function isUnbounded() {
        return !!t.props.unbounded;
      },
      isSurfaceActive: function isSurfaceActive() {
        return !!t.root.ref && yt(t.root.ref, ":active");
      },
      isSurfaceDisabled: function isSurfaceDisabled() {
        return !!t.props.disabled;
      },
      addClass: function addClass(e) {
        return t.surface.addClass(e);
      },
      removeClass: function removeClass(e) {
        return t.surface.removeClass(e);
      },
      containsEventTarget: function containsEventTarget(e) {
        return !!t.root.ref && t.root.ref.contains(e);
      },
      registerInteractionHandler: function registerInteractionHandler(e, n) {
        return t.root.addEventListener(e, n);
      },
      deregisterInteractionHandler: function deregisterInteractionHandler(e, n) {
        return t.root.removeEventListener(e, n);
      },
      registerDocumentInteractionHandler: function registerDocumentInteractionHandler(t, e) {
        return document.documentElement.addEventListener(t, e, gn());
      },
      deregisterDocumentInteractionHandler: function deregisterDocumentInteractionHandler(t, e) {
        return document.documentElement.removeEventListener(t, e, gn());
      },
      registerResizeHandler: function registerResizeHandler(t) {
        return window.addEventListener("resize", t);
      },
      deregisterResizeHandler: function deregisterResizeHandler(t) {
        return window.removeEventListener("resize", t);
      },
      updateCssVariable: function updateCssVariable(e, n) {
        return t.surface.setStyle(e, n);
      },
      computeBoundingRect: function computeBoundingRect() {
        return t.root.ref ? t.root.ref.getBoundingClientRect() : {
          width: 0,
          height: 0
        };
      },
      getWindowPageOffset: function getWindowPageOffset() {
        return {
          x: window.pageXOffset,
          y: window.pageYOffset
        };
      }
    });
  }, e.prototype.sync = function (t, e) {
    this.root.setRef(_(this)), t.unbounded !== e.unbounded && this.foundation.setUnbounded(!!t.unbounded);
  }, e.prototype.handleFocus = function (t) {
    this.props.onFocus && this.props.onFocus(t), this.foundation && this.foundation.handleFocus();
  }, e.prototype.handleBlur = function (t) {
    this.props.onBlur && this.props.onBlur(t), this.foundation.handleBlur();
  }, e.prototype.handleMouseDown = function (t) {
    this.props.onMouseDown && this.props.onMouseDown(t), this.isTouched || this.activateRipple(t), this.isTouched = !1;
  }, e.prototype.handleMouseUp = function (t) {
    this.props.onMouseUp && this.props.onMouseUp(t), this.deactivateRipple(t);
  }, e.prototype.handleTouchStart = function (t) {
    this.isTouched = !0, this.props.onTouchStart && this.props.onTouchStart(t), this.activateRipple(t);
  }, e.prototype.handleTouchEnd = function (t) {
    this.props.onTouchEnd && this.props.onTouchEnd(t), this.deactivateRipple(t);
  }, e.prototype.handleKeyDown = function (t) {
    this.props.onKeyDown && this.props.onKeyDown(t), this.activateRipple(t);
  }, e.prototype.handleKeyUp = function (t) {
    this.props.onKeyUp && this.props.onKeyUp(t), this.deactivateRipple(t);
  }, e.prototype.activateRipple = function (t) {
    t.persist(), this.foundation.activate(t);
  }, e.prototype.deactivateRipple = function (t) {
    t.persist(), this.foundation.deactivate();
  }, e.prototype.render = function () {
    var t = this.props,
        e = t.children,
        i = t.className,
        r = t.primary,
        c = t.accent,
        u = t.unbounded,
        l = t.surface,
        d = wn(t, ["children", "className", "primary", "accent", "unbounded", "surface"]),
        h = s.only(e);
    if (!a(h)) return null;

    var p = u ? {
      "data-mdc-ripple-is-unbounded": !0
    } : {},
        f = !l || !u ? this.surface.props({
      style: h.props.style
    }) : {},
        _ = m(i, f.className, h.props.className, {
      "mdc-ripple-surface": "boolean" == typeof l ? l : void 0 === l,
      "mdc-ripple-surface--primary": r,
      "mdc-ripple-surface--accent": c
    });

    d.disabled && (_ = _.replace("mdc-ripple-upgraded--background-focused", ""));
    var g = o(h, _Sn({}, h.props, p, this.root.props(_Sn({}, d, {
      style: h.props.style
    }, f, {
      className: _
    })), {
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      onMouseDown: this.handleMouseDown,
      onMouseUp: this.handleMouseUp,
      onTouchStart: this.handleTouchStart,
      onTouchEnd: this.handleTouchEnd,
      onKeyDown: this.handleKeyDown,
      onKeyUp: this.handleKeyUp
    }));
    return n(xn.Provider, {
      value: this.surface.props({
        style: h.props.style
      })
    }, g);
  }, e.shouldDebounce = !0, e.displayName = "Ripple", e;
}(Rt),
    Rn = function Rn(t) {
  var e = t.className,
      i = wn(t, ["className"]);
  return n(xn.Consumer, null, function (t) {
    return n("div", _Sn({}, i, t, {
      className: e + " " + (t.className || "")
    }));
  });
},
    Ln = function Ln(t) {
  var e = void 0 === t ? {} : t,
      i = e.unbounded,
      o = e.accent,
      a = e.surface;
  return function (t) {
    var e = un()(r(function (e, r) {
      var s = e.providerContext,
          c = e.ripple,
          u = void 0 === c ? s.ripple : c,
          l = wn(e, ["providerContext", "ripple"]),
          d = "object" != typeof u ? {} : u;
      return (l.accent || l.unbounded || l.surface) && (ft("'accent', 'unbounded', and 'surface' have been deprecated as indiviudal props. Please pass an options object to the ripple prop directly. ripple={{accent: true, unbounded: true}} "), d.accent = l.accent || d.accent, d.unbounded = l.unbounded || d.unbounded, d.surface = l.surface || d.surface), u ? n(Nn, _Sn({}, l, {
        accent: d.accent || o,
        unbounded: d.unbounded || i,
        surface: d.surface || a
      }), n(t, _Sn({}, l, {
        ref: r
      }))) : n(t, _Sn({}, l, {
        ref: r
      }));
    }));
    return e.displayName = "withRipple(" + (t.displayName || "Unknown") + ")", e;
  };
},
    Dn = function () {
  var _t10 = function t(e, n) {
    return (_t10 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var n in e) {
        e.hasOwnProperty(n) && (t[n] = e[n]);
      }
    })(e, n);
  };

  return function (e, n) {
    function i() {
      this.constructor = e;
    }

    _t10(e, n), e.prototype = null === n ? Object.create(n) : (i.prototype = n.prototype, new i());
  };
}(),
    _kn = function kn() {
  return (_kn = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    Pn = function Pn(t, e) {
  var n = {};

  for (var i in t) {
    Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
  }

  if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
    var r = 0;

    for (i = Object.getOwnPropertySymbols(t); r < i.length; r++) {
      e.indexOf(i[r]) < 0 && (n[i[r]] = t[i[r]]);
    }
  }

  return n;
},
    Fn = Ln({
  surface: !1
})(Mt({
  displayName: "TabRoot",
  tag: "button",
  classNames: function classNames(t) {
    return ["mdc-tab", {
      "mdc-tab--stacked": t.stacked
    }];
  },
  consumeProps: ["stacked"]
})),
    Mn = Mt({
  displayName: "TabIcon",
  tag: mn,
  classNames: ["mdc-tab__icon"]
}),
    Hn = function (t) {
  return function (e) {
    return n(W.Consumer, null, function (i) {
      return n(t, _q({}, e, {
        contextApi: i
      }));
    });
  };
}(((vn = function (t) {
  function e(e) {
    var n = t.call(this, e) || this;
    return n._id = bt("tab"), n.root = n.createElement("root"), n.tabIndicator = null, n.content = null, n.props.contextApi && n.props.contextApi.registerTab(n), n.handleClick = n.handleClick.bind(n), n;
  }

  return Dn(e, t), e.prototype.componentWillUnmount = function () {
    this.props.contextApi && this.props.contextApi.unregisterTab(this);
  }, Object.defineProperty(e.prototype, "id", {
    get: function get() {
      return this.props.id ? this.props.id : this._reactInternalFiber.key || this._id;
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new we({
      setAttr: function setAttr(e, n) {
        return t.root.setProp(e, n);
      },
      addClass: function addClass(e) {
        return t.root.addClass(e);
      },
      removeClass: function removeClass(e) {
        return t.root.removeClass(e);
      },
      hasClass: function hasClass(e) {
        return t.root.hasClass(e);
      },
      activateIndicator: function activateIndicator(e) {
        return t.tabIndicator && t.tabIndicator.activate(e);
      },
      deactivateIndicator: function deactivateIndicator() {
        return t.tabIndicator && t.tabIndicator.deactivate();
      },
      notifyInteracted: function notifyInteracted() {
        var e = t.emit("onInteraction", {
          tabId: t.id
        }, !0);
        t.props.contextApi && t.props.contextApi.onTabInteraction(e);
      },
      getOffsetLeft: function getOffsetLeft() {
        return t.root.ref ? t.root.ref.offsetLeft : 0;
      },
      getOffsetWidth: function getOffsetWidth() {
        return t.root.ref ? t.root.ref.offsetWidth : 0;
      },
      getContentOffsetLeft: function getContentOffsetLeft() {
        return t.content ? t.content.offsetLeft : 0;
      },
      getContentOffsetWidth: function getContentOffsetWidth() {
        return t.content ? t.content.offsetWidth : 0;
      },
      focus: function focus() {
        return t.root.ref && t.root.ref.focus && t.root.ref.focus();
      }
    });
  }, e.prototype.handleClick = function (t) {
    this.props.onClick && this.props.onClick(t), this.foundation.handleClick();
  }, Object.defineProperty(e.prototype, "active", {
    get: function get() {
      return this.foundation.isActive();
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "focusOnActivate", {
    set: function set(t) {
      this.foundation.setFocusOnActivate(t);
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.activate = function (t) {
    this.foundation.activate(t);
  }, e.prototype.deactivate = function () {
    this.foundation.deactivate();
  }, e.prototype.computeIndicatorClientRect = function () {
    return this.tabIndicator && this.tabIndicator.computeContentClientRect();
  }, e.prototype.computeDimensions = function () {
    return this.foundation.computeDimensions();
  }, e.prototype.focus = function () {
    this.root.ref && this.root.ref && this.root.ref.focus();
  }, e.prototype.render = function () {
    var t = this,
        e = this.props,
        i = e.children,
        r = e.label,
        o = e.icon,
        a = e.stacked,
        s = e.restrictIndicator,
        c = (e.contextApi, Pn(e, ["children", "label", "icon", "stacked", "restrictIndicator", "contextApi"]));
    return n(Fn, _kn({}, this.root.props(c), {
      onClick: this.handleClick,
      stacked: a,
      ref: this.root.setRef,
      ripple: {
        surface: !1
      }
    }), n("div", {
      className: "mdc-tab__content",
      ref: function ref(e) {
        return t.content = e;
      }
    }, !!o && n(Mn, {
      icon: o
    }), (void 0 !== i || void 0 !== r) && n("span", {
      className: "mdc-tab__text-label"
    }, r, i), !!s && n(an, {
      ref: function ref(e) {
        return t.tabIndicator = e;
      }
    })), !s && n(an, {
      ref: function ref(e) {
        return t.tabIndicator = e;
      }
    }), n(Rn, {
      className: "mdc-tab__ripple"
    }));
  }, e;
}(Rt)).displayName = "TabFoundation", vn));

Hn.displayName = "Tab";

var Bn =
/*#__PURE__*/
function () {
  function Bn(t) {
    _classCallCheck(this, Bn);

    this.data = t;
  }

  _createClass(Bn, [{
    key: "classnames",
    value: function classnames(t, e) {
      var n = this.preparePrivateClassnames(t);
      var i = this.prepareClassnames(t);
      return e && (Array.isArray(e) ? i = i.concat(m(e)) : i.push(e)), m(i.concat(n));
    }
  }, {
    key: "prepareClassnames",
    value: function prepareClassnames(t) {
      if (this.data.classNames) {
        var _e2;

        if (_e2 = "function" == typeof this.data.classNames ? this.data.classNames(t) : this.data.classNames) return _e2;
      }

      return [];
    }
  }, {
    key: "preparePrivateClassnames",
    value: function preparePrivateClassnames(t) {
      var e = this.data.privateStyles;

      if (this.data.privateClassNames) {
        var _n2;

        if (_n2 = "function" == typeof this.data.privateClassNames ? this.data.privateClassNames(t) : this.data.privateClassNames) return _n2.map(function (t) {
          return Array.isArray(t) ? t.map(function (t) {
            return e[t];
          }) : "object" == typeof t ? Object.keys(t).map(function (n) {
            return t[n] ? e[n] : "";
          }) : e[t];
        });
      }

      return [];
    }
  }]);

  return Bn;
}();

var Vn,
    jn,
    Un = {
  LINE_RIPPLE_ACTIVE: "mdc-line-ripple--active",
  LINE_RIPPLE_DEACTIVATING: "mdc-line-ripple--deactivating"
},
    Gn = function (t) {
  function e(n) {
    var i = t.call(this, _jt({}, e.defaultAdapter, n)) || this;
    return i.transitionEndHandler_ = function (t) {
      return i.handleTransitionEnd(t);
    }, i;
  }

  return Vt(e, t), Object.defineProperty(e, "cssClasses", {
    get: function get() {
      return Un;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultAdapter", {
    get: function get() {
      return {
        addClass: function addClass() {},
        removeClass: function removeClass() {},
        hasClass: function hasClass() {
          return !1;
        },
        setStyle: function setStyle() {},
        registerEventHandler: function registerEventHandler() {},
        deregisterEventHandler: function deregisterEventHandler() {}
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.init = function () {
    this.adapter_.registerEventHandler("transitionend", this.transitionEndHandler_);
  }, e.prototype.destroy = function () {
    this.adapter_.deregisterEventHandler("transitionend", this.transitionEndHandler_);
  }, e.prototype.activate = function () {
    this.adapter_.removeClass(Un.LINE_RIPPLE_DEACTIVATING), this.adapter_.addClass(Un.LINE_RIPPLE_ACTIVE);
  }, e.prototype.setRippleCenter = function (t) {
    this.adapter_.setStyle("transform-origin", t + "px center");
  }, e.prototype.deactivate = function () {
    this.adapter_.addClass(Un.LINE_RIPPLE_DEACTIVATING);
  }, e.prototype.handleTransitionEnd = function (t) {
    var e = this.adapter_.hasClass(Un.LINE_RIPPLE_DEACTIVATING);
    "opacity" === t.propertyName && e && (this.adapter_.removeClass(Un.LINE_RIPPLE_ACTIVE), this.adapter_.removeClass(Un.LINE_RIPPLE_DEACTIVATING));
  }, e;
}(Yt),
    zn = (function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  Vt(e, t), e.attachTo = function (t) {
    return new e(t);
  }, e.prototype.activate = function () {
    this.foundation_.activate();
  }, e.prototype.deactivate = function () {
    this.foundation_.deactivate();
  }, e.prototype.setRippleCenter = function (t) {
    this.foundation_.setRippleCenter(t);
  }, e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new Gn({
      addClass: function addClass(e) {
        return t.root_.classList.add(e);
      },
      removeClass: function removeClass(e) {
        return t.root_.classList.remove(e);
      },
      hasClass: function hasClass(e) {
        return t.root_.classList.contains(e);
      },
      setStyle: function setStyle(e, n) {
        return t.root_.style.setProperty(e, n);
      },
      registerEventHandler: function registerEventHandler(e, n) {
        return t.listen(e, n);
      },
      deregisterEventHandler: function deregisterEventHandler(e, n) {
        return t.unlisten(e, n);
      }
    });
  };
}($t), function () {
  var _t11 = function t(e, n) {
    return (_t11 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var n in e) {
        e.hasOwnProperty(n) && (t[n] = e[n]);
      }
    })(e, n);
  };

  return function (e, n) {
    function i() {
      this.constructor = e;
    }

    _t11(e, n), e.prototype = null === n ? Object.create(n) : (i.prototype = n.prototype, new i());
  };
}()),
    _Kn = function Kn() {
  return (_Kn = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    qn = function qn(t, e) {
  var n = {};

  for (var i in t) {
    Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
  }

  if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
    var r = 0;

    for (i = Object.getOwnPropertySymbols(t); r < i.length; r++) {
      e.indexOf(i[r]) < 0 && (n[i[r]] = t[i[r]]);
    }
  }

  return n;
},
    Wn = function (t) {
  function e() {
    var e = null !== t && t.apply(this, arguments) || this;
    return e.root = e.createElement("root"), e;
  }

  return zn(e, t), e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new Gn({
      addClass: function addClass(e) {
        return t.root.addClass(e);
      },
      removeClass: function removeClass(e) {
        return t.root.removeClass(e);
      },
      hasClass: function hasClass(e) {
        return t.root.hasClass(e);
      },
      setStyle: function setStyle(e, n) {
        return t.root.setStyle(e, n);
      },
      registerEventHandler: function registerEventHandler(e, n) {
        return t.root.addEventListener(e, n);
      },
      deregisterEventHandler: function deregisterEventHandler(e, n) {
        return t.root.removeEventListener(e, n);
      }
    });
  }, e.prototype.sync = function (t, e) {
    var n = this;
    this.syncProp(t.active, e.active, function () {
      t.active ? n.foundation.activate() : n.foundation.deactivate();
    }), this.syncProp(t.center, e.center, function () {
      "number" == typeof t.center && n.foundation.setRippleCenter(t.center);
    });
  }, e.prototype.render = function () {
    var t = this.props,
        e = (t.active, t.center, qn(t, ["active", "center"]));
    return n("div", _Kn({}, this.root.props(_Kn({}, e, {
      className: "mdc-line-ripple " + (this.props.className || "")
    })), {
      ref: this.root.setRef
    }));
  }, e.displayName = "LineRipple", e;
}(Rt),
    Xn = {
  grid: "mib-pgrid-grid-1o05W",
  row: "mib-pgrid-row-1YMLs",
  "select-mode": "mib-pgrid-select-mode-3UKCT",
  "row-collapsable": "mib-pgrid-row-collapsable-evsMa",
  "row-collapsable-body": "mib-pgrid-row-collapsable-body-3MJ2N",
  "row-category-body": "mib-pgrid-row-category-body-273JG",
  row_theme: "mib-pgrid-row_theme-18-_u",
  invalid: "mib-pgrid-invalid-24Zdt",
  "toolbar-row": "mib-pgrid-toolbar-row-3PbFo",
  expanded: "mib-pgrid-expanded-2eKoZ",
  row_c__expanded: "mib-pgrid-row_c__expanded-313_q",
  row_c_dd_ico: "mib-pgrid-row_c_dd_ico-3vRIN",
  row_c__focused: "mib-pgrid-row_c__focused-14azA",
  row_c_lbl: "mib-pgrid-row_c_lbl-3Q6rZ",
  "icon-txt--cancel": "mib-pgrid-icon-txt--cancel-17L10",
  "txt-edit": "mib-pgrid-txt-edit-3Zk6I",
  "hide-label": "mib-pgrid-hide-label-1xOBk",
  "dd-edit": "mib-pgrid-dd-edit-1jhQk",
  disabled: "mib-pgrid-disabled-2N_ab"
};

var Yn =
/*#__PURE__*/
function () {
  function Yn(t) {
    _classCallCheck(this, Yn);

    this.data = t;
  }

  _createClass(Yn, [{
    key: "type",
    get: function get() {
      return this.data.type;
    }
  }, {
    key: "objectType",
    get: function get() {
      return this.data.objectType;
    }
  }, {
    key: "propertyPath",
    get: function get() {
      return this.data.propertyPath;
    }
  }, {
    key: "array",
    get: function get() {
      return this.data.array;
    }
  }, {
    key: "description",
    get: function get() {
      return this.data.description;
    }
  }, {
    key: "selectionOptions",
    get: function get() {
      return this.data.selectionOptions;
    }
  }, {
    key: "toStringFunction",
    get: function get() {
      return this.data.toStringFunction;
    }
  }, {
    key: "defaultValue",
    get: function get() {
      return this.data.defaultValue;
    }
  }, {
    key: "disabled",
    get: function get() {
      return this.data.disabled;
    }
  }, {
    key: "customValidation",
    get: function get() {
      return this.data.customValidation;
    }
  }, {
    key: "customHandling",
    get: function get() {
      return this.data.customHandling;
    }
  }, {
    key: "optional",
    get: function get() {
      return this.data.optional;
    }
  }, {
    key: "defaultCreate",
    get: function get() {
      return this.data.defaultCreate;
    }
  }, {
    key: "tab",
    get: function get() {
      return this.data.tab;
    }
  }, {
    key: "category",
    get: function get() {
      return this.data.category;
    }
  }, {
    key: "html",
    get: function get() {
      return this.data.html;
    }
  }, {
    key: "sortOrder",
    get: function get() {
      return this.data.sortOrder;
    }
  }, {
    key: "name",
    get: function get() {
      if (this.propertyPath) {
        var _t12 = this.propertyPath.lastIndexOf(".");

        return _t12 > -1 ? this.propertyPath.substring(_t12 + 1) : this.propertyPath;
      }

      return "";
    }
  }]);

  return Yn;
}();

var $n = function $n(t) {
  _classCallCheck(this, $n);

  this.data = t;
};

var Qn = function Qn() {
  _classCallCheck(this, Qn);

  this.acceptValue = !0, this.message = "", this.currentResult = !0;
};

!function (t) {
  t.number = "number", t.boolean = "boolean", t.string = "string", t.object = "object";
}(Vn || (Vn = {})), function (t) {
  t.Date = "Date";
}(jn || (jn = {}));
var Zn,
    Jn,
    ti = Object.freeze({
  PropertyDescriptorSet:
  /*#__PURE__*/
  function () {
    function PropertyDescriptorSet(t) {
      var _this = this;

      _classCallCheck(this, PropertyDescriptorSet);

      this.properties = new Map(), t && t.forEach(function (t) {
        t.propertyPath && _this.properties.set(t.propertyPath.toLowerCase(), new Yn(t));
      });
    }

    _createClass(PropertyDescriptorSet, [{
      key: "getProperty",
      value: function getProperty(t) {
        return t ? this.properties.get(t.toLowerCase()) : void 0;
      }
    }, {
      key: "getUndefinedProperties",
      value: function getUndefinedProperties(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        var n = [];
        return t && this.properties.forEach(function (i) {
          var r = i.propertyPath;
          r && (e && (e.endsWith(".") || (e += "."), r = r.startsWith(e) ? r.substring(e.length) : ""), (r = r.toLowerCase()) && r.indexOf(".") < 0 && !t.includes(r) && n.push(i));
        }), n;
      }
    }, {
      key: "validate",
      value: function validate(t, e, n) {
        return e && (e.html && (e.html.required && !t && !1 !== t && 0 !== t ? (n.message = "Please fill out this field.", n.currentResult = !1) : t && ("string" == typeof t ? e.html.pattern && !RegExp(e.html.pattern).test(t) ? (n.message = "Please match the requested format (".concat(e.html.pattern, ")."), n.currentResult = !1) : void 0 !== e.html.minLength && t.length < e.html.minLength ? (n.message = "Please lengthen this text to ".concat(e.html.minLength, " characters or more (you are currently using ").concat(t.length, " characters)."), n.currentResult = !1) : void 0 !== e.html.maxLength && t.length > e.html.maxLength && (n.message = "Please shorten this text to ".concat(e.html.maxLength, " characters or less (you are currently using ").concat(t.length, " characters)."), n.currentResult = !1) : "number" == typeof t && (void 0 !== e.html.min && t < e.html.min ? (n.message = "Value must be greater than or equal to ".concat(e.html.min, "."), n.currentResult = !1) : void 0 !== e.html.max && t > e.html.max && (n.message = "Value must be less than or equal to ".concat(e.html.max, "."), n.currentResult = !1)))), e.customValidation) ? e.customValidation(t, n) : n.currentResult;
      }
    }]);

    return PropertyDescriptorSet;
  }(),
  PropertyDescriptor: Yn,
  CustomHandlingArgs: $n,
  ValidationEventArgs: Qn,

  get CoreTypes() {
    return Vn;
  },

  get CommonObjectTypes() {
    return jn;
  }

});

function ei(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 56;
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 40;
  return t.reduce(function (t, e) {
    return t + e.calculateHeight();
  }, n);
}

!function (t) {
  t.all = "all", t.error = "error", t.label = "label", t.value = "value";
}(Zn || (Zn = {})), function (t) {
  t[t.default = 0] = "default", t[t.search = 1] = "search", t[t.tabs = 2] = "tabs";
}(Jn || (Jn = {}));

var ni =
/*#__PURE__*/
function () {
  function ni(t, e, n, i) {
    _classCallCheck(this, ni);

    this.data = t, this.onStateChangedCallback = e, this.descriptorSet = n, this.implicitPropertyCreation = i, this._filter = "", this._globalIdCounter = 0, this._rootIdCounter = 0, this.filterMode = Zn.all, this.gridView = Jn.default, this._rootRow = new ri(this.generateUniqueRootRowID(), t, this);
  }

  _createClass(ni, [{
    key: "refreshData",
    value: function refreshData(t) {
      return this.data !== t && (this.data = t, this._rootRow = new ri(this.generateUniqueRootRowID(), t, this), this._categories = void 0, this._tabs = void 0, this._globalIdCounter = 0, !0);
    }
  }, {
    key: "generateUniqueRootRowID",
    value: function generateUniqueRootRowID() {
      return "rr_".concat(this._rootIdCounter++);
    }
  }, {
    key: "generateUniqueID",
    value: function generateUniqueID() {
      return "gc_".concat(this._globalIdCounter++);
    }
  }, {
    key: "notifyChange",
    value: function notifyChange() {
      console.log("Root.notifyChange"), this.onStateChangedCallback && this.onStateChangedCallback();
    }
  }, {
    key: "notifyPropertyChange",
    value: function notifyPropertyChange(t) {
      console.log("Root.notifyPropertyChange (onPropertyChanged): localUpdate ".concat(t && void 0 !== t.updateView)), this.onPropertyChanged && this.onPropertyChanged(t), t && t.updateView() || this.notifyChange();
    }
  }, {
    key: "sortTabs",
    value: function sortTabs() {
      this.sort(this.tabs, function (t) {
        return t;
      }, this.descriptorSet && this.descriptorSet.tabs);
    }
  }, {
    key: "sortCats",
    value: function sortCats() {
      this.sort(this.categories, function (t) {
        return t.name;
      }, this.descriptorSet && this.descriptorSet.categories);
    }
  }, {
    key: "recalcCatsAndTabs",
    value: function recalcCatsAndTabs(t) {
      this.activeTab = t.tab, -1 === this._rootRow.childRows.findIndex(function (e) {
        return e.category === t.category;
      }) && this.categories.findIndex(function (e) {
        return e.name === t.category;
      }) > -1 ? this._categories = this.categories.filter(function (e) {
        return e.name !== t.category;
      }) : -1 === this.categories.findIndex(function (e) {
        return e.name === t.category;
      }) && (this.categories.push(new oi(t.category, this)), this.sortCats()), this.tabs.includes(t.tab) ? -1 === this._rootRow.childRows.findIndex(function (e) {
        return e.tab === t.tab;
      }) && (this._tabs = this.tabs.filter(function (e) {
        return e !== t.tab;
      })) : (this.tabs.push(t.tab), this.sortTabs());
    }
  }, {
    key: "sort",
    value: function sort(t, e, n) {
      n ? t.sort(function (t, i) {
        var r = e(t),
            o = e(i),
            a = n.indexOf(r),
            s = n.indexOf(o);
        return a < 0 && s < 0 ? r.toLowerCase().localeCompare(o.toLowerCase()) : (a < 0 ? Number.MAX_VALUE : a) - (s < 0 ? Number.MAX_VALUE : s);
      }) : t.sort(function (t, n) {
        return e(t).toLowerCase().localeCompare(e(n).toLowerCase());
      });
    }
  }, {
    key: "filterRowsByCategory",
    value: function filterRowsByCategory(t) {
      return this.filterRows(this._rootRow.childRows.filter(function (e) {
        return e.category === t;
      }));
    }
  }, {
    key: "filterRows",
    value: function filterRows(t) {
      var _this2 = this;

      return t && this.gridView === Jn.tabs ? t.filter(function (t) {
        return t instanceof oi ? _this2.filterRows(t.childRows).length > 0 : t instanceof ii && (t.isChild || (t.tab ? _this2.activeTab === t.tab.toUpperCase() : "OTHER" === _this2.activeTab));
      }) : t && this.gridView === Jn.search && (this.filter || this.filterMode === Zn.error) ? t.filter(function (t) {
        var e;
        if (t instanceof ii) switch (_this2.filterMode) {
          case Zn.error:
            e = t.isInvalid;
            break;

          case Zn.label:
            e = !t.name || t.name.toLocaleLowerCase().indexOf(_this2._filter) > -1;
            break;

          case Zn.value:
            e = t.value && t.valueToString().toLocaleLowerCase().indexOf(_this2._filter) > -1;
            break;

          default:
            e = !t.name || t.name.toLocaleLowerCase().indexOf(_this2._filter) > -1 || t.value && t.valueToString().toLocaleLowerCase().indexOf(_this2._filter) > -1;
        }
        return !e && (t instanceof oi || t.isCompleType) && (e = _this2.filterRows(t.childRows).length > 0), e;
      }) : t;
    }
  }, {
    key: "rows",
    get: function get() {
      return this.sorted ? this._rootRow.childRows : this.filterRows(this.categories);
    }
  }, {
    key: "rootRow",
    get: function get() {
      return this._rootRow;
    }
  }, {
    key: "categories",
    get: function get() {
      var _this3 = this;

      if (!this._categories) {
        var _t13 = {};
        this._categories = Object.keys(this._rootRow.childRows.reduce(function (t, e) {
          var n = e.category,
              i = t[n];
          return i ? i.push(e) : t[n] = [e], t;
        }, _t13)).map(function (t) {
          return new oi(t, _this3);
        }), this.sortCats();
      }

      return this._rootRow.selectMode ? this._categories.filter(function (t) {
        return t.childRows.length > 0;
      }) : this._categories;
    }
  }, {
    key: "tabs",
    get: function get() {
      return this._tabs || (this._tabs = this._rootRow.childRows.map(function (t) {
        return t.tab;
      }).reduce(function (t, e) {
        var n = e ? e.toLocaleUpperCase() : "OTHER";
        return t.includes(n) || t.push(n.toLocaleUpperCase()), t;
      }, []), this.sortTabs()), this._tabs;
    }
  }, {
    key: "activeTab",
    get: function get() {
      return this.tabs[this._activeTabIndex];
    },
    set: function set(t) {
      var e = this.tabs.indexOf(t.toUpperCase());
      this._activeTabIndex = e > -1 ? e : 0;
    }
  }, {
    key: "activeTabIndex",
    get: function get() {
      return this._activeTabIndex;
    },
    set: function set(t) {
      this._activeTabIndex !== t && (this._activeTabIndex = t, this.notifyChange());
    }
  }, {
    key: "tabsSupported",
    get: function get() {
      return this.tabs.length > 0;
    }
  }, {
    key: "anySelectMode",
    get: function get() {
      return this._rootRow.anySelectMode;
    }
  }, {
    key: "sorted",
    get: function get() {
      return !!this._sorted;
    },
    set: function set(t) {
      this._sorted = t, this._rootRow.sort(this.sorted), this.notifyChange();
    }
  }, {
    key: "filter",
    get: function get() {
      return (this.filterMode !== Zn.all ? "[".concat(this.filterMode, "] ") : "") + this._filter;
    },
    set: function set(t) {
      if (t) {
        if ((t = t.trim()).startsWith("[")) {
          var _e3 = t.indexOf("]");

          if (_e3 > 0) {
            var _n3 = t.substr(1, _e3 - 1);

            Zn[_n3] ? this.filterMode = _n3 : this.filterMode = Zn.all, t = t.substr(_e3 + 1).trim();
          } else this.filterMode = Zn.all;
        }

        this._filter = t.toLocaleLowerCase();
      } else this._filter = "", this.filterMode = Zn.all;

      this.notifyChange();
    }
  }]);

  return ni;
}();

var ii =
/*#__PURE__*/
function () {
  function ii(t, e, n, i) {
    var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !0;

    _classCallCheck(this, ii);

    this.data = e, this.rootContext = n, this.parent = i, this.undefinedProperties = [], this._name = t, this._descriptor = this.rootContext.descriptorSet ? this.rootContext.descriptorSet.getProperty(this.path) : this.inferDescriptor(), this.onStateChanged = this.onStateChanged.bind(this), r && this.inferTypeInfo();
  }

  _createClass(ii, [{
    key: "inferDescriptor",
    value: function inferDescriptor() {
      var t = "_".concat(this.name, "Desc"),
          e = this.data && this.data.constructor && this.data.constructor[t];
      return e || void 0;
    }
  }, {
    key: "inferTypeInfo",
    value: function inferTypeInfo() {
      this.descriptor && this.descriptor.type ? this.descriptor.array && "PropertyGridArrayRowData" === this.constructor.name ? (this._type = "object", this._objectType = "Array") : this._type = this.descriptor.type : void 0 !== this.value && null !== this.value ? this._type = typeof this.value : this.hasDefault ? this._type = typeof this.defaultValue : this._type = "string", this.handleDefault(), this.validate(), "object" === this._type && (this._objectType || (this._objectType = null !== this.value ? this.value.constructor.name : void 0), this.buildComplexChildData());
    }
  }, {
    key: "buildComplexChildData",
    value: function buildComplexChildData() {
      this._childCache || (this._childCache = function (t, e, n, i) {
        var r = [];
        var o = Array.isArray(t);
        if (t) if (o) r = t.map(function (i, r) {
          return new si(r, t, e, n);
        });else {
          r = Object.keys(t).map(function (i) {
            return "object" == typeof t[i] && Array.isArray(t[i]) ? new ai(i, t, e, n) : new ii(i, t, e, n);
          });

          var _o2 = Object.keys(t).map(function (t) {
            return t.toLowerCase();
          });

          if (e.descriptorSet) {
            var _r2;

            var _a2 = [[], []];
            e.descriptorSet.getUndefinedProperties(_o2, n && n.path).reduce(function (r, o) {
              if (i || !o.optional || o.defaultCreate) {
                var _i2 = n && n.path ? o.propertyPath.substring(n.path.length + 1) : o.propertyPath;

                r[0].push(new ii(_i2, t, e, n));
              } else r[1].push(o);

              return r;
            }, _a2), (_r2 = r).push.apply(_r2, _toConsumableArray(_a2[0])), n && (n.undefinedProperties = _a2[1]);
          }
        }
        return r;
      }(this.value, this.rootContext, this), this.sort(!1));
    }
  }, {
    key: "sort",
    value: function sort(t) {
      this._childCache && (t ? this._childCache.sort(function (t, e) {
        return t.name.toLowerCase().localeCompare(e.name.toLowerCase());
      }) : this._childCache.sort(function (t, e) {
        var n = t._descriptor && t._descriptor.sortOrder,
            i = e._descriptor && e._descriptor.sortOrder;
        return void 0 === n && void 0 === i ? t.name.toLowerCase().localeCompare(e.name.toLowerCase()) : (void 0 === n ? Number.MAX_VALUE : n) - (void 0 === i ? Number.MAX_VALUE : i);
      }));
    }
  }, {
    key: "defineProperties",
    value: function defineProperties(t) {
      var _this4 = this;

      new ci({
        type: "PropertyDefine",
        text: 1 === t.length ? "Define property ".concat(t[0].name) : "Define ".concat(t.length, " properties"),
        do: function _do() {
          return _this4.executeDefineProperties(t);
        },
        redo: function redo(e) {
          return _this4.executeDefineProperties(t, e);
        },
        undo: function undo(t) {
          return _this4.executeUndefineProperties(t);
        },
        updateView: function updateView() {
          return _this4.onStateChanged(!0, !0);
        }
      }, this).do();
    }
  }, {
    key: "executeDefineProperties",
    value: function executeDefineProperties(t, e) {
      var _this5 = this;

      var n = [];
      var i;
      return t.forEach(function (t) {
        var r = e ? e.find(function (e) {
          return e.descriptor === t;
        }) : t.array ? new ai(t.name, _this5.data, _this5.rootContext, _this5) : new ii(t.name, _this5.data, _this5.rootContext, _this5);
        r._focusOnMount = !0, _this5._childCache && (n.push(r), _this5._childCache.push(r), _this5.rootContext.recalcCatsAndTabs(r), _this5.undefinedProperties = _this5.undefinedProperties.filter(function (e) {
          return e.propertyPath !== t.propertyPath;
        }), i = r, r.ensureVisibility());
      }), i && this.rootContext.gridView === Jn.tabs && (this.rootContext.activeTab = i.tab), this.sort(this.rootContext.sorted), n;
    }
  }, {
    key: "undefineProperties",
    value: function undefineProperties(t) {
      var _this6 = this;

      new ci({
        type: "PropertyUndefine",
        text: 1 === t.length ? "Undefine property ".concat(t[0].name) : "Undefine ".concat(t.length, " properties"),
        do: function _do() {
          return _this6.executeUndefineProperties(t);
        },
        undo: function undo(e) {
          return _this6.executeDefineProperties(t.map(function (t) {
            return t.descriptor;
          }, e));
        },
        updateView: function updateView() {
          return _this6.onStateChanged(!0, !0);
        }
      }, this).do();
    }
  }, {
    key: "executeUndefineProperties",
    value: function executeUndefineProperties(t) {
      var _this7 = this;

      if (this._childCache) {
        var _e4 = this._childCache;

        var _n4;

        _e4.forEach(function (i, r) {
          t.find(function (t) {
            return t._name === i.name;
          }) && i.descriptor && (_this7.undefinedProperties.push(i.descriptor), _e4.splice(r, 1), _this7.rootContext.recalcCatsAndTabs(i), _n4 = i);
        }), _n4 && this.rootContext.gridView === Jn.tabs && (this.rootContext.activeTab = _n4.tab), this._selectMode = !1, console.log("executeUndefineProperties", t);
      }

      return t;
    }
  }, {
    key: "ensureVisibility",
    value: function ensureVisibility() {
      this._expanded = !!this.isCompleType || this._expanded, this.parent && this.parent.ensureVisibility();
    }
  }, {
    key: "executeSetValue",
    value: function executeSetValue(t) {
      var e = this.data[this._name];
      return this.data[this._name] = t, this.handleDefault(), e;
    }
  }, {
    key: "handleChange",
    value: function handleChange(t, e) {
      var n = new Qn();
      t = this.convert(t, n, e), console.log("Row.handleChange (".concat(this.path, "): ").concat(t)), this.validate(t, n) && (this.value = t), console.log("Row.handleChange (".concat(this.path, "): ").concat(t, " => valid: ").concat(!this.isInvalid));
    }
  }, {
    key: "validate",
    value: function validate() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.value;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Qn();

      if (this.rootContext && this.rootContext.descriptorSet && this._descriptor) {
        var _n5 = this.rootContext.descriptorSet.validate(t, this._descriptor, e);

        return this.setValidationError(_n5, e.message), e.acceptValue;
      }

      return this._validationMessage = void 0, !0;
    }
  }, {
    key: "setValidationError",
    value: function setValidationError(t, e) {
      t ? (this._validationMessage = void 0, this._invalid = !1) : (this._validationMessage = e, this._invalid = !0);
    }
  }, {
    key: "resetFocusOnMount",
    value: function resetFocusOnMount() {
      this._focusOnMount = void 0;
    }
  }, {
    key: "handleDefault",
    value: function handleDefault() {
      !this.hasValue && this.hasDefault && (this.data[this._name] = this.defaultValue);
    }
  }, {
    key: "removeDeselectedProperties",
    value: function removeDeselectedProperties() {
      this.undefineProperties(this.childRows.filter(function (t) {
        return !t.selected && t.isSelectable && t.descriptor;
      }));
    }
  }, {
    key: "valueToString",
    value: function valueToString() {
      var t = this.value;
      return t ? this._descriptor && this._descriptor.toStringFunction ? this._descriptor.toStringFunction(t) : t.toString() : "";
    }
  }, {
    key: "getSelectionOptions",
    value: function getSelectionOptions() {
      return this.descriptor ? this.descriptor.selectionOptions : null;
    }
  }, {
    key: "getHtmlFormProps",
    value: function getHtmlFormProps() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "text";
      return "Date" === this.objectType && (t = "datetime-local"), this.descriptor && this.descriptor.html ? {
        type: this.descriptor.html.inputType || t,
        min: this.descriptor.html.min,
        max: this.descriptor.html.max,
        step: this.descriptor.html.step,
        minLength: this.descriptor.html.minLength,
        maxLength: this.descriptor.html.maxLength
      } : {
        type: t
      };
    }
  }, {
    key: "onStateChanged",
    value: function onStateChanged() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      console.log("Row.onStateChanged (".concat(this.path, ")")), !(t = t || !(!this._descriptor || !this._descriptor.requireParentRefresh)) || !this.parent || this.parent.isRoot && this.rootContext.sorted ? this.onStateChangedCallback && this.onStateChangedCallback() : this.parent.onStateChanged(t, e);
    }
  }, {
    key: "convert",
    value: function convert(t, e, n) {
      if (t) switch (this.type) {
        case "string":
          t = t.toString();
          break;

        case "number":
          t = parseFloat(t);
          break;

        case "object":
          if (this.objectType) switch (this.objectType) {
            case "Date":
              "time" === n && (t = "1970-01-01T" + t);

              var _i3 = Date.parse(t);

              _i3 ? t = new Date(_i3) : e && (e.currentResult = !1, e.message = "Please enter a valid datetime string.");
          }
      } else switch (this.type) {
        case "string":
          t = "";
          break;

        default:
          t = void 0;
      }
      return t;
    }
  }, {
    key: "calculateHeight",
    value: function calculateHeight() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 56;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 40;
      return this.expanded ? ei(this.childRows, t, e) : t;
    }
  }, {
    key: "isRoot",
    get: function get() {
      return !1;
    }
  }, {
    key: "childRows",
    get: function get() {
      if (this._childCache) {
        var _t14 = this.rootContext.filterRows(this._childCache).filter(function (t) {
          return t.isVisible;
        });

        return this.selectMode ? _t14.filter(function (t) {
          return t.showSelect && t.isSelectable;
        }) : _t14;
      }

      return [];
    }
  }, {
    key: "undefinedProperties4Menu",
    get: function get() {
      var _this8 = this;

      var t = this.undefinedProperties ? this.undefinedProperties.map(function (t) {
        return {
          text: t.propertyPath,
          handler: function handler() {
            return _this8.defineProperties([t]);
          }
        };
      }) : [];
      return this.childRows.reduce(function (t, e) {
        return t;
      }, t);
    }
  }, {
    key: "descriptor",
    get: function get() {
      return this._descriptor;
    }
  }, {
    key: "value",
    get: function get() {
      return this._name ? this.data[this._name] : this.data;
    },
    set: function set(t) {
      var _this9 = this;

      if (this._name) {
        new ci({
          type: "PropertyChange",
          id: this.path,
          text: "Change property ".concat(this._name),
          do: function _do() {
            return _this9.executeSetValue(t);
          },
          undo: function undo(t) {
            return _this9.executeSetValue(t);
          },
          updateView: function updateView() {
            return _this9.onStateChanged();
          }
        }, this).do();
      }
    }
  }, {
    key: "hasErrors",
    get: function get() {
      return this._childCache && this._childCache.reduce(function (t, e) {
        return t || e.isInvalid || e.hasErrors;
      }, !1);
    }
  }, {
    key: "hasAnyOptionalProperties",
    get: function get() {
      return this.undefinedProperties && this.undefinedProperties.length > 0 || this.hasOptionalProperties;
    }
  }, {
    key: "hasOptionalProperties",
    get: function get() {
      return this._childCache && this._childCache.reduce(function (t, e) {
        return t || e.isSelectable;
      }, !1);
    }
  }, {
    key: "id",
    get: function get() {
      return "".concat(this.rootContext.rootRow.id, ".").concat(this.name);
    }
  }, {
    key: "focusOnMount",
    get: function get() {
      return this._focusOnMount;
    }
  }, {
    key: "category",
    get: function get() {
      return this._descriptor && this._descriptor.category ? this._descriptor.category : "Misc";
    }
  }, {
    key: "hasValue",
    get: function get() {
      return void 0 !== this.value && null !== this.value;
    }
  }, {
    key: "name",
    get: function get() {
      return this._name;
    }
  }, {
    key: "path",
    get: function get() {
      var t = this.parent ? this.parent.path : "";
      return (t ? t + "." : t) + this.name;
    }
  }, {
    key: "isChild",
    get: function get() {
      return !!this.parent && !this.parent.isRoot;
    }
  }, {
    key: "tooltip",
    get: function get() {
      return this._validationMessage ? this._validationMessage : this._descriptor && this._descriptor.description;
    }
  }, {
    key: "defaultValue",
    get: function get() {
      return this._descriptor && this._descriptor.defaultValue;
    }
  }, {
    key: "hasDefault",
    get: function get() {
      return void 0 !== this.defaultValue;
    }
  }, {
    key: "isDefault",
    get: function get() {
      return this.defaultValue === this.value;
    }
  }, {
    key: "showSelect",
    get: function get() {
      return this.parent && this.parent._selectMode;
    }
  }, {
    key: "selectMode",
    get: function get() {
      return !!this._selectMode;
    },
    set: function set(t) {
      this._selectMode = t, t && (this._expanded = !0, this.childRows.forEach(function (t) {
        return t._selected = void 0;
      })), this.rootContext.notifyChange();
    }
  }, {
    key: "anySelectMode",
    get: function get() {
      return this.selectMode;
    }
  }, {
    key: "deselectedCount",
    get: function get() {
      return this.childRows.reduce(function (t, e) {
        return t + (!e.selected && e.isSelectable ? 1 : 0);
      }, 0);
    }
  }, {
    key: "selected",
    get: function get() {
      return void 0 === this._selected || this._selected;
    },
    set: function set(t) {
      this._selected = t, this.rootContext.notifyChange();
    }
  }, {
    key: "isSelectable",
    get: function get() {
      return this._descriptor && this._descriptor.optional;
    }
  }, {
    key: "isDisabled",
    get: function get() {
      return this.rootContext.anySelectMode || this.customHandling.disabled || this._descriptor && this._descriptor.disabled || this.parent && this.parent.isDisabled;
    }
  }, {
    key: "isVisible",
    get: function get() {
      return !1 !== this.customHandling.visible;
    }
  }, {
    key: "customHandling",
    get: function get() {
      var t = new $n(this.data);
      return this._descriptor && this._descriptor.customHandling && this._descriptor.customHandling(t), t;
    }
  }, {
    key: "isInvalid",
    get: function get() {
      return (!this._descriptor || !this._descriptor.disabled) && (this._invalid || this._childCache && this._childCache.reduce(function (t, e) {
        return t || e.isInvalid;
      }, !1));
    }
  }, {
    key: "type",
    get: function get() {
      return this._type;
    }
  }, {
    key: "objectType",
    get: function get() {
      return this._descriptor && this._descriptor.objectType ? "function" == typeof this._descriptor.objectType ? this._descriptor.objectType.name : this._descriptor.objectType : this._objectType ? this._objectType : this.hasDefault && "object" == typeof this.defaultValue ? this.defaultValue.constructor.name : void 0;
    }
  }, {
    key: "tab",
    get: function get() {
      return (this._descriptor && this._descriptor.tab || "OTHER").toLocaleUpperCase();
    }
  }, {
    key: "isCompleType",
    get: function get() {
      return null !== this.value && (Array.isArray(this.value) || "object" == typeof this.value);
    }
  }, {
    key: "showRow",
    get: function get() {
      return this.isCompleType && this.rootContext.gridView === Jn.search && (!!this.rootContext.filter || this.rootContext.filterMode === Zn.error);
    }
  }, {
    key: "expanded",
    get: function get() {
      return this._expanded || this.showRow;
    },
    set: function set(t) {
      this._expanded !== t && (this._expanded = t, this.onStateChanged(!0));
    }
  }, {
    key: "hasSelectionOptions",
    get: function get() {
      return this.descriptor && this.descriptor.selectionOptions;
    }
  }]);

  return ii;
}();

var ri =
/*#__PURE__*/
function (_ii) {
  _inherits(ri, _ii);

  function ri(t, e, n) {
    _classCallCheck(this, ri);

    return _possibleConstructorReturn(this, _getPrototypeOf(ri).call(this, t, e, n));
  }

  _createClass(ri, [{
    key: "onStateChanged",
    value: function onStateChanged() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      (e || t && !this.rootContext.sorted) && (console.log("Row.onStateChanged (Root)"), this.rootContext.notifyChange());
    }
  }, {
    key: "id",
    get: function get() {
      return this.name;
    }
  }, {
    key: "isRoot",
    get: function get() {
      return !0;
    }
  }, {
    key: "value",
    get: function get() {
      return this.data;
    }
  }]);

  return ri;
}(ii);

var oi =
/*#__PURE__*/
function () {
  function oi(t, e) {
    _classCallCheck(this, oi);

    this.name = t, this.rootContext = e, this._expanded = !0;
  }

  _createClass(oi, [{
    key: "calculateHeight",
    value: function calculateHeight() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 56;
      var e = arguments.length > 1 ? arguments[1] : undefined;
      return this.expanded ? ei(this.childRows, t, e) : 28;
    }
  }, {
    key: "onStateChanged",
    value: function onStateChanged() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      console.log("Row.onStateChanged: Category ".concat(this.name, ")")), t ? this.rootContext.notifyChange() : this.onStateChangedCallback && this.onStateChangedCallback();
    }
  }, {
    key: "id",
    get: function get() {
      return this.name + "_cat";
    }
  }, {
    key: "expanded",
    get: function get() {
      return this._expanded;
    },
    set: function set(t) {
      this._expanded = t, this.onStateChanged();
    }
  }, {
    key: "childRows",
    get: function get() {
      return this.rootContext.filterRowsByCategory(this.name);
    }
  }]);

  return oi;
}();

var ai =
/*#__PURE__*/
function (_ii2) {
  _inherits(ai, _ii2);

  function ai(t, e, n, i) {
    var _this10;

    _classCallCheck(this, ai);

    _this10 = _possibleConstructorReturn(this, _getPrototypeOf(ai).call(this, t, e, n, i)), _this10._childCache && _this10._childCache.length > 0 ? (_this10._elementType = _this10._childCache[0].type, _this10._elementObjectType = _this10._childCache[0].objectType) : void 0 === _this10.value && (_this10.value = []);
    return _this10;
  }

  _createClass(ai, [{
    key: "moveSelectedElements",
    value: function moveSelectedElements(t) {
      var _this11 = this;

      var e = this.childRows.filter(function (t) {
        return t.selected;
      }),
          n = [];
      var i = 0;

      switch (t) {
        case "top":
          e.forEach(function (t) {
            n.push([t.index, i++]);
          });
          break;

        case "up":
          e.forEach(function (t) {
            n.push([t.index, t.index > i ? t.index - 1 : t.index]), i++;
          });
          break;

        case "bottom":
          i = this.value.length - 1, e.reverse().forEach(function (t) {
            n.push([t.index, i--]);
          });
          break;

        case "down":
          i = this.value.length - 1, e.reverse().forEach(function (t) {
            n.push([t.index, t.index < i ? t.index + 1 : t.index]), i--;
          });
      }

      new ci({
        type: "ArrayElementMove",
        text: "Move element(s) ".concat(t),
        do: function _do() {
          return _this11.executeMoveSelectedElements(n);
        },
        undo: function undo(t) {
          return _this11.executeMoveSelectedElements(t);
        },
        updateView: function updateView() {
          return _this11.onStateChanged();
        }
      }, this).do();
    }
  }, {
    key: "executeMoveSelectedElements",
    value: function executeMoveSelectedElements(t) {
      var _this12 = this;

      var e = this._childCache;
      return t.forEach(function (t) {
        _this12.value.splice(t[1], 0, _this12.value.splice(t[0], 1)[0]), e.splice(t[1], 0, e.splice(t[0], 1)[0]);
      }), e.forEach(function (t, e) {
        return t.index = e;
      }), t.map(function (t) {
        return [t[1], t[0]];
      }).reverse();
    }
  }, {
    key: "createNewElement",
    value: function createNewElement() {
      var _this13 = this;

      if (this._childCache) {
        var _t15 = new si(-1, this.value, this.rootContext, this, this._elementType, this._elementObjectType, !0);

        new ci({
          type: "ArrayElementAdd",
          text: "Add new element",
          do: function _do() {
            return _this13.executeCreateNewElements([_t15]);
          },
          undo: function undo(t) {
            return _this13.executeRemoveElements(t);
          },
          updateView: function updateView() {
            return _this13.onStateChanged();
          }
        }, this).do();
      }
    }
  }, {
    key: "executeCreateNewElements",
    value: function executeCreateNewElements(t) {
      var _this14 = this;

      return t.forEach(function (t) {
        t.index > -1 ? (_this14.value.splice(t.index, 0, t.cachedValue), _this14._childCache && _this14._childCache.splice(t.index, 0, t)) : (_this14.value.push(t.index > -1 ? t.value : void 0), _this14._childCache && _this14._childCache.push(t)), t.selected = _this14.selectMode;
      }), this._childCache.forEach(function (t, e) {
        return t.index = e;
      }), this.expanded = !0, t;
    }
  }, {
    key: "removeSelectedElements",
    value: function removeSelectedElements() {
      var _this15 = this;

      var t = this.childRows.filter(function (t) {
        return t.selected;
      });
      new ci({
        type: "ArrayElementRemove",
        text: "Remove element(s)",
        do: function _do() {
          return _this15.executeRemoveElements(t);
        },
        undo: function undo(t) {
          return _this15.executeCreateNewElements(t);
        },
        updateView: function updateView() {
          return _this15.onStateChanged();
        }
      }, this).do();
    }
  }, {
    key: "executeRemoveElements",
    value: function executeRemoveElements(t) {
      var _this16 = this;

      return this._childCache && (t.reverse().forEach(function (t) {
        t.cacheValue(), _this16._childCache && _this16._childCache.splice(t.index, 1), _this16.value.splice(t.index, 1);
      }), this._childCache.forEach(function (t, e) {
        return t.index = e;
      })), t.reverse();
    }
  }, {
    key: "canCreateNewElement",
    get: function get() {
      return !0;
    }
  }, {
    key: "hasElements",
    get: function get() {
      return this.value && this.value.length > 0;
    }
  }, {
    key: "childRows",
    get: function get() {
      return this._childCache ? this._childCache : [];
    }
  }, {
    key: "selectedElementCount",
    get: function get() {
      return this.childRows.reduce(function (t, e) {
        return t + (e.selected ? 1 : 0);
      }, 0);
    }
  }]);

  return ai;
}(ii);

var si =
/*#__PURE__*/
function (_ii3) {
  _inherits(si, _ii3);

  function si(t, e, n, i, r, o, a) {
    var _this17;

    _classCallCheck(this, si);

    _this17 = _possibleConstructorReturn(this, _getPrototypeOf(si).call(this, n.generateUniqueID(), e, n, i)), _this17._index = t, _this17.inferTypeInfo(), r && (_this17._type = r), o && (_this17._objectType = o), _this17._focusOnMount = a;
    return _this17;
  }

  _createClass(si, [{
    key: "cacheValue",
    value: function cacheValue() {
      this._cachedValue = this.value;
    }
  }, {
    key: "executeSetValue",
    value: function executeSetValue(t) {
      var e = this.data[this._index];
      return this.data[this._index] = t, this.handleDefault(), e;
    }
  }, {
    key: "calculateHeight",
    value: function calculateHeight() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 32;
      var e = arguments.length > 1 ? arguments[1] : undefined;
      return _get(_getPrototypeOf(si.prototype), "calculateHeight", this).call(this, 32, e);
    }
  }, {
    key: "descriptor",
    get: function get() {
      return this.parent && this.parent.descriptor;
    }
  }, {
    key: "index",
    get: function get() {
      return this._index;
    },
    set: function set(t) {
      this._index = t;
    }
  }, {
    key: "value",
    get: function get() {
      return this.data[this._index];
    },
    set: function set(t) {
      var _this18 = this;

      new ci({
        type: "PropertyChange",
        id: this.path,
        text: "Change property ".concat(this.parent && this.parent.name, "[").concat(this._index, "]"),
        do: function _do() {
          return _this18.executeSetValue(t);
        },
        undo: function undo(t) {
          return _this18.executeSetValue(t);
        },
        updateView: function updateView() {
          return _this18.onStateChanged();
        }
      }, this).do();
    }
  }, {
    key: "selected",
    get: function get() {
      return void 0 !== this._selected && this._selected;
    },
    set: function set(t) {
      this._selected = t, this.rootContext.notifyChange();
    }
  }, {
    key: "isSelectable",
    get: function get() {
      return !0;
    }
  }, {
    key: "cachedValue",
    get: function get() {
      return this._cachedValue;
    }
  }]);

  return si;
}(ii);

var ci =
/*#__PURE__*/
function () {
  function ci(t, e) {
    _classCallCheck(this, ci);

    this.data = t, this.row = e, this._state = 0;
  }

  _createClass(ci, [{
    key: "do",
    value: function _do() {
      this._doResult = this.data.do(), this.row.rootContext.notifyPropertyChange(this);
    }
  }, {
    key: "undo",
    value: function undo() {
      this.data.undo(this._doResult), this._state = 1, this.row.rootContext.notifyPropertyChange(this);
    }
  }, {
    key: "redo",
    value: function redo() {
      this._state = 2, this.data.redo ? (this.data.redo(this._doResult), this.row.rootContext.notifyPropertyChange(this)) : this.do();
    }
  }, {
    key: "updateView",
    value: function updateView() {
      return !!this.data.updateView && (this.data.updateView(), !0);
    }
  }, {
    key: "merge",
    value: function merge(t) {
      return !!(t.id && t.id === this.data.id && t instanceof ci) && (this.data.do = t.data.do, this.data.redo = t.data.redo, !0);
    }
  }, {
    key: "type",
    get: function get() {
      return this.data.type;
    }
  }, {
    key: "id",
    get: function get() {
      return this.data.id || "";
    }
  }, {
    key: "text",
    get: function get() {
      return this.data.text;
    }
  }, {
    key: "wasUndone",
    get: function get() {
      return 1 === this._state;
    }
  }, {
    key: "wasRedone",
    get: function get() {
      return 2 === this._state;
    }
  }, {
    key: "restructure",
    get: function get() {
      return !(!this.row.descriptor || !this.row.descriptor.requireParentRefresh);
    }
  }]);

  return ci;
}();

var ui = {
  animationend: {
    cssProperty: "animation",
    prefixed: "webkitAnimationEnd",
    standard: "animationend"
  },
  animationiteration: {
    cssProperty: "animation",
    prefixed: "webkitAnimationIteration",
    standard: "animationiteration"
  },
  animationstart: {
    cssProperty: "animation",
    prefixed: "webkitAnimationStart",
    standard: "animationstart"
  },
  transitionend: {
    cssProperty: "transition",
    prefixed: "webkitTransitionEnd",
    standard: "transitionend"
  }
};

function li(t, e) {
  if (function (t) {
    return Boolean(t.document) && "function" == typeof t.document.createElement;
  }(t) && e in ui) {
    var n = t.document.createElement("div"),
        i = ui[e],
        r = i.standard,
        o = i.prefixed;
    return i.cssProperty in n.style ? r : o;
  }

  return e;
}

var di,
    hi,
    pi = {
  BG_FOCUSED: "mdc-ripple-upgraded--background-focused",
  FG_ACTIVATION: "mdc-ripple-upgraded--foreground-activation",
  FG_DEACTIVATION: "mdc-ripple-upgraded--foreground-deactivation",
  ROOT: "mdc-ripple-upgraded",
  UNBOUNDED: "mdc-ripple-upgraded--unbounded"
},
    fi = {
  VAR_FG_SCALE: "--mdc-ripple-fg-scale",
  VAR_FG_SIZE: "--mdc-ripple-fg-size",
  VAR_FG_TRANSLATE_END: "--mdc-ripple-fg-translate-end",
  VAR_FG_TRANSLATE_START: "--mdc-ripple-fg-translate-start",
  VAR_LEFT: "--mdc-ripple-left",
  VAR_TOP: "--mdc-ripple-top"
},
    mi = {
  DEACTIVATION_TIMEOUT_MS: 225,
  FG_DEACTIVATION_MS: 150,
  INITIAL_ORIGIN_SCALE: .6,
  PADDING: 10,
  TAP_DELAY_MS: 300
};

function _i(t, e) {
  if (void 0 === t && (t = window), void 0 === e && (e = !1), void 0 === hi || e) {
    var n = !1;

    try {
      t.document.addEventListener("test", function () {}, {
        get passive() {
          return n = !0;
        }

      });
    } catch (t) {}

    hi = n;
  }

  return !!hi && {
    passive: !0
  };
}

var gi = ["touchstart", "pointerdown", "mousedown", "keydown"],
    vi = ["touchend", "pointerup", "mouseup", "contextmenu"],
    yi = [],
    bi = function (t) {
  function e(n) {
    var i = t.call(this, _jt({}, e.defaultAdapter, n)) || this;
    return i.activationAnimationHasEnded_ = !1, i.activationTimer_ = 0, i.fgDeactivationRemovalTimer_ = 0, i.fgScale_ = "0", i.frame_ = {
      width: 0,
      height: 0
    }, i.initialSize_ = 0, i.layoutFrame_ = 0, i.maxRadius_ = 0, i.unboundedCoords_ = {
      left: 0,
      top: 0
    }, i.activationState_ = i.defaultActivationState_(), i.activationTimerCallback_ = function () {
      i.activationAnimationHasEnded_ = !0, i.runDeactivationUXLogicIfReady_();
    }, i.activateHandler_ = function (t) {
      return i.activate_(t);
    }, i.deactivateHandler_ = function () {
      return i.deactivate_();
    }, i.focusHandler_ = function () {
      return i.handleFocus();
    }, i.blurHandler_ = function () {
      return i.handleBlur();
    }, i.resizeHandler_ = function () {
      return i.layout();
    }, i;
  }

  return Vt(e, t), Object.defineProperty(e, "cssClasses", {
    get: function get() {
      return pi;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "strings", {
    get: function get() {
      return fi;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "numbers", {
    get: function get() {
      return mi;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultAdapter", {
    get: function get() {
      return {
        addClass: function addClass() {},
        browserSupportsCssVars: function browserSupportsCssVars() {
          return !0;
        },
        computeBoundingRect: function computeBoundingRect() {
          return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            width: 0,
            height: 0
          };
        },
        containsEventTarget: function containsEventTarget() {
          return !0;
        },
        deregisterDocumentInteractionHandler: function deregisterDocumentInteractionHandler() {},
        deregisterInteractionHandler: function deregisterInteractionHandler() {},
        deregisterResizeHandler: function deregisterResizeHandler() {},
        getWindowPageOffset: function getWindowPageOffset() {
          return {
            x: 0,
            y: 0
          };
        },
        isSurfaceActive: function isSurfaceActive() {
          return !0;
        },
        isSurfaceDisabled: function isSurfaceDisabled() {
          return !0;
        },
        isUnbounded: function isUnbounded() {
          return !0;
        },
        registerDocumentInteractionHandler: function registerDocumentInteractionHandler() {},
        registerInteractionHandler: function registerInteractionHandler() {},
        registerResizeHandler: function registerResizeHandler() {},
        removeClass: function removeClass() {},
        updateCssVariable: function updateCssVariable() {}
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.init = function () {
    var t = this,
        n = this.supportsPressRipple_();

    if (this.registerRootHandlers_(n), n) {
      var i = e.cssClasses,
          r = i.ROOT,
          o = i.UNBOUNDED;
      requestAnimationFrame(function () {
        t.adapter_.addClass(r), t.adapter_.isUnbounded() && (t.adapter_.addClass(o), t.layoutInternal_());
      });
    }
  }, e.prototype.destroy = function () {
    var t = this;

    if (this.supportsPressRipple_()) {
      this.activationTimer_ && (clearTimeout(this.activationTimer_), this.activationTimer_ = 0, this.adapter_.removeClass(e.cssClasses.FG_ACTIVATION)), this.fgDeactivationRemovalTimer_ && (clearTimeout(this.fgDeactivationRemovalTimer_), this.fgDeactivationRemovalTimer_ = 0, this.adapter_.removeClass(e.cssClasses.FG_DEACTIVATION));
      var n = e.cssClasses,
          i = n.ROOT,
          r = n.UNBOUNDED;
      requestAnimationFrame(function () {
        t.adapter_.removeClass(i), t.adapter_.removeClass(r), t.removeCssVars_();
      });
    }

    this.deregisterRootHandlers_(), this.deregisterDeactivationHandlers_();
  }, e.prototype.activate = function (t) {
    this.activate_(t);
  }, e.prototype.deactivate = function () {
    this.deactivate_();
  }, e.prototype.layout = function () {
    var t = this;
    this.layoutFrame_ && cancelAnimationFrame(this.layoutFrame_), this.layoutFrame_ = requestAnimationFrame(function () {
      t.layoutInternal_(), t.layoutFrame_ = 0;
    });
  }, e.prototype.setUnbounded = function (t) {
    var n = e.cssClasses.UNBOUNDED;
    t ? this.adapter_.addClass(n) : this.adapter_.removeClass(n);
  }, e.prototype.handleFocus = function () {
    var t = this;
    requestAnimationFrame(function () {
      return t.adapter_.addClass(e.cssClasses.BG_FOCUSED);
    });
  }, e.prototype.handleBlur = function () {
    var t = this;
    requestAnimationFrame(function () {
      return t.adapter_.removeClass(e.cssClasses.BG_FOCUSED);
    });
  }, e.prototype.supportsPressRipple_ = function () {
    return this.adapter_.browserSupportsCssVars();
  }, e.prototype.defaultActivationState_ = function () {
    return {
      activationEvent: void 0,
      hasDeactivationUXRun: !1,
      isActivated: !1,
      isProgrammatic: !1,
      wasActivatedByPointer: !1,
      wasElementMadeActive: !1
    };
  }, e.prototype.registerRootHandlers_ = function (t) {
    var e = this;
    t && (gi.forEach(function (t) {
      e.adapter_.registerInteractionHandler(t, e.activateHandler_);
    }), this.adapter_.isUnbounded() && this.adapter_.registerResizeHandler(this.resizeHandler_)), this.adapter_.registerInteractionHandler("focus", this.focusHandler_), this.adapter_.registerInteractionHandler("blur", this.blurHandler_);
  }, e.prototype.registerDeactivationHandlers_ = function (t) {
    var e = this;
    "keydown" === t.type ? this.adapter_.registerInteractionHandler("keyup", this.deactivateHandler_) : vi.forEach(function (t) {
      e.adapter_.registerDocumentInteractionHandler(t, e.deactivateHandler_);
    });
  }, e.prototype.deregisterRootHandlers_ = function () {
    var t = this;
    gi.forEach(function (e) {
      t.adapter_.deregisterInteractionHandler(e, t.activateHandler_);
    }), this.adapter_.deregisterInteractionHandler("focus", this.focusHandler_), this.adapter_.deregisterInteractionHandler("blur", this.blurHandler_), this.adapter_.isUnbounded() && this.adapter_.deregisterResizeHandler(this.resizeHandler_);
  }, e.prototype.deregisterDeactivationHandlers_ = function () {
    var t = this;
    this.adapter_.deregisterInteractionHandler("keyup", this.deactivateHandler_), vi.forEach(function (e) {
      t.adapter_.deregisterDocumentInteractionHandler(e, t.deactivateHandler_);
    });
  }, e.prototype.removeCssVars_ = function () {
    var t = this,
        n = e.strings;
    Object.keys(n).forEach(function (e) {
      0 === e.indexOf("VAR_") && t.adapter_.updateCssVariable(n[e], null);
    });
  }, e.prototype.activate_ = function (t) {
    var e = this;

    if (!this.adapter_.isSurfaceDisabled()) {
      var n = this.activationState_;

      if (!n.isActivated) {
        var i = this.previousActivationEvent_;
        if (!(i && void 0 !== t && i.type !== t.type)) n.isActivated = !0, n.isProgrammatic = void 0 === t, n.activationEvent = t, n.wasActivatedByPointer = !n.isProgrammatic && void 0 !== t && ("mousedown" === t.type || "touchstart" === t.type || "pointerdown" === t.type), void 0 !== t && yi.length > 0 && yi.some(function (t) {
          return e.adapter_.containsEventTarget(t);
        }) ? this.resetActivationState_() : (void 0 !== t && (yi.push(t.target), this.registerDeactivationHandlers_(t)), n.wasElementMadeActive = this.checkElementMadeActive_(t), n.wasElementMadeActive && this.animateActivation_(), requestAnimationFrame(function () {
          yi = [], n.wasElementMadeActive || void 0 === t || " " !== t.key && 32 !== t.keyCode || (n.wasElementMadeActive = e.checkElementMadeActive_(t), n.wasElementMadeActive && e.animateActivation_()), n.wasElementMadeActive || (e.activationState_ = e.defaultActivationState_());
        }));
      }
    }
  }, e.prototype.checkElementMadeActive_ = function (t) {
    return void 0 === t || "keydown" !== t.type || this.adapter_.isSurfaceActive();
  }, e.prototype.animateActivation_ = function () {
    var t = this,
        n = e.strings,
        i = n.VAR_FG_TRANSLATE_START,
        r = n.VAR_FG_TRANSLATE_END,
        o = e.cssClasses,
        a = o.FG_DEACTIVATION,
        s = o.FG_ACTIVATION,
        c = e.numbers.DEACTIVATION_TIMEOUT_MS;
    this.layoutInternal_();
    var u = "",
        l = "";

    if (!this.adapter_.isUnbounded()) {
      var d = this.getFgTranslationCoordinates_(),
          h = d.startPoint,
          p = d.endPoint;
      u = h.x + "px, " + h.y + "px", l = p.x + "px, " + p.y + "px";
    }

    this.adapter_.updateCssVariable(i, u), this.adapter_.updateCssVariable(r, l), clearTimeout(this.activationTimer_), clearTimeout(this.fgDeactivationRemovalTimer_), this.rmBoundedActivationClasses_(), this.adapter_.removeClass(a), this.adapter_.computeBoundingRect(), this.adapter_.addClass(s), this.activationTimer_ = setTimeout(function () {
      return t.activationTimerCallback_();
    }, c);
  }, e.prototype.getFgTranslationCoordinates_ = function () {
    var t,
        e = this.activationState_,
        n = e.activationEvent;
    return {
      startPoint: t = {
        x: (t = e.wasActivatedByPointer ? function (t, e, n) {
          if (!t) return {
            x: 0,
            y: 0
          };
          var i,
              r,
              o = e.x,
              a = e.y,
              s = o + n.left,
              c = a + n.top;

          if ("touchstart" === t.type) {
            var u = t;
            i = u.changedTouches[0].pageX - s, r = u.changedTouches[0].pageY - c;
          } else {
            var l = t;
            i = l.pageX - s, r = l.pageY - c;
          }

          return {
            x: i,
            y: r
          };
        }(n, this.adapter_.getWindowPageOffset(), this.adapter_.computeBoundingRect()) : {
          x: this.frame_.width / 2,
          y: this.frame_.height / 2
        }).x - this.initialSize_ / 2,
        y: t.y - this.initialSize_ / 2
      },
      endPoint: {
        x: this.frame_.width / 2 - this.initialSize_ / 2,
        y: this.frame_.height / 2 - this.initialSize_ / 2
      }
    };
  }, e.prototype.runDeactivationUXLogicIfReady_ = function () {
    var t = this,
        n = e.cssClasses.FG_DEACTIVATION,
        i = this.activationState_,
        r = i.hasDeactivationUXRun,
        o = i.isActivated;
    (r || !o) && this.activationAnimationHasEnded_ && (this.rmBoundedActivationClasses_(), this.adapter_.addClass(n), this.fgDeactivationRemovalTimer_ = setTimeout(function () {
      t.adapter_.removeClass(n);
    }, mi.FG_DEACTIVATION_MS));
  }, e.prototype.rmBoundedActivationClasses_ = function () {
    var t = e.cssClasses.FG_ACTIVATION;
    this.adapter_.removeClass(t), this.activationAnimationHasEnded_ = !1, this.adapter_.computeBoundingRect();
  }, e.prototype.resetActivationState_ = function () {
    var t = this;
    this.previousActivationEvent_ = this.activationState_.activationEvent, this.activationState_ = this.defaultActivationState_(), setTimeout(function () {
      return t.previousActivationEvent_ = void 0;
    }, e.numbers.TAP_DELAY_MS);
  }, e.prototype.deactivate_ = function () {
    var t = this,
        e = this.activationState_;

    if (e.isActivated) {
      var n = _jt({}, e);

      e.isProgrammatic ? (requestAnimationFrame(function () {
        return t.animateDeactivation_(n);
      }), this.resetActivationState_()) : (this.deregisterDeactivationHandlers_(), requestAnimationFrame(function () {
        t.activationState_.hasDeactivationUXRun = !0, t.animateDeactivation_(n), t.resetActivationState_();
      }));
    }
  }, e.prototype.animateDeactivation_ = function (t) {
    var e = t.wasActivatedByPointer,
        n = t.wasElementMadeActive;
    (e || n) && this.runDeactivationUXLogicIfReady_();
  }, e.prototype.layoutInternal_ = function () {
    var t = this;
    this.frame_ = this.adapter_.computeBoundingRect();
    var n = Math.max(this.frame_.height, this.frame_.width);
    this.maxRadius_ = this.adapter_.isUnbounded() ? n : Math.sqrt(Math.pow(t.frame_.width, 2) + Math.pow(t.frame_.height, 2)) + e.numbers.PADDING, this.initialSize_ = Math.floor(n * e.numbers.INITIAL_ORIGIN_SCALE), this.fgScale_ = "" + this.maxRadius_ / this.initialSize_, this.updateLayoutCssVars_();
  }, e.prototype.updateLayoutCssVars_ = function () {
    var t = e.strings,
        n = t.VAR_FG_SIZE,
        i = t.VAR_LEFT,
        r = t.VAR_TOP,
        o = t.VAR_FG_SCALE;
    this.adapter_.updateCssVariable(n, this.initialSize_ + "px"), this.adapter_.updateCssVariable(o, this.fgScale_), this.adapter_.isUnbounded() && (this.unboundedCoords_ = {
      left: Math.round(this.frame_.width / 2 - this.initialSize_ / 2),
      top: Math.round(this.frame_.height / 2 - this.initialSize_ / 2)
    }, this.adapter_.updateCssVariable(i, this.unboundedCoords_.left + "px"), this.adapter_.updateCssVariable(r, this.unboundedCoords_.top + "px"));
  }, e;
}(Yt),
    Ei = function (t) {
  function e() {
    var e = null !== t && t.apply(this, arguments) || this;
    return e.disabled = !1, e;
  }

  return Vt(e, t), e.attachTo = function (t, n) {
    void 0 === n && (n = {
      isUnbounded: void 0
    });
    var i = new e(t);
    return void 0 !== n.isUnbounded && (i.unbounded = n.isUnbounded), i;
  }, e.createAdapter = function (t) {
    return {
      addClass: function addClass(e) {
        return t.root_.classList.add(e);
      },
      browserSupportsCssVars: function browserSupportsCssVars() {
        return function (t, e) {
          void 0 === e && (e = !1);
          var n = t.CSS,
              i = di;
          if ("boolean" == typeof di && !e) return di;
          if (!n || "function" != typeof n.supports) return !1;
          var r = n.supports("--css-vars", "yes"),
              o = n.supports("(--css-vars: yes)") && n.supports("color", "#00000000");
          return i = !(!r && !o || function (t) {
            var e = t.document,
                n = e.createElement("div");
            n.className = "mdc-ripple-surface--test-edge-var-bug", e.body.appendChild(n);
            var i = t.getComputedStyle(n),
                r = null !== i && "solid" === i.borderTopStyle;
            return n.parentNode && n.parentNode.removeChild(n), r;
          }(t)), e || (di = i), i;
        }(window);
      },
      computeBoundingRect: function computeBoundingRect() {
        return t.root_.getBoundingClientRect();
      },
      containsEventTarget: function containsEventTarget(e) {
        return t.root_.contains(e);
      },
      deregisterDocumentInteractionHandler: function deregisterDocumentInteractionHandler(t, e) {
        return document.documentElement.removeEventListener(t, e, _i());
      },
      deregisterInteractionHandler: function deregisterInteractionHandler(e, n) {
        return t.root_.removeEventListener(e, n, _i());
      },
      deregisterResizeHandler: function deregisterResizeHandler(t) {
        return window.removeEventListener("resize", t);
      },
      getWindowPageOffset: function getWindowPageOffset() {
        return {
          x: window.pageXOffset,
          y: window.pageYOffset
        };
      },
      isSurfaceActive: function isSurfaceActive() {
        return Zt(t.root_, ":active");
      },
      isSurfaceDisabled: function isSurfaceDisabled() {
        return Boolean(t.disabled);
      },
      isUnbounded: function isUnbounded() {
        return Boolean(t.unbounded);
      },
      registerDocumentInteractionHandler: function registerDocumentInteractionHandler(t, e) {
        return document.documentElement.addEventListener(t, e, _i());
      },
      registerInteractionHandler: function registerInteractionHandler(e, n) {
        return t.root_.addEventListener(e, n, _i());
      },
      registerResizeHandler: function registerResizeHandler(t) {
        return window.addEventListener("resize", t);
      },
      removeClass: function removeClass(e) {
        return t.root_.classList.remove(e);
      },
      updateCssVariable: function updateCssVariable(e, n) {
        return t.root_.style.setProperty(e, n);
      }
    };
  }, Object.defineProperty(e.prototype, "unbounded", {
    get: function get() {
      return Boolean(this.unbounded_);
    },
    set: function set(t) {
      this.unbounded_ = Boolean(t), this.setUnbounded_();
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.activate = function () {
    this.foundation_.activate();
  }, e.prototype.deactivate = function () {
    this.foundation_.deactivate();
  }, e.prototype.layout = function () {
    this.foundation_.layout();
  }, e.prototype.getDefaultFoundation = function () {
    return new bi(e.createAdapter(this));
  }, e.prototype.initialSyncWithDOM = function () {
    var t = this.root_;
    this.unbounded = "mdcRippleIsUnbounded" in t.dataset;
  }, e.prototype.setUnbounded_ = function () {
    this.foundation_.setUnbounded(Boolean(this.unbounded_));
  }, e;
}($t),
    Ci = {
  ANIM_CHECKED_INDETERMINATE: "mdc-checkbox--anim-checked-indeterminate",
  ANIM_CHECKED_UNCHECKED: "mdc-checkbox--anim-checked-unchecked",
  ANIM_INDETERMINATE_CHECKED: "mdc-checkbox--anim-indeterminate-checked",
  ANIM_INDETERMINATE_UNCHECKED: "mdc-checkbox--anim-indeterminate-unchecked",
  ANIM_UNCHECKED_CHECKED: "mdc-checkbox--anim-unchecked-checked",
  ANIM_UNCHECKED_INDETERMINATE: "mdc-checkbox--anim-unchecked-indeterminate",
  BACKGROUND: "mdc-checkbox__background",
  CHECKED: "mdc-checkbox--checked",
  CHECKMARK: "mdc-checkbox__checkmark",
  CHECKMARK_PATH: "mdc-checkbox__checkmark-path",
  DISABLED: "mdc-checkbox--disabled",
  INDETERMINATE: "mdc-checkbox--indeterminate",
  MIXEDMARK: "mdc-checkbox__mixedmark",
  NATIVE_CONTROL: "mdc-checkbox__native-control",
  ROOT: "mdc-checkbox",
  SELECTED: "mdc-checkbox--selected",
  UPGRADED: "mdc-checkbox--upgraded"
},
    Ai = {
  ARIA_CHECKED_ATTR: "aria-checked",
  ARIA_CHECKED_INDETERMINATE_VALUE: "mixed",
  NATIVE_CONTROL_SELECTOR: ".mdc-checkbox__native-control",
  TRANSITION_STATE_CHECKED: "checked",
  TRANSITION_STATE_INDETERMINATE: "indeterminate",
  TRANSITION_STATE_INIT: "init",
  TRANSITION_STATE_UNCHECKED: "unchecked"
},
    Ti = {
  ANIM_END_LATCH_MS: 250
},
    Ii = function (t) {
  function e(n) {
    var i = t.call(this, _jt({}, e.defaultAdapter, n)) || this;
    return i.currentCheckState_ = Ai.TRANSITION_STATE_INIT, i.currentAnimationClass_ = "", i.animEndLatchTimer_ = 0, i.enableAnimationEndHandler_ = !1, i;
  }

  return Vt(e, t), Object.defineProperty(e, "cssClasses", {
    get: function get() {
      return Ci;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "strings", {
    get: function get() {
      return Ai;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "numbers", {
    get: function get() {
      return Ti;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultAdapter", {
    get: function get() {
      return {
        addClass: function addClass() {},
        forceLayout: function forceLayout() {},
        hasNativeControl: function hasNativeControl() {
          return !1;
        },
        isAttachedToDOM: function isAttachedToDOM() {
          return !1;
        },
        isChecked: function isChecked() {
          return !1;
        },
        isIndeterminate: function isIndeterminate() {
          return !1;
        },
        removeClass: function removeClass() {},
        removeNativeControlAttr: function removeNativeControlAttr() {},
        setNativeControlAttr: function setNativeControlAttr() {},
        setNativeControlDisabled: function setNativeControlDisabled() {}
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.init = function () {
    this.currentCheckState_ = this.determineCheckState_(), this.updateAriaChecked_(), this.adapter_.addClass(Ci.UPGRADED);
  }, e.prototype.destroy = function () {
    clearTimeout(this.animEndLatchTimer_);
  }, e.prototype.setDisabled = function (t) {
    this.adapter_.setNativeControlDisabled(t), t ? this.adapter_.addClass(Ci.DISABLED) : this.adapter_.removeClass(Ci.DISABLED);
  }, e.prototype.handleAnimationEnd = function () {
    var t = this;
    this.enableAnimationEndHandler_ && (clearTimeout(this.animEndLatchTimer_), this.animEndLatchTimer_ = setTimeout(function () {
      t.adapter_.removeClass(t.currentAnimationClass_), t.enableAnimationEndHandler_ = !1;
    }, Ti.ANIM_END_LATCH_MS));
  }, e.prototype.handleChange = function () {
    this.transitionCheckState_();
  }, e.prototype.transitionCheckState_ = function () {
    if (this.adapter_.hasNativeControl()) {
      var t = this.currentCheckState_,
          e = this.determineCheckState_();

      if (t !== e) {
        this.updateAriaChecked_();
        var n = Ai.TRANSITION_STATE_UNCHECKED,
            i = Ci.SELECTED;
        e === n ? this.adapter_.removeClass(i) : this.adapter_.addClass(i), this.currentAnimationClass_.length > 0 && (clearTimeout(this.animEndLatchTimer_), this.adapter_.forceLayout(), this.adapter_.removeClass(this.currentAnimationClass_)), this.currentAnimationClass_ = this.getTransitionAnimationClass_(t, e), this.currentCheckState_ = e, this.adapter_.isAttachedToDOM() && this.currentAnimationClass_.length > 0 && (this.adapter_.addClass(this.currentAnimationClass_), this.enableAnimationEndHandler_ = !0);
      }
    }
  }, e.prototype.determineCheckState_ = function () {
    var t = Ai.TRANSITION_STATE_INDETERMINATE,
        e = Ai.TRANSITION_STATE_CHECKED,
        n = Ai.TRANSITION_STATE_UNCHECKED;
    return this.adapter_.isIndeterminate() ? t : this.adapter_.isChecked() ? e : n;
  }, e.prototype.getTransitionAnimationClass_ = function (t, n) {
    var i = Ai.TRANSITION_STATE_INIT,
        r = Ai.TRANSITION_STATE_CHECKED,
        o = Ai.TRANSITION_STATE_UNCHECKED,
        a = e.cssClasses,
        s = a.ANIM_UNCHECKED_CHECKED,
        c = a.ANIM_UNCHECKED_INDETERMINATE,
        u = a.ANIM_CHECKED_UNCHECKED,
        l = a.ANIM_CHECKED_INDETERMINATE,
        d = a.ANIM_INDETERMINATE_CHECKED,
        h = a.ANIM_INDETERMINATE_UNCHECKED;

    switch (t) {
      case i:
        return n === o ? "" : n === r ? d : h;

      case o:
        return n === r ? s : c;

      case r:
        return n === o ? u : l;

      default:
        return n === r ? d : h;
    }
  }, e.prototype.updateAriaChecked_ = function () {
    this.adapter_.isIndeterminate() ? this.adapter_.setNativeControlAttr(Ai.ARIA_CHECKED_ATTR, Ai.ARIA_CHECKED_INDETERMINATE_VALUE) : this.adapter_.removeNativeControlAttr(Ai.ARIA_CHECKED_ATTR);
  }, e;
}(Yt),
    Oi = ["checked", "indeterminate"];

!function (t) {
  function e() {
    var e = null !== t && t.apply(this, arguments) || this;
    return e.ripple_ = e.createRipple_(), e;
  }

  Vt(e, t), e.attachTo = function (t) {
    return new e(t);
  }, Object.defineProperty(e.prototype, "ripple", {
    get: function get() {
      return this.ripple_;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "checked", {
    get: function get() {
      return this.nativeControl_.checked;
    },
    set: function set(t) {
      this.nativeControl_.checked = t;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "indeterminate", {
    get: function get() {
      return this.nativeControl_.indeterminate;
    },
    set: function set(t) {
      this.nativeControl_.indeterminate = t;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "disabled", {
    get: function get() {
      return this.nativeControl_.disabled;
    },
    set: function set(t) {
      this.foundation_.setDisabled(t);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "value", {
    get: function get() {
      return this.nativeControl_.value;
    },
    set: function set(t) {
      this.nativeControl_.value = t;
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.initialSyncWithDOM = function () {
    var t = this;
    this.handleChange_ = function () {
      return t.foundation_.handleChange();
    }, this.handleAnimationEnd_ = function () {
      return t.foundation_.handleAnimationEnd();
    }, this.nativeControl_.addEventListener("change", this.handleChange_), this.listen(li(window, "animationend"), this.handleAnimationEnd_), this.installPropertyChangeHooks_();
  }, e.prototype.destroy = function () {
    this.ripple_.destroy(), this.nativeControl_.removeEventListener("change", this.handleChange_), this.unlisten(li(window, "animationend"), this.handleAnimationEnd_), this.uninstallPropertyChangeHooks_(), t.prototype.destroy.call(this);
  }, e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new Ii({
      addClass: function addClass(e) {
        return t.root_.classList.add(e);
      },
      forceLayout: function forceLayout() {
        return t.root_.offsetWidth;
      },
      hasNativeControl: function hasNativeControl() {
        return !!t.nativeControl_;
      },
      isAttachedToDOM: function isAttachedToDOM() {
        return Boolean(t.root_.parentNode);
      },
      isChecked: function isChecked() {
        return t.checked;
      },
      isIndeterminate: function isIndeterminate() {
        return t.indeterminate;
      },
      removeClass: function removeClass(e) {
        return t.root_.classList.remove(e);
      },
      removeNativeControlAttr: function removeNativeControlAttr(e) {
        return t.nativeControl_.removeAttribute(e);
      },
      setNativeControlAttr: function setNativeControlAttr(e, n) {
        return t.nativeControl_.setAttribute(e, n);
      },
      setNativeControlDisabled: function setNativeControlDisabled(e) {
        return t.nativeControl_.disabled = e;
      }
    });
  }, e.prototype.createRipple_ = function () {
    var t = this,
        e = _jt({}, Ei.createAdapter(this), {
      deregisterInteractionHandler: function deregisterInteractionHandler(e, n) {
        return t.nativeControl_.removeEventListener(e, n);
      },
      isSurfaceActive: function isSurfaceActive() {
        return Zt(t.nativeControl_, ":active");
      },
      isUnbounded: function isUnbounded() {
        return !0;
      },
      registerInteractionHandler: function registerInteractionHandler(e, n) {
        return t.nativeControl_.addEventListener(e, n);
      }
    });

    return new Ei(this.root_, new bi(e));
  }, e.prototype.installPropertyChangeHooks_ = function () {
    var t = this,
        e = this.nativeControl_,
        n = Object.getPrototypeOf(e);
    Oi.forEach(function (i) {
      var r = Object.getOwnPropertyDescriptor(n, i);

      if (Si(r)) {
        var o = r.get,
            a = {
          configurable: r.configurable,
          enumerable: r.enumerable,
          get: o,
          set: function set(n) {
            r.set.call(e, n), t.foundation_.handleChange();
          }
        };
        Object.defineProperty(e, i, a);
      }
    });
  }, e.prototype.uninstallPropertyChangeHooks_ = function () {
    var t = this.nativeControl_,
        e = Object.getPrototypeOf(t);
    Oi.forEach(function (n) {
      var i = Object.getOwnPropertyDescriptor(e, n);
      Si(i) && Object.defineProperty(t, n, i);
    });
  }, Object.defineProperty(e.prototype, "nativeControl_", {
    get: function get() {
      var t = Ii.strings.NATIVE_CONTROL_SELECTOR,
          e = this.root_.querySelector(t);
      if (!e) throw new Error("Checkbox component requires a " + t + " element");
      return e;
    },
    enumerable: !0,
    configurable: !0
  });
}($t);

function Si(t) {
  return !!t && "function" == typeof t.set;
}

var wi = {
  ROOT: "mdc-form-field"
},
    xi = {
  LABEL_SELECTOR: ".mdc-form-field > label"
},
    Ni = function (t) {
  function e(n) {
    var i = t.call(this, _jt({}, e.defaultAdapter, n)) || this;
    return i.clickHandler_ = function () {
      return i.handleClick_();
    }, i;
  }

  return Vt(e, t), Object.defineProperty(e, "cssClasses", {
    get: function get() {
      return wi;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "strings", {
    get: function get() {
      return xi;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultAdapter", {
    get: function get() {
      return {
        activateInputRipple: function activateInputRipple() {},
        deactivateInputRipple: function deactivateInputRipple() {},
        deregisterInteractionHandler: function deregisterInteractionHandler() {},
        registerInteractionHandler: function registerInteractionHandler() {}
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.init = function () {
    this.adapter_.registerInteractionHandler("click", this.clickHandler_);
  }, e.prototype.destroy = function () {
    this.adapter_.deregisterInteractionHandler("click", this.clickHandler_);
  }, e.prototype.handleClick_ = function () {
    var t = this;
    this.adapter_.activateInputRipple(), requestAnimationFrame(function () {
      return t.adapter_.deactivateInputRipple();
    });
  }, e;
}(Yt),
    Ri = (function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  Vt(e, t), e.attachTo = function (t) {
    return new e(t);
  }, Object.defineProperty(e.prototype, "input", {
    get: function get() {
      return this.input_;
    },
    set: function set(t) {
      this.input_ = t;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "label_", {
    get: function get() {
      var t = Ni.strings.LABEL_SELECTOR;
      return this.root_.querySelector(t);
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new Ni({
      activateInputRipple: function activateInputRipple() {
        t.input_ && t.input_.ripple && t.input_.ripple.activate();
      },
      deactivateInputRipple: function deactivateInputRipple() {
        t.input_ && t.input_.ripple && t.input_.ripple.deactivate();
      },
      deregisterInteractionHandler: function deregisterInteractionHandler(e, n) {
        t.label_ && t.label_.removeEventListener(e, n);
      },
      registerInteractionHandler: function registerInteractionHandler(e, n) {
        t.label_ && t.label_.addEventListener(e, n);
      }
    });
  };
}($t), function () {
  var _t16 = function t(e, n) {
    return (_t16 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var n in e) {
        e.hasOwnProperty(n) && (t[n] = e[n]);
      }
    })(e, n);
  };

  return function (e, n) {
    function i() {
      this.constructor = e;
    }

    _t16(e, n), e.prototype = null === n ? Object.create(n) : (i.prototype = n.prototype, new i());
  };
}()),
    _Li = function Li() {
  return (_Li = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    Di = Mt({
  displayName: "FormFieldRoot",
  defaultProps: {
    alignEnd: void 0
  },
  classNames: function classNames(t) {
    return ["mdc-form-field", {
      "mdc-form-field--align-end": t.alignEnd
    }];
  },
  consumeProps: ["alignEnd"]
}),
    ki = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return Ri(e, t), e.prototype.getDefaultFoundation = function () {
    return new Ni({
      registerInteractionHandler: function registerInteractionHandler(t, e) {},
      deregisterInteractionHandler: function deregisterInteractionHandler(t, e) {},
      activateInputRipple: function activateInputRipple() {},
      deactivateInputRipple: function deactivateInputRipple() {}
    });
  }, e.prototype.render = function () {
    return n(Di, _Li({}, this.props));
  }, e.displayName = "FormField", e;
}(Rt),
    Pi = function () {
  var _t17 = function t(e, n) {
    return (_t17 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var n in e) {
        e.hasOwnProperty(n) && (t[n] = e[n]);
      }
    })(e, n);
  };

  return function (e, n) {
    function i() {
      this.constructor = e;
    }

    _t17(e, n), e.prototype = null === n ? Object.create(n) : (i.prototype = n.prototype, new i());
  };
}(),
    _Fi = function Fi() {
  return (_Fi = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    Mi = function (t) {
  function e() {
    var e = null !== t && t.apply(this, arguments) || this;
    return e.generatedId = bt(e.constructor.displayName), e;
  }

  return Pi(e, t), Object.defineProperty(e.prototype, "hasLabel", {
    get: function get() {
      return this.props.label || this.props.children;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "id", {
    get: function get() {
      return this.props.id || this.generatedId;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "toggleRootProps", {
    get: function get() {
      var t = this.props,
          e = t.className,
          n = t.style,
          i = t.disabled,
          r = t.rootProps,
          o = void 0 === r ? {} : r;
      return this.hasLabel ? this.root.props({
        disabled: i
      }) : _Fi({}, this.root.props(_Fi({
        className: e,
        style: n,
        disabled: i
      }, o)));
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.renderToggle = function (t) {
    var e = this.props,
        i = e.className,
        r = e.style,
        o = e.rootProps,
        a = e.label,
        s = e.children;
    return this.hasLabel ? n(ki, _Fi({}, o, {
      className: i,
      style: r
    }), t, n("label", {
      id: this.id + "label",
      htmlFor: this.id
    }, a, s)) : t;
  }, e;
}(Rt),
    Hi = function () {
  var _t18 = function t(e, n) {
    return (_t18 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var n in e) {
        e.hasOwnProperty(n) && (t[n] = e[n]);
      }
    })(e, n);
  };

  return function (e, n) {
    function i() {
      this.constructor = e;
    }

    _t18(e, n), e.prototype = null === n ? Object.create(n) : (i.prototype = n.prototype, new i());
  };
}(),
    _Bi = function Bi() {
  return (_Bi = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    Vi = function Vi(t, e) {
  var n = {};

  for (var i in t) {
    Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
  }

  if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
    var r = 0;

    for (i = Object.getOwnPropertySymbols(t); r < i.length; r++) {
      e.indexOf(i[r]) < 0 && (n[i[r]] = t[i[r]]);
    }
  }

  return n;
};

Ii.prototype.installPropertyChangeHooks_ = function () {};

var ji = Ln({
  surface: !1,
  unbounded: !0
})(Mt({
  displayName: "CheckboxRoot",
  classNames: function classNames(t) {
    return ["mdc-checkbox", {
      "mdc-checkbox--disabled": t.disabled
    }];
  },
  consumeProps: ["disabled"]
})),
    Ui = Mt({
  displayName: "CheckboxNativeControl",
  defaultProps: {
    type: "checkbox"
  },
  tag: "input",
  classNames: ["mdc-checkbox__native-control"]
}),
    Gi = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return Hi(e, t), e.prototype.shouldComponentUpdate = function () {
    return !1;
  }, e.prototype.render = function () {
    return n("div", {
      className: "mdc-checkbox__background"
    }, n("svg", {
      className: "mdc-checkbox__checkmark",
      viewBox: "0 0 24 24"
    }, n("path", {
      className: "mdc-checkbox__checkmark-path",
      fill: "none",
      stroke: "white",
      d: "M1.73,12.91 8.1,19.28 22.79,4.59"
    })), n("div", {
      className: "mdc-checkbox__mixedmark"
    }));
  }, e.displayName = "CheckboxBackground", e;
}(i),
    zi = function (t) {
  function e(e) {
    var n = t.call(this, e) || this;
    return n.nativeCb = n.createElement("nativeCb"), n.root = n.createElement("root"), n.handleAnimationEnd = n.handleAnimationEnd.bind(n), n.handleOnChange = n.handleOnChange.bind(n), n;
  }

  return Hi(e, t), e.prototype.sync = function (t) {
    this.foundation && this.foundation.handleChange(), this.nativeCb.ref && t.indeterminate !== this.nativeCb.ref.indeterminate && (this.nativeCb.ref.indeterminate = !!t.indeterminate);
  }, e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new Ii({
      addClass: function addClass(e) {
        return t.root.addClass(e);
      },
      removeClass: function removeClass(e) {
        return t.root.removeClass(e);
      },
      setNativeControlAttr: function setNativeControlAttr(e, n) {
        return t.nativeCb.setProp(e, n);
      },
      removeNativeControlAttr: function removeNativeControlAttr(e) {
        return t.nativeCb.removeProp(e);
      },
      isIndeterminate: function isIndeterminate() {
        return !!t.props.indeterminate;
      },
      isChecked: function isChecked() {
        return void 0 !== t.props.checked ? !!t.props.checked : !!t.nativeCb.ref && t.nativeCb.ref.checked;
      },
      hasNativeControl: function hasNativeControl() {
        return !!t.nativeCb.ref;
      },
      setNativeControlDisabled: function setNativeControlDisabled(e) {
        return t.nativeCb.setProp("disabled", e);
      },
      forceLayout: function forceLayout() {
        return t.root.ref && t.root.ref.offsetWidth;
      },
      isAttachedToDOM: function isAttachedToDOM() {
        return !0;
      }
    });
  }, e.prototype.handleAnimationEnd = function (t) {
    this.props.onAnimationEnd && this.props.onAnimationEnd(t), this.foundation && this.foundation.handleAnimationEnd();
  }, e.prototype.handleOnChange = function (t) {
    this.props.onChange && this.props.onChange(t), this.sync(this.props);
  }, e.prototype.render = function () {
    var t = this,
        e = this.props,
        i = (e.children, e.className, e.label, e.style, e.indeterminate, e.inputRef),
        r = Vi(e, ["children", "className", "label", "style", "indeterminate", "inputRef"]),
        o = n(ji, _Bi({}, this.toggleRootProps, {
      ref: this.root.setRef,
      onAnimationEnd: this.handleAnimationEnd
    }), n(Ui, _Bi({}, this.nativeCb.props(r), {
      ref: function ref(e) {
        t.nativeCb.setRef(e), i && i(e);
      },
      id: this.id,
      onChange: this.handleOnChange
    })), n(Gi, null));
    return this.renderToggle(o);
  }, e.displayName = "Checkbox", e;
}(Mi);

var Ki =
/*#__PURE__*/
function (_i4) {
  _inherits(Ki, _i4);

  function Ki() {
    _classCallCheck(this, Ki);

    return _possibleConstructorReturn(this, _getPrototypeOf(Ki).apply(this, arguments));
  }

  _createClass(Ki, [{
    key: "createTextFieldClassNames",
    value: function createTextFieldClassNames() {
      return function (t) {
        var e = [Xn["txt-edit"], "mdc-text-field"];
        return t.data.isDisabled && e.push("mdc-text-field--disabled"), t.focused && e.push("mdc-text-field--focused"), t.data.isInvalid && e.push("mdc-text-field--invalid"), t.hideLabel && e.push(Xn["hide-label"]), e;
      };
    }
  }, {
    key: "renderFloatingLabel",
    value: function renderFloatingLabel(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return n("label", {
        style: e,
        className: "mdc-floating-label mdc-floating-label--float-above"
      }, t);
    }
  }]);

  return Ki;
}(i);

var qi =
/*#__PURE__*/
function (_Ki) {
  _inherits(qi, _Ki);

  function qi() {
    var _this19;

    _classCallCheck(this, qi);

    _this19 = _possibleConstructorReturn(this, _getPrototypeOf(qi).apply(this, arguments)), _this19.classNames = _this19.createTextFieldClassNames(), _this19.iconClassNames = "material-icons mdc-text-field__icon " + Xn["icon-txt--cancel"];
    return _this19;
  }

  _createClass(qi, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.inputRef && this.props.data.focusOnMount && this.inputRef.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this20 = this;

      var _this$props = this.props,
          t = _this$props.data,
          e = _this$props.hideLabel,
          i = t.getHtmlFormProps(),
          r = Object.assign({
        ref: function ref(t) {
          return _this20.inputRef = t;
        },
        onChange: function onChange(e) {
          return t.handleChange(e.currentTarget.value, i.type);
        },
        className: "mdc-text-field__input" + (e ? " " + Xn["hide-label"] : ""),
        disabled: t.isDisabled,
        value: t.isDefault || !t.hasValue ? "" : t.value,
        placeholder: t.hasDefault ? t.defaultValue : void 0,
        title: t.tooltip
      }, i);
      if (r.value && "object" == typeof r.value) switch (t.objectType) {
        case "Date":
          switch (r.type) {
            case "date":
              r.value = "".concat(r.value.getFullYear(), "-").concat(("0" + (r.value.getMonth() + 1)).slice(-2), "-").concat(("0" + r.value.getDate()).slice(-2));
              break;

            case "time":
              r.value = "".concat(("0" + r.value.getHours()).slice(-2), ":").concat(("0" + r.value.getMinutes()).slice(-2), ":").concat(("0" + r.value.getSeconds()).slice(-2));
              break;

            case "datetime-local":
            case "text":
              r.value = "".concat(r.value.getFullYear(), "-").concat(("0" + (r.value.getMonth() + 1)).slice(-2), "-").concat(("0" + r.value.getDate()).slice(-2), "T").concat(("0" + r.value.getHours()).slice(-2), ":").concat(("0" + r.value.getMinutes()).slice(-2), ":").concat(("0" + r.value.getSeconds()).slice(-2));
          }

      }
      var o = "text" === r.type;
      var a;

      switch (r.type) {
        case "number":
        case "text":
          a = "inherit";
          break;

        case "color":
          a = 150;
          break;

        default:
          a = "fit-content";
      }

      return n("div", {
        className: m(this.classNames(this.props))
      }, !e && this.renderFloatingLabel(t.name), n("input", Object.assign({}, r, {
        style: {
          borderBottom: "0px",
          width: a
        }
      })), o && r.value && n("i", {
        tabIndex: 0,
        className: this.iconClassNames,
        onClick: function onClick() {
          _this20.inputRef && (_this20.inputRef.value = "", _this20.props.data.handleChange(""), _this20.inputRef.focus());
        },
        title: "clear text"
      }, "cancel"));
    }
  }]);

  return qi;
}(Ki);

qi.displayName = "TextInputEditor";

var Wi =
/*#__PURE__*/
function (_Ki2) {
  _inherits(Wi, _Ki2);

  function Wi() {
    var _this21;

    _classCallCheck(this, Wi);

    _this21 = _possibleConstructorReturn(this, _getPrototypeOf(Wi).apply(this, arguments)), _this21.classNames = _this21.createTextFieldClassNames();
    return _this21;
  }

  _createClass(Wi, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          t = _this$props2.data,
          e = _this$props2.hideLabel,
          i = {
        onChange: function onChange(e) {
          return t.value = e.target.checked;
        },
        checked: t.hasValue ? t.value : !!t.hasDefault && t.defaultValue,
        title: t.tooltip,
        disabled: t.isDisabled
      };
      return n("div", {
        className: m(this.classNames(this.props)),
        style: {
          width: "100%",
          cursor: "initial"
        }
      }, !e && this.renderFloatingLabel(t.name), n("div", {
        style: {
          marginTop: e ? "0px" : "16px"
        }
      }, n(zi, Object.assign({}, i))));
    }
  }]);

  return Wi;
}(Ki);

Wi.displayName = "CheckboxEditor";

var Xi =
/*#__PURE__*/
function (_i5) {
  _inherits(Xi, _i5);

  function Xi() {
    _classCallCheck(this, Xi);

    return _possibleConstructorReturn(this, _getPrototypeOf(Xi).apply(this, arguments));
  }

  _createClass(Xi, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return !1;
    }
  }, {
    key: "render",
    value: function render() {
      return n("i", {
        style: Object.assign({}, this.props.style, {
          left: "auto",
          right: 8,
          bottom: 16,
          width: 24,
          height: 24,
          zIndex: 1,
          position: "absolute"
        }),
        className: "material-icons " + Xn.row_c_dd_ico
      }, "arrow_drop_down");
    }
  }]);

  return Xi;
}(i);

var Yi =
/*#__PURE__*/
function (_Ki3) {
  _inherits(Yi, _Ki3);

  function Yi(t) {
    var _this22;

    _classCallCheck(this, Yi);

    _this22 = _possibleConstructorReturn(this, _getPrototypeOf(Yi).call(this, t)), _this22.classNamesContainer = function (t) {
      var e = [Xn["dd-edit"], "mdc-select"];
      return t.data.isDisabled && e.push("mdc-select--disabled"), t.focused && e.push("mdc-select--focused"), t.data.isInvalid && e.push("mdc-select--invalid"), t.hideLabel && e.push(Xn["hide-label"]), e;
    };
    return _this22;
  }

  _createClass(Yi, [{
    key: "createSelectOptions",
    value: function createSelectOptions(t) {
      var _this23 = this;

      return Array.isArray(t) && t[0] && "object" == typeof t[0] ? t.map(function (t) {
        if ("object" != typeof t) throw new Error("Encountered non object for Select ".concat(t));
        return Object.assign({}, t, {
          options: _this23.createSelectOptions(t.options)
        });
      }) : Array.isArray(t) ? t.map(function (t) {
        return {
          value: t,
          label: t
        };
      }) : "object" == typeof t ? Object.keys(t).map(function (e) {
        return {
          value: e,
          label: t[e]
        };
      }) : t;
    }
  }, {
    key: "render",
    value: function render() {
      var _this24 = this;

      var _this$props3 = this.props,
          t = _this$props3.data,
          e = _this$props3.hideLabel,
          i = _this$props3.children,
          r = this.createSelectOptions(t.getSelectionOptions()),
          o = {
        ref: function ref(t) {
          return _this24.selectRef = t;
        },
        className: "mdc-select__native-control",
        onChange: function onChange(e) {
          return t.handleChange(e.currentTarget.value);
        },
        disabled: t.isDisabled,
        title: t.tooltip,
        placeholder: t.defaultValue,
        value: t.value
      };
      return n("div", {
        style: {
          width: "100%",
          borderRadius: "unset"
        },
        className: m(this.classNamesContainer(this.props))
      }, !e && this.renderFloatingLabel(t.name, {
        left: "12px"
      }), n(Xi, {
        style: {
          bottom: e ? "unset" : ""
        }
      }), n("select", Object.assign({}, o, {
        style: {
          border: "none",
          paddingLeft: "12px",
          height: e ? "unset" : "",
          paddingTop: e ? "unset" : "",
          paddingBottom: e ? "unset" : ""
        }
      }), (!t.value || t.hasDefault) && n("option", {
        value: t.hasDefault ? t.defaultValue : "",
        disabled: !t.hasDefault
      }, t.defaultValue), !!r && r.map(function (t, e) {
        var i = t.label,
            r = t.options,
            o = Ut(t, ["label", "options"]);
        return r ? n("optgroup", {
          label: i,
          key: i
        }, r.map(function (t, e) {
          var i = t.label,
              r = Ut(t, ["label"]);
          return n("option", Object.assign({
            key: i
          }, r, {
            value: r.value
          }), i);
        })) : n("option", Object.assign({
          key: i
        }, o, {
          value: o.value
        }), i);
      }), i));
    }
  }]);

  return Yi;
}(Ki);

Yi.displayName = "DropdownListEditor";
var $i,
    Qi,
    Zi = {
  toolbar: "mib-toolbar-toolbar-3TOFZ",
  row: "mib-toolbar-row-XIhs_",
  second: "mib-toolbar-second-3pznf",
  vertical: "mib-toolbar-vertical-ig4cB",
  section: "mib-toolbar-section-1-z7x",
  hidden: "mib-toolbar-hidden-UdeET",
  opened: "mib-toolbar-opened-1nGhq",
  button: "mib-toolbar-button-3IbeT",
  "select-mode": "mib-toolbar-select-mode-3tz43",
  icon: "mib-toolbar-icon-1sMCn",
  "icon--disabled": "mib-toolbar-icon--disabled-2HvFs",
  "icon-withContent": "mib-toolbar-icon-withContent-3GqBs",
  "icon-second": "mib-toolbar-icon-second-1fNFm",
  "icon-small": "mib-toolbar-icon-small-1NBLI",
  "icon--checked": "mib-toolbar-icon--checked-356yd",
  "label-small": "mib-toolbar-label-small-3G6jx"
},
    Ji = {
  ANCHOR: "mdc-menu-surface--anchor",
  ANIMATING_CLOSED: "mdc-menu-surface--animating-closed",
  ANIMATING_OPEN: "mdc-menu-surface--animating-open",
  FIXED: "mdc-menu-surface--fixed",
  OPEN: "mdc-menu-surface--open",
  ROOT: "mdc-menu-surface"
},
    tr = {
  CLOSED_EVENT: "MDCMenuSurface:closed",
  OPENED_EVENT: "MDCMenuSurface:opened",
  FOCUSABLE_ELEMENTS: ["button:not(:disabled)", '[href]:not([aria-disabled="true"])', "input:not(:disabled)", "select:not(:disabled)", "textarea:not(:disabled)", '[tabindex]:not([tabindex="-1"]):not([aria-disabled="true"])'].join(", ")
},
    er = {
  TRANSITION_OPEN_DURATION: 120,
  TRANSITION_CLOSE_DURATION: 75,
  MARGIN_TO_EDGE: 32,
  ANCHOR_TO_MENU_SURFACE_WIDTH_RATIO: .67
};
!function (t) {
  t[t.BOTTOM = 1] = "BOTTOM", t[t.CENTER = 2] = "CENTER", t[t.RIGHT = 4] = "RIGHT", t[t.FLIP_RTL = 8] = "FLIP_RTL";
}($i || ($i = {})), function (t) {
  t[t.TOP_LEFT = 0] = "TOP_LEFT", t[t.TOP_RIGHT = 4] = "TOP_RIGHT", t[t.BOTTOM_LEFT = 1] = "BOTTOM_LEFT", t[t.BOTTOM_RIGHT = 5] = "BOTTOM_RIGHT", t[t.TOP_START = 8] = "TOP_START", t[t.TOP_END = 12] = "TOP_END", t[t.BOTTOM_START = 9] = "BOTTOM_START", t[t.BOTTOM_END = 13] = "BOTTOM_END";
}(Qi || (Qi = {}));
var nr = {
  LIST_ITEM_ACTIVATED_CLASS: "mdc-list-item--activated",
  LIST_ITEM_CLASS: "mdc-list-item",
  LIST_ITEM_DISABLED_CLASS: "mdc-list-item--disabled",
  LIST_ITEM_SELECTED_CLASS: "mdc-list-item--selected",
  ROOT: "mdc-list"
},
    ir = {
  ACTION_EVENT: "MDCList:action",
  ARIA_CHECKED: "aria-checked",
  ARIA_CHECKED_CHECKBOX_SELECTOR: '[role="checkbox"][aria-checked="true"]',
  ARIA_CHECKED_RADIO_SELECTOR: '[role="radio"][aria-checked="true"]',
  ARIA_CURRENT: "aria-current",
  ARIA_ORIENTATION: "aria-orientation",
  ARIA_ORIENTATION_HORIZONTAL: "horizontal",
  ARIA_ROLE_CHECKBOX_SELECTOR: '[role="checkbox"]',
  ARIA_SELECTED: "aria-selected",
  CHECKBOX_RADIO_SELECTOR: 'input[type="checkbox"]:not(:disabled), input[type="radio"]:not(:disabled)',
  CHECKBOX_SELECTOR: 'input[type="checkbox"]:not(:disabled)',
  CHILD_ELEMENTS_TO_TOGGLE_TABINDEX: "\n    ." + nr.LIST_ITEM_CLASS + " button:not(:disabled),\n    ." + nr.LIST_ITEM_CLASS + " a\n  ",
  FOCUSABLE_CHILD_ELEMENTS: "\n    ." + nr.LIST_ITEM_CLASS + " button:not(:disabled),\n    ." + nr.LIST_ITEM_CLASS + " a,\n    ." + nr.LIST_ITEM_CLASS + ' input[type="radio"]:not(:disabled),\n    .' + nr.LIST_ITEM_CLASS + ' input[type="checkbox"]:not(:disabled)\n  ',
  RADIO_SELECTOR: 'input[type="radio"]:not(:disabled)'
},
    rr = {
  UNSET_INDEX: -1
},
    or = ["input", "button", "textarea", "select"];

var ar,
    sr = function (t) {
  function e(n) {
    var i = t.call(this, _jt({}, e.defaultAdapter, n)) || this;
    return i.wrapFocus_ = !1, i.isVertical_ = !0, i.isSingleSelectionList_ = !1, i.selectedIndex_ = rr.UNSET_INDEX, i.focusedItemIndex_ = rr.UNSET_INDEX, i.useActivatedClass_ = !1, i.ariaCurrentAttrValue_ = null, i.isCheckboxList_ = !1, i.isRadioList_ = !1, i;
  }

  return Vt(e, t), Object.defineProperty(e, "strings", {
    get: function get() {
      return ir;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "cssClasses", {
    get: function get() {
      return nr;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "numbers", {
    get: function get() {
      return rr;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultAdapter", {
    get: function get() {
      return {
        addClassForElementIndex: function addClassForElementIndex() {},
        focusItemAtIndex: function focusItemAtIndex() {},
        getAttributeForElementIndex: function getAttributeForElementIndex() {
          return null;
        },
        getFocusedElementIndex: function getFocusedElementIndex() {
          return 0;
        },
        getListItemCount: function getListItemCount() {
          return 0;
        },
        hasCheckboxAtIndex: function hasCheckboxAtIndex() {
          return !1;
        },
        hasRadioAtIndex: function hasRadioAtIndex() {
          return !1;
        },
        isCheckboxCheckedAtIndex: function isCheckboxCheckedAtIndex() {
          return !1;
        },
        isFocusInsideList: function isFocusInsideList() {
          return !1;
        },
        isRootFocused: function isRootFocused() {
          return !1;
        },
        notifyAction: function notifyAction() {},
        removeClassForElementIndex: function removeClassForElementIndex() {},
        setAttributeForElementIndex: function setAttributeForElementIndex() {},
        setCheckedCheckboxOrRadioAtIndex: function setCheckedCheckboxOrRadioAtIndex() {},
        setTabIndexForListItemChildren: function setTabIndexForListItemChildren() {}
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.layout = function () {
    0 !== this.adapter_.getListItemCount() && (this.adapter_.hasCheckboxAtIndex(0) ? this.isCheckboxList_ = !0 : this.adapter_.hasRadioAtIndex(0) && (this.isRadioList_ = !0));
  }, e.prototype.setWrapFocus = function (t) {
    this.wrapFocus_ = t;
  }, e.prototype.setVerticalOrientation = function (t) {
    this.isVertical_ = t;
  }, e.prototype.setSingleSelection = function (t) {
    this.isSingleSelectionList_ = t;
  }, e.prototype.setUseActivatedClass = function (t) {
    this.useActivatedClass_ = t;
  }, e.prototype.getSelectedIndex = function () {
    return this.selectedIndex_;
  }, e.prototype.setSelectedIndex = function (t) {
    this.isIndexValid_(t) && (this.isCheckboxList_ ? this.setCheckboxAtIndex_(t) : this.isRadioList_ ? this.setRadioAtIndex_(t) : this.setSingleSelectionAtIndex_(t));
  }, e.prototype.handleFocusIn = function (t, e) {
    e >= 0 && this.adapter_.setTabIndexForListItemChildren(e, "0");
  }, e.prototype.handleFocusOut = function (t, e) {
    var n = this;
    e >= 0 && this.adapter_.setTabIndexForListItemChildren(e, "-1"), setTimeout(function () {
      n.adapter_.isFocusInsideList() || n.setTabindexToFirstSelectedItem_();
    }, 0);
  }, e.prototype.handleKeydown = function (t, e, n) {
    var i = "ArrowLeft" === t.key || 37 === t.keyCode,
        r = "ArrowUp" === t.key || 38 === t.keyCode,
        o = "ArrowRight" === t.key || 39 === t.keyCode,
        a = "ArrowDown" === t.key || 40 === t.keyCode,
        s = "Home" === t.key || 36 === t.keyCode,
        c = "End" === t.key || 35 === t.keyCode,
        u = "Enter" === t.key || 13 === t.keyCode,
        l = "Space" === t.key || 32 === t.keyCode;
    if (this.adapter_.isRootFocused()) r || c ? (t.preventDefault(), this.focusLastElement()) : (a || s) && (t.preventDefault(), this.focusFirstElement());else {
      var d = this.adapter_.getFocusedElementIndex();

      if (!(-1 === d && (d = n) < 0)) {
        var h;
        if (this.isVertical_ && a || !this.isVertical_ && o) this.preventDefaultEvent_(t), h = this.focusNextElement(d);else if (this.isVertical_ && r || !this.isVertical_ && i) this.preventDefaultEvent_(t), h = this.focusPrevElement(d);else if (s) this.preventDefaultEvent_(t), h = this.focusFirstElement();else if (c) this.preventDefaultEvent_(t), h = this.focusLastElement();else if ((u || l) && e) {
          var p = t.target;
          if (p && "A" === p.tagName && u) return;
          this.preventDefaultEvent_(t), this.isSelectableList_() && this.setSelectedIndexOnAction_(d), this.adapter_.notifyAction(d);
        }
        this.focusedItemIndex_ = d, void 0 !== h && (this.setTabindexAtIndex_(h), this.focusedItemIndex_ = h);
      }
    }
  }, e.prototype.handleClick = function (t, e) {
    t !== rr.UNSET_INDEX && (this.isSelectableList_() && this.setSelectedIndexOnAction_(t, e), this.adapter_.notifyAction(t), this.setTabindexAtIndex_(t), this.focusedItemIndex_ = t);
  }, e.prototype.focusNextElement = function (t) {
    var e = t + 1;

    if (e >= this.adapter_.getListItemCount()) {
      if (!this.wrapFocus_) return t;
      e = 0;
    }

    return this.adapter_.focusItemAtIndex(e), e;
  }, e.prototype.focusPrevElement = function (t) {
    var e = t - 1;

    if (e < 0) {
      if (!this.wrapFocus_) return t;
      e = this.adapter_.getListItemCount() - 1;
    }

    return this.adapter_.focusItemAtIndex(e), e;
  }, e.prototype.focusFirstElement = function () {
    return this.adapter_.focusItemAtIndex(0), 0;
  }, e.prototype.focusLastElement = function () {
    var t = this.adapter_.getListItemCount() - 1;
    return this.adapter_.focusItemAtIndex(t), t;
  }, e.prototype.preventDefaultEvent_ = function (t) {
    var e = ("" + t.target.tagName).toLowerCase();
    -1 === or.indexOf(e) && t.preventDefault();
  }, e.prototype.setSingleSelectionAtIndex_ = function (t) {
    if (this.selectedIndex_ !== t) {
      var e = nr.LIST_ITEM_SELECTED_CLASS;
      this.useActivatedClass_ && (e = nr.LIST_ITEM_ACTIVATED_CLASS), this.selectedIndex_ !== rr.UNSET_INDEX && this.adapter_.removeClassForElementIndex(this.selectedIndex_, e), this.adapter_.addClassForElementIndex(t, e), this.setAriaForSingleSelectionAtIndex_(t), this.selectedIndex_ = t;
    }
  }, e.prototype.setAriaForSingleSelectionAtIndex_ = function (t) {
    this.selectedIndex_ === rr.UNSET_INDEX && (this.ariaCurrentAttrValue_ = this.adapter_.getAttributeForElementIndex(t, ir.ARIA_CURRENT));
    var e = null !== this.ariaCurrentAttrValue_,
        n = e ? ir.ARIA_CURRENT : ir.ARIA_SELECTED;
    this.selectedIndex_ !== rr.UNSET_INDEX && this.adapter_.setAttributeForElementIndex(this.selectedIndex_, n, "false");
    var i = e ? this.ariaCurrentAttrValue_ : "true";
    this.adapter_.setAttributeForElementIndex(t, n, i);
  }, e.prototype.setRadioAtIndex_ = function (t) {
    this.adapter_.setCheckedCheckboxOrRadioAtIndex(t, !0), this.selectedIndex_ !== rr.UNSET_INDEX && this.adapter_.setAttributeForElementIndex(this.selectedIndex_, ir.ARIA_CHECKED, "false"), this.adapter_.setAttributeForElementIndex(t, ir.ARIA_CHECKED, "true"), this.selectedIndex_ = t;
  }, e.prototype.setCheckboxAtIndex_ = function (t) {
    for (var e = 0; e < this.adapter_.getListItemCount(); e++) {
      var n = !1;
      t.indexOf(e) >= 0 && (n = !0), this.adapter_.setCheckedCheckboxOrRadioAtIndex(e, n), this.adapter_.setAttributeForElementIndex(e, ir.ARIA_CHECKED, n ? "true" : "false");
    }

    this.selectedIndex_ = t;
  }, e.prototype.setTabindexAtIndex_ = function (t) {
    this.focusedItemIndex_ === rr.UNSET_INDEX && 0 !== t ? this.adapter_.setAttributeForElementIndex(0, "tabindex", "-1") : this.focusedItemIndex_ >= 0 && this.focusedItemIndex_ !== t && this.adapter_.setAttributeForElementIndex(this.focusedItemIndex_, "tabindex", "-1"), this.adapter_.setAttributeForElementIndex(t, "tabindex", "0");
  }, e.prototype.isSelectableList_ = function () {
    return this.isSingleSelectionList_ || this.isCheckboxList_ || this.isRadioList_;
  }, e.prototype.setTabindexToFirstSelectedItem_ = function () {
    var t = 0;
    this.isSelectableList_() && ("number" == typeof this.selectedIndex_ && this.selectedIndex_ !== rr.UNSET_INDEX ? t = this.selectedIndex_ : this.selectedIndex_ instanceof Array && this.selectedIndex_.length > 0 && (t = this.selectedIndex_.reduce(function (t, e) {
      return Math.min(t, e);
    }))), this.setTabindexAtIndex_(t);
  }, e.prototype.isIndexValid_ = function (t) {
    var e = this;

    if (t instanceof Array) {
      if (!this.isCheckboxList_) throw new Error("MDCListFoundation: Array of index is only supported for checkbox based list");
      return 0 === t.length || t.some(function (t) {
        return e.isIndexInRange_(t);
      });
    }

    if ("number" == typeof t) {
      if (this.isCheckboxList_) throw new Error("MDCListFoundation: Expected array of index for checkbox based list but got number: " + t);
      return this.isIndexInRange_(t);
    }

    return !1;
  }, e.prototype.isIndexInRange_ = function (t) {
    var e = this.adapter_.getListItemCount();
    return t >= 0 && t < e;
  }, e.prototype.setSelectedIndexOnAction_ = function (t, e) {
    void 0 === e && (e = !0), this.isCheckboxList_ ? this.toggleCheckboxAtIndex_(t, e) : this.setSelectedIndex(t);
  }, e.prototype.toggleCheckboxAtIndex_ = function (t, e) {
    var n = this.adapter_.isCheckboxCheckedAtIndex(t);
    e && (n = !n, this.adapter_.setCheckedCheckboxOrRadioAtIndex(t, n)), this.adapter_.setAttributeForElementIndex(t, ir.ARIA_CHECKED, n ? "true" : "false");
    var i = this.selectedIndex_ === rr.UNSET_INDEX ? [] : this.selectedIndex_.slice();
    n ? i.push(t) : i = i.filter(function (e) {
      return e !== t;
    }), this.selectedIndex_ = i;
  }, e;
}(Yt),
    cr = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return Vt(e, t), Object.defineProperty(e.prototype, "vertical", {
    set: function set(t) {
      this.foundation_.setVerticalOrientation(t);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "listElements", {
    get: function get() {
      return [].slice.call(this.root_.querySelectorAll("." + nr.LIST_ITEM_CLASS));
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "wrapFocus", {
    set: function set(t) {
      this.foundation_.setWrapFocus(t);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "singleSelection", {
    set: function set(t) {
      this.foundation_.setSingleSelection(t);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "selectedIndex", {
    get: function get() {
      return this.foundation_.getSelectedIndex();
    },
    set: function set(t) {
      this.foundation_.setSelectedIndex(t);
    },
    enumerable: !0,
    configurable: !0
  }), e.attachTo = function (t) {
    return new e(t);
  }, e.prototype.initialSyncWithDOM = function () {
    this.handleClick_ = this.handleClickEvent_.bind(this), this.handleKeydown_ = this.handleKeydownEvent_.bind(this), this.focusInEventListener_ = this.handleFocusInEvent_.bind(this), this.focusOutEventListener_ = this.handleFocusOutEvent_.bind(this), this.listen("keydown", this.handleKeydown_), this.listen("click", this.handleClick_), this.listen("focusin", this.focusInEventListener_), this.listen("focusout", this.focusOutEventListener_), this.layout(), this.initializeListType();
  }, e.prototype.destroy = function () {
    this.unlisten("keydown", this.handleKeydown_), this.unlisten("click", this.handleClick_), this.unlisten("focusin", this.focusInEventListener_), this.unlisten("focusout", this.focusOutEventListener_);
  }, e.prototype.layout = function () {
    var t = this.root_.getAttribute(ir.ARIA_ORIENTATION);
    this.vertical = t !== ir.ARIA_ORIENTATION_HORIZONTAL, [].slice.call(this.root_.querySelectorAll(".mdc-list-item:not([tabindex])")).forEach(function (t) {
      t.setAttribute("tabindex", "-1");
    }), [].slice.call(this.root_.querySelectorAll(ir.FOCUSABLE_CHILD_ELEMENTS)).forEach(function (t) {
      return t.setAttribute("tabindex", "-1");
    }), this.foundation_.layout();
  }, e.prototype.initializeListType = function () {
    var t = this,
        e = this.root_.querySelectorAll(ir.ARIA_ROLE_CHECKBOX_SELECTOR),
        n = this.root_.querySelector("\n      ." + nr.LIST_ITEM_ACTIVATED_CLASS + ",\n      ." + nr.LIST_ITEM_SELECTED_CLASS + "\n    "),
        i = this.root_.querySelector(ir.ARIA_CHECKED_RADIO_SELECTOR);

    if (e.length) {
      var r = this.root_.querySelectorAll(ir.ARIA_CHECKED_CHECKBOX_SELECTOR);
      this.selectedIndex = [].map.call(r, function (e) {
        return t.listElements.indexOf(e);
      });
    } else n ? (n.classList.contains(nr.LIST_ITEM_ACTIVATED_CLASS) && this.foundation_.setUseActivatedClass(!0), this.singleSelection = !0, this.selectedIndex = this.listElements.indexOf(n)) : i && (this.selectedIndex = this.listElements.indexOf(i));
  }, e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new sr({
      addClassForElementIndex: function addClassForElementIndex(e, n) {
        var i = t.listElements[e];
        i && i.classList.add(n);
      },
      focusItemAtIndex: function focusItemAtIndex(e) {
        var n = t.listElements[e];
        n && n.focus();
      },
      getAttributeForElementIndex: function getAttributeForElementIndex(e, n) {
        return t.listElements[e].getAttribute(n);
      },
      getFocusedElementIndex: function getFocusedElementIndex() {
        return t.listElements.indexOf(document.activeElement);
      },
      getListItemCount: function getListItemCount() {
        return t.listElements.length;
      },
      hasCheckboxAtIndex: function hasCheckboxAtIndex(e) {
        return !!t.listElements[e].querySelector(ir.CHECKBOX_SELECTOR);
      },
      hasRadioAtIndex: function hasRadioAtIndex(e) {
        return !!t.listElements[e].querySelector(ir.RADIO_SELECTOR);
      },
      isCheckboxCheckedAtIndex: function isCheckboxCheckedAtIndex(e) {
        return t.listElements[e].querySelector(ir.CHECKBOX_SELECTOR).checked;
      },
      isFocusInsideList: function isFocusInsideList() {
        return t.root_.contains(document.activeElement);
      },
      isRootFocused: function isRootFocused() {
        return document.activeElement === t.root_;
      },
      notifyAction: function notifyAction(e) {
        t.emit(ir.ACTION_EVENT, {
          index: e
        }, !0);
      },
      removeClassForElementIndex: function removeClassForElementIndex(e, n) {
        var i = t.listElements[e];
        i && i.classList.remove(n);
      },
      setAttributeForElementIndex: function setAttributeForElementIndex(e, n, i) {
        var r = t.listElements[e];
        r && r.setAttribute(n, i);
      },
      setCheckedCheckboxOrRadioAtIndex: function setCheckedCheckboxOrRadioAtIndex(e, n) {
        var i = t.listElements[e].querySelector(ir.CHECKBOX_RADIO_SELECTOR);
        i.checked = n;
        var r = document.createEvent("Event");
        r.initEvent("change", !0, !0), i.dispatchEvent(r);
      },
      setTabIndexForListItemChildren: function setTabIndexForListItemChildren(e, n) {
        var i = t.listElements[e];
        [].slice.call(i.querySelectorAll(ir.CHILD_ELEMENTS_TO_TOGGLE_TABINDEX)).forEach(function (t) {
          return t.setAttribute("tabindex", n);
        });
      }
    });
  }, e.prototype.getListItemIndex_ = function (t) {
    var e = Qt(t.target, "." + nr.LIST_ITEM_CLASS + ", ." + nr.ROOT);
    return e && Zt(e, "." + nr.LIST_ITEM_CLASS) ? this.listElements.indexOf(e) : -1;
  }, e.prototype.handleFocusInEvent_ = function (t) {
    var e = this.getListItemIndex_(t);
    this.foundation_.handleFocusIn(t, e);
  }, e.prototype.handleFocusOutEvent_ = function (t) {
    var e = this.getListItemIndex_(t);
    this.foundation_.handleFocusOut(t, e);
  }, e.prototype.handleKeydownEvent_ = function (t) {
    var e = this.getListItemIndex_(t),
        n = t.target;
    this.foundation_.handleKeydown(t, n.classList.contains(nr.LIST_ITEM_CLASS), e);
  }, e.prototype.handleClickEvent_ = function (t) {
    var e = this.getListItemIndex_(t),
        n = !Zt(t.target, ir.CHECKBOX_RADIO_SELECTOR);
    this.foundation_.handleClick(e, n);
  }, e;
}($t),
    ur = function (t) {
  function e(n) {
    var i = t.call(this, _jt({}, e.defaultAdapter, n)) || this;
    return i.isOpen_ = !1, i.isQuickOpen_ = !1, i.isHoistedElement_ = !1, i.isFixedPosition_ = !1, i.openAnimationEndTimerId_ = 0, i.closeAnimationEndTimerId_ = 0, i.animationRequestId_ = 0, i.anchorCorner_ = Qi.TOP_START, i.anchorMargin_ = {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }, i.position_ = {
      x: 0,
      y: 0
    }, i;
  }

  return Vt(e, t), Object.defineProperty(e, "cssClasses", {
    get: function get() {
      return Ji;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "strings", {
    get: function get() {
      return tr;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "numbers", {
    get: function get() {
      return er;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "Corner", {
    get: function get() {
      return Qi;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultAdapter", {
    get: function get() {
      return {
        addClass: function addClass() {},
        removeClass: function removeClass() {},
        hasClass: function hasClass() {
          return !1;
        },
        hasAnchor: function hasAnchor() {
          return !1;
        },
        isElementInContainer: function isElementInContainer() {
          return !1;
        },
        isFocused: function isFocused() {
          return !1;
        },
        isFirstElementFocused: function isFirstElementFocused() {
          return !1;
        },
        isLastElementFocused: function isLastElementFocused() {
          return !1;
        },
        isRtl: function isRtl() {
          return !1;
        },
        getInnerDimensions: function getInnerDimensions() {
          return {
            height: 0,
            width: 0
          };
        },
        getAnchorDimensions: function getAnchorDimensions() {
          return null;
        },
        getWindowDimensions: function getWindowDimensions() {
          return {
            height: 0,
            width: 0
          };
        },
        getBodyDimensions: function getBodyDimensions() {
          return {
            height: 0,
            width: 0
          };
        },
        getWindowScroll: function getWindowScroll() {
          return {
            x: 0,
            y: 0
          };
        },
        setPosition: function setPosition() {},
        setMaxHeight: function setMaxHeight() {},
        setTransformOrigin: function setTransformOrigin() {},
        saveFocus: function saveFocus() {},
        restoreFocus: function restoreFocus() {},
        focusFirstElement: function focusFirstElement() {},
        focusLastElement: function focusLastElement() {},
        notifyClose: function notifyClose() {},
        notifyOpen: function notifyOpen() {}
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.init = function () {
    var t = e.cssClasses,
        n = t.ROOT,
        i = t.OPEN;
    if (!this.adapter_.hasClass(n)) throw new Error(n + " class required in root element.");
    this.adapter_.hasClass(i) && (this.isOpen_ = !0);
  }, e.prototype.destroy = function () {
    clearTimeout(this.openAnimationEndTimerId_), clearTimeout(this.closeAnimationEndTimerId_), cancelAnimationFrame(this.animationRequestId_);
  }, e.prototype.setAnchorCorner = function (t) {
    this.anchorCorner_ = t;
  }, e.prototype.setAnchorMargin = function (t) {
    this.anchorMargin_.top = t.top || 0, this.anchorMargin_.right = t.right || 0, this.anchorMargin_.bottom = t.bottom || 0, this.anchorMargin_.left = t.left || 0;
  }, e.prototype.setIsHoisted = function (t) {
    this.isHoistedElement_ = t;
  }, e.prototype.setFixedPosition = function (t) {
    this.isFixedPosition_ = t;
  }, e.prototype.setAbsolutePosition = function (t, e) {
    this.position_.x = this.isFinite_(t) ? t : 0, this.position_.y = this.isFinite_(e) ? e : 0;
  }, e.prototype.setQuickOpen = function (t) {
    this.isQuickOpen_ = t;
  }, e.prototype.isOpen = function () {
    return this.isOpen_;
  }, e.prototype.open = function () {
    var t = this;
    this.adapter_.saveFocus(), this.isQuickOpen_ || this.adapter_.addClass(e.cssClasses.ANIMATING_OPEN), this.animationRequestId_ = requestAnimationFrame(function () {
      t.adapter_.addClass(e.cssClasses.OPEN), t.dimensions_ = t.adapter_.getInnerDimensions(), t.autoPosition_(), t.isQuickOpen_ ? t.adapter_.notifyOpen() : t.openAnimationEndTimerId_ = setTimeout(function () {
        t.openAnimationEndTimerId_ = 0, t.adapter_.removeClass(e.cssClasses.ANIMATING_OPEN), t.adapter_.notifyOpen();
      }, er.TRANSITION_OPEN_DURATION);
    }), this.isOpen_ = !0;
  }, e.prototype.close = function () {
    var t = this;
    this.isQuickOpen_ || this.adapter_.addClass(e.cssClasses.ANIMATING_CLOSED), requestAnimationFrame(function () {
      t.adapter_.removeClass(e.cssClasses.OPEN), t.isQuickOpen_ ? t.adapter_.notifyClose() : t.closeAnimationEndTimerId_ = setTimeout(function () {
        t.closeAnimationEndTimerId_ = 0, t.adapter_.removeClass(e.cssClasses.ANIMATING_CLOSED), t.adapter_.notifyClose();
      }, er.TRANSITION_CLOSE_DURATION);
    }), this.isOpen_ = !1, this.maybeRestoreFocus_();
  }, e.prototype.handleBodyClick = function (t) {
    var e = t.target;
    this.adapter_.isElementInContainer(e) || this.close();
  }, e.prototype.handleKeydown = function (t) {
    var e = t.keyCode,
        n = t.key,
        i = t.shiftKey,
        r = "Tab" === n || 9 === e;
    "Escape" === n || 27 === e ? this.close() : r && (this.adapter_.isLastElementFocused() && !i ? (this.adapter_.focusFirstElement(), t.preventDefault()) : this.adapter_.isFirstElementFocused() && i && (this.adapter_.focusLastElement(), t.preventDefault()));
  }, e.prototype.autoPosition_ = function () {
    var t;
    this.measurements_ = this.getAutoLayoutMeasurements_();
    var e = this.getOriginCorner_(),
        n = this.getMenuSurfaceMaxHeight_(e),
        i = this.hasBit_(e, $i.BOTTOM) ? "bottom" : "top",
        r = this.hasBit_(e, $i.RIGHT) ? "right" : "left",
        o = this.getHorizontalOriginOffset_(e),
        a = this.getVerticalOriginOffset_(e),
        s = this.measurements_,
        c = s.anchorSize,
        u = s.surfaceSize,
        l = ((t = {})[r] = o, t[i] = a, t);
    c.width / u.width > er.ANCHOR_TO_MENU_SURFACE_WIDTH_RATIO && (r = "center"), (this.isHoistedElement_ || this.isFixedPosition_) && this.adjustPositionForHoistedElement_(l), this.adapter_.setTransformOrigin(r + " " + i), this.adapter_.setPosition(l), this.adapter_.setMaxHeight(n ? n + "px" : "");
  }, e.prototype.getAutoLayoutMeasurements_ = function () {
    var t = this.adapter_.getAnchorDimensions(),
        e = this.adapter_.getBodyDimensions(),
        n = this.adapter_.getWindowDimensions(),
        i = this.adapter_.getWindowScroll();
    return t || (t = {
      top: this.position_.y,
      right: this.position_.x,
      bottom: this.position_.y,
      left: this.position_.x,
      width: 0,
      height: 0
    }), {
      anchorSize: t,
      bodySize: e,
      surfaceSize: this.dimensions_,
      viewportDistance: {
        top: t.top,
        right: n.width - t.right,
        bottom: n.height - t.bottom,
        left: t.left
      },
      viewportSize: n,
      windowScroll: i
    };
  }, e.prototype.getOriginCorner_ = function () {
    var t = Qi.TOP_LEFT,
        e = this.measurements_,
        n = e.viewportDistance,
        i = e.anchorSize,
        r = e.surfaceSize,
        o = this.hasBit_(this.anchorCorner_, $i.BOTTOM),
        a = o ? n.top + i.height + this.anchorMargin_.bottom : n.top + this.anchorMargin_.top,
        s = o ? n.bottom - this.anchorMargin_.bottom : n.bottom + i.height - this.anchorMargin_.top,
        c = r.height - a,
        u = r.height - s;
    u > 0 && c < u && (t = this.setBit_(t, $i.BOTTOM));

    var l = this.adapter_.isRtl(),
        d = this.hasBit_(this.anchorCorner_, $i.FLIP_RTL),
        h = this.hasBit_(this.anchorCorner_, $i.RIGHT),
        p = h && !l || !h && d && l,
        f = p ? n.left + i.width + this.anchorMargin_.right : n.left + this.anchorMargin_.left,
        m = p ? n.right - this.anchorMargin_.right : n.right + i.width - this.anchorMargin_.left,
        _ = r.width - f,
        g = r.width - m;

    return (_ < 0 && p && l || h && !p && _ < 0 || g > 0 && _ < g) && (t = this.setBit_(t, $i.RIGHT)), t;
  }, e.prototype.getMenuSurfaceMaxHeight_ = function (t) {
    var n = this.measurements_.viewportDistance,
        i = 0,
        r = this.hasBit_(t, $i.BOTTOM),
        o = this.hasBit_(this.anchorCorner_, $i.BOTTOM),
        a = e.numbers.MARGIN_TO_EDGE;
    return r ? (i = n.top + this.anchorMargin_.top - a, o || (i += this.measurements_.anchorSize.height)) : (i = n.bottom - this.anchorMargin_.bottom + this.measurements_.anchorSize.height - a, o && (i -= this.measurements_.anchorSize.height)), i;
  }, e.prototype.getHorizontalOriginOffset_ = function (t) {
    var e = this.measurements_.anchorSize,
        n = this.hasBit_(t, $i.RIGHT),
        i = this.hasBit_(this.anchorCorner_, $i.RIGHT);

    if (n) {
      var r = i ? e.width - this.anchorMargin_.left : this.anchorMargin_.right;
      return this.isHoistedElement_ || this.isFixedPosition_ ? r - (this.measurements_.viewportSize.width - this.measurements_.bodySize.width) : r;
    }

    return i ? e.width - this.anchorMargin_.right : this.anchorMargin_.left;
  }, e.prototype.getVerticalOriginOffset_ = function (t) {
    var e = this.measurements_.anchorSize,
        n = this.hasBit_(t, $i.BOTTOM),
        i = this.hasBit_(this.anchorCorner_, $i.BOTTOM);
    return n ? i ? e.height - this.anchorMargin_.top : -this.anchorMargin_.bottom : i ? e.height + this.anchorMargin_.bottom : this.anchorMargin_.top;
  }, e.prototype.adjustPositionForHoistedElement_ = function (t) {
    var e,
        n,
        i = this.measurements_,
        r = i.windowScroll,
        o = i.viewportDistance,
        a = Object.keys(t);

    try {
      for (var s = qt(a), c = s.next(); !c.done; c = s.next()) {
        var u = c.value,
            l = t[u] || 0;
        l += o[u], this.isFixedPosition_ || ("top" === u ? l += r.y : "bottom" === u ? l -= r.y : "left" === u ? l += r.x : l -= r.x), t[u] = l;
      }
    } catch (t) {
      e = {
        error: t
      };
    } finally {
      try {
        c && !c.done && (n = s.return) && n.call(s);
      } finally {
        if (e) throw e.error;
      }
    }
  }, e.prototype.maybeRestoreFocus_ = function () {
    var t = this.adapter_.isFocused(),
        e = document.activeElement && this.adapter_.isElementInContainer(document.activeElement);
    (t || e) && this.adapter_.restoreFocus();
  }, e.prototype.hasBit_ = function (t, e) {
    return Boolean(t & e);
  }, e.prototype.setBit_ = function (t, e) {
    return t | e;
  }, e.prototype.isFinite_ = function (t) {
    return "number" == typeof t && isFinite(t);
  }, e;
}(Yt);

var lr,
    dr = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return Vt(e, t), e.attachTo = function (t) {
    return new e(t);
  }, e.prototype.initialSyncWithDOM = function () {
    var t = this,
        e = this.root_.parentElement;
    this.anchorElement = e && e.classList.contains(Ji.ANCHOR) ? e : null, this.root_.classList.contains(Ji.FIXED) && this.setFixedPosition(!0), this.handleKeydown_ = function (e) {
      return t.foundation_.handleKeydown(e);
    }, this.handleBodyClick_ = function (e) {
      return t.foundation_.handleBodyClick(e);
    }, this.registerBodyClickListener_ = function () {
      return document.body.addEventListener("click", t.handleBodyClick_);
    }, this.deregisterBodyClickListener_ = function () {
      return document.body.removeEventListener("click", t.handleBodyClick_);
    }, this.listen("keydown", this.handleKeydown_), this.listen(tr.OPENED_EVENT, this.registerBodyClickListener_), this.listen(tr.CLOSED_EVENT, this.deregisterBodyClickListener_);
  }, e.prototype.destroy = function () {
    this.unlisten("keydown", this.handleKeydown_), this.unlisten(tr.OPENED_EVENT, this.registerBodyClickListener_), this.unlisten(tr.CLOSED_EVENT, this.deregisterBodyClickListener_), t.prototype.destroy.call(this);
  }, Object.defineProperty(e.prototype, "open", {
    get: function get() {
      return this.foundation_.isOpen();
    },
    set: function set(t) {
      if (t) {
        var e = this.root_.querySelectorAll(tr.FOCUSABLE_ELEMENTS);
        this.firstFocusableElement_ = e[0], this.lastFocusableElement_ = e[e.length - 1], this.foundation_.open();
      } else this.foundation_.close();
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "quickOpen", {
    set: function set(t) {
      this.foundation_.setQuickOpen(t);
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.hoistMenuToBody = function () {
    document.body.appendChild(this.root_), this.setIsHoisted(!0);
  }, e.prototype.setIsHoisted = function (t) {
    this.foundation_.setIsHoisted(t);
  }, e.prototype.setMenuSurfaceAnchorElement = function (t) {
    this.anchorElement = t;
  }, e.prototype.setFixedPosition = function (t) {
    t ? this.root_.classList.add(Ji.FIXED) : this.root_.classList.remove(Ji.FIXED), this.foundation_.setFixedPosition(t);
  }, e.prototype.setAbsolutePosition = function (t, e) {
    this.foundation_.setAbsolutePosition(t, e), this.setIsHoisted(!0);
  }, e.prototype.setAnchorCorner = function (t) {
    this.foundation_.setAnchorCorner(t);
  }, e.prototype.setAnchorMargin = function (t) {
    this.foundation_.setAnchorMargin(t);
  }, e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new ur({
      addClass: function addClass(e) {
        return t.root_.classList.add(e);
      },
      removeClass: function removeClass(e) {
        return t.root_.classList.remove(e);
      },
      hasClass: function hasClass(e) {
        return t.root_.classList.contains(e);
      },
      hasAnchor: function hasAnchor() {
        return !!t.anchorElement;
      },
      notifyClose: function notifyClose() {
        return t.emit(ur.strings.CLOSED_EVENT, {});
      },
      notifyOpen: function notifyOpen() {
        return t.emit(ur.strings.OPENED_EVENT, {});
      },
      isElementInContainer: function isElementInContainer(e) {
        return t.root_.contains(e);
      },
      isRtl: function isRtl() {
        return "rtl" === getComputedStyle(t.root_).getPropertyValue("direction");
      },
      setTransformOrigin: function setTransformOrigin(e) {
        var n = function (t, e) {
          if (void 0 === e && (e = !1), void 0 === ar || e) {
            var n = t.document.createElement("div");
            ar = "transform" in n.style ? "transform" : "webkitTransform";
          }

          return ar;
        }(window) + "-origin";

        t.root_.style.setProperty(n, e);
      },
      isFocused: function isFocused() {
        return document.activeElement === t.root_;
      },
      saveFocus: function saveFocus() {
        t.previousFocus_ = document.activeElement;
      },
      restoreFocus: function restoreFocus() {
        t.root_.contains(document.activeElement) && t.previousFocus_ && t.previousFocus_.focus && t.previousFocus_.focus();
      },
      isFirstElementFocused: function isFirstElementFocused() {
        return !!t.firstFocusableElement_ && t.firstFocusableElement_ === document.activeElement;
      },
      isLastElementFocused: function isLastElementFocused() {
        return !!t.lastFocusableElement_ && t.lastFocusableElement_ === document.activeElement;
      },
      focusFirstElement: function focusFirstElement() {
        return t.firstFocusableElement_ && t.firstFocusableElement_.focus && t.firstFocusableElement_.focus();
      },
      focusLastElement: function focusLastElement() {
        return t.lastFocusableElement_ && t.lastFocusableElement_.focus && t.lastFocusableElement_.focus();
      },
      getInnerDimensions: function getInnerDimensions() {
        return {
          width: t.root_.offsetWidth,
          height: t.root_.offsetHeight
        };
      },
      getAnchorDimensions: function getAnchorDimensions() {
        return t.anchorElement ? t.anchorElement.getBoundingClientRect() : null;
      },
      getWindowDimensions: function getWindowDimensions() {
        return {
          width: window.innerWidth,
          height: window.innerHeight
        };
      },
      getBodyDimensions: function getBodyDimensions() {
        return {
          width: document.body.clientWidth,
          height: document.body.clientHeight
        };
      },
      getWindowScroll: function getWindowScroll() {
        return {
          x: window.pageXOffset,
          y: window.pageYOffset
        };
      },
      setPosition: function setPosition(e) {
        t.root_.style.left = "left" in e ? e.left + "px" : "", t.root_.style.right = "right" in e ? e.right + "px" : "", t.root_.style.top = "top" in e ? e.top + "px" : "", t.root_.style.bottom = "bottom" in e ? e.bottom + "px" : "";
      },
      setMaxHeight: function setMaxHeight(e) {
        t.root_.style.maxHeight = e;
      }
    });
  }, e;
}($t),
    hr = {
  MENU_SELECTED_LIST_ITEM: "mdc-menu-item--selected",
  MENU_SELECTION_GROUP: "mdc-menu__selection-group",
  ROOT: "mdc-menu"
},
    pr = {
  ARIA_SELECTED_ATTR: "aria-selected",
  CHECKBOX_SELECTOR: 'input[type="checkbox"]',
  LIST_SELECTOR: ".mdc-list",
  SELECTED_EVENT: "MDCMenu:selected"
},
    fr = {
  FOCUS_ROOT_INDEX: -1
};

!function (t) {
  t[t.NONE = 0] = "NONE", t[t.LIST_ROOT = 1] = "LIST_ROOT", t[t.FIRST_ITEM = 2] = "FIRST_ITEM", t[t.LAST_ITEM = 3] = "LAST_ITEM";
}(lr || (lr = {}));

var mr = function (t) {
  function e(n) {
    var i = t.call(this, _jt({}, e.defaultAdapter, n)) || this;
    return i.closeAnimationEndTimerId_ = 0, i.defaultFocusState_ = lr.LIST_ROOT, i;
  }

  return Vt(e, t), Object.defineProperty(e, "cssClasses", {
    get: function get() {
      return hr;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "strings", {
    get: function get() {
      return pr;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "numbers", {
    get: function get() {
      return fr;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultAdapter", {
    get: function get() {
      return {
        addClassToElementAtIndex: function addClassToElementAtIndex() {},
        removeClassFromElementAtIndex: function removeClassFromElementAtIndex() {},
        addAttributeToElementAtIndex: function addAttributeToElementAtIndex() {},
        removeAttributeFromElementAtIndex: function removeAttributeFromElementAtIndex() {},
        elementContainsClass: function elementContainsClass() {
          return !1;
        },
        closeSurface: function closeSurface() {},
        getElementIndex: function getElementIndex() {
          return -1;
        },
        getParentElement: function getParentElement() {
          return null;
        },
        getSelectedElementIndex: function getSelectedElementIndex() {
          return -1;
        },
        notifySelected: function notifySelected() {},
        getMenuItemCount: function getMenuItemCount() {
          return 0;
        },
        focusItemAtIndex: function focusItemAtIndex() {},
        focusListRoot: function focusListRoot() {}
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.destroy = function () {
    this.closeAnimationEndTimerId_ && clearTimeout(this.closeAnimationEndTimerId_), this.adapter_.closeSurface();
  }, e.prototype.handleKeydown = function (t) {
    var e = t.key,
        n = t.keyCode;
    ("Tab" === e || 9 === n) && this.adapter_.closeSurface();
  }, e.prototype.handleItemAction = function (t) {
    var e = this,
        n = this.adapter_.getElementIndex(t);
    n < 0 || (this.adapter_.notifySelected({
      index: n
    }), this.adapter_.closeSurface(), this.closeAnimationEndTimerId_ = setTimeout(function () {
      var i = e.getSelectionGroup_(t);
      i && e.handleSelectionGroup_(i, n);
    }, ur.numbers.TRANSITION_CLOSE_DURATION));
  }, e.prototype.handleMenuSurfaceOpened = function () {
    switch (this.defaultFocusState_) {
      case lr.FIRST_ITEM:
        this.adapter_.focusItemAtIndex(0);
        break;

      case lr.LAST_ITEM:
        this.adapter_.focusItemAtIndex(this.adapter_.getMenuItemCount() - 1);
        break;

      case lr.NONE:
        break;

      default:
        this.adapter_.focusListRoot();
    }
  }, e.prototype.setDefaultFocusState = function (t) {
    this.defaultFocusState_ = t;
  }, e.prototype.handleSelectionGroup_ = function (t, e) {
    var n = this.adapter_.getSelectedElementIndex(t);
    n >= 0 && (this.adapter_.removeAttributeFromElementAtIndex(n, pr.ARIA_SELECTED_ATTR), this.adapter_.removeClassFromElementAtIndex(n, hr.MENU_SELECTED_LIST_ITEM)), this.adapter_.addClassToElementAtIndex(e, hr.MENU_SELECTED_LIST_ITEM), this.adapter_.addAttributeToElementAtIndex(e, pr.ARIA_SELECTED_ATTR, "true");
  }, e.prototype.getSelectionGroup_ = function (t) {
    var e = this.adapter_.getParentElement(t);
    if (!e) return null;

    for (var n = this.adapter_.elementContainsClass(e, hr.MENU_SELECTION_GROUP); !n && e && !this.adapter_.elementContainsClass(e, sr.cssClasses.ROOT);) {
      n = !!(e = this.adapter_.getParentElement(e)) && this.adapter_.elementContainsClass(e, hr.MENU_SELECTION_GROUP);
    }

    return n ? e : null;
  }, e;
}(Yt),
    _r = (function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  Vt(e, t), e.attachTo = function (t) {
    return new e(t);
  }, e.prototype.initialize = function (t, e) {
    void 0 === t && (t = function t(_t19) {
      return new dr(_t19);
    }), void 0 === e && (e = function e(t) {
      return new cr(t);
    }), this.menuSurfaceFactory_ = t, this.listFactory_ = e;
  }, e.prototype.initialSyncWithDOM = function () {
    var t = this;
    this.menuSurface_ = this.menuSurfaceFactory_(this.root_);
    var e = this.root_.querySelector(pr.LIST_SELECTOR);
    e ? (this.list_ = this.listFactory_(e), this.list_.wrapFocus = !0) : this.list_ = null, this.handleKeydown_ = function (e) {
      return t.foundation_.handleKeydown(e);
    }, this.handleItemAction_ = function (e) {
      return t.foundation_.handleItemAction(t.items[e.detail.index]);
    }, this.handleMenuSurfaceOpened_ = function () {
      return t.foundation_.handleMenuSurfaceOpened();
    }, this.menuSurface_.listen(ur.strings.OPENED_EVENT, this.handleMenuSurfaceOpened_), this.listen("keydown", this.handleKeydown_), this.listen(sr.strings.ACTION_EVENT, this.handleItemAction_);
  }, e.prototype.destroy = function () {
    this.list_ && this.list_.destroy(), this.menuSurface_.destroy(), this.menuSurface_.unlisten(ur.strings.OPENED_EVENT, this.handleMenuSurfaceOpened_), this.unlisten("keydown", this.handleKeydown_), this.unlisten(sr.strings.ACTION_EVENT, this.handleItemAction_), t.prototype.destroy.call(this);
  }, Object.defineProperty(e.prototype, "open", {
    get: function get() {
      return this.menuSurface_.open;
    },
    set: function set(t) {
      this.menuSurface_.open = t;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "wrapFocus", {
    get: function get() {
      return !!this.list_ && this.list_.wrapFocus;
    },
    set: function set(t) {
      this.list_ && (this.list_.wrapFocus = t);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "items", {
    get: function get() {
      return this.list_ ? this.list_.listElements : [];
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "quickOpen", {
    set: function set(t) {
      this.menuSurface_.quickOpen = t;
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.setDefaultFocusState = function (t) {
    this.foundation_.setDefaultFocusState(t);
  }, e.prototype.setAnchorCorner = function (t) {
    this.menuSurface_.setAnchorCorner(t);
  }, e.prototype.setAnchorMargin = function (t) {
    this.menuSurface_.setAnchorMargin(t);
  }, e.prototype.getOptionByIndex = function (t) {
    return t < this.items.length ? this.items[t] : null;
  }, e.prototype.setFixedPosition = function (t) {
    this.menuSurface_.setFixedPosition(t);
  }, e.prototype.hoistMenuToBody = function () {
    this.menuSurface_.hoistMenuToBody();
  }, e.prototype.setIsHoisted = function (t) {
    this.menuSurface_.setIsHoisted(t);
  }, e.prototype.setAbsolutePosition = function (t, e) {
    this.menuSurface_.setAbsolutePosition(t, e);
  }, e.prototype.setAnchorElement = function (t) {
    this.menuSurface_.anchorElement = t;
  }, e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new mr({
      addClassToElementAtIndex: function addClassToElementAtIndex(e, n) {
        t.items[e].classList.add(n);
      },
      removeClassFromElementAtIndex: function removeClassFromElementAtIndex(e, n) {
        t.items[e].classList.remove(n);
      },
      addAttributeToElementAtIndex: function addAttributeToElementAtIndex(e, n, i) {
        t.items[e].setAttribute(n, i);
      },
      removeAttributeFromElementAtIndex: function removeAttributeFromElementAtIndex(e, n) {
        t.items[e].removeAttribute(n);
      },
      elementContainsClass: function elementContainsClass(t, e) {
        return t.classList.contains(e);
      },
      closeSurface: function closeSurface() {
        return t.open = !1;
      },
      getElementIndex: function getElementIndex(e) {
        return t.items.indexOf(e);
      },
      getParentElement: function getParentElement(t) {
        return t.parentElement;
      },
      getSelectedElementIndex: function getSelectedElementIndex(e) {
        var n = e.querySelector("." + hr.MENU_SELECTED_LIST_ITEM);
        return n ? t.items.indexOf(n) : -1;
      },
      notifySelected: function notifySelected(e) {
        return t.emit(pr.SELECTED_EVENT, {
          index: e.index,
          item: t.items[e.index]
        });
      },
      getMenuItemCount: function getMenuItemCount() {
        return t.items.length;
      },
      focusItemAtIndex: function focusItemAtIndex(e) {
        return t.items[e].focus();
      },
      focusListRoot: function focusListRoot() {
        return t.root_.querySelector(pr.LIST_SELECTOR).focus();
      }
    });
  };
}($t), {
  LIST_ITEM_ACTIVATED_CLASS: "mdc-list-item--activated",
  LIST_ITEM_CLASS: "mdc-list-item",
  LIST_ITEM_DISABLED_CLASS: "mdc-list-item--disabled",
  LIST_ITEM_SELECTED_CLASS: "mdc-list-item--selected",
  ROOT: "mdc-list"
}),
    gr = {
  ACTION_EVENT: "MDCList:action",
  ARIA_CHECKED: "aria-checked",
  ARIA_CHECKED_CHECKBOX_SELECTOR: '[role="checkbox"][aria-checked="true"]',
  ARIA_CHECKED_RADIO_SELECTOR: '[role="radio"][aria-checked="true"]',
  ARIA_CURRENT: "aria-current",
  ARIA_ORIENTATION: "aria-orientation",
  ARIA_ORIENTATION_HORIZONTAL: "horizontal",
  ARIA_ROLE_CHECKBOX_SELECTOR: '[role="checkbox"]',
  ARIA_SELECTED: "aria-selected",
  CHECKBOX_RADIO_SELECTOR: 'input[type="checkbox"]:not(:disabled), input[type="radio"]:not(:disabled)',
  CHECKBOX_SELECTOR: 'input[type="checkbox"]:not(:disabled)',
  CHILD_ELEMENTS_TO_TOGGLE_TABINDEX: "\n    ." + _r.LIST_ITEM_CLASS + " button:not(:disabled),\n    ." + _r.LIST_ITEM_CLASS + " a\n  ",
  FOCUSABLE_CHILD_ELEMENTS: "\n    ." + _r.LIST_ITEM_CLASS + " button:not(:disabled),\n    ." + _r.LIST_ITEM_CLASS + " a,\n    ." + _r.LIST_ITEM_CLASS + ' input[type="radio"]:not(:disabled),\n    .' + _r.LIST_ITEM_CLASS + ' input[type="checkbox"]:not(:disabled)\n  ',
  RADIO_SELECTOR: 'input[type="radio"]:not(:disabled)'
},
    vr = {
  UNSET_INDEX: -1
},
    yr = ["input", "button", "textarea", "select"];

var br,
    Er = function (t) {
  function e(n) {
    var i = t.call(this, _jt({}, e.defaultAdapter, n)) || this;
    return i.wrapFocus_ = !1, i.isVertical_ = !0, i.isSingleSelectionList_ = !1, i.selectedIndex_ = vr.UNSET_INDEX, i.focusedItemIndex_ = vr.UNSET_INDEX, i.useActivatedClass_ = !1, i.ariaCurrentAttrValue_ = null, i.isCheckboxList_ = !1, i.isRadioList_ = !1, i;
  }

  return Vt(e, t), Object.defineProperty(e, "strings", {
    get: function get() {
      return gr;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "cssClasses", {
    get: function get() {
      return _r;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "numbers", {
    get: function get() {
      return vr;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultAdapter", {
    get: function get() {
      return {
        addClassForElementIndex: function addClassForElementIndex() {},
        focusItemAtIndex: function focusItemAtIndex() {},
        getAttributeForElementIndex: function getAttributeForElementIndex() {
          return null;
        },
        getFocusedElementIndex: function getFocusedElementIndex() {
          return 0;
        },
        getListItemCount: function getListItemCount() {
          return 0;
        },
        hasCheckboxAtIndex: function hasCheckboxAtIndex() {
          return !1;
        },
        hasRadioAtIndex: function hasRadioAtIndex() {
          return !1;
        },
        isCheckboxCheckedAtIndex: function isCheckboxCheckedAtIndex() {
          return !1;
        },
        isFocusInsideList: function isFocusInsideList() {
          return !1;
        },
        isRootFocused: function isRootFocused() {
          return !1;
        },
        notifyAction: function notifyAction() {},
        removeClassForElementIndex: function removeClassForElementIndex() {},
        setAttributeForElementIndex: function setAttributeForElementIndex() {},
        setCheckedCheckboxOrRadioAtIndex: function setCheckedCheckboxOrRadioAtIndex() {},
        setTabIndexForListItemChildren: function setTabIndexForListItemChildren() {}
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.layout = function () {
    0 !== this.adapter_.getListItemCount() && (this.adapter_.hasCheckboxAtIndex(0) ? this.isCheckboxList_ = !0 : this.adapter_.hasRadioAtIndex(0) && (this.isRadioList_ = !0));
  }, e.prototype.setWrapFocus = function (t) {
    this.wrapFocus_ = t;
  }, e.prototype.setVerticalOrientation = function (t) {
    this.isVertical_ = t;
  }, e.prototype.setSingleSelection = function (t) {
    this.isSingleSelectionList_ = t;
  }, e.prototype.setUseActivatedClass = function (t) {
    this.useActivatedClass_ = t;
  }, e.prototype.getSelectedIndex = function () {
    return this.selectedIndex_;
  }, e.prototype.setSelectedIndex = function (t) {
    this.isIndexValid_(t) && (this.isCheckboxList_ ? this.setCheckboxAtIndex_(t) : this.isRadioList_ ? this.setRadioAtIndex_(t) : this.setSingleSelectionAtIndex_(t));
  }, e.prototype.handleFocusIn = function (t, e) {
    e >= 0 && this.adapter_.setTabIndexForListItemChildren(e, "0");
  }, e.prototype.handleFocusOut = function (t, e) {
    var n = this;
    e >= 0 && this.adapter_.setTabIndexForListItemChildren(e, "-1"), setTimeout(function () {
      n.adapter_.isFocusInsideList() || n.setTabindexToFirstSelectedItem_();
    }, 0);
  }, e.prototype.handleKeydown = function (t, e, n) {
    var i = "ArrowLeft" === t.key || 37 === t.keyCode,
        r = "ArrowUp" === t.key || 38 === t.keyCode,
        o = "ArrowRight" === t.key || 39 === t.keyCode,
        a = "ArrowDown" === t.key || 40 === t.keyCode,
        s = "Home" === t.key || 36 === t.keyCode,
        c = "End" === t.key || 35 === t.keyCode,
        u = "Enter" === t.key || 13 === t.keyCode,
        l = "Space" === t.key || 32 === t.keyCode;
    if (this.adapter_.isRootFocused()) r || c ? (t.preventDefault(), this.focusLastElement()) : (a || s) && (t.preventDefault(), this.focusFirstElement());else {
      var d = this.adapter_.getFocusedElementIndex();

      if (!(-1 === d && (d = n) < 0)) {
        var h;
        if (this.isVertical_ && a || !this.isVertical_ && o) this.preventDefaultEvent_(t), h = this.focusNextElement(d);else if (this.isVertical_ && r || !this.isVertical_ && i) this.preventDefaultEvent_(t), h = this.focusPrevElement(d);else if (s) this.preventDefaultEvent_(t), h = this.focusFirstElement();else if (c) this.preventDefaultEvent_(t), h = this.focusLastElement();else if ((u || l) && e) {
          var p = t.target;
          if (p && "A" === p.tagName && u) return;
          this.preventDefaultEvent_(t), this.isSelectableList_() && this.setSelectedIndexOnAction_(d), this.adapter_.notifyAction(d);
        }
        this.focusedItemIndex_ = d, void 0 !== h && (this.setTabindexAtIndex_(h), this.focusedItemIndex_ = h);
      }
    }
  }, e.prototype.handleClick = function (t, e) {
    t !== vr.UNSET_INDEX && (this.isSelectableList_() && this.setSelectedIndexOnAction_(t, e), this.adapter_.notifyAction(t), this.setTabindexAtIndex_(t), this.focusedItemIndex_ = t);
  }, e.prototype.focusNextElement = function (t) {
    var e = t + 1;

    if (e >= this.adapter_.getListItemCount()) {
      if (!this.wrapFocus_) return t;
      e = 0;
    }

    return this.adapter_.focusItemAtIndex(e), e;
  }, e.prototype.focusPrevElement = function (t) {
    var e = t - 1;

    if (e < 0) {
      if (!this.wrapFocus_) return t;
      e = this.adapter_.getListItemCount() - 1;
    }

    return this.adapter_.focusItemAtIndex(e), e;
  }, e.prototype.focusFirstElement = function () {
    return this.adapter_.focusItemAtIndex(0), 0;
  }, e.prototype.focusLastElement = function () {
    var t = this.adapter_.getListItemCount() - 1;
    return this.adapter_.focusItemAtIndex(t), t;
  }, e.prototype.preventDefaultEvent_ = function (t) {
    var e = ("" + t.target.tagName).toLowerCase();
    -1 === yr.indexOf(e) && t.preventDefault();
  }, e.prototype.setSingleSelectionAtIndex_ = function (t) {
    if (this.selectedIndex_ !== t) {
      var e = _r.LIST_ITEM_SELECTED_CLASS;
      this.useActivatedClass_ && (e = _r.LIST_ITEM_ACTIVATED_CLASS), this.selectedIndex_ !== vr.UNSET_INDEX && this.adapter_.removeClassForElementIndex(this.selectedIndex_, e), this.adapter_.addClassForElementIndex(t, e), this.setAriaForSingleSelectionAtIndex_(t), this.selectedIndex_ = t;
    }
  }, e.prototype.setAriaForSingleSelectionAtIndex_ = function (t) {
    this.selectedIndex_ === vr.UNSET_INDEX && (this.ariaCurrentAttrValue_ = this.adapter_.getAttributeForElementIndex(t, gr.ARIA_CURRENT));
    var e = null !== this.ariaCurrentAttrValue_,
        n = e ? gr.ARIA_CURRENT : gr.ARIA_SELECTED;
    this.selectedIndex_ !== vr.UNSET_INDEX && this.adapter_.setAttributeForElementIndex(this.selectedIndex_, n, "false");
    var i = e ? this.ariaCurrentAttrValue_ : "true";
    this.adapter_.setAttributeForElementIndex(t, n, i);
  }, e.prototype.setRadioAtIndex_ = function (t) {
    this.adapter_.setCheckedCheckboxOrRadioAtIndex(t, !0), this.selectedIndex_ !== vr.UNSET_INDEX && this.adapter_.setAttributeForElementIndex(this.selectedIndex_, gr.ARIA_CHECKED, "false"), this.adapter_.setAttributeForElementIndex(t, gr.ARIA_CHECKED, "true"), this.selectedIndex_ = t;
  }, e.prototype.setCheckboxAtIndex_ = function (t) {
    for (var e = 0; e < this.adapter_.getListItemCount(); e++) {
      var n = !1;
      t.indexOf(e) >= 0 && (n = !0), this.adapter_.setCheckedCheckboxOrRadioAtIndex(e, n), this.adapter_.setAttributeForElementIndex(e, gr.ARIA_CHECKED, n ? "true" : "false");
    }

    this.selectedIndex_ = t;
  }, e.prototype.setTabindexAtIndex_ = function (t) {
    this.focusedItemIndex_ === vr.UNSET_INDEX && 0 !== t ? this.adapter_.setAttributeForElementIndex(0, "tabindex", "-1") : this.focusedItemIndex_ >= 0 && this.focusedItemIndex_ !== t && this.adapter_.setAttributeForElementIndex(this.focusedItemIndex_, "tabindex", "-1"), this.adapter_.setAttributeForElementIndex(t, "tabindex", "0");
  }, e.prototype.isSelectableList_ = function () {
    return this.isSingleSelectionList_ || this.isCheckboxList_ || this.isRadioList_;
  }, e.prototype.setTabindexToFirstSelectedItem_ = function () {
    var t = 0;
    this.isSelectableList_() && ("number" == typeof this.selectedIndex_ && this.selectedIndex_ !== vr.UNSET_INDEX ? t = this.selectedIndex_ : this.selectedIndex_ instanceof Array && this.selectedIndex_.length > 0 && (t = this.selectedIndex_.reduce(function (t, e) {
      return Math.min(t, e);
    }))), this.setTabindexAtIndex_(t);
  }, e.prototype.isIndexValid_ = function (t) {
    var e = this;

    if (t instanceof Array) {
      if (!this.isCheckboxList_) throw new Error("MDCListFoundation: Array of index is only supported for checkbox based list");
      return 0 === t.length || t.some(function (t) {
        return e.isIndexInRange_(t);
      });
    }

    if ("number" == typeof t) {
      if (this.isCheckboxList_) throw new Error("MDCListFoundation: Expected array of index for checkbox based list but got number: " + t);
      return this.isIndexInRange_(t);
    }

    return !1;
  }, e.prototype.isIndexInRange_ = function (t) {
    var e = this.adapter_.getListItemCount();
    return t >= 0 && t < e;
  }, e.prototype.setSelectedIndexOnAction_ = function (t, e) {
    void 0 === e && (e = !0), this.isCheckboxList_ ? this.toggleCheckboxAtIndex_(t, e) : this.setSelectedIndex(t);
  }, e.prototype.toggleCheckboxAtIndex_ = function (t, e) {
    var n = this.adapter_.isCheckboxCheckedAtIndex(t);
    e && (n = !n, this.adapter_.setCheckedCheckboxOrRadioAtIndex(t, n)), this.adapter_.setAttributeForElementIndex(t, gr.ARIA_CHECKED, n ? "true" : "false");
    var i = this.selectedIndex_ === vr.UNSET_INDEX ? [] : this.selectedIndex_.slice();
    n ? i.push(t) : i = i.filter(function (e) {
      return e !== t;
    }), this.selectedIndex_ = i;
  }, e;
}(Yt),
    Cr = (function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  Vt(e, t), Object.defineProperty(e.prototype, "vertical", {
    set: function set(t) {
      this.foundation_.setVerticalOrientation(t);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "listElements", {
    get: function get() {
      return [].slice.call(this.root_.querySelectorAll("." + _r.LIST_ITEM_CLASS));
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "wrapFocus", {
    set: function set(t) {
      this.foundation_.setWrapFocus(t);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "singleSelection", {
    set: function set(t) {
      this.foundation_.setSingleSelection(t);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "selectedIndex", {
    get: function get() {
      return this.foundation_.getSelectedIndex();
    },
    set: function set(t) {
      this.foundation_.setSelectedIndex(t);
    },
    enumerable: !0,
    configurable: !0
  }), e.attachTo = function (t) {
    return new e(t);
  }, e.prototype.initialSyncWithDOM = function () {
    this.handleClick_ = this.handleClickEvent_.bind(this), this.handleKeydown_ = this.handleKeydownEvent_.bind(this), this.focusInEventListener_ = this.handleFocusInEvent_.bind(this), this.focusOutEventListener_ = this.handleFocusOutEvent_.bind(this), this.listen("keydown", this.handleKeydown_), this.listen("click", this.handleClick_), this.listen("focusin", this.focusInEventListener_), this.listen("focusout", this.focusOutEventListener_), this.layout(), this.initializeListType();
  }, e.prototype.destroy = function () {
    this.unlisten("keydown", this.handleKeydown_), this.unlisten("click", this.handleClick_), this.unlisten("focusin", this.focusInEventListener_), this.unlisten("focusout", this.focusOutEventListener_);
  }, e.prototype.layout = function () {
    var t = this.root_.getAttribute(gr.ARIA_ORIENTATION);
    this.vertical = t !== gr.ARIA_ORIENTATION_HORIZONTAL, [].slice.call(this.root_.querySelectorAll(".mdc-list-item:not([tabindex])")).forEach(function (t) {
      t.setAttribute("tabindex", "-1");
    }), [].slice.call(this.root_.querySelectorAll(gr.FOCUSABLE_CHILD_ELEMENTS)).forEach(function (t) {
      return t.setAttribute("tabindex", "-1");
    }), this.foundation_.layout();
  }, e.prototype.initializeListType = function () {
    var t = this,
        e = this.root_.querySelectorAll(gr.ARIA_ROLE_CHECKBOX_SELECTOR),
        n = this.root_.querySelector("\n      ." + _r.LIST_ITEM_ACTIVATED_CLASS + ",\n      ." + _r.LIST_ITEM_SELECTED_CLASS + "\n    "),
        i = this.root_.querySelector(gr.ARIA_CHECKED_RADIO_SELECTOR);

    if (e.length) {
      var r = this.root_.querySelectorAll(gr.ARIA_CHECKED_CHECKBOX_SELECTOR);
      this.selectedIndex = [].map.call(r, function (e) {
        return t.listElements.indexOf(e);
      });
    } else n ? (n.classList.contains(_r.LIST_ITEM_ACTIVATED_CLASS) && this.foundation_.setUseActivatedClass(!0), this.singleSelection = !0, this.selectedIndex = this.listElements.indexOf(n)) : i && (this.selectedIndex = this.listElements.indexOf(i));
  }, e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new Er({
      addClassForElementIndex: function addClassForElementIndex(e, n) {
        var i = t.listElements[e];
        i && i.classList.add(n);
      },
      focusItemAtIndex: function focusItemAtIndex(e) {
        var n = t.listElements[e];
        n && n.focus();
      },
      getAttributeForElementIndex: function getAttributeForElementIndex(e, n) {
        return t.listElements[e].getAttribute(n);
      },
      getFocusedElementIndex: function getFocusedElementIndex() {
        return t.listElements.indexOf(document.activeElement);
      },
      getListItemCount: function getListItemCount() {
        return t.listElements.length;
      },
      hasCheckboxAtIndex: function hasCheckboxAtIndex(e) {
        return !!t.listElements[e].querySelector(gr.CHECKBOX_SELECTOR);
      },
      hasRadioAtIndex: function hasRadioAtIndex(e) {
        return !!t.listElements[e].querySelector(gr.RADIO_SELECTOR);
      },
      isCheckboxCheckedAtIndex: function isCheckboxCheckedAtIndex(e) {
        return t.listElements[e].querySelector(gr.CHECKBOX_SELECTOR).checked;
      },
      isFocusInsideList: function isFocusInsideList() {
        return t.root_.contains(document.activeElement);
      },
      isRootFocused: function isRootFocused() {
        return document.activeElement === t.root_;
      },
      notifyAction: function notifyAction(e) {
        t.emit(gr.ACTION_EVENT, {
          index: e
        }, !0);
      },
      removeClassForElementIndex: function removeClassForElementIndex(e, n) {
        var i = t.listElements[e];
        i && i.classList.remove(n);
      },
      setAttributeForElementIndex: function setAttributeForElementIndex(e, n, i) {
        var r = t.listElements[e];
        r && r.setAttribute(n, i);
      },
      setCheckedCheckboxOrRadioAtIndex: function setCheckedCheckboxOrRadioAtIndex(e, n) {
        var i = t.listElements[e].querySelector(gr.CHECKBOX_RADIO_SELECTOR);
        i.checked = n;
        var r = document.createEvent("Event");
        r.initEvent("change", !0, !0), i.dispatchEvent(r);
      },
      setTabIndexForListItemChildren: function setTabIndexForListItemChildren(e, n) {
        var i = t.listElements[e];
        [].slice.call(i.querySelectorAll(gr.CHILD_ELEMENTS_TO_TOGGLE_TABINDEX)).forEach(function (t) {
          return t.setAttribute("tabindex", n);
        });
      }
    });
  }, e.prototype.getListItemIndex_ = function (t) {
    var e = Qt(t.target, "." + _r.LIST_ITEM_CLASS + ", ." + _r.ROOT);
    return e && Zt(e, "." + _r.LIST_ITEM_CLASS) ? this.listElements.indexOf(e) : -1;
  }, e.prototype.handleFocusInEvent_ = function (t) {
    var e = this.getListItemIndex_(t);
    this.foundation_.handleFocusIn(t, e);
  }, e.prototype.handleFocusOutEvent_ = function (t) {
    var e = this.getListItemIndex_(t);
    this.foundation_.handleFocusOut(t, e);
  }, e.prototype.handleKeydownEvent_ = function (t) {
    var e = this.getListItemIndex_(t),
        n = t.target;
    this.foundation_.handleKeydown(t, n.classList.contains(_r.LIST_ITEM_CLASS), e);
  }, e.prototype.handleClickEvent_ = function (t) {
    var e = this.getListItemIndex_(t),
        n = !Zt(t.target, gr.CHECKBOX_RADIO_SELECTOR);
    this.foundation_.handleClick(e, n);
  };
}($t), function () {
  var _t20 = function t(e, n) {
    return (_t20 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var n in e) {
        e.hasOwnProperty(n) && (t[n] = e[n]);
      }
    })(e, n);
  };

  return function (e, n) {
    function i() {
      this.constructor = e;
    }

    _t20(e, n), e.prototype = null === n ? Object.create(n) : (i.prototype = n.prototype, new i());
  };
}()),
    _Ar = function Ar() {
  return (_Ar = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    Tr = function Tr(t, e) {
  var n = {};

  for (var i in t) {
    Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
  }

  if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
    var r = 0;

    for (i = Object.getOwnPropertySymbols(t); r < i.length; r++) {
      e.indexOf(i[r]) < 0 && (n[i[r]] = t[i[r]]);
    }
  }

  return n;
},
    Ir = Mt({
  displayName: "ListRoot",
  defaultProps: {
    dense: void 0,
    twoLine: void 0,
    avatarList: void 0,
    nonInteractive: void 0
  },
  classNames: function classNames(t) {
    return ["mdc-list", {
      "mdc-list--dense": t.dense,
      "mdc-list--two-line": t.twoLine,
      "mdc-list--avatar-list": t.avatarList,
      "mdc-list--non-interactive": t.nonInteractive
    }];
  },
  consumeProps: ["dense", "twoLine", "avatarList", "nonInteractive", "onAction"]
}),
    Or = function (t) {
  function e(e) {
    var n = t.call(this, e) || this;
    return n.root = n.createElement("root"), n.handleClick = n.handleClick.bind(n), n.handleKeydown = n.handleKeydown.bind(n), n.handleFocusIn = n.handleFocusIn.bind(n), n.handleFocusOut = n.handleFocusOut.bind(n), n;
  }

  return Cr(e, t), Object.defineProperty(e, "cssClasses", {
    get: function get() {
      return Er.cssClasses;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "listElements", {
    get: function get() {
      return this.root.ref ? [].slice.call(this.root.ref.querySelectorAll("." + Er.cssClasses.LIST_ITEM_CLASS)) : [];
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.componentDidMount = function () {
    t.prototype.componentDidMount.call(this), this.foundation.layout();
  }, e.prototype.focusItemAtIndex = function (t) {
    this.foundation.adapter_.focusItemAtIndex(t);
  }, e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new Er(Object.assign({
      getListItemCount: function getListItemCount() {
        return t.listElements.length;
      },
      getFocusedElementIndex: function getFocusedElementIndex() {
        return t.listElements.indexOf(document.activeElement);
      },
      setAttributeForElementIndex: function setAttributeForElementIndex(e, n, i) {
        if ("tabindex" !== n || -1 !== i) {
          var r = t.listElements[e];
          r && r.setAttribute(n, String(i));
        }
      },
      removeAttributeForElementIndex: function removeAttributeForElementIndex(e, n) {
        var i = t.listElements[e];
        i && i.removeAttribute(n);
      },
      addClassForElementIndex: function addClassForElementIndex(e, n) {
        var i = t.listElements[e];
        i && i.classList.add(n);
      },
      removeClassForElementIndex: function removeClassForElementIndex(e, n) {
        var i = t.listElements[e];
        i && i.classList.remove(n);
      },
      focusItemAtIndex: function focusItemAtIndex(e) {
        var n = t.listElements[e];
        n && n.focus();
      },
      setTabIndexForListItemChildren: function setTabIndexForListItemChildren(e, n) {
        var i = t.listElements[e];
        [].slice.call(i.querySelectorAll(Er.strings.CHILD_ELEMENTS_TO_TOGGLE_TABINDEX)).forEach(function (t) {
          return t.setAttribute("tabindex", String(n));
        });
      },
      hasCheckboxAtIndex: function hasCheckboxAtIndex(e) {
        return !!t.listElements[e].querySelector(Er.strings.CHECKBOX_SELECTOR);
      },
      hasRadioAtIndex: function hasRadioAtIndex(e) {
        return !!t.listElements[e].querySelector(Er.strings.RADIO_SELECTOR);
      },
      isCheckboxCheckedAtIndex: function isCheckboxCheckedAtIndex(e) {
        var n = t.listElements[e].querySelector(Er.strings.CHECKBOX_SELECTOR);
        return !!n && n.checked;
      },
      setCheckedCheckboxOrRadioAtIndex: function setCheckedCheckboxOrRadioAtIndex(e, n) {
        var i = t.listElements[e].querySelector(Er.strings.CHECKBOX_RADIO_SELECTOR);

        if (i) {
          i.checked = n;
          var r = document.createEvent("Event");
          r.initEvent("change", !0, !0), i.dispatchEvent(r);
        }
      },
      notifyAction: function notifyAction(e) {
        t.emit("onAction", e);
      },
      isFocusInsideList: function isFocusInsideList() {
        return t.root.ref && t.root.ref.contains(document.activeElement);
      }
    }));
  }, e.prototype.getListItemIndex = function (t) {
    for (var e = t.target, n = -1; e && !e.classList.contains(Er.cssClasses.LIST_ITEM_CLASS) && !e.classList.contains(Er.cssClasses.ROOT);) {
      e = e.parentElement;
    }

    return e && e.classList.contains(Er.cssClasses.LIST_ITEM_CLASS) && (n = this.listElements.indexOf(e)), n;
  }, e.prototype.handleClick = function (t) {
    this.props.onClick && this.props.onClick(t);
    var e = this.getListItemIndex(t),
        n = !yt(t.target, Er.strings.CHECKBOX_RADIO_SELECTOR);
    this.foundation.handleClick(e, n);
  }, e.prototype.handleKeydown = function (t) {
    this.props.onKeyDown && this.props.onKeyDown(t);
    var e = this.getListItemIndex(t);
    e >= 0 && this.foundation.handleKeydown(t, t.target instanceof Element && t.target.classList.contains(Er.cssClasses.LIST_ITEM_CLASS), e);
  }, e.prototype.handleFocusIn = function (t) {
    this.props.onFocus && this.props.onFocus(t), this.foundation.handleFocusIn(t, this.getListItemIndex(t));
  }, e.prototype.handleFocusOut = function (t) {
    this.props.onBlur && this.props.onBlur(t), this.foundation.handleFocusOut(t, this.getListItemIndex(t));
  }, e.prototype.render = function () {
    var t = Tr(this.props, []);
    return n(Ir, _Ar({}, t, {
      ref: this.root.setRef,
      onClick: this.handleClick,
      onKeyDown: this.handleKeydown,
      onFocus: this.handleFocusIn,
      onBlur: this.handleFocusOut
    }));
  }, e;
}(Rt),
    _Sr = function Sr() {
  return (_Sr = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    wr = function wr(t, e) {
  var n = {};

  for (var i in t) {
    Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
  }

  if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
    var r = 0;

    for (i = Object.getOwnPropertySymbols(t); r < i.length; r++) {
      e.indexOf(i[r]) < 0 && (n[i[r]] = t[i[r]]);
    }
  }

  return n;
},
    xr = Ln({
  surface: !1
})(Mt({
  displayName: "ListItem",
  defaultProps: {
    tabIndex: 0
  },
  classNames: function classNames(t) {
    return ["mdc-list-item", {
      "mdc-list-item--selected": t.selected,
      "mdc-list-item--activated": t.activated,
      "mdc-list-item--disabled": t.disabled
    }];
  },
  consumeProps: ["selected", "activated", "disabled", "options"]
})),
    Nr = (Mt({
  displayName: "ListItemText",
  tag: "span",
  classNames: ["mdc-list-item__text"]
}), Mt({
  displayName: "ListItemPrimaryText",
  tag: "span",
  classNames: ["mdc-list-item__primary-text"]
}), Mt({
  displayName: "ListItemSecondaryText",
  tag: "span",
  classNames: ["mdc-list-item__secondary-text"]
}), Mt({
  displayName: "ListItemGraphic",
  classNames: ["mdc-list-item__graphic"],
  tag: mn
}), Mt({
  displayName: "ListItemMeta",
  classNames: ["mdc-list-item__meta"],
  tag: "div",
  render: function render(t, e, i) {
    if (t.icon) return n(mn, _Sr({
      ref: e
    }, t));

    if (a(t.children)) {
      t.children;
      var r = wr(t, ["children"]);
      return o(t.children, _Sr({}, r, t.children.props, {
        className: m(t.className, t.children.props.className)
      }));
    }

    return n(i, _Sr({
      ref: e
    }, t));
  }
}), Mt({
  displayName: "ListGroup",
  classNames: ["mdc-list-group"]
}), Mt({
  displayName: "ListGroupSubheader",
  classNames: ["mdc-list-group__subheader"]
}), Mt({
  displayName: "ListDivider",
  classNames: ["mdc-list-divider"]
})),
    Rr = function () {
  var _t21 = function t(e, n) {
    return (_t21 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var n in e) {
        e.hasOwnProperty(n) && (t[n] = e[n]);
      }
    })(e, n);
  };

  return function (e, n) {
    function i() {
      this.constructor = e;
    }

    _t21(e, n), e.prototype = null === n ? Object.create(n) : (i.prototype = n.prototype, new i());
  };
}(),
    _Lr = function Lr() {
  return (_Lr = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    Dr = function Dr(t, e) {
  var n = {};

  for (var i in t) {
    Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
  }

  if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
    var r = 0;

    for (i = Object.getOwnPropertySymbols(t); r < i.length; r++) {
      e.indexOf(i[r]) < 0 && (n[i[r]] = t[i[r]]);
    }
  }

  return n;
},
    kr = Mt({
  displayName: "CollapsibleRoot",
  classNames: ["rmwc-collapsible-list"]
}),
    Pr = function Pr(t) {
  if (!t) return !1;
  var e = t.getAttribute("tabindex");
  return !!(e && Number(e) >= 0) && (t.focus(), !0);
},
    Fr = function Fr(t, e) {
  if (!t) return null;
  var n = e ? t.previousElementSibling : t.nextElementSibling;
  return null === n ? Fr(t.parentElement, e) : n;
};

!function (t) {
  function e(e) {
    var n = t.call(this, e) || this;
    return n.childContainer = null, n.root = null, n.state = {
      open: !!n.props.startOpen || !!n.props.open,
      childrenStyle: {}
    }, n.handleClick = n.handleClick.bind(n), n.handleKeydown = n.handleKeydown.bind(n), n.handleFocus = n.handleFocus.bind(n), n;
  }

  Rr(e, t), e.getDerivedStateFromProps = function (t, e) {
    return void 0 !== t.open && t.open !== e.open ? _Lr({}, e, {
      open: t.open
    }) : e;
  }, e.prototype.componentDidMount = function () {
    this.syncOpenState();
  }, e.prototype.componentDidUpdate = function (t, e) {
    e.open !== this.state.open && this.syncOpenState();
  }, e.prototype.syncOpenState = function () {
    var t = this,
        e = this.props,
        n = e.onOpen,
        i = e.onClose,
        r = {
      maxHeight: this.childContainer ? this.childContainer.offsetHeight + "px" : "0px"
    };
    this.setState({
      childrenStyle: r
    }, function () {
      t.state.open ? (n && n(), setTimeout(function () {
        t.state.open && t.setState({
          childrenStyle: {
            maxHeight: "none"
          }
        });
      }, 300)) : (i && i(), window.requestAnimationFrame(function () {
        t.setState({
          childrenStyle: {}
        });
      }));
    });
  }, e.prototype.correctFocus = function (t) {
    var e = this;
    window.requestAnimationFrame(function () {
      if (!e.state.open && e.root && e.root.contains(document.activeElement)) {
        var n = Fr(e.root, t);
        if (Pr(n)) return;
        if (n) for (var i = n.querySelectorAll("[tabindex]"), r = 0; r < i.length && !Pr(i[r]); r++) {
          ;
        }
      }
    });
  }, e.prototype.toggleOpen = function (t) {
    this.setState({
      open: t
    });
  }, e.prototype.handleClick = function (t) {
    var e = this.props.handle;
    e.props.onClick && e.props.onClick(t), this.toggleOpen(!this.state.open);
  }, e.prototype.handleKeydown = function (t) {
    var e = this.props.handle;

    switch (e.props.onKeyDown && e.props.onKeyDown(t), t.which) {
      case 13:
        return void this.toggleOpen(!this.state.open);

      case 39:
        return void this.toggleOpen(!0);

      case 38:
      case 40:
      case 9:
        var n = t.shiftKey || 38 === t.which;
        return void this.correctFocus(n);

      case 37:
        return void this.toggleOpen(!1);
    }
  }, e.prototype.handleFocus = function (t) {
    if (!this.state.open && this.root && this.childContainer && this.childContainer.contains(document.activeElement)) {
      var e = this.root.querySelector(".rmwc-collapsible-list__handle .mdc-list-item");
      e && e.focus();
    }
  }, e.prototype.render = function () {
    var t,
        e = this,
        i = this.props,
        r = i.children,
        a = i.handle,
        s = (i.onOpen, i.onClose, i.open, i.startOpen, Dr(i, ["children", "handle", "onOpen", "onClose", "open", "startOpen"])),
        c = this.state,
        u = c.open,
        l = c.childrenStyle;
    return n(kr, _Lr({}, s, {
      onFocus: this.handleFocus,
      ref: function ref(t) {
        return e.root = t;
      },
      className: m("rmwc-collapsible-list", (t = {}, t["rmwc-collapsible-list--open"] = u, t))
    }), n("div", {
      className: "rmwc-collapsible-list__handle"
    }, o(a, _Lr({}, a.props, {
      onClick: this.handleClick,
      onKeyDown: this.handleKeydown
    }))), n("div", {
      className: "rmwc-collapsible-list__children",
      style: l
    }, n("div", {
      className: "rmwc-collapsible-list__children-inner",
      ref: function ref(t) {
        return e.childContainer = t;
      }
    }, r)));
  }, e.displayName = "CollapsibleList";
}(i);

function Mr(t, e) {
  if (void 0 === e && (e = !1), void 0 === br || e) {
    var n = t.document.createElement("div");
    br = "transform" in n.style ? "transform" : "webkitTransform";
  }

  return br;
}

var Hr,
    Br,
    Vr = {
  ANCHOR: "mdc-menu-surface--anchor",
  ANIMATING_CLOSED: "mdc-menu-surface--animating-closed",
  ANIMATING_OPEN: "mdc-menu-surface--animating-open",
  FIXED: "mdc-menu-surface--fixed",
  OPEN: "mdc-menu-surface--open",
  ROOT: "mdc-menu-surface"
},
    jr = {
  CLOSED_EVENT: "MDCMenuSurface:closed",
  OPENED_EVENT: "MDCMenuSurface:opened",
  FOCUSABLE_ELEMENTS: ["button:not(:disabled)", '[href]:not([aria-disabled="true"])', "input:not(:disabled)", "select:not(:disabled)", "textarea:not(:disabled)", '[tabindex]:not([tabindex="-1"]):not([aria-disabled="true"])'].join(", ")
},
    Ur = {
  TRANSITION_OPEN_DURATION: 120,
  TRANSITION_CLOSE_DURATION: 75,
  MARGIN_TO_EDGE: 32,
  ANCHOR_TO_MENU_SURFACE_WIDTH_RATIO: .67
};
!function (t) {
  t[t.BOTTOM = 1] = "BOTTOM", t[t.CENTER = 2] = "CENTER", t[t.RIGHT = 4] = "RIGHT", t[t.FLIP_RTL = 8] = "FLIP_RTL";
}(Hr || (Hr = {})), function (t) {
  t[t.TOP_LEFT = 0] = "TOP_LEFT", t[t.TOP_RIGHT = 4] = "TOP_RIGHT", t[t.BOTTOM_LEFT = 1] = "BOTTOM_LEFT", t[t.BOTTOM_RIGHT = 5] = "BOTTOM_RIGHT", t[t.TOP_START = 8] = "TOP_START", t[t.TOP_END = 12] = "TOP_END", t[t.BOTTOM_START = 9] = "BOTTOM_START", t[t.BOTTOM_END = 13] = "BOTTOM_END";
}(Br || (Br = {}));

var Gr = function (t) {
  function e(n) {
    var i = t.call(this, _jt({}, e.defaultAdapter, n)) || this;
    return i.isOpen_ = !1, i.isQuickOpen_ = !1, i.isHoistedElement_ = !1, i.isFixedPosition_ = !1, i.openAnimationEndTimerId_ = 0, i.closeAnimationEndTimerId_ = 0, i.animationRequestId_ = 0, i.anchorCorner_ = Br.TOP_START, i.anchorMargin_ = {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }, i.position_ = {
      x: 0,
      y: 0
    }, i;
  }

  return Vt(e, t), Object.defineProperty(e, "cssClasses", {
    get: function get() {
      return Vr;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "strings", {
    get: function get() {
      return jr;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "numbers", {
    get: function get() {
      return Ur;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "Corner", {
    get: function get() {
      return Br;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultAdapter", {
    get: function get() {
      return {
        addClass: function addClass() {},
        removeClass: function removeClass() {},
        hasClass: function hasClass() {
          return !1;
        },
        hasAnchor: function hasAnchor() {
          return !1;
        },
        isElementInContainer: function isElementInContainer() {
          return !1;
        },
        isFocused: function isFocused() {
          return !1;
        },
        isFirstElementFocused: function isFirstElementFocused() {
          return !1;
        },
        isLastElementFocused: function isLastElementFocused() {
          return !1;
        },
        isRtl: function isRtl() {
          return !1;
        },
        getInnerDimensions: function getInnerDimensions() {
          return {
            height: 0,
            width: 0
          };
        },
        getAnchorDimensions: function getAnchorDimensions() {
          return null;
        },
        getWindowDimensions: function getWindowDimensions() {
          return {
            height: 0,
            width: 0
          };
        },
        getBodyDimensions: function getBodyDimensions() {
          return {
            height: 0,
            width: 0
          };
        },
        getWindowScroll: function getWindowScroll() {
          return {
            x: 0,
            y: 0
          };
        },
        setPosition: function setPosition() {},
        setMaxHeight: function setMaxHeight() {},
        setTransformOrigin: function setTransformOrigin() {},
        saveFocus: function saveFocus() {},
        restoreFocus: function restoreFocus() {},
        focusFirstElement: function focusFirstElement() {},
        focusLastElement: function focusLastElement() {},
        notifyClose: function notifyClose() {},
        notifyOpen: function notifyOpen() {}
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.init = function () {
    var t = e.cssClasses,
        n = t.ROOT,
        i = t.OPEN;
    if (!this.adapter_.hasClass(n)) throw new Error(n + " class required in root element.");
    this.adapter_.hasClass(i) && (this.isOpen_ = !0);
  }, e.prototype.destroy = function () {
    clearTimeout(this.openAnimationEndTimerId_), clearTimeout(this.closeAnimationEndTimerId_), cancelAnimationFrame(this.animationRequestId_);
  }, e.prototype.setAnchorCorner = function (t) {
    this.anchorCorner_ = t;
  }, e.prototype.setAnchorMargin = function (t) {
    this.anchorMargin_.top = t.top || 0, this.anchorMargin_.right = t.right || 0, this.anchorMargin_.bottom = t.bottom || 0, this.anchorMargin_.left = t.left || 0;
  }, e.prototype.setIsHoisted = function (t) {
    this.isHoistedElement_ = t;
  }, e.prototype.setFixedPosition = function (t) {
    this.isFixedPosition_ = t;
  }, e.prototype.setAbsolutePosition = function (t, e) {
    this.position_.x = this.isFinite_(t) ? t : 0, this.position_.y = this.isFinite_(e) ? e : 0;
  }, e.prototype.setQuickOpen = function (t) {
    this.isQuickOpen_ = t;
  }, e.prototype.isOpen = function () {
    return this.isOpen_;
  }, e.prototype.open = function () {
    var t = this;
    this.adapter_.saveFocus(), this.isQuickOpen_ || this.adapter_.addClass(e.cssClasses.ANIMATING_OPEN), this.animationRequestId_ = requestAnimationFrame(function () {
      t.adapter_.addClass(e.cssClasses.OPEN), t.dimensions_ = t.adapter_.getInnerDimensions(), t.autoPosition_(), t.isQuickOpen_ ? t.adapter_.notifyOpen() : t.openAnimationEndTimerId_ = setTimeout(function () {
        t.openAnimationEndTimerId_ = 0, t.adapter_.removeClass(e.cssClasses.ANIMATING_OPEN), t.adapter_.notifyOpen();
      }, Ur.TRANSITION_OPEN_DURATION);
    }), this.isOpen_ = !0;
  }, e.prototype.close = function () {
    var t = this;
    this.isQuickOpen_ || this.adapter_.addClass(e.cssClasses.ANIMATING_CLOSED), requestAnimationFrame(function () {
      t.adapter_.removeClass(e.cssClasses.OPEN), t.isQuickOpen_ ? t.adapter_.notifyClose() : t.closeAnimationEndTimerId_ = setTimeout(function () {
        t.closeAnimationEndTimerId_ = 0, t.adapter_.removeClass(e.cssClasses.ANIMATING_CLOSED), t.adapter_.notifyClose();
      }, Ur.TRANSITION_CLOSE_DURATION);
    }), this.isOpen_ = !1, this.maybeRestoreFocus_();
  }, e.prototype.handleBodyClick = function (t) {
    var e = t.target;
    this.adapter_.isElementInContainer(e) || this.close();
  }, e.prototype.handleKeydown = function (t) {
    var e = t.keyCode,
        n = t.key,
        i = t.shiftKey,
        r = "Tab" === n || 9 === e;
    "Escape" === n || 27 === e ? this.close() : r && (this.adapter_.isLastElementFocused() && !i ? (this.adapter_.focusFirstElement(), t.preventDefault()) : this.adapter_.isFirstElementFocused() && i && (this.adapter_.focusLastElement(), t.preventDefault()));
  }, e.prototype.autoPosition_ = function () {
    var t;
    this.measurements_ = this.getAutoLayoutMeasurements_();
    var e = this.getOriginCorner_(),
        n = this.getMenuSurfaceMaxHeight_(e),
        i = this.hasBit_(e, Hr.BOTTOM) ? "bottom" : "top",
        r = this.hasBit_(e, Hr.RIGHT) ? "right" : "left",
        o = this.getHorizontalOriginOffset_(e),
        a = this.getVerticalOriginOffset_(e),
        s = this.measurements_,
        c = s.anchorSize,
        u = s.surfaceSize,
        l = ((t = {})[r] = o, t[i] = a, t);
    c.width / u.width > Ur.ANCHOR_TO_MENU_SURFACE_WIDTH_RATIO && (r = "center"), (this.isHoistedElement_ || this.isFixedPosition_) && this.adjustPositionForHoistedElement_(l), this.adapter_.setTransformOrigin(r + " " + i), this.adapter_.setPosition(l), this.adapter_.setMaxHeight(n ? n + "px" : "");
  }, e.prototype.getAutoLayoutMeasurements_ = function () {
    var t = this.adapter_.getAnchorDimensions(),
        e = this.adapter_.getBodyDimensions(),
        n = this.adapter_.getWindowDimensions(),
        i = this.adapter_.getWindowScroll();
    return t || (t = {
      top: this.position_.y,
      right: this.position_.x,
      bottom: this.position_.y,
      left: this.position_.x,
      width: 0,
      height: 0
    }), {
      anchorSize: t,
      bodySize: e,
      surfaceSize: this.dimensions_,
      viewportDistance: {
        top: t.top,
        right: n.width - t.right,
        bottom: n.height - t.bottom,
        left: t.left
      },
      viewportSize: n,
      windowScroll: i
    };
  }, e.prototype.getOriginCorner_ = function () {
    var t = Br.TOP_LEFT,
        e = this.measurements_,
        n = e.viewportDistance,
        i = e.anchorSize,
        r = e.surfaceSize,
        o = this.hasBit_(this.anchorCorner_, Hr.BOTTOM),
        a = o ? n.top + i.height + this.anchorMargin_.bottom : n.top + this.anchorMargin_.top,
        s = o ? n.bottom - this.anchorMargin_.bottom : n.bottom + i.height - this.anchorMargin_.top,
        c = r.height - a,
        u = r.height - s;
    u > 0 && c < u && (t = this.setBit_(t, Hr.BOTTOM));

    var l = this.adapter_.isRtl(),
        d = this.hasBit_(this.anchorCorner_, Hr.FLIP_RTL),
        h = this.hasBit_(this.anchorCorner_, Hr.RIGHT),
        p = h && !l || !h && d && l,
        f = p ? n.left + i.width + this.anchorMargin_.right : n.left + this.anchorMargin_.left,
        m = p ? n.right - this.anchorMargin_.right : n.right + i.width - this.anchorMargin_.left,
        _ = r.width - f,
        g = r.width - m;

    return (_ < 0 && p && l || h && !p && _ < 0 || g > 0 && _ < g) && (t = this.setBit_(t, Hr.RIGHT)), t;
  }, e.prototype.getMenuSurfaceMaxHeight_ = function (t) {
    var n = this.measurements_.viewportDistance,
        i = 0,
        r = this.hasBit_(t, Hr.BOTTOM),
        o = this.hasBit_(this.anchorCorner_, Hr.BOTTOM),
        a = e.numbers.MARGIN_TO_EDGE;
    return r ? (i = n.top + this.anchorMargin_.top - a, o || (i += this.measurements_.anchorSize.height)) : (i = n.bottom - this.anchorMargin_.bottom + this.measurements_.anchorSize.height - a, o && (i -= this.measurements_.anchorSize.height)), i;
  }, e.prototype.getHorizontalOriginOffset_ = function (t) {
    var e = this.measurements_.anchorSize,
        n = this.hasBit_(t, Hr.RIGHT),
        i = this.hasBit_(this.anchorCorner_, Hr.RIGHT);

    if (n) {
      var r = i ? e.width - this.anchorMargin_.left : this.anchorMargin_.right;
      return this.isHoistedElement_ || this.isFixedPosition_ ? r - (this.measurements_.viewportSize.width - this.measurements_.bodySize.width) : r;
    }

    return i ? e.width - this.anchorMargin_.right : this.anchorMargin_.left;
  }, e.prototype.getVerticalOriginOffset_ = function (t) {
    var e = this.measurements_.anchorSize,
        n = this.hasBit_(t, Hr.BOTTOM),
        i = this.hasBit_(this.anchorCorner_, Hr.BOTTOM);
    return n ? i ? e.height - this.anchorMargin_.top : -this.anchorMargin_.bottom : i ? e.height + this.anchorMargin_.bottom : this.anchorMargin_.top;
  }, e.prototype.adjustPositionForHoistedElement_ = function (t) {
    var e,
        n,
        i = this.measurements_,
        r = i.windowScroll,
        o = i.viewportDistance,
        a = Object.keys(t);

    try {
      for (var s = qt(a), c = s.next(); !c.done; c = s.next()) {
        var u = c.value,
            l = t[u] || 0;
        l += o[u], this.isFixedPosition_ || ("top" === u ? l += r.y : "bottom" === u ? l -= r.y : "left" === u ? l += r.x : l -= r.x), t[u] = l;
      }
    } catch (t) {
      e = {
        error: t
      };
    } finally {
      try {
        c && !c.done && (n = s.return) && n.call(s);
      } finally {
        if (e) throw e.error;
      }
    }
  }, e.prototype.maybeRestoreFocus_ = function () {
    var t = this.adapter_.isFocused(),
        e = document.activeElement && this.adapter_.isElementInContainer(document.activeElement);
    (t || e) && this.adapter_.restoreFocus();
  }, e.prototype.hasBit_ = function (t, e) {
    return Boolean(t & e);
  }, e.prototype.setBit_ = function (t, e) {
    return t | e;
  }, e.prototype.isFinite_ = function (t) {
    return "number" == typeof t && isFinite(t);
  }, e;
}(Yt),
    zr = (function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  Vt(e, t), e.attachTo = function (t) {
    return new e(t);
  }, e.prototype.initialSyncWithDOM = function () {
    var t = this,
        e = this.root_.parentElement;
    this.anchorElement = e && e.classList.contains(Vr.ANCHOR) ? e : null, this.root_.classList.contains(Vr.FIXED) && this.setFixedPosition(!0), this.handleKeydown_ = function (e) {
      return t.foundation_.handleKeydown(e);
    }, this.handleBodyClick_ = function (e) {
      return t.foundation_.handleBodyClick(e);
    }, this.registerBodyClickListener_ = function () {
      return document.body.addEventListener("click", t.handleBodyClick_);
    }, this.deregisterBodyClickListener_ = function () {
      return document.body.removeEventListener("click", t.handleBodyClick_);
    }, this.listen("keydown", this.handleKeydown_), this.listen(jr.OPENED_EVENT, this.registerBodyClickListener_), this.listen(jr.CLOSED_EVENT, this.deregisterBodyClickListener_);
  }, e.prototype.destroy = function () {
    this.unlisten("keydown", this.handleKeydown_), this.unlisten(jr.OPENED_EVENT, this.registerBodyClickListener_), this.unlisten(jr.CLOSED_EVENT, this.deregisterBodyClickListener_), t.prototype.destroy.call(this);
  }, Object.defineProperty(e.prototype, "open", {
    get: function get() {
      return this.foundation_.isOpen();
    },
    set: function set(t) {
      if (t) {
        var e = this.root_.querySelectorAll(jr.FOCUSABLE_ELEMENTS);
        this.firstFocusableElement_ = e[0], this.lastFocusableElement_ = e[e.length - 1], this.foundation_.open();
      } else this.foundation_.close();
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "quickOpen", {
    set: function set(t) {
      this.foundation_.setQuickOpen(t);
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.hoistMenuToBody = function () {
    document.body.appendChild(this.root_), this.setIsHoisted(!0);
  }, e.prototype.setIsHoisted = function (t) {
    this.foundation_.setIsHoisted(t);
  }, e.prototype.setMenuSurfaceAnchorElement = function (t) {
    this.anchorElement = t;
  }, e.prototype.setFixedPosition = function (t) {
    t ? this.root_.classList.add(Vr.FIXED) : this.root_.classList.remove(Vr.FIXED), this.foundation_.setFixedPosition(t);
  }, e.prototype.setAbsolutePosition = function (t, e) {
    this.foundation_.setAbsolutePosition(t, e), this.setIsHoisted(!0);
  }, e.prototype.setAnchorCorner = function (t) {
    this.foundation_.setAnchorCorner(t);
  }, e.prototype.setAnchorMargin = function (t) {
    this.foundation_.setAnchorMargin(t);
  }, e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new Gr({
      addClass: function addClass(e) {
        return t.root_.classList.add(e);
      },
      removeClass: function removeClass(e) {
        return t.root_.classList.remove(e);
      },
      hasClass: function hasClass(e) {
        return t.root_.classList.contains(e);
      },
      hasAnchor: function hasAnchor() {
        return !!t.anchorElement;
      },
      notifyClose: function notifyClose() {
        return t.emit(Gr.strings.CLOSED_EVENT, {});
      },
      notifyOpen: function notifyOpen() {
        return t.emit(Gr.strings.OPENED_EVENT, {});
      },
      isElementInContainer: function isElementInContainer(e) {
        return t.root_.contains(e);
      },
      isRtl: function isRtl() {
        return "rtl" === getComputedStyle(t.root_).getPropertyValue("direction");
      },
      setTransformOrigin: function setTransformOrigin(e) {
        var n = Mr(window) + "-origin";
        t.root_.style.setProperty(n, e);
      },
      isFocused: function isFocused() {
        return document.activeElement === t.root_;
      },
      saveFocus: function saveFocus() {
        t.previousFocus_ = document.activeElement;
      },
      restoreFocus: function restoreFocus() {
        t.root_.contains(document.activeElement) && t.previousFocus_ && t.previousFocus_.focus && t.previousFocus_.focus();
      },
      isFirstElementFocused: function isFirstElementFocused() {
        return !!t.firstFocusableElement_ && t.firstFocusableElement_ === document.activeElement;
      },
      isLastElementFocused: function isLastElementFocused() {
        return !!t.lastFocusableElement_ && t.lastFocusableElement_ === document.activeElement;
      },
      focusFirstElement: function focusFirstElement() {
        return t.firstFocusableElement_ && t.firstFocusableElement_.focus && t.firstFocusableElement_.focus();
      },
      focusLastElement: function focusLastElement() {
        return t.lastFocusableElement_ && t.lastFocusableElement_.focus && t.lastFocusableElement_.focus();
      },
      getInnerDimensions: function getInnerDimensions() {
        return {
          width: t.root_.offsetWidth,
          height: t.root_.offsetHeight
        };
      },
      getAnchorDimensions: function getAnchorDimensions() {
        return t.anchorElement ? t.anchorElement.getBoundingClientRect() : null;
      },
      getWindowDimensions: function getWindowDimensions() {
        return {
          width: window.innerWidth,
          height: window.innerHeight
        };
      },
      getBodyDimensions: function getBodyDimensions() {
        return {
          width: document.body.clientWidth,
          height: document.body.clientHeight
        };
      },
      getWindowScroll: function getWindowScroll() {
        return {
          x: window.pageXOffset,
          y: window.pageYOffset
        };
      },
      setPosition: function setPosition(e) {
        t.root_.style.left = "left" in e ? e.left + "px" : "", t.root_.style.right = "right" in e ? e.right + "px" : "", t.root_.style.top = "top" in e ? e.top + "px" : "", t.root_.style.bottom = "bottom" in e ? e.bottom + "px" : "";
      },
      setMaxHeight: function setMaxHeight(e) {
        t.root_.style.maxHeight = e;
      }
    });
  };
}($t), function () {
  var _t22 = function t(e, n) {
    return (_t22 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var n in e) {
        e.hasOwnProperty(n) && (t[n] = e[n]);
      }
    })(e, n);
  };

  return function (e, n) {
    function i() {
      this.constructor = e;
    }

    _t22(e, n), e.prototype = null === n ? Object.create(n) : (i.prototype = n.prototype, new i());
  };
}()),
    _Kr = function Kr() {
  return (_Kr = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    qr = function qr(t, e) {
  var n = {};

  for (var i in t) {
    Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
  }

  if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
    var r = 0;

    for (i = Object.getOwnPropertySymbols(t); r < i.length; r++) {
      e.indexOf(i[r]) < 0 && (n[i[r]] = t[i[r]]);
    }
  }

  return n;
},
    Wr = {
  bottomEnd: "BOTTOM_END",
  bottomLeft: "BOTTOM_LEFT",
  bottomRight: "BOTTOM_RIGHT",
  bottomStart: "BOTTOM_START",
  topEnd: "TOP_END",
  topLeft: "TOP_LEFT",
  topRight: "TOP_RIGHT",
  topStart: "TOP_START"
},
    Xr = Mt({
  displayName: "MenuSurfaceRoot",
  classNames: function classNames(t) {
    return ["mdc-menu-surface", {
      "mdc-menu-surface--fixed": t.fixed
    }];
  },
  consumeProps: ["fixed"]
}),
    Yr = function (t) {
  function e(e) {
    var n = t.call(this, e) || this;
    return n.root = n.createElement("root"), n.anchorElement = null, n.previousFocus = null, n.firstFocusableElement = null, n.lastFocusableElement = null, n.hoisted = !1, n.handleKeydown = n.handleKeydown.bind(n), n.handleBodyClick = n.handleBodyClick.bind(n), n;
  }

  return zr(e, t), e.prototype.componentDidMount = function () {
    if (this.root.ref) {
      var e = vt(this.root.ref, "." + Gr.cssClasses.ANCHOR);
      e && (this.anchorElement = e);
    }

    t.prototype.componentDidMount.call(this);
  }, e.prototype.componentWillUnmount = function () {
    this.hoisted && this.unhoistMenuFromBody(), t.prototype.componentWillUnmount.call(this);
  }, Object.defineProperty(e.prototype, "open", {
    get: function get() {
      return this.foundation.isOpen();
    },
    set: function set(t) {
      if (t && this.foundation && !this.foundation.isOpen()) {
        var e = this.root.ref ? this.root.ref.querySelectorAll(Gr.strings.FOCUSABLE_ELEMENTS) : [];
        this.firstFocusableElement = e.length > 0 ? e[0] : null, this.lastFocusableElement = e.length > 0 ? e[e.length - 1] : null, this.foundation.open();
      } else this.foundation && this.foundation.isOpen() && this.foundation.close();
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new Gr(_Kr({
      addClass: function addClass(e) {
        t.root.addClass(e);
      },
      removeClass: function removeClass(e) {
        t.root.removeClass(e);
      },
      hasClass: function hasClass(e) {
        return "mdc-menu-surface" === e || t.root.hasClass(e);
      },
      hasAnchor: function hasAnchor() {
        return !!t.anchorElement;
      },
      notifyClose: function notifyClose() {
        t.emit("onClose", {}), t.deregisterBodyClickListener(), t.props.open && (t.open = t.props.open);
      },
      notifyOpen: function notifyOpen() {
        t.emit("onOpen", {}), t.registerBodyClickListener();
      },
      isElementInContainer: function isElementInContainer(e) {
        return t.root.ref === e || !!t.root.ref && t.root.ref.contains(e);
      },
      isRtl: function isRtl() {
        return !!t.root.ref && "rtl" === getComputedStyle(t.root.ref).getPropertyValue("direction");
      },
      setTransformOrigin: function setTransformOrigin(e) {
        t.root.setStyle(Mr(window) + "-origin", e);
      }
    }, this.getFocusAdapterMethods(), this.getDimensionAdapterMethods()));
  }, e.prototype.getFocusAdapterMethods = function () {
    var t = this;
    return {
      isFocused: function isFocused() {
        return document.activeElement === t.root.ref;
      },
      saveFocus: function saveFocus() {
        t.previousFocus = document.activeElement;
      },
      restoreFocus: function restoreFocus() {
        t.root.ref && t.root.ref.contains(document.activeElement) && t.previousFocus && t.previousFocus.focus && t.previousFocus.focus();
      },
      isFirstElementFocused: function isFirstElementFocused() {
        return !!t.firstFocusableElement && t.firstFocusableElement === document.activeElement;
      },
      isLastElementFocused: function isLastElementFocused() {
        return !!t.firstFocusableElement && t.firstFocusableElement === document.activeElement;
      },
      focusFirstElement: function focusFirstElement() {
        return !!t.firstFocusableElement && t.firstFocusableElement.focus && t.firstFocusableElement.focus();
      },
      focusLastElement: function focusLastElement() {
        return !!t.firstFocusableElement && t.firstFocusableElement.focus && t.firstFocusableElement.focus();
      }
    };
  }, e.prototype.getDimensionAdapterMethods = function () {
    var t = this;
    return {
      getInnerDimensions: function getInnerDimensions() {
        return {
          width: t.root.ref ? t.root.ref.offsetWidth : 0,
          height: t.root.ref ? t.root.ref.offsetHeight : 0
        };
      },
      getAnchorDimensions: function getAnchorDimensions() {
        return t.anchorElement && t.anchorElement.getBoundingClientRect();
      },
      getWindowDimensions: function getWindowDimensions() {
        return {
          width: window.innerWidth,
          height: window.innerHeight
        };
      },
      getBodyDimensions: function getBodyDimensions() {
        return {
          width: document.body.clientWidth,
          height: document.body.clientHeight
        };
      },
      getWindowScroll: function getWindowScroll() {
        return {
          x: window.pageXOffset,
          y: window.pageYOffset
        };
      },
      setPosition: function setPosition(e) {
        t.root.setStyle("left", void 0 !== e.left ? e.left : null), t.root.setStyle("right", void 0 !== e.right ? e.right : null), t.root.setStyle("top", void 0 !== e.top ? e.top : null), t.root.setStyle("bottom", void 0 !== e.bottom ? e.bottom : null);
      },
      setMaxHeight: function setMaxHeight(e) {
        t.root.setStyle("maxHeight", e);
      }
    };
  }, e.prototype.sync = function (t, e) {
    var n = this;
    this.syncProp(t.fixed, e.fixed, function () {
      n.foundation.setFixedPosition(!!t.fixed);
    }), this.syncProp(t.hoistToBody, e.hoistToBody, function () {
      t.hoistToBody ? n.hoistMenuToBody() : n.unhoistMenuFromBody();
    });

    var i = t.anchorCorner && function (t) {
      return Gr.Corner[Wr[t]];
    }(t.anchorCorner);

    this.syncProp(i, this.foundation.anchorCorner_, function () {
      i && (n.foundation.setAnchorCorner(i), n.foundation.dimensions_ = n.foundation.adapter_.getInnerDimensions(), n.foundation.autoPosition_());
    }), this.syncProp(t.open, e.open, function () {
      n.open = !!t.open;
    });
  }, e.prototype.hoistMenuToBody = function () {
    var t = this;
    this.root.ref && this.root.ref.parentElement && (document.body.appendChild(this.root.ref.parentElement.removeChild(this.root.ref)), this.hoisted = !0, this.foundation.setIsHoisted(!0), this.props.open && setTimeout(function () {
      return t.foundation.autoPosition_();
    }));
  }, e.prototype.unhoistMenuFromBody = function () {
    this.anchorElement && this.root.ref && (this.anchorElement.appendChild(this.root.ref), this.hoisted = !1, this.foundation.setIsHoisted(!1));
  }, e.prototype.setAnchorCorner = function (t) {
    this.foundation.setAnchorCorner(t);
  }, e.prototype.registerBodyClickListener = function () {
    document.body.addEventListener("click", this.handleBodyClick), document.body.addEventListener("touchstart", this.handleBodyClick);
  }, e.prototype.deregisterBodyClickListener = function () {
    document.body.removeEventListener("click", this.handleBodyClick), document.body.removeEventListener("touchstart", this.handleBodyClick);
  }, e.prototype.handleBodyClick = function (t) {
    this.foundation && this.foundation.handleBodyClick(t);
  }, e.prototype.handleKeydown = function (t) {
    this.props.onKeyDown && this.props.onKeyDown(t), this.foundation.handleKeydown(t);
  }, e.prototype.render = function () {
    var t = this.props,
        e = t.children,
        i = (t.open, t.anchorCorner, t.onOpen, t.onClose, t.hoistToBody, qr(t, ["children", "open", "anchorCorner", "onOpen", "onClose", "hoistToBody"]));
    return n(Xr, _Kr({}, this.root.props(i), {
      ref: this.root.setRef,
      onKeyDown: this.handleKeydown
    }), e);
  }, e.displayName = "MenuSurface", e;
}(Rt),
    $r = Mt({
  displayName: "MenuSurfaceAnchor",
  classNames: ["mdc-menu-surface--anchor"]
}),
    Qr = function () {
  var _t23 = function t(e, n) {
    return (_t23 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var n in e) {
        e.hasOwnProperty(n) && (t[n] = e[n]);
      }
    })(e, n);
  };

  return function (e, n) {
    function i() {
      this.constructor = e;
    }

    _t23(e, n), e.prototype = null === n ? Object.create(n) : (i.prototype = n.prototype, new i());
  };
}(),
    _Zr = function Zr() {
  return (_Zr = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    Jr = function Jr(t, e) {
  var n = {};

  for (var i in t) {
    Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
  }

  if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
    var r = 0;

    for (i = Object.getOwnPropertySymbols(t); r < i.length; r++) {
      e.indexOf(i[r]) < 0 && (n[i[r]] = t[i[r]]);
    }
  }

  return n;
},
    to = Mt({
  displayName: "MenuItems",
  tag: Or,
  classNames: ["mdc-list mdc-menu__items"],
  defaultProps: {
    role: "menu"
  }
}),
    eo = Mt({
  displayName: "MenuItem",
  tag: xr,
  defaultProps: {
    role: "menuitem",
    tabIndex: 0
  }
}),
    no = function (t) {
  function e(e) {
    var n = t.call(this, e) || this;
    return n.list = null, n.menuSurface = null, n.handleKeydown = n.handleKeydown.bind(n), n.handleClick = n.handleClick.bind(n), n.handleOpen = n.handleOpen.bind(n), n;
  }

  return Qr(e, t), Object.defineProperty(e.prototype, "items", {
    get: function get() {
      return this.list ? this.list.listElements : [];
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.hoistMenuToBody = function () {
    this.menuSurface && this.menuSurface.hoistMenuToBody();
  }, e.prototype.setAnchorCorner = function (t) {
    this.menuSurface && this.menuSurface.setAnchorCorner(t);
  }, e.prototype.setAnchorElement = function (t) {
    this.menuSurface && (this.menuSurface.anchorElement = t);
  }, e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new mr({
      addClassToElementAtIndex: function addClassToElementAtIndex(e, n) {
        t.items[e].classList.add(n);
      },
      removeClassFromElementAtIndex: function removeClassFromElementAtIndex(e, n) {
        t.items[e].classList.remove(n);
      },
      addAttributeToElementAtIndex: function addAttributeToElementAtIndex(e, n, i) {
        t.items[e].setAttribute(n, i);
      },
      removeAttributeFromElementAtIndex: function removeAttributeFromElementAtIndex(e, n) {
        t.items[e].removeAttribute(n);
      },
      elementContainsClass: function elementContainsClass(t, e) {
        return t.classList.contains(e);
      },
      closeSurface: function closeSurface() {
        t.menuSurface && (t.menuSurface.open = !1);
      },
      getElementIndex: function getElementIndex(e) {
        return t.items.indexOf(e);
      },
      getParentElement: function getParentElement(t) {
        return t.parentElement;
      },
      getSelectedElementIndex: function getSelectedElementIndex(e) {
        return t.items.indexOf(e.querySelector("." + mr.cssClasses.MENU_SELECTED_LIST_ITEM));
      },
      notifySelected: function notifySelected(e) {
        return t.emit("onSelect", {
          index: e.index,
          item: t.items[e.index]
        });
      },
      getMenuItemCount: function getMenuItemCount() {
        return t.items.length;
      },
      focusItemAtIndex: function focusItemAtIndex(e) {
        return t.items[e].focus();
      },
      focusListRoot: function focusListRoot() {
        return t.list && t.list.root && t.list.root.ref && t.list.root.ref.focus();
      }
    });
  }, e.prototype.handleClick = function (t) {
    this.props.onClick && this.props.onClick(t);
    var e = vt(t.target, ".mdc-list-item");
    e && this.foundation.handleItemAction(e);
  }, e.prototype.handleKeydown = function (t) {
    this.props.onKeyDown && this.props.onKeyDown(t), this.foundation.handleKeydown(t), 13 === t.which && t.target instanceof Element && t.target.classList.contains(Or.cssClasses.LIST_ITEM_CLASS) && this.foundation.handleItemAction(t.target);
  }, e.prototype.handleOpen = function (t) {
    var e = this.items;
    this.props.focusOnOpen && e.length > 0 && !e.some(function (t) {
      return t === document.activeElement;
    }) && e[0].focus(), this.props.onOpen && this.props.onOpen(t);
  }, e.prototype.render = function () {
    var t = this,
        e = this.props,
        i = e.children,
        r = (e.focusOnOpen, Jr(e, ["children", "focusOnOpen"])),
        a = !(i && "object" == typeof i && "MenuItems" === (i.type || {}).displayName);
    return n(Yr, _Zr({}, r, {
      "aria-hidden": !r.open,
      className: "mdc-menu " + (r.className || ""),
      onKeyDown: this.handleKeydown,
      onClick: this.handleClick,
      onOpen: this.handleOpen,
      ref: function ref(e) {
        return t.menuSurface = e;
      }
    }), a ? n(to, {
      ref: function ref(e) {
        return t.list = e;
      }
    }, i) : o(i, {
      ref: function ref(e) {
        return t.list = e;
      }
    }));
  }, e.displayName = "Menu", e.defaultProps = {
    focusOnOpen: !0
  }, e;
}(Rt),
    io = function io(t) {
  var e;
  return (e = function (e) {
    function i() {
      var t = null !== e && e.apply(this, arguments) || this;
      return t.state = {
        open: !!t.props.open
      }, t;
    }

    return Qr(i, e), i.prototype.componentDidMount = function () {
      this.syncWithOpenProp(this.props.open);
    }, i.prototype.componentDidUpdate = function (t) {
      this.syncWithOpenProp(t.open);
    }, i.prototype.syncWithOpenProp = function (t) {
      void 0 !== t && this.state.open !== t && this.setState({
        open: t
      });
    }, i.prototype.render = function () {
      var e = this,
          i = this.props,
          r = i.handle,
          a = i.onClose,
          s = i.children,
          c = i.rootProps,
          u = void 0 === c ? {} : c,
          l = i.open,
          d = Jr(i, ["handle", "onClose", "children", "rootProps", "open"]),
          h = o(r, _Zr({}, r.props, {
        onClick: function onClick(t) {
          e.setState({
            open: !e.state.open
          }), r.props.onClick && r.props.onClick(t);
        }
      }));
      return n($r, _Zr({}, u), n(t, _Zr({}, d, {
        onClose: function onClose(t) {
          e.setState({
            open: !!l || !1
          }), a && a(t);
        },
        open: this.state.open
      }), s), h);
    }, i;
  }(i)).displayName = "Simple" + t.displayName, e;
},
    ro = (io(no), io(Yr), function () {
  return (ro = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
}),
    oo = function oo(t, e) {
  var n = {};

  for (var i in t) {
    Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
  }

  if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
    var r = 0;

    for (i = Object.getOwnPropertySymbols(t); r < i.length; r++) {
      e.indexOf(i[r]) < 0 && (n[i[r]] = t[i[r]]);
    }
  }

  return n;
},
    ao = Ln({
  surface: !1
})(Mt({
  displayName: "FabRoot",
  tag: "button",
  classNames: function classNames(t) {
    return ["mdc-fab", {
      "mdc-fab--mini": t.mini,
      "mdc-fab--exited": t.exited,
      "mdc-fab--extended": t.label
    }];
  },
  defaultProps: {
    cssOnly: !1,
    mini: !1
  },
  consumeProps: ["mini", "cssOnly", "exited", "label", "icon"]
})),
    so = Mt({
  displayName: "FabIcon",
  tag: mn,
  classNames: ["mdc-fab__icon"]
}),
    co = Mt({
  displayName: "FabLabel",
  classNames: ["mdc-fab__label"]
}),
    uo = r(function (t, e) {
  var i = t.children,
      r = t.label,
      o = t.icon,
      a = t.trailingIcon,
      s = oo(t, ["children", "label", "icon", "trailingIcon"]);
  return a && !r && console.warn("FAB 'trailingIcon' prop should only be used in conjunction with 'label'"), n(ao, ro({
    label: r
  }, s, {
    ref: e
  }), !!o && n(so, {
    icon: o
  }), !!r && n(co, null, r), i, !!a && n(so, {
    icon: a
  }));
});

uo.displayName = "Fab";
var lo = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function ho(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}

function po(t, e) {
  return t(e = {
    exports: {}
  }, e.exports), e.exports;
}

var fo = po(function (t, e) {
  var n = lo && lo.__assign || function () {
    return (n = Object.assign || function (t) {
      for (var e, n = 1, i = arguments.length; n < i; n++) {
        for (var r in e = arguments[n]) {
          Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
        }
      }

      return t;
    }).apply(this, arguments);
  };

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  var i = {
    aliceblue: "#f0f8ff",
    antiquewhite: "#faebd7",
    aqua: "#00ffff",
    aquamarine: "#7fffd4",
    azure: "#f0ffff",
    beige: "#f5f5dc",
    bisque: "#ffe4c4",
    black: "#000000",
    blanchedalmond: "#ffebcd",
    blue: "#0000ff",
    blueviolet: "#8a2be2",
    brown: "#a52a2a",
    burlywood: "#deb887",
    cadetblue: "#5f9ea0",
    chartreuse: "#7fff00",
    chocolate: "#d2691e",
    coral: "#ff7f50",
    cornflowerblue: "#6495ed",
    cornsilk: "#fff8dc",
    crimson: "#dc143c",
    cyan: "#00ffff",
    darkblue: "#00008b",
    darkcyan: "#008b8b",
    darkgoldenrod: "#b8860b",
    darkgray: "#a9a9a9",
    darkgreen: "#006400",
    darkkhaki: "#bdb76b",
    darkmagenta: "#8b008b",
    darkolivegreen: "#556b2f",
    darkorange: "#ff8c00",
    darkorchid: "#9932cc",
    darkred: "#8b0000",
    darksalmon: "#e9967a",
    darkseagreen: "#8fbc8f",
    darkslateblue: "#483d8b",
    darkslategray: "#2f4f4f",
    darkturquoise: "#00ced1",
    darkviolet: "#9400d3",
    deeppink: "#ff1493",
    deepskyblue: "#00bfff",
    dimgray: "#696969",
    dodgerblue: "#1e90ff",
    firebrick: "#b22222",
    floralwhite: "#fffaf0",
    forestgreen: "#228b22",
    fuchsia: "#ff00ff",
    gainsboro: "#dcdcdc",
    ghostwhite: "#f8f8ff",
    gold: "#ffd700",
    goldenrod: "#daa520",
    gray: "#808080",
    green: "#008000",
    greenyellow: "#adff2f",
    honeydew: "#f0fff0",
    hotpink: "#ff69b4",
    "indianred ": "#cd5c5c",
    indigo: "#4b0082",
    ivory: "#fffff0",
    khaki: "#f0e68c",
    lavender: "#e6e6fa",
    lavenderblush: "#fff0f5",
    lawngreen: "#7cfc00",
    lemonchiffon: "#fffacd",
    lightblue: "#add8e6",
    lightcoral: "#f08080",
    lightcyan: "#e0ffff",
    lightgoldenrodyellow: "#fafad2",
    lightgrey: "#d3d3d3",
    lightgreen: "#90ee90",
    lightpink: "#ffb6c1",
    lightsalmon: "#ffa07a",
    lightseagreen: "#20b2aa",
    lightskyblue: "#87cefa",
    lightslategray: "#778899",
    lightsteelblue: "#b0c4de",
    lightyellow: "#ffffe0",
    lime: "#00ff00",
    limegreen: "#32cd32",
    linen: "#faf0e6",
    magenta: "#ff00ff",
    maroon: "#800000",
    mediumaquamarine: "#66cdaa",
    mediumblue: "#0000cd",
    mediumorchid: "#ba55d3",
    mediumpurple: "#9370d8",
    mediumseagreen: "#3cb371",
    mediumslateblue: "#7b68ee",
    mediumspringgreen: "#00fa9a",
    mediumturquoise: "#48d1cc",
    mediumvioletred: "#c71585",
    midnightblue: "#191970",
    mintcream: "#f5fffa",
    mistyrose: "#ffe4e1",
    moccasin: "#ffe4b5",
    navajowhite: "#ffdead",
    navy: "#000080",
    oldlace: "#fdf5e6",
    olive: "#808000",
    olivedrab: "#6b8e23",
    orange: "#ffa500",
    orangered: "#ff4500",
    orchid: "#da70d6",
    palegoldenrod: "#eee8aa",
    palegreen: "#98fb98",
    paleturquoise: "#afeeee",
    palevioletred: "#d87093",
    papayawhip: "#ffefd5",
    peachpuff: "#ffdab9",
    peru: "#cd853f",
    pink: "#ffc0cb",
    plum: "#dda0dd",
    powderblue: "#b0e0e6",
    purple: "#800080",
    red: "#ff0000",
    rosybrown: "#bc8f8f",
    royalblue: "#4169e1",
    saddlebrown: "#8b4513",
    salmon: "#fa8072",
    sandybrown: "#f4a460",
    seagreen: "#2e8b57",
    seashell: "#fff5ee",
    sienna: "#a0522d",
    silver: "#c0c0c0",
    skyblue: "#87ceeb",
    slateblue: "#6a5acd",
    slategray: "#708090",
    snow: "#fffafa",
    springgreen: "#00ff7f",
    steelblue: "#4682b4",
    tan: "#d2b48c",
    teal: "#008080",
    thistle: "#d8bfd8",
    tomato: "#ff6347",
    transparent: "#ffffff",
    turquoise: "#40e0d0",
    violet: "#ee82ee",
    wheat: "#f5deb3",
    white: "#ffffff",
    whitesmoke: "#f5f5f5",
    yellow: "#ffff00",
    yellowgreen: "#9acd32"
  },
      r = function r(t, e, n) {
    var i = [t, e, n].map(function (t) {
      return (t /= 255) <= .03928 ? t / 12.92 : Math.pow((t + .055) / 1.055, 2.4);
    });
    return .2126 * i[0] + .7152 * i[1] + .0722 * i[2];
  };

  e.getRgb = function (t) {
    var e;
    return function (t) {
      4 === t.length && (t += t.slice(1));
      var e = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);
      return e ? {
        r: parseInt(e[1], 16),
        g: parseInt(e[2], 16),
        b: parseInt(e[3], 16)
      } : {
        r: 0,
        g: 0,
        b: 0
      };
    }(t = i[e = t] || e);
  }, e.isDark = function (t) {
    var n,
        i,
        o = e.getRgb(t),
        a = o.r,
        s = o.g,
        c = o.b;
    return !((i = [a, s, c], (r((n = [255, 255, 255])[0], n[1], n[2]) + .05) / (r(i[0], i[1], i[2]) + .05)) > 3);
  };
  var o = {
    "--mdc-theme-primary": [["--mdc-theme-on-primary", 0]],
    "--mdc-theme-surface": [["--mdc-theme-on-surface", 0]],
    "--mdc-theme-secondary": [["--mdc-theme-on-secondary", 0]],
    "--mdc-theme-background": [["--mdc-theme-text-primary-on-background", 0], ["--mdc-theme-text-secondary-on-background", 1], ["--mdc-theme-text-hint-on-background", 2], ["--mdc-theme-text-disabled-on-background", 2], ["--mdc-theme-text-icon-on-background", 2]]
  },
      a = ["rgba(0, 0, 0, 0.87)", "rgba(0, 0, 0, 0.54)", "rgba(0, 0, 0, 0.38)"],
      s = ["rgba(255, 255, 255, 1)", "rgba(255, 255, 255, 0.7)", "rgba(255, 255, 255, 0.5)"];

  e.getAutoColorsForTheme = function (t) {
    var i = Object.keys(o).reduce(function (n, i) {
      if (t[i]) {
        var r = e.isDark(t[i]) ? a : s;
        o[i].forEach(function (t) {
          n[t[0]] = r[t[1]];
        });
      }

      return n;
    }, {});
    return n({}, i, t);
  };
});
ho(fo);
fo.getRgb, fo.isDark;

var mo,
    _o,
    go,
    vo = fo.getAutoColorsForTheme;

function yo(t, e) {
  return Eo(t, void 0, e, void 0, !1);
}

function bo(t, e) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
  var i = arguments.length > 3 ? arguments[3] : undefined;
  return Eo(t, e, n ? _o.default : void 0, i);
}

function Eo(t, e, i, r) {
  var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !0;
  return function (a) {
    var _a$themeBG = a.themeBG,
        s = _a$themeBG === void 0 ? e : _a$themeBG,
        _a$themeColor = a.themeColor,
        c = _a$themeColor === void 0 ? i : _a$themeColor,
        _a$intensity = a.intensity,
        u = _a$intensity === void 0 ? r : _a$intensity,
        l = Ut(a, ["themeBG", "themeColor", "intensity"]),
        d = m(Ao(s, c, u, o), l.className);
    return n(t, Object.assign({}, l, {
      className: d
    }));
  };
}

!function (t) {
  t.primary = "primary", t.secondary = "secondary", t.dark = "dark", t.light = "light";
}(mo || (mo = {})), function (t) {
  t.default = "default", t.primary = "primary", t.secondary = "secondary", t.error = "error";
}(_o || (_o = {})), function (t) {
  t.light = "light", t.dark = "dark";
}(go || (go = {}));

var Co = function Co(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _o.default;
  var n = arguments.length > 2 ? arguments[2] : undefined;
  return Ao(t, e, n);
};

function Ao(t, e, n) {
  var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
  var r = e === _o.default;
  return m([t && i ? So(t, void 0) : null, e ? So(r ? t : e, r) : null]);
}

var To = function To(t, e) {
  return Io(t || "background", e);
},
    Io = function Io(t, e) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  var i = t === mo.dark || t === mo.light ? "mib" : "mdc",
      r = n ? "on-" : "";
  return e ? "var(--mib-theme-".concat(r).concat(t).concat(e, ", var(--").concat(i, "-theme-").concat(r).concat(t, "))") : "var(--".concat(i, "-theme-").concat(r).concat(t, ")");
},
    Oo = function Oo(t, e) {
  return Io(t, e, !0);
},
    So = function So(t, e) {
  var n;
  var i = void 0 === e;

  switch (t) {
    case mo.dark:
    case mo.light:
      n = "mib-theme--";
      break;

    default:
      n = "mdc-theme--";
  }

  return "".concat(n).concat(e ? "on-" : "").concat(t).concat(i ? "-bg" : "");
},
    wo = {
  "--mdc-theme-primary": "#6200ee",
  "--mdc-theme-secondary": "#03dac6",
  "--mdc-theme-background": "#fff",
  "--mdc-theme-surface": "#fff",
  "--mdc-theme-error": "#b00020"
},
    xo = {
  "--mdc-theme-on-primary": "#fff",
  "--mdc-theme-on-secondary": "#fff",
  "--mdc-theme-on-surface": "#000",
  "--mdc-theme-on-error": "#fff",
  "--mdc-theme-text-primary-on-background": "rgba(0, 0, 0, 0.87)",
  "--mdc-theme-text-secondary-on-background": "rgba(0, 0, 0, 0.54)",
  "--mdc-theme-text-hint-on-background": "rgba(0, 0, 0, 0.38)",
  "--mdc-theme-text-disabled-on-background": "rgba(0, 0, 0, 0.38)",
  "--mdc-theme-text-icon-on-background": "rgba(0, 0, 0, 0.38)",
  "--mdc-theme-text-primary-on-light": "rgba(0, 0, 0, 0.87)",
  "--mdc-theme-text-secondary-on-light": "rgba(0, 0, 0, 0.54)",
  "--mdc-theme-text-hint-on-light": "rgba(0, 0, 0, 0.38)",
  "--mdc-theme-text-disabled-on-light": "rgba(0, 0, 0, 0.38)",
  "--mdc-theme-text-icon-on-light": "rgba(0, 0, 0, 0.38)",
  "--mdc-theme-text-primary-on-dark": "white",
  "--mdc-theme-text-secondary-on-dark": "rgba(255, 255, 255, 0.7)",
  "--mdc-theme-text-hint-on-dark": "rgba(255, 255, 255, 0.5)",
  "--mdc-theme-text-disabled-on-dark": "rgba(255, 255, 255, 0.5)",
  "--mdc-theme-text-icon-on-dark": "rgba(255, 255, 255, 0.5)"
},
    No = {
  Default: {
    "--mib-theme-light": "var(--mib-theme-light)",
    "--mib-theme-dark": "var(--mib-theme-dark)",
    "--mib-theme-on-light": "var(--mib-theme-on-light)",
    "--mib-theme-on-dark": "var(--mib-theme-on-dark)",
    "--mdc-theme-primary": "var(--mdc-theme-primary)",
    "--mdc-theme-secondary": "var(--mdc-theme-secondary)",
    "--mdc-theme-surface": "var(--mdc-theme-surface)",
    "--mdc-theme-error": "var(--mdc-theme-error)",
    "--mdc-theme-background": "var(--mdc-theme-background)",
    "--mdc-theme-on-primary": "var(--mdc-theme-on-primary)",
    "--mdc-theme-on-secondary": "var(--mdc-theme-on-secondary)",
    "--mdc-theme-on-surface": "var(--mdc-theme-on-surface)",
    "--mdc-theme-on-error": "var(--mdc-theme-on-error)"
  },
  Baseline: {
    "--mdc-theme-primary": "#6200ee",
    "--mdc-theme-secondary": "#03dac6",
    "--mib-theme-secondarylight": "#66fff9",
    "--mib-theme-secondarydark": "#00a896",
    "--mib-theme-light": "#E0E0E0",
    "--mib-theme-on-light": " #555",
    "--mib-theme-dark": "#424242",
    "--mib-theme-on-dark": "#fff"
  },
  MiB: {
    "--mdc-theme-primary": "#7caf00",
    "--mdc-theme-secondary": "#e89000",
    "--mib-theme-primarylight": "#afe147",
    "--mib-theme-primarydark": "#497f00",
    "--mib-theme-on-primarydark": " #fff",
    "--mib-theme-secondarylight": "#ffc045",
    "--mib-theme-secondarydark": "#b06200",
    "--mib-theme-on-secondarydark": " #fff",
    "--mib-theme-light": "#E0E0E0",
    "--mib-theme-lightlight": "#e9e9e9",
    "--mib-theme-lightdark": "#aeaeae",
    "--mib-theme-on-lightdark": "#000",
    "--mib-theme-on-light": " #555",
    "--mib-theme-dark": "#424242",
    "--mib-theme-darklight": "#6d6d6d",
    "--mib-theme-darkdark": "#1b1b1b",
    "--mib-theme-on-dark": "#fff"
  },
  Fortnightly: {
    "--mdc-theme-primary": "#303030",
    "--mdc-theme-secondary": "#661fff"
  },
  Shrine: {
    "--mdc-theme-primary": "#ffdbcf",
    "--mdc-theme-secondary": "#feeae6"
  },
  Dark: {
    "--mdc-theme-background": "#212121",
    "--mdc-theme-surface": "#37474F",
    "--mdc-theme-on-surface": "rgba(255,255,255,.87)",
    "--mdc-theme-primary": "#24aee9",
    "--mdc-theme-on-primary": "rgba(255,255,255,.87)",
    "--mdc-theme-secondary": "#e539ff",
    "--mdc-theme-on-secondary": "rgba(0,0,0,0.87)"
  }
},
    Ro = function Ro(t) {
  var e = Object.assign({}, wo, No[t] || {}),
      n = vo(e),
      i = Object.assign({}, xo, n);
  return ["primary", "primarylight", "primarydark", "onPrimarydark", "secondary", "secondarylight", "secondarydark", "onSecondarydark", "lightdark", "lightlight", "onLightdark", "darkdark", "darklight", "onDarkdark", "error", "background", "surface", "light", "dark", "onPrimary", "onSecondary", "onSurface", "onError", "onLight", "onDark", "textPrimaryOnBackground", "textSecondaryOnBackground", "textHintOnBackground", "textDisabledOnBackground", "textIconOnBackground", "textPrimaryOnLight", "textSecondaryOnLight", "textHintOnLight", "textDisabledOnLight", "textIconOnLight", "textPrimaryOnDark", "textSecondaryOnDark", "textHintOnDark", "textDisabledOnDark", "textIconOnDark"].reduce(function (t, e) {
    var n = "--mdc-theme-".concat(ht(e)),
        r = "--mib-theme-".concat(ht(e));
    return void 0 !== i[n] ? t[n] = i[n] : t[r] = i[r], t;
  }, {});
};

var Lo =
/*#__PURE__*/
function (_i6) {
  _inherits(Lo, _i6);

  function Lo() {
    var _this25;

    _classCallCheck(this, Lo);

    _this25 = _possibleConstructorReturn(this, _getPrototypeOf(Lo).apply(this, arguments)), _this25.mounting = new Bn({
      classNames: ["material-icons mdc-toolbar__icon"],
      privateStyles: Zi,
      privateClassNames: function privateClassNames(t) {
        return ["button", {
          icon: !t.withContent,
          "icon-small": t.small,
          "icon-withContent": t.withContent,
          "icon--checked": t.checked,
          "icon--disabled": t.disabled,
          "icon-second": t.second
        }];
      }
    });
    return _this25;
  }

  _createClass(Lo, [{
    key: "renderFab",
    value: function renderFab() {
      return n(uo, null);
    }
  }, {
    key: "render",
    value: function render() {
      var _this26 = this;

      var _this$props4 = this.props,
          t = _this$props4.icon,
          e = _this$props4.tooltip,
          i = _this$props4.fab,
          r = _this$props4.style,
          o = {
        onClick: function onClick(t) {
          _this26.props.disabled || _this26.props.onClick(), t.stopPropagation();
        }
      };
      return i ? n(uo, Object.assign({}, o, {
        icon: t
      })) : n("i", Object.assign({
        className: this.mounting.classnames(this.props)
      }, o, {
        style: r,
        title: this.props.tooltip
      }), t);
    }
  }]);

  return Lo;
}(i);

Lo.displayName = "ToolbarButton";

var Do =
/*#__PURE__*/
function (_i7) {
  _inherits(Do, _i7);

  function Do(t) {
    var _this27;

    _classCallCheck(this, Do);

    _this27 = _possibleConstructorReturn(this, _getPrototypeOf(Do).call(this, t)), _this27.mounting = new Bn({
      privateStyles: Zi,
      privateClassNames: function privateClassNames(t) {
        return [{
          opened: t.opened
        }];
      }
    }), _this27.state = {
      opened: !1
    }, _this27.handleOpen.bind(_assertThisInitialized(_this27)), _this27.handleSelect.bind(_assertThisInitialized(_this27));
    return _this27;
  }

  _createClass(Do, [{
    key: "handleOpen",
    value: function handleOpen(t) {
      this.state.opened !== t && this.setState({
        opened: t
      });
    }
  }, {
    key: "handleSelect",
    value: function handleSelect(t) {
      var e = this.props.menuItems,
          n = e[t];
      this.handleOpen(!1), n && n.handler && n.handler();
    }
  }, {
    key: "render",
    value: function render() {
      var _this28 = this;

      var t = this.props,
          e = t.menuItems,
          i = t.disabled,
          r = Ut(t, ["menuItems", "disabled"]),
          o = this.state.opened;
      return console.log("ToolbarDropdown.Render: ".concat(e.length)), n($r, {
        className: this.mounting.classnames(this.state)
      }, o && n(no, {
        anchorCorner: "bottomStart",
        open: o,
        onSelect: function onSelect(t) {
          return _this28.handleSelect(t.detail.index);
        },
        onClose: function onClose() {
          return _this28.handleOpen(!1);
        }
      }, o && e.map(function (t) {
        return n(eo, {
          disabled: t.disabled,
          key: t.text,
          style: Object.assign({
            height: 30,
            whiteSpace: "nowrap"
          }, t.style)
        }, t.text);
      })), n(Lo, Object.assign({
        disabled: i
      }, r, {
        onClick: function onClick() {
          return !i && _this28.handleOpen(!o);
        }
      })));
    }
  }]);

  return Do;
}(i);

var ko =
/*#__PURE__*/
function (_i8) {
  _inherits(ko, _i8);

  function ko(t) {
    var _this29;

    _classCallCheck(this, ko);

    _this29 = _possibleConstructorReturn(this, _getPrototypeOf(ko).call(this, t)), _this29.mounting = new Bn({
      classNames: ["mdc-toolbar"],
      privateStyles: Zi,
      privateClassNames: function privateClassNames(t) {
        return ["toolbar", {
          second: t.second,
          "select-mode": t.editMode,
          vertical: t.vertical
        }];
      }
    });
    return _this29;
  }

  _createClass(ko, [{
    key: "render",
    value: function render() {
      var _this$props$theme = this.props.theme,
          t = _this$props$theme === void 0 ? mo.primary : _this$props$theme;
      return console.log("Toolbar.Render"), n("div", {
        className: this.mounting.classnames(this.props, [this.props.className, Co(t)]),
        style: this.props.style
      }, this.props.children);
    }
  }]);

  return ko;
}(i);

var Po =
/*#__PURE__*/
function (_i9) {
  _inherits(Po, _i9);

  function Po() {
    var _this30;

    _classCallCheck(this, Po);

    _this30 = _possibleConstructorReturn(this, _getPrototypeOf(Po).apply(this, arguments)), _this30.mounting = new Bn({
      classNames: function classNames(t) {
        return [["mdc-toolbar__section"], {
          "mdc-toolbar__section--align-start": "start" === t.align,
          "mdc-toolbar__section--align-end": "end" === t.align
        }];
      },
      privateStyles: Zi,
      privateClassNames: function privateClassNames(t) {
        return [["section"], {
          hidden: t.hidden
        }];
      }
    });
    return _this30;
  }

  _createClass(Po, [{
    key: "render",
    value: function render() {
      return n("div", {
        className: this.mounting.classnames(this.props),
        style: {
          padding: "unset"
        }
      }, this.props.children);
    }
  }]);

  return Po;
}(i);

var Fo =
/*#__PURE__*/
function (_i10) {
  _inherits(Fo, _i10);

  function Fo() {
    var _this31;

    _classCallCheck(this, Fo);

    _this31 = _possibleConstructorReturn(this, _getPrototypeOf(Fo).apply(this, arguments)), _this31.mounting = new Bn({
      classNames: function classNames(t) {
        return [["mdc-toolbar__row"]];
      },
      privateStyles: Zi,
      privateClassNames: ["row"]
    });
    return _this31;
  }

  _createClass(Fo, [{
    key: "render",
    value: function render() {
      var t = this.props.vertical;
      return n("div", {
        className: this.mounting.classnames(this.props)
      }, this.props.children);
    }
  }]);

  return Fo;
}(i);

var Mo =
/*#__PURE__*/
function (_i11) {
  _inherits(Mo, _i11);

  function Mo() {
    var _this32;

    _classCallCheck(this, Mo);

    _this32 = _possibleConstructorReturn(this, _getPrototypeOf(Mo).apply(this, arguments)), _this32.mounting = new Bn({
      classNames: ["mdc-toolbar__title"],
      privateStyles: Zi,
      privateClassNames: function privateClassNames(t) {
        return [{
          "label-small": t.small
        }];
      }
    });
    return _this32;
  }

  _createClass(Mo, [{
    key: "render",
    value: function render() {
      var t = this.props.style;
      return n("div", {
        className: this.mounting.classnames(this.props),
        style: Object.assign({
          margin: "0px 5px"
        }, t)
      }, this.props.children);
    }
  }]);

  return Mo;
}(i);

var Ho =
/*#__PURE__*/
function (_i12) {
  _inherits(Ho, _i12);

  function Ho(t) {
    var _this33;

    _classCallCheck(this, Ho);

    _this33 = _possibleConstructorReturn(this, _getPrototypeOf(Ho).call(this, t)), _this33.classNames = function (t) {
      var e = [Xn.row];
      return t.data instanceof ii && t.data.isInvalid && e.push(Xn.invalid), t.data instanceof ii && t.data.showSelect && t.data.isSelectable && e.push(Xn["select-mode"]), e;
    }, _this33.state = {
      focused: void 0
    }, _this33._elementRef = c(), _this33._lineRipple = c(), ["handleFocus_", "handleBlur_", "handleClick_"].forEach(function (t) {
      return _this33[t] = _this33[t].bind(_assertThisInitialized(_this33));
    });
    return _this33;
  }

  _createClass(Ho, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this34 = this;

      var t = this.props.data;
      t.onStateChangedCallback = function () {
        _this34.forceUpdate();
      }, t instanceof ii && this._elementRef && this._elementRef.current && t.focusOnMount && (this.handleFocus_(void 0), t.resetFocusOnMount());
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.data.onStateChangedCallback = void 0;
    }
  }, {
    key: "handleFocus_",
    value: function handleFocus_(t) {
      var e = this.props.data;
      e instanceof ii && (e.isDisabled || (this.setState({
        focused: !0
      }), this._lineRipple && this._lineRipple.current && this._lineRipple.current.sync({
        active: !0
      }, {})));
    }
  }, {
    key: "handleBlur_",
    value: function handleBlur_(t) {
      this.setState({
        focused: !1
      }), this._lineRipple && this._lineRipple.current && this._lineRipple.current.sync({
        active: !1
      }, {});
    }
  }, {
    key: "handleClick_",
    value: function handleClick_(t) {
      var e = this.props.data;
      e && e.isSelectable && (e.selected = !e.selected);
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.state.focused,
          e = this.props.data;
      var i;
      if (this.props.data instanceof oi) i = n(Uo, {
        focused: t,
        data: this.props.data
      });else {
        var _r3 = {
          focused: t,
          data: e,
          hideLabel: this.props.hideLabel
        };
        if (i = n(qi, Object.assign({}, _r3)), e.isCompleType) switch (e.objectType) {
          case "Array":
            i = n(Go, Object.assign({}, _r3));
            break;

          case "Date":
            break;

          default:
            i = n(jo, Object.assign({}, _r3));
        } else e.hasSelectionOptions ? i = n(Yi, Object.assign({}, _r3)) : "boolean" === e.type && (i = n(Wi, Object.assign({}, _r3)));
      }
      var r = this.props.data.calculateHeight();
      return n("div", {
        ref: this._elementRef,
        className: m(this.classNames(this.props)),
        style: {
          width: "100%",
          height: r + "px"
        },
        tabIndex: -1,
        onClick: this.handleClick_,
        onFocus: this.handleFocus_,
        onBlur: this.handleBlur_
      }, !!e && e.showSelect && n("div", {
        style: {
          height: "100%",
          width: 20,
          position: "relative",
          top: 0,
          background: "rgba(0, 0, 0, 0.37)"
        }
      }, n("div", {
        className: "mdc-checkbox",
        style: {
          padding: "unset",
          margin: "0px 2px",
          width: 16,
          height: "100%"
        }
      }, n("input", {
        className: "mdc-checkbox__native-control",
        checked: e.selected,
        onChange: function onChange(t) {
          return e.selected = t.currentTarget.checked;
        },
        disabled: !e.isSelectable,
        type: "checkbox"
      }), n("div", {
        className: "mdc-checkbox__background",
        style: {
          width: "100%",
          height: 16,
          left: 0,
          top: "calc(50% - 8px)",
          borderRadius: 10
        }
      }, n("svg", {
        className: "mdc-checkbox__checkmark",
        viewBox: "0 0 24 24"
      }, n("path", {
        className: "mdc-checkbox__checkmark-path",
        fill: "none",
        stroke: "white",
        d: "M1.73,12.91 8.1,19.28 22.79,4.59"
      })), n("div", {
        className: "mdc-checkbox__mixedmark"
      })))), this.props.children, i, !!e && n(Wn, {
        style: {
          bottom: -1,
          zIndex: 0
        },
        className: Xn.row_theme,
        ref: this._lineRipple
      }));
    }
  }]);

  return Ho;
}(i);

Ho.displayName = "GridRow";

var Bo =
/*#__PURE__*/
function (_i13) {
  _inherits(Bo, _i13);

  function Bo() {
    _classCallCheck(this, Bo);

    return _possibleConstructorReturn(this, _getPrototypeOf(Bo).apply(this, arguments));
  }

  _createClass(Bo, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return !1;
    }
  }, {
    key: "render",
    value: function render() {
      return n("i", {
        style: {
          left: "6px",
          top: "0px",
          zIndex: 1,
          position: "absolute"
        },
        className: "material-icons " + Xn.row_c_dd_ico
      }, "arrow_drop_down");
    }
  }]);

  return Bo;
}(i);

var Vo =
/*#__PURE__*/
function (_Ki4) {
  _inherits(Vo, _Ki4);

  function Vo(t) {
    var _this35;

    _classCallCheck(this, Vo);

    _this35 = _possibleConstructorReturn(this, _getPrototypeOf(Vo).call(this, t)), ["handleKeyDown_", "preventKeyDown_", "handleClick_", "preventClick_"].forEach(function (t) {
      return _this35[t] = _this35[t].bind(_assertThisInitialized(_this35));
    });
    return _this35;
  }

  _createClass(Vo, [{
    key: "handleClick_",
    value: function handleClick_(t) {
      this.props.data.expanded = !this.props.data.expanded, t.stopPropagation();
    }
  }, {
    key: "handleKeyDown_",
    value: function handleKeyDown_(t) {
      ("Space" === t.key || 32 === t.keyCode) && (this.props.data.expanded = !this.props.data.expanded), t.stopPropagation();
    }
  }, {
    key: "preventKeyDown_",
    value: function preventKeyDown_(t) {
      t.stopPropagation();
    }
  }, {
    key: "preventClick_",
    value: function preventClick_(t) {
      t.stopPropagation();
    }
  }, {
    key: "renderBodyNotExpanded",
    value: function renderBodyNotExpanded() {}
  }, {
    key: "renderChildRow",
    value: function renderChildRow(t) {
      return n(Ho, {
        key: t.id,
        data: t
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this36 = this;

      var _this$props5 = this.props,
          t = _this$props5.data,
          e = _this$props5.hideLabel,
          i = {
        onKeyDown: this.handleKeyDown_,
        onClick: this.handleClick_,
        className: m(this.classNames(this.props))
      };
      return n("div", Object.assign({}, i, {
        tabIndex: 0,
        style: {}
      }), n(Bo, null), (!e || t.expanded) && this.renderHeader(), t.expanded && n("div", {
        onClick: this.preventClick_,
        onKeyDown: this.preventKeyDown_,
        className: m("function" == typeof this.classNamesBody ? this.classNamesBody(this.props) : this.classNamesBody)
      }, t.childRows.map(function (t) {
        return _this36.renderChildRow(t);
      })), !t.expanded && this.renderBodyNotExpanded());
    }
  }]);

  return Vo;
}(Ki);

var jo =
/*#__PURE__*/
function (_Vo) {
  _inherits(jo, _Vo);

  function jo() {
    var _this37;

    _classCallCheck(this, jo);

    _this37 = _possibleConstructorReturn(this, _getPrototypeOf(jo).apply(this, arguments)), _this37.classNames = function (t) {
      var e = [Xn["row-collapsable"]];
      return t.data.expanded && e.push(Xn.row_c__expanded), t.focused && e.push(Xn.row_c__focused), t.data.selectMode && e.push(Xn["select-mode"]), e;
    }, _this37.classNamesBody = function (t) {
      return [Xn["row-collapsable-body"]];
    }, _this37.classNamesLabel = _this37.createTextFieldClassNames(), _this37.classNamesTxtPH = function (t) {
      return ["mdc-text-field__input", Xn.disabled];
    };
    return _this37;
  }

  _createClass(jo, [{
    key: "renderHeader",
    value: function renderHeader() {
      var _this$props6 = this.props,
          t = _this$props6.data,
          e = _this$props6.hideLabel,
          i = t.selectMode;
      return n("div", null, n("div", {
        className: m(this.classNamesLabel(this.props)),
        style: {
          position: "absolute",
          height: "100%",
          cursor: "pointer"
        }
      }, this.renderFloatingLabel(e ? "" : t.name, {
        left: "28px",
        top: "16px",
        bottom: "unset"
      })), n(ko, {
        editMode: i,
        second: !0
      }, t.hasAnyOptionalProperties && (!t.isDisabled || i) && n("div", {
        className: "mdc-toolbar__row",
        style: {
          minHeight: "unset",
          padding: "2px 2px 0px 12px"
        }
      }, n(Po, {
        align: "end",
        hidden: !i
      }, !i && n(Lo, {
        tooltip: "Enter select mode",
        icon: "select_all",
        checked: i,
        small: !0,
        second: !0,
        disabled: !t.hasOptionalProperties,
        onClick: function onClick() {
          return t.selectMode = !0;
        }
      }), !i && n(Do, {
        icon: "note_add",
        tooltip: "Add optional property",
        small: !0,
        second: !0,
        disabled: 0 === t.undefinedProperties.length,
        menuItems: t.undefinedProperties4Menu
      }), i && n(Mo, {
        small: !0
      }, "".concat(t.deselectedCount, " deselected properties")), i && n(Lo, {
        disabled: 0 === t.deselectedCount,
        icon: "delete",
        tooltip: "Remove unselected optional properties",
        small: !0,
        second: !0,
        onClick: function onClick() {
          return t.removeDeselectedProperties();
        }
      }), i && n(Lo, {
        tooltip: "Exit select mode",
        icon: "close",
        small: !0,
        second: !0,
        onClick: function onClick() {
          return t.selectMode = !1;
        }
      })))));
    }
  }, {
    key: "renderBodyNotExpanded",
    value: function renderBodyNotExpanded() {
      var t = {
        className: m(this.classNamesTxtPH(this.props))
      };
      return n("div", Object.assign({
        style: {
          left: this.props.hideLabel ? "32px" : "16px",
          position: "relative",
          borderBottom: "0px",
          background: "transparent",
          padding: "unset"
        }
      }, t), this.props.data.valueToString());
    }
  }]);

  return jo;
}(Vo);

jo.displayName = "ComplexRow";

var Uo =
/*#__PURE__*/
function (_Vo2) {
  _inherits(Uo, _Vo2);

  function Uo() {
    var _this38;

    _classCallCheck(this, Uo);

    _this38 = _possibleConstructorReturn(this, _getPrototypeOf(Uo).apply(this, arguments)), _this38.classNames = function (t) {
      var e = [Xn["row-collapsable"]];
      return t.data.expanded && e.push(Xn.row_c__expanded), e;
    }, _this38.classNamesBody = [Xn["row-category-body"]];
    return _this38;
  }

  _createClass(Uo, [{
    key: "renderHeader",
    value: function renderHeader() {
      var t = this.props.data.name;
      return n("div", {
        className: Xn["txt-edit"] + " mdc-text-field",
        style: {
          position: "absolute",
          height: "100%",
          cursor: "pointer"
        }
      }, this.renderFloatingLabel(t, {
        left: "28px",
        top: "16px",
        bottom: "unset",
        marginBottom: 28
      }));
    }
  }]);

  return Uo;
}(Vo);

Uo.displayName = "CategoryRow";

var Go =
/*#__PURE__*/
function (_Vo3) {
  _inherits(Go, _Vo3);

  function Go() {
    var _this39;

    _classCallCheck(this, Go);

    _this39 = _possibleConstructorReturn(this, _getPrototypeOf(Go).apply(this, arguments)), _this39.classNames = function (t) {
      var e = [Xn["row-collapsable"]];
      return t.data.expanded && e.push(Xn.row_c__expanded), t.focused && e.push(Xn.row_c__focused), t.data.selectMode && e.push(Xn["select-mode"]), e;
    }, _this39.classNamesBody = [Xn["row-collapsable-body"]], _this39.classNamesLabel = _this39.createTextFieldClassNames(), _this39.classNamesTxtPH = function (t) {
      return ["mdc-text-field__input", Xn.disabled];
    };
    return _this39;
  }

  _createClass(Go, [{
    key: "renderHeader",
    value: function renderHeader() {
      var t = this.props.data,
          e = t.selectMode,
          i = 0 === t.selectedElementCount;
      return n("div", null, n("div", {
        className: m(this.classNamesLabel(this.props)),
        style: {
          position: "absolute",
          height: "100%",
          cursor: "pointer"
        }
      }, this.renderFloatingLabel(t.name, {
        left: "28px",
        top: "16px",
        bottom: "unset"
      })), n(ko, {
        editMode: e,
        second: !0
      }, n(Po, {
        align: "end",
        hidden: !e
      }, e && n(Lo, {
        tooltip: "Move selected element(s) to top",
        icon: "first_page",
        small: !0,
        second: !0,
        disabled: i,
        onClick: function onClick() {
          return t.moveSelectedElements("top");
        }
      }), e && n(Lo, {
        tooltip: "Move selected element(s) up",
        icon: "chevron_left",
        small: !0,
        second: !0,
        disabled: i,
        onClick: function onClick() {
          return t.moveSelectedElements("up");
        }
      }), e && n(Lo, {
        tooltip: "Move selected element(s) down",
        icon: "chevron_right",
        small: !0,
        second: !0,
        disabled: i,
        onClick: function onClick() {
          return t.moveSelectedElements("down");
        }
      }), e && n(Lo, {
        tooltip: "Move selected element(s) to bottom",
        icon: "last_page",
        small: !0,
        second: !0,
        disabled: i,
        onClick: function onClick() {
          return t.moveSelectedElements("bottom");
        }
      }), !e && n(Lo, {
        tooltip: "Enter select mode",
        icon: "select_all",
        checked: e,
        small: !0,
        second: !0,
        disabled: !t.hasElements,
        onClick: function onClick() {
          return t.selectMode = !0;
        }
      }), e && n(Mo, {
        small: !0
      }, "".concat(t.selectedElementCount, " selected element(s)")), e && n(Lo, {
        disabled: i,
        icon: "delete",
        tooltip: "Remove selected element(s)",
        small: !0,
        second: !0,
        onClick: function onClick() {
          return t.removeSelectedElements();
        }
      }), n(Lo, {
        icon: "note_add",
        tooltip: "Add new element",
        small: !0,
        second: !0,
        disabled: !t.canCreateNewElement,
        onClick: function onClick() {
          return t.createNewElement();
        }
      }), e && n(Lo, {
        tooltip: "Exit select mode",
        icon: "close",
        small: !0,
        second: !0,
        onClick: function onClick() {
          return t.selectMode = !1;
        }
      }))));
    }
  }, {
    key: "renderChildRow",
    value: function renderChildRow(t) {
      return n(Ho, {
        hideLabel: !0,
        key: t.id,
        data: t
      }, n("div", {
        style: {
          padding: "18px 2px 2px 2px",
          display: "flex",
          alignItems: "flex-end",
          flexDirection: "column-reverse",
          width: 26,
          background: "lightgray",
          color: "gray",
          fontSize: "0.8rem",
          fontFamily: "monospace"
        }
      }, t.index));
    }
  }, {
    key: "renderBodyNotExpanded",
    value: function renderBodyNotExpanded() {
      var t = {
        className: m(this.classNamesTxtPH(this.props))
      };
      return n("div", Object.assign({
        style: {
          left: "16px",
          position: "relative",
          borderBottom: "0px",
          background: "transparent",
          padding: "unset"
        }
      }, t), this.props.data.valueToString());
    }
  }]);

  return Go;
}(Vo);

Go.displayName = "ArrayRow";

var zo = function () {
  var _t24 = function t(e, n) {
    return (_t24 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var n in e) {
        e.hasOwnProperty(n) && (t[n] = e[n]);
      }
    })(e, n);
  };

  return function (e, n) {
    function i() {
      this.constructor = e;
    }

    _t24(e, n), e.prototype = null === n ? Object.create(n) : (i.prototype = n.prototype, new i());
  };
}(),
    _Ko = function Ko() {
  return (_Ko = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    qo = function qo(t, e) {
  var n = {};

  for (var i in t) {
    Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
  }

  if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
    var r = 0;

    for (i = Object.getOwnPropertySymbols(t); r < i.length; r++) {
      e.indexOf(i[r]) < 0 && (n[i[r]] = t[i[r]]);
    }
  }

  return n;
},
    Wo = {
  xsmall: 18,
  small: 20,
  medium: 24,
  large: 36,
  xlarge: 48
},
    Xo = Mt({
  displayName: "CircularProgressRoot",
  classNames: function classNames(t) {
    var e;
    return ["rmwc-circular-progress", (e = {}, e["rmwc-circular-progress--size-" + t._size] = "string" == typeof t._size, e["rmwc-circular-progress--indeterminate"] = void 0 === t._progress, e["rmwc-circular-progress--thickerstroke"] = !!t._size && (Wo[t._size] || Number(t._size)) > 36, e)];
  },
  consumeProps: ["size", "progress"]
}),
    Yo = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return zo(e, t), e.prototype.calculateRatio = function (t) {
    var e = this.props,
        n = e.min,
        i = void 0 === n ? 0 : n,
        r = e.max,
        o = void 0 === r ? 1 : r;
    return t < i ? 0 : t > o ? 1 : (t - i) / (o - i);
  }, e.prototype.circularStyle = function (t) {
    return void 0 !== this.props.progress ? {
      strokeDasharray: 2 * Math.PI * (t / 2.4) * this.calculateRatio(this.props.progress) + ", 666.66%"
    } : void 0;
  }, e.prototype.render = function () {
    var t = this.props,
        e = t.max,
        i = t.min,
        r = t.size,
        o = void 0 === r ? "medium" : r,
        a = t.progress,
        s = qo(t, ["max", "min", "size", "progress"]),
        c = s.style,
        u = Wo[o] || Number(o);
    return Wo[o] || (c = _Ko({}, s.style, {
      fontSize: Number(o)
    })), n(Xo, _Ko({
      "aria-valuenow": a,
      "aria-valuemin": i,
      "aria-valuemax": e,
      _size: o,
      _progress: a
    }, s, {
      style: c
    }), n("svg", {
      className: "rmwc-circular-progress__circle",
      viewBox: "0 0 " + u + " " + u
    }, n("circle", {
      className: "rmwc-circular-progress__path",
      style: this.circularStyle(u),
      cx: u / 2,
      cy: u / 2,
      r: u / 2.4
    })));
  }, e.displayName = "CircularProgress", e.defaultProps = {
    progress: void 0,
    size: "medium"
  }, e;
}(i);

var $o = function $o(t) {
  return n("div", {
    style: {
      flex: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      width: "100%",
      boxSizing: "border-box",
      backgroundColor: t.overlay ? "rgba(255, 255, 255, 0.75)" : "unset",
      zIndex: t.overlay ? 100 : "unset",
      position: t.overlay ? "relative" : "unset"
    }
  }, n(Yo, {
    size: "xlarge"
  }));
};

var Qo =
/*#__PURE__*/
function (_i14) {
  _inherits(Qo, _i14);

  function Qo(t) {
    var _this40;

    _classCallCheck(this, Qo);

    _this40 = _possibleConstructorReturn(this, _getPrototypeOf(Qo).call(this, t)), _this40._allowSearch = !0, _this40._allowTabs = !0, _this40._allowPropertyMgmt = !0, _this40.mountingHeader = new Bn({
      privateStyles: Zi,
      privateClassNames: function privateClassNames(t) {
        return [{
          "select-mode": t.context.rootRow.selectMode
        }];
      }
    }), _this40.mounting = new Bn({
      privateStyles: Xn,
      privateClassNames: ["grid"]
    });
    var _this40$props = _this40.props,
        e = _this40$props.data,
        n = _this40$props.typeInfo,
        i = _this40$props.onPropertyChanged,
        r = _this40$props.context,
        o = _this40$props.allowTabs,
        a = _this40$props.allowSearch,
        s = _this40$props.allowPropertyMgmt;
    _this40._allowSearch = void 0 === a || a, _this40._allowTabs = void 0 === o || o, _this40._allowPropertyMgmt = void 0 === s || s;
    var c = new ni(e, function () {
      return _this40.setState({});
    }, n);
    c.onPropertyChanged = i, _this40.state = {
      context: c
    }, r && r(c), _this40.handleOptionChange.bind(_assertThisInitialized(_this40));
    return _this40;
  }

  _createClass(Qo, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(t, e) {
      return t.forceRefresh || this.state.context.refreshData(t.data) || this.state !== e || this.props.loading != t.loading;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._searchInputRef && this.state.context.gridView === Jn.search && this._searchInputRef.focus();
    }
  }, {
    key: "handleOptionChange",
    value: function handleOptionChange(t) {
      var e = this.state.context;
      void 0 !== t.filterMode && (e.filterMode = t.filterMode), void 0 !== t.showSearch ? e.gridView = t.showSearch ? Jn.search : Jn.default : void 0 !== t.showTabs && (e.gridView = t.showTabs ? Jn.tabs : Jn.default), this.setState({});
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var _this41 = this;

      var _this$state$context = this.state.context,
          t = _this$state$context.filter,
          e = _this$state$context.sorted,
          i = _this$state$context.gridView,
          r = _this$state$context.rootRow,
          _this$props$theme2 = this.props.theme,
          o = _this$props$theme2 === void 0 ? mo.primary : _this$props$theme2;
      var a = this.props.allowTabs;
      var s = i === Jn.search,
          c = i === Jn.tabs,
          u = r.selectMode,
          l = !!this.state.context.anySelectMode;
      return a = this._allowTabs && this.state.context.tabsSupported, n("div", null, n(ko, {
        theme: o,
        className: this.mountingHeader.classnames(this.state)
      }, n(Fo, null, n(Po, {
        align: "start"
      }, this._allowSearch && n(Lo, {
        icon: "search",
        checked: s,
        withContent: !0,
        disabled: l,
        onClick: function onClick() {
          return _this41.handleOptionChange({
            showSearch: !s
          });
        }
      }), a && this.state.context.tabsSupported && n(Lo, {
        icon: "tab",
        checked: c,
        withContent: !0,
        disabled: l,
        onClick: function onClick() {
          return _this41.handleOptionChange({
            showTabs: !c
          });
        }
      })), n(Po, {
        align: "end"
      }, this._allowSearch && !u && r.hasErrors && n(Lo, {
        icon: "error_outline",
        tooltip: "show properties with errors only",
        disabled: l,
        onClick: function onClick() {
          return _this41.handleOptionChange({
            showSearch: !0,
            filterMode: Zn.error
          });
        }
      }), !u && n(Lo, {
        icon: "sort_by_alpha",
        tooltip: "Toggle categorized & alphabetical sorting",
        checked: e,
        disabled: l,
        onClick: function onClick() {
          return _this41.state.context.sorted = !e;
        }
      }), this._allowPropertyMgmt && !u && n(Lo, {
        tooltip: "Enter select mode",
        icon: "select_all",
        disabled: l,
        checked: u,
        onClick: function onClick() {
          return r.selectMode = !0;
        }
      }), this._allowPropertyMgmt && !u && n(Do, {
        icon: "note_add",
        tooltip: "Add optional property",
        disabled: l || 0 === r.undefinedProperties4Menu.length,
        menuItems: r.undefinedProperties4Menu
      }), u && n(Mo, null, "".concat(r.deselectedCount, " deselected properties")), u && n(Lo, {
        disabled: 0 === r.deselectedCount,
        icon: "delete",
        tooltip: "Remove unselected optional properties",
        onClick: function onClick() {
          return r.removeDeselectedProperties();
        }
      }), u && n(Lo, {
        tooltip: "Exit select mode",
        icon: "close",
        onClick: function onClick() {
          return r.selectMode = !1;
        }
      }))), n("div", {
        className: "mdc-toolbar__row " + Xn["toolbar-row"] + (s || c ? " " + Xn.expanded : ""),
        style: {
          minHeight: "unset"
        }
      }, s && n("input", {
        type: "search",
        ref: function ref(t) {
          return _this41._searchInputRef = t;
        },
        value: t,
        onChange: function onChange(t) {
          return _this41.state.context.filter = t.currentTarget.value;
        },
        className: "mdc-text-field__input",
        style: {
          background: "whitesmoke",
          border: "none",
          padding: 6
        }
      }), c && n(Qe, {
        style: {
          background: "whitesmoke"
        },
        activeTabIndex: this.state.context.activeTabIndex,
        onActivate: function onActivate(t) {
          return _this41.state.context.activeTabIndex = t.detail.index;
        }
      }, this.state.context.tabs.map(function (t) {
        return n(Hn, {
          key: t
        }, t);
      })))));
    }
  }, {
    key: "renderBody",
    value: function renderBody() {
      return n("div", {
        style: {}
      }, this.state.context.rows.map(function (t) {
        return n(Ho, {
          key: t.id,
          data: t
        });
      }));
    }
  }, {
    key: "render",
    value: function render() {
      console.log("PropertyGrid.Render", this.props);
      var _this$props7 = this.props,
          t = _this$props7.style,
          e = _this$props7.loading;
      return n("div", {
        style: t,
        className: this.mounting.classnames(this.state, this.props.className)
      }, this.renderHeader(), n("div", {
        ref: this._scrollRef,
        style: {
          border: "thin solid rgba(0, 0, 0, 0.42)",
          borderTop: "0px",
          overflowY: "auto",
          overflowX: "hidden",
          background: "whitesmoke",
          height: "100%"
        }
      }, !0 === e && n($o, {
        overlay: !0
      }), this.renderBody()));
    }
  }]);

  return Qo;
}(i);

Qo.displayName = "PropertyGrid";
var Zo = {
  editor: "mib-GraphStyles-editor-2NVmk",
  sidebar: "mib-GraphStyles-sidebar-2BvvJ",
  props: "mib-GraphStyles-props-2Qh-x",
  panel: "mib-GraphStyles-panel-tOxXV",
  diagram: "mib-GraphStyles-diagram-25-Ct",
  menu: "mib-GraphStyles-menu-3z9kd",
  toolbar: "mib-GraphStyles-toolbar-2H_tB"
};
var Jo = e(void 0);
Jo.displayName = "GraphContext";
Jo.Consumer;

var ta =
/*#__PURE__*/
function (_i15) {
  _inherits(ta, _i15);

  function ta(t) {
    var _this42;

    _classCallCheck(this, ta);

    _this42 = _possibleConstructorReturn(this, _getPrototypeOf(ta).call(this, t)), _this42._mxLib = new g(), _this42._mxLib.mx.mxEventSource.prototype.mx = _this42._mxLib.mx;
    return _this42;
  }

  _createClass(ta, [{
    key: "render",
    value: function render() {
      var t = this.props.children;
      return n(Jo.Provider, {
        value: this._mxLib
      }, t);
    }
  }]);

  return ta;
}(i);

function ea(t) {
  return null != t && "object" == typeof t && !0 === t["@@functional/placeholder"];
}

function na(t) {
  return function e(n) {
    return 0 === arguments.length || ea(n) ? e : t.apply(this, arguments);
  };
}

var ia = na(function (t) {
  return function () {
    return t;
  };
}),
    ra = ia(!1),
    oa = ia(!0);

function aa(t) {
  return function e(n, i) {
    switch (arguments.length) {
      case 0:
        return e;

      case 1:
        return ea(n) ? e : na(function (e) {
          return t(n, e);
        });

      default:
        return ea(n) && ea(i) ? e : ea(n) ? na(function (e) {
          return t(e, i);
        }) : ea(i) ? na(function (e) {
          return t(n, e);
        }) : t(n, i);
    }
  };
}

var sa = aa(function (t, e) {
  return Number(t) + Number(e);
});

function ca(t, e) {
  var n;
  e = e || [];
  var i = (t = t || []).length,
      r = e.length,
      o = [];

  for (n = 0; n < i;) {
    o[o.length] = t[n], n += 1;
  }

  for (n = 0; n < r;) {
    o[o.length] = e[n], n += 1;
  }

  return o;
}

function ua(t, e) {
  switch (t) {
    case 0:
      return function () {
        return e.apply(this, arguments);
      };

    case 1:
      return function (t) {
        return e.apply(this, arguments);
      };

    case 2:
      return function (t, n) {
        return e.apply(this, arguments);
      };

    case 3:
      return function (t, n, i) {
        return e.apply(this, arguments);
      };

    case 4:
      return function (t, n, i, r) {
        return e.apply(this, arguments);
      };

    case 5:
      return function (t, n, i, r, o) {
        return e.apply(this, arguments);
      };

    case 6:
      return function (t, n, i, r, o, a) {
        return e.apply(this, arguments);
      };

    case 7:
      return function (t, n, i, r, o, a, s) {
        return e.apply(this, arguments);
      };

    case 8:
      return function (t, n, i, r, o, a, s, c) {
        return e.apply(this, arguments);
      };

    case 9:
      return function (t, n, i, r, o, a, s, c, u) {
        return e.apply(this, arguments);
      };

    case 10:
      return function (t, n, i, r, o, a, s, c, u, l) {
        return e.apply(this, arguments);
      };

    default:
      throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
  }
}

function la(t, e, n) {
  return function () {
    for (var i = [], r = 0, o = t, a = 0; a < e.length || r < arguments.length;) {
      var s;
      a < e.length && (!ea(e[a]) || r >= arguments.length) ? s = e[a] : (s = arguments[r], r += 1), i[a] = s, ea(s) || (o -= 1), a += 1;
    }

    return o <= 0 ? n.apply(this, i) : ua(o, la(t, i, n));
  };
}

var da = aa(function (t, e) {
  return 1 === t ? na(e) : ua(t, la(t, [], e));
}),
    ha = na(function (t) {
  return da(t.length, function () {
    var e = 0,
        n = arguments[0],
        i = arguments[arguments.length - 1],
        r = Array.prototype.slice.call(arguments, 0);
    return r[0] = function () {
      var t = n.apply(this, ca(arguments, [e, i]));
      return e += 1, t;
    }, t.apply(this, r);
  });
});

function pa(t) {
  return function e(n, i, r) {
    switch (arguments.length) {
      case 0:
        return e;

      case 1:
        return ea(n) ? e : aa(function (e, i) {
          return t(n, e, i);
        });

      case 2:
        return ea(n) && ea(i) ? e : ea(n) ? aa(function (e, n) {
          return t(e, i, n);
        }) : ea(i) ? aa(function (e, i) {
          return t(n, e, i);
        }) : na(function (e) {
          return t(n, i, e);
        });

      default:
        return ea(n) && ea(i) && ea(r) ? e : ea(n) && ea(i) ? aa(function (e, n) {
          return t(e, n, r);
        }) : ea(n) && ea(r) ? aa(function (e, n) {
          return t(e, i, n);
        }) : ea(i) && ea(r) ? aa(function (e, i) {
          return t(n, e, i);
        }) : ea(n) ? na(function (e) {
          return t(e, i, r);
        }) : ea(i) ? na(function (e) {
          return t(n, e, r);
        }) : ea(r) ? na(function (e) {
          return t(n, i, e);
        }) : t(n, i, r);
    }
  };
}

var fa = pa(function (t, e, n) {
  if (e >= n.length || e < -n.length) return n;
  var i = (e < 0 ? n.length : 0) + e,
      r = ca(n);
  return r[i] = t(n[i]), r;
}),
    ma = Array.isArray || function (t) {
  return null != t && t.length >= 0 && "[object Array]" === Object.prototype.toString.call(t);
};

function _a(t) {
  return "function" == typeof t["@@transducer/step"];
}

function ga(t, e, n) {
  return function () {
    if (0 === arguments.length) return n();
    var i = Array.prototype.slice.call(arguments, 0),
        r = i.pop();

    if (!ma(r)) {
      for (var o = 0; o < t.length;) {
        if ("function" == typeof r[t[o]]) return r[t[o]].apply(r, i);
        o += 1;
      }

      if (_a(r)) return e.apply(null, i)(r);
    }

    return n.apply(this, arguments);
  };
}

function va(t) {
  return t && t["@@transducer/reduced"] ? t : {
    "@@transducer/value": t,
    "@@transducer/reduced": !0
  };
}

var ya = {
  init: function init() {
    return this.xf["@@transducer/init"]();
  },
  result: function result(t) {
    return this.xf["@@transducer/result"](t);
  }
},
    ba = function () {
  function t(t, e) {
    this.xf = e, this.f = t, this.all = !0;
  }

  return t.prototype["@@transducer/init"] = ya.init, t.prototype["@@transducer/result"] = function (t) {
    return this.all && (t = this.xf["@@transducer/step"](t, !0)), this.xf["@@transducer/result"](t);
  }, t.prototype["@@transducer/step"] = function (t, e) {
    return this.f(e) || (this.all = !1, t = va(this.xf["@@transducer/step"](t, !1))), t;
  }, t;
}(),
    Ea = aa(ga(["all"], aa(function (t, e) {
  return new ba(t, e);
}), function (t, e) {
  for (var n = 0; n < e.length;) {
    if (!t(e[n])) return !1;
    n += 1;
  }

  return !0;
})),
    Ca = aa(function (t, e) {
  return e > t ? e : t;
});

function Aa(t, e) {
  for (var n = 0, i = e.length, r = Array(i); n < i;) {
    r[n] = t(e[n]), n += 1;
  }

  return r;
}

function Ta(t) {
  return "[object String]" === Object.prototype.toString.call(t);
}

var Ia = na(function (t) {
  return !!ma(t) || !!t && "object" == typeof t && !Ta(t) && (1 === t.nodeType ? !!t.length : 0 === t.length || t.length > 0 && t.hasOwnProperty(0) && t.hasOwnProperty(t.length - 1));
}),
    Oa = function () {
  function t(t) {
    this.f = t;
  }

  return t.prototype["@@transducer/init"] = function () {
    throw new Error("init not implemented on XWrap");
  }, t.prototype["@@transducer/result"] = function (t) {
    return t;
  }, t.prototype["@@transducer/step"] = function (t, e) {
    return this.f(t, e);
  }, t;
}();

function Sa(t) {
  return new Oa(t);
}

var wa = aa(function (t, e) {
  return ua(t.length, function () {
    return t.apply(e, arguments);
  });
});

function xa(t, e, n) {
  for (var i = n.next(); !i.done;) {
    if ((e = t["@@transducer/step"](e, i.value)) && e["@@transducer/reduced"]) {
      e = e["@@transducer/value"];
      break;
    }

    i = n.next();
  }

  return t["@@transducer/result"](e);
}

function Na(t, e, n, i) {
  return t["@@transducer/result"](n[i](wa(t["@@transducer/step"], t), e));
}

var Ra = "undefined" != typeof Symbol ? Symbol.iterator : "@@iterator";

function La(t, e, n) {
  if ("function" == typeof t && (t = Sa(t)), Ia(n)) return function (t, e, n) {
    for (var i = 0, r = n.length; i < r;) {
      if ((e = t["@@transducer/step"](e, n[i])) && e["@@transducer/reduced"]) {
        e = e["@@transducer/value"];
        break;
      }

      i += 1;
    }

    return t["@@transducer/result"](e);
  }(t, e, n);
  if ("function" == typeof n["fantasy-land/reduce"]) return Na(t, e, n, "fantasy-land/reduce");
  if (null != n[Ra]) return xa(t, e, n[Ra]());
  if ("function" == typeof n.next) return xa(t, e, n);
  if ("function" == typeof n.reduce) return Na(t, e, n, "reduce");
  throw new TypeError("reduce: list must be array or iterable");
}

var Da = function () {
  function t(t, e) {
    this.xf = e, this.f = t;
  }

  return t.prototype["@@transducer/init"] = ya.init, t.prototype["@@transducer/result"] = ya.result, t.prototype["@@transducer/step"] = function (t, e) {
    return this.xf["@@transducer/step"](t, this.f(e));
  }, t;
}(),
    ka = aa(function (t, e) {
  return new Da(t, e);
});

function Pa(t, e) {
  return Object.prototype.hasOwnProperty.call(e, t);
}

var Fa = Object.prototype.toString,
    Ma = function Ma() {
  return "[object Arguments]" === Fa.call(arguments) ? function (t) {
    return "[object Arguments]" === Fa.call(t);
  } : function (t) {
    return Pa("callee", t);
  };
},
    Ha = !{
  toString: null
}.propertyIsEnumerable("toString"),
    Ba = ["constructor", "valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"],
    Va = function () {
  return arguments.propertyIsEnumerable("length");
}(),
    ja = function ja(t, e) {
  for (var n = 0; n < t.length;) {
    if (t[n] === e) return !0;
    n += 1;
  }

  return !1;
},
    Ua = na("function" != typeof Object.keys || Va ? function (t) {
  if (Object(t) !== t) return [];
  var e,
      n,
      i = [],
      r = Va && Ma(t);

  for (e in t) {
    !Pa(e, t) || r && "length" === e || (i[i.length] = e);
  }

  if (Ha) for (n = Ba.length - 1; n >= 0;) {
    Pa(e = Ba[n], t) && !ja(i, e) && (i[i.length] = e), n -= 1;
  }
  return i;
} : function (t) {
  return Object(t) !== t ? [] : Object.keys(t);
}),
    Ga = aa(ga(["fantasy-land/map", "map"], ka, function (t, e) {
  switch (Object.prototype.toString.call(e)) {
    case "[object Function]":
      return da(e.length, function () {
        return t.call(this, e.apply(this, arguments));
      });

    case "[object Object]":
      return La(function (n, i) {
        return n[i] = t(e[i]), n;
      }, {}, Ua(e));

    default:
      return Aa(t, e);
  }
})),
    za = aa(function (t, e) {
  for (var n = e, i = 0; i < t.length;) {
    if (null == n) return;
    n = n[t[i]], i += 1;
  }

  return n;
}),
    Ka = aa(function (t, e) {
  return za([t], e);
}),
    qa = aa(function (t, e) {
  return Ga(Ka(t), e);
}),
    Wa = pa(La),
    Xa = na(function (t) {
  return da(Wa(Ca, 0, qa("length", t)), function () {
    for (var e = 0, n = t.length; e < n;) {
      if (!t[e].apply(this, arguments)) return !1;
      e += 1;
    }

    return !0;
  });
}),
    Ya = aa(function (t, e) {
  return t && e;
}),
    $a = function () {
  function t(t, e) {
    this.xf = e, this.f = t, this.any = !1;
  }

  return t.prototype["@@transducer/init"] = ya.init, t.prototype["@@transducer/result"] = function (t) {
    return this.any || (t = this.xf["@@transducer/step"](t, !1)), this.xf["@@transducer/result"](t);
  }, t.prototype["@@transducer/step"] = function (t, e) {
    return this.f(e) && (this.any = !0, t = va(this.xf["@@transducer/step"](t, !0))), t;
  }, t;
}(),
    Qa = aa(function (t, e) {
  return new $a(t, e);
}),
    Za = aa(ga(["any"], Qa, function (t, e) {
  for (var n = 0; n < e.length;) {
    if (t(e[n])) return !0;
    n += 1;
  }

  return !1;
})),
    Ja = na(function (t) {
  return da(Wa(Ca, 0, qa("length", t)), function () {
    for (var e = 0, n = t.length; e < n;) {
      if (t[e].apply(this, arguments)) return !0;
      e += 1;
    }

    return !1;
  });
}),
    ts = aa(function (t, e) {
  return "function" == typeof e["fantasy-land/ap"] ? e["fantasy-land/ap"](t) : "function" == typeof t.ap ? t.ap(e) : "function" == typeof t ? function (n) {
    return t(n)(e(n));
  } : La(function (t, n) {
    return ca(t, Ga(n, e));
  }, [], t);
});

function es(t, e) {
  for (var n = 0, i = e.length - (t - 1), r = new Array(i >= 0 ? i : 0); n < i;) {
    r[n] = Array.prototype.slice.call(e, n, n + t), n += 1;
  }

  return r;
}

var ns = function () {
  function t(t, e) {
    this.xf = e, this.pos = 0, this.full = !1, this.acc = new Array(t);
  }

  return t.prototype["@@transducer/init"] = ya.init, t.prototype["@@transducer/result"] = function (t) {
    return this.acc = null, this.xf["@@transducer/result"](t);
  }, t.prototype["@@transducer/step"] = function (t, e) {
    return this.store(e), this.full ? this.xf["@@transducer/step"](t, this.getCopy()) : t;
  }, t.prototype.store = function (t) {
    this.acc[this.pos] = t, this.pos += 1, this.pos === this.acc.length && (this.pos = 0, this.full = !0);
  }, t.prototype.getCopy = function () {
    return ca(Array.prototype.slice.call(this.acc, this.pos), Array.prototype.slice.call(this.acc, 0, this.pos));
  }, t;
}(),
    is = aa(ga([], aa(function (t, e) {
  return new ns(t, e);
}), es)),
    rs = aa(function (t, e) {
  return ca(e, [t]);
}),
    os = aa(function (t, e) {
  return t.apply(this, e);
}),
    as = na(function (t) {
  for (var e = Ua(t), n = e.length, i = [], r = 0; r < n;) {
    i[r] = t[e[r]], r += 1;
  }

  return i;
}),
    ss = na(function t(e) {
  return e = Ga(function (e) {
    return "function" == typeof e ? e : t(e);
  }, e), da(Wa(Ca, 0, qa("length", as(e))), function () {
    var t = arguments;
    return Ga(function (e) {
      return os(e, t);
    }, e);
  });
}),
    cs = aa(function (t, e) {
  return e(t);
}),
    us = pa(function (t, e, n) {
  var i = t(e),
      r = t(n);
  return i < r ? -1 : i > r ? 1 : 0;
}),
    ls = pa(function (t, e, n) {
  var i = {};

  for (var r in n) {
    i[r] = n[r];
  }

  return i[t] = e, i;
}),
    ds = Number.isInteger || function (t) {
  return t << 0 === t;
},
    hs = na(function (t) {
  return null == t;
}),
    ps = pa(function t(e, n, i) {
  if (0 === e.length) return n;
  var r = e[0];

  if (e.length > 1) {
    var o = !hs(i) && Pa(r, i) ? i[r] : ds(e[1]) ? [] : {};
    n = t(Array.prototype.slice.call(e, 1), n, o);
  }

  if (ds(r) && ma(i)) {
    var a = [].concat(i);
    return a[r] = n, a;
  }

  return ls(r, n, i);
}),
    fs = aa(function (t, e) {
  switch (t) {
    case 0:
      return function () {
        return e.call(this);
      };

    case 1:
      return function (t) {
        return e.call(this, t);
      };

    case 2:
      return function (t, n) {
        return e.call(this, t, n);
      };

    case 3:
      return function (t, n, i) {
        return e.call(this, t, n, i);
      };

    case 4:
      return function (t, n, i, r) {
        return e.call(this, t, n, i, r);
      };

    case 5:
      return function (t, n, i, r, o) {
        return e.call(this, t, n, i, r, o);
      };

    case 6:
      return function (t, n, i, r, o, a) {
        return e.call(this, t, n, i, r, o, a);
      };

    case 7:
      return function (t, n, i, r, o, a, s) {
        return e.call(this, t, n, i, r, o, a, s);
      };

    case 8:
      return function (t, n, i, r, o, a, s, c) {
        return e.call(this, t, n, i, r, o, a, s, c);
      };

    case 9:
      return function (t, n, i, r, o, a, s, c, u) {
        return e.call(this, t, n, i, r, o, a, s, c, u);
      };

    case 10:
      return function (t, n, i, r, o, a, s, c, u, l) {
        return e.call(this, t, n, i, r, o, a, s, c, u, l);
      };

    default:
      throw new Error("First argument to nAry must be a non-negative integer no greater than ten");
  }
}),
    ms = na(function (t) {
  return fs(2, t);
});

function _s(t) {
  return "[object Function]" === Object.prototype.toString.call(t);
}

var gs = aa(function (t, e) {
  var n = da(t, e);
  return da(t, function () {
    return La(ts, Ga(n, arguments[0]), Array.prototype.slice.call(arguments, 1));
  });
}),
    vs = na(function (t) {
  return gs(t.length, t);
}),
    ys = aa(function (t, e) {
  return _s(t) ? function () {
    return t.apply(this, arguments) && e.apply(this, arguments);
  } : vs(Ya)(t, e);
}),
    bs = na(function (t) {
  return da(t.length, t);
}),
    Es = bs(function (t) {
  return t.apply(this, Array.prototype.slice.call(arguments, 1));
});

function Cs(t) {
  return function e(n) {
    for (var i, r, o, a = [], s = 0, c = n.length; s < c;) {
      if (Ia(n[s])) for (o = 0, r = (i = t ? e(n[s]) : n[s]).length; o < r;) {
        a[a.length] = i[o], o += 1;
      } else a[a.length] = n[s];
      s += 1;
    }

    return a;
  };
}

var As = function As(t) {
  var e = function (t) {
    return {
      "@@transducer/init": ya.init,
      "@@transducer/result": function transducerResult(e) {
        return t["@@transducer/result"](e);
      },
      "@@transducer/step": function transducerStep(e, n) {
        var i = t["@@transducer/step"](e, n);
        return i["@@transducer/reduced"] ? {
          "@@transducer/value": i,
          "@@transducer/reduced": !0
        } : i;
      }
    };
  }(t);

  return {
    "@@transducer/init": ya.init,
    "@@transducer/result": function transducerResult(t) {
      return e["@@transducer/result"](t);
    },
    "@@transducer/step": function transducerStep(t, n) {
      return Ia(n) ? La(e, t, n) : La(e, t, [n]);
    }
  };
},
    Ts = aa(ga(["fantasy-land/chain", "chain"], aa(function (t, e) {
  return Ga(t, As(e));
}), function (t, e) {
  return "function" == typeof e ? function (n) {
    return t(e(n))(n);
  } : Cs(!1)(Ga(t, e));
})),
    Is = pa(function (t, e, n) {
  if (t > e) throw new Error("min must not be greater than max in clamp(min, max, value)");
  return n < t ? t : n > e ? e : n;
});

function Os(t) {
  return new RegExp(t.source, (t.global ? "g" : "") + (t.ignoreCase ? "i" : "") + (t.multiline ? "m" : "") + (t.sticky ? "y" : "") + (t.unicode ? "u" : ""));
}

var Ss = na(function (t) {
  return null === t ? "Null" : void 0 === t ? "Undefined" : Object.prototype.toString.call(t).slice(8, -1);
});

function ws(t, e, n, i) {
  var r = function r(_r4) {
    for (var o = e.length, a = 0; a < o;) {
      if (t === e[a]) return n[a];
      a += 1;
    }

    for (var s in e[a + 1] = t, n[a + 1] = _r4, t) {
      _r4[s] = i ? ws(t[s], e, n, !0) : t[s];
    }

    return _r4;
  };

  switch (Ss(t)) {
    case "Object":
      return r({});

    case "Array":
      return r([]);

    case "Date":
      return new Date(t.valueOf());

    case "RegExp":
      return Os(t);

    default:
      return t;
  }
}

var xs = na(function (t) {
  return null != t && "function" == typeof t.clone ? t.clone() : ws(t, [], [], !0);
}),
    Ns = na(function (t) {
  return function (e, n) {
    return t(e, n) ? -1 : t(n, e) ? 1 : 0;
  };
}),
    Rs = na(function (t) {
  return !t;
}),
    Ls = vs(Rs);

function Ds(t, e) {
  return function () {
    return e.call(this, t.apply(this, arguments));
  };
}

function ks(t, e) {
  return function () {
    var n = arguments.length;
    if (0 === n) return e();
    var i = arguments[n - 1];
    return ma(i) || "function" != typeof i[t] ? e.apply(this, arguments) : i[t].apply(i, Array.prototype.slice.call(arguments, 0, n - 1));
  };
}

var Ps = pa(ks("slice", function (t, e, n) {
  return Array.prototype.slice.call(n, t, e);
})),
    Fs = na(ks("tail", Ps(1, 1 / 0)));

function Ms() {
  if (0 === arguments.length) throw new Error("pipe requires at least one argument");
  return ua(arguments[0].length, Wa(Ds, arguments[0], Fs(arguments)));
}

var Hs = na(function (t) {
  return Ta(t) ? t.split("").reverse().join("") : Array.prototype.slice.call(t, 0).reverse();
});

function Bs() {
  if (0 === arguments.length) throw new Error("compose requires at least one argument");
  return Ms.apply(this, Hs(arguments));
}

function Vs() {
  if (0 === arguments.length) throw new Error("composeK requires at least one argument");
  var t = Array.prototype.slice.call(arguments),
      e = t.pop();
  return Bs(Bs.apply(this, Ga(Ts, t)), e);
}

function js(t, e) {
  return function () {
    var n = this;
    return t.apply(n, arguments).then(function (t) {
      return e.call(n, t);
    });
  };
}

function Us() {
  if (0 === arguments.length) throw new Error("pipeP requires at least one argument");
  return ua(arguments[0].length, Wa(js, arguments[0], Fs(arguments)));
}

function Gs(t) {
  for (var e, n = []; !(e = t.next()).done;) {
    n.push(e.value);
  }

  return n;
}

function zs(t, e, n) {
  for (var i = 0, r = n.length; i < r;) {
    if (t(e, n[i])) return !0;
    i += 1;
  }

  return !1;
}

var Ks = aa(function (t, e) {
  return t === e ? 0 !== t || 1 / t == 1 / e : t != t && e != e;
});

function qs(t, e, n, i) {
  var r = Gs(t);

  function o(t, e) {
    return Ws(t, e, n.slice(), i.slice());
  }

  return !zs(function (t, e) {
    return !zs(o, e, t);
  }, Gs(e), r);
}

function Ws(t, e, n, i) {
  if (Ks(t, e)) return !0;
  var r = Ss(t);
  if (r !== Ss(e)) return !1;
  if (null == t || null == e) return !1;
  if ("function" == typeof t["fantasy-land/equals"] || "function" == typeof e["fantasy-land/equals"]) return "function" == typeof t["fantasy-land/equals"] && t["fantasy-land/equals"](e) && "function" == typeof e["fantasy-land/equals"] && e["fantasy-land/equals"](t);
  if ("function" == typeof t.equals || "function" == typeof e.equals) return "function" == typeof t.equals && t.equals(e) && "function" == typeof e.equals && e.equals(t);

  switch (r) {
    case "Arguments":
    case "Array":
    case "Object":
      if ("function" == typeof t.constructor && "Promise" === function (t) {
        var e = String(t).match(/^function (\w*)/);
        return null == e ? "" : e[1];
      }(t.constructor)) return t === e;
      break;

    case "Boolean":
    case "Number":
    case "String":
      if (typeof t != typeof e || !Ks(t.valueOf(), e.valueOf())) return !1;
      break;

    case "Date":
      if (!Ks(t.valueOf(), e.valueOf())) return !1;
      break;

    case "Error":
      return t.name === e.name && t.message === e.message;

    case "RegExp":
      if (t.source !== e.source || t.global !== e.global || t.ignoreCase !== e.ignoreCase || t.multiline !== e.multiline || t.sticky !== e.sticky || t.unicode !== e.unicode) return !1;
  }

  for (var o = n.length - 1; o >= 0;) {
    if (n[o] === t) return i[o] === e;
    o -= 1;
  }

  switch (r) {
    case "Map":
      return t.size === e.size && qs(t.entries(), e.entries(), n.concat([t]), i.concat([e]));

    case "Set":
      return t.size === e.size && qs(t.values(), e.values(), n.concat([t]), i.concat([e]));

    case "Arguments":
    case "Array":
    case "Object":
    case "Boolean":
    case "Number":
    case "String":
    case "Date":
    case "Error":
    case "RegExp":
    case "Int8Array":
    case "Uint8Array":
    case "Uint8ClampedArray":
    case "Int16Array":
    case "Uint16Array":
    case "Int32Array":
    case "Uint32Array":
    case "Float32Array":
    case "Float64Array":
    case "ArrayBuffer":
      break;

    default:
      return !1;
  }

  var a = Ua(t);
  if (a.length !== Ua(e).length) return !1;
  var s = n.concat([t]),
      c = i.concat([e]);

  for (o = a.length - 1; o >= 0;) {
    var u = a[o];
    if (!Pa(u, e) || !Ws(e[u], t[u], s, c)) return !1;
    o -= 1;
  }

  return !0;
}

var Xs = aa(function (t, e) {
  return Ws(t, e, [], []);
});

function Ys(t, e, n) {
  var i, r;
  if ("function" == typeof t.indexOf) switch (typeof e) {
    case "number":
      if (0 === e) {
        for (i = 1 / e; n < t.length;) {
          if (0 === (r = t[n]) && 1 / r === i) return n;
          n += 1;
        }

        return -1;
      }

      if (e != e) {
        for (; n < t.length;) {
          if ("number" == typeof (r = t[n]) && r != r) return n;
          n += 1;
        }

        return -1;
      }

      return t.indexOf(e, n);

    case "string":
    case "boolean":
    case "function":
    case "undefined":
      return t.indexOf(e, n);

    case "object":
      if (null === e) return t.indexOf(e, n);
  }

  for (; n < t.length;) {
    if (Xs(t[n], e)) return n;
    n += 1;
  }

  return -1;
}

function $s(t, e) {
  return Ys(e, t, 0) >= 0;
}

function Qs(t) {
  return '"' + t.replace(/\\/g, "\\\\").replace(/[\b]/g, "\\b").replace(/\f/g, "\\f").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\t/g, "\\t").replace(/\v/g, "\\v").replace(/\0/g, "\\0").replace(/"/g, '\\"') + '"';
}

var Zs = function Zs(t) {
  return (t < 10 ? "0" : "") + t;
},
    Js = "function" == typeof Date.prototype.toISOString ? function (t) {
  return t.toISOString();
} : function (t) {
  return t.getUTCFullYear() + "-" + Zs(t.getUTCMonth() + 1) + "-" + Zs(t.getUTCDate()) + "T" + Zs(t.getUTCHours()) + ":" + Zs(t.getUTCMinutes()) + ":" + Zs(t.getUTCSeconds()) + "." + (t.getUTCMilliseconds() / 1e3).toFixed(3).slice(2, 5) + "Z";
};

function tc(t) {
  return function () {
    return !t.apply(this, arguments);
  };
}

function ec(t, e) {
  for (var n = 0, i = e.length, r = []; n < i;) {
    t(e[n]) && (r[r.length] = e[n]), n += 1;
  }

  return r;
}

function nc(t) {
  return "[object Object]" === Object.prototype.toString.call(t);
}

var ic = function () {
  function t(t, e) {
    this.xf = e, this.f = t;
  }

  return t.prototype["@@transducer/init"] = ya.init, t.prototype["@@transducer/result"] = ya.result, t.prototype["@@transducer/step"] = function (t, e) {
    return this.f(e) ? this.xf["@@transducer/step"](t, e) : t;
  }, t;
}(),
    rc = aa(ga(["filter"], aa(function (t, e) {
  return new ic(t, e);
}), function (t, e) {
  return nc(e) ? La(function (n, i) {
    return t(e[i]) && (n[i] = e[i]), n;
  }, {}, Ua(e)) : ec(t, e);
})),
    oc = aa(function (t, e) {
  return rc(tc(t), e);
});

var ac = na(function (t) {
  return function t(e, n) {
    var i = function i(_i16) {
      var r = n.concat([e]);
      return $s(_i16, r) ? "<Circular>" : t(_i16, r);
    },
        r = function r(t, e) {
      return Aa(function (e) {
        return Qs(e) + ": " + i(t[e]);
      }, e.slice().sort());
    };

    switch (Object.prototype.toString.call(e)) {
      case "[object Arguments]":
        return "(function() { return arguments; }(" + Aa(i, e).join(", ") + "))";

      case "[object Array]":
        return "[" + Aa(i, e).concat(r(e, oc(function (t) {
          return /^\d+$/.test(t);
        }, Ua(e)))).join(", ") + "]";

      case "[object Boolean]":
        return "object" == typeof e ? "new Boolean(" + i(e.valueOf()) + ")" : e.toString();

      case "[object Date]":
        return "new Date(" + (isNaN(e.valueOf()) ? i(NaN) : Qs(Js(e))) + ")";

      case "[object Null]":
        return "null";

      case "[object Number]":
        return "object" == typeof e ? "new Number(" + i(e.valueOf()) + ")" : 1 / e == -1 / 0 ? "-0" : e.toString(10);

      case "[object String]":
        return "object" == typeof e ? "new String(" + i(e.valueOf()) + ")" : Qs(e);

      case "[object Undefined]":
        return "undefined";

      default:
        if ("function" == typeof e.toString) {
          var o = e.toString();
          if ("[object Object]" !== o) return o;
        }

        return "{" + r(e, Ua(e)).join(", ") + "}";
    }
  }(t, []);
}),
    sc = aa(function (t, e) {
  if (ma(t)) {
    if (ma(e)) return t.concat(e);
    throw new TypeError(ac(e) + " is not an array");
  }

  if (Ta(t)) {
    if (Ta(e)) return t + e;
    throw new TypeError(ac(e) + " is not a string");
  }

  if (null != t && _s(t["fantasy-land/concat"])) return t["fantasy-land/concat"](e);
  if (null != t && _s(t.concat)) return t.concat(e);
  throw new TypeError(ac(t) + ' does not have a method named "concat" or "fantasy-land/concat"');
}),
    cc = na(function (t) {
  return ua(Wa(Ca, 0, Ga(function (t) {
    return t[0].length;
  }, t)), function () {
    for (var e = 0; e < t.length;) {
      if (t[e][0].apply(this, arguments)) return t[e][1].apply(this, arguments);
      e += 1;
    }
  });
}),
    uc = aa(function (t, e) {
  if (t > 10) throw new Error("Constructor with greater than ten arguments");
  return 0 === t ? function () {
    return new e();
  } : bs(fs(t, function (t, n, i, r, o, a, s, c, u, l) {
    switch (arguments.length) {
      case 1:
        return new e(t);

      case 2:
        return new e(t, n);

      case 3:
        return new e(t, n, i);

      case 4:
        return new e(t, n, i, r);

      case 5:
        return new e(t, n, i, r, o);

      case 6:
        return new e(t, n, i, r, o, a);

      case 7:
        return new e(t, n, i, r, o, a, s);

      case 8:
        return new e(t, n, i, r, o, a, s, c);

      case 9:
        return new e(t, n, i, r, o, a, s, c, u);

      case 10:
        return new e(t, n, i, r, o, a, s, c, u, l);
    }
  }));
}),
    lc = na(function (t) {
  return uc(t.length, t);
}),
    dc = aa($s),
    hc = aa(function (t, e) {
  return da(Wa(Ca, 0, qa("length", e)), function () {
    var n = arguments,
        i = this;
    return t.apply(i, Aa(function (t) {
      return t.apply(i, n);
    }, e));
  });
}),
    pc = function () {
  function t(t, e, n, i) {
    this.valueFn = t, this.valueAcc = e, this.keyFn = n, this.xf = i, this.inputs = {};
  }

  return t.prototype["@@transducer/init"] = ya.init, t.prototype["@@transducer/result"] = function (t) {
    var e;

    for (e in this.inputs) {
      if (Pa(e, this.inputs) && (t = this.xf["@@transducer/step"](t, this.inputs[e]))["@@transducer/reduced"]) {
        t = t["@@transducer/value"];
        break;
      }
    }

    return this.inputs = null, this.xf["@@transducer/result"](t);
  }, t.prototype["@@transducer/step"] = function (t, e) {
    var n = this.keyFn(e);
    return this.inputs[n] = this.inputs[n] || [n, this.valueAcc], this.inputs[n][1] = this.valueFn(this.inputs[n][1], e), t;
  }, t;
}(),
    fc = la(4, [], ga([], la(4, [], function (t, e, n, i) {
  return new pc(t, e, n, i);
}), function (t, e, n, i) {
  return La(function (i, r) {
    var o = n(r);
    return i[o] = t(Pa(o, i) ? i[o] : e, r), i;
  }, {}, i);
})),
    mc = fc(function (t, e) {
  return t + 1;
}, 0),
    _c = sa(-1),
    gc = aa(function (t, e) {
  return null == e || e != e ? t : e;
}),
    vc = pa(function (t, e, n) {
  var i = t(e),
      r = t(n);
  return i > r ? -1 : i < r ? 1 : 0;
}),
    yc = aa(function (t, e) {
  for (var n = [], i = 0, r = t.length; i < r;) {
    $s(t[i], e) || $s(t[i], n) || (n[n.length] = t[i]), i += 1;
  }

  return n;
}),
    bc = pa(function (t, e, n) {
  for (var i = [], r = 0, o = e.length; r < o;) {
    zs(t, e[r], n) || zs(t, e[r], i) || i.push(e[r]), r += 1;
  }

  return i;
}),
    Ec = aa(function (t, e) {
  var n = {};

  for (var i in e) {
    n[i] = e[i];
  }

  return delete n[t], n;
}),
    Cc = pa(function (t, e, n) {
  var i = Array.prototype.slice.call(n, 0);
  return i.splice(t, e), i;
}),
    Ac = pa(function (t, e, n) {
  return fa(ia(e), t, n);
}),
    Tc = aa(function t(e, n) {
  switch (e.length) {
    case 0:
      return n;

    case 1:
      return ds(e[0]) ? Cc(e[0], 1, n) : Ec(e[0], n);

    default:
      var i = e[0],
          r = Array.prototype.slice.call(e, 1);
      return null == n[i] ? n : ds(e[0]) ? Ac(i, t(r, n[i]), n) : ls(i, t(r, n[i]), n);
  }
}),
    Ic = aa(function (t, e) {
  return t / e;
}),
    Oc = function () {
  function t(t, e) {
    this.xf = e, this.n = t;
  }

  return t.prototype["@@transducer/init"] = ya.init, t.prototype["@@transducer/result"] = ya.result, t.prototype["@@transducer/step"] = function (t, e) {
    return this.n > 0 ? (this.n -= 1, t) : this.xf["@@transducer/step"](t, e);
  }, t;
}(),
    Sc = aa(ga(["drop"], aa(function (t, e) {
  return new Oc(t, e);
}), function (t, e) {
  return Ps(Math.max(0, t), 1 / 0, e);
})),
    wc = function () {
  function t(t, e) {
    this.xf = e, this.n = t, this.i = 0;
  }

  return t.prototype["@@transducer/init"] = ya.init, t.prototype["@@transducer/result"] = ya.result, t.prototype["@@transducer/step"] = function (t, e) {
    this.i += 1;
    var n = 0 === this.n ? t : this.xf["@@transducer/step"](t, e);
    return this.n >= 0 && this.i >= this.n ? va(n) : n;
  }, t;
}(),
    xc = aa(ga(["take"], aa(function (t, e) {
  return new wc(t, e);
}), function (t, e) {
  return Ps(0, t < 0 ? 1 / 0 : t, e);
}));

function Nc(t, e) {
  return xc(t < e.length ? e.length - t : 0, e);
}

var Rc = function () {
  function t(t, e) {
    this.xf = e, this.pos = 0, this.full = !1, this.acc = new Array(t);
  }

  return t.prototype["@@transducer/init"] = ya.init, t.prototype["@@transducer/result"] = function (t) {
    return this.acc = null, this.xf["@@transducer/result"](t);
  }, t.prototype["@@transducer/step"] = function (t, e) {
    return this.full && (t = this.xf["@@transducer/step"](t, this.acc[this.pos])), this.store(e), t;
  }, t.prototype.store = function (t) {
    this.acc[this.pos] = t, this.pos += 1, this.pos === this.acc.length && (this.pos = 0, this.full = !0);
  }, t;
}(),
    Lc = aa(ga([], aa(function (t, e) {
  return new Rc(t, e);
}), Nc));

function Dc(t, e) {
  for (var n = e.length - 1; n >= 0 && t(e[n]);) {
    n -= 1;
  }

  return Ps(0, n + 1, e);
}

var kc = function () {
  function t(t, e) {
    this.f = t, this.retained = [], this.xf = e;
  }

  return t.prototype["@@transducer/init"] = ya.init, t.prototype["@@transducer/result"] = function (t) {
    return this.retained = null, this.xf["@@transducer/result"](t);
  }, t.prototype["@@transducer/step"] = function (t, e) {
    return this.f(e) ? this.retain(t, e) : this.flush(t, e);
  }, t.prototype.flush = function (t, e) {
    return t = La(this.xf["@@transducer/step"], t, this.retained), this.retained = [], this.xf["@@transducer/step"](t, e);
  }, t.prototype.retain = function (t, e) {
    return this.retained.push(e), t;
  }, t;
}(),
    Pc = aa(ga([], aa(function (t, e) {
  return new kc(t, e);
}), Dc)),
    Fc = function () {
  function t(t, e) {
    this.xf = e, this.pred = t, this.lastValue = void 0, this.seenFirstValue = !1;
  }

  return t.prototype["@@transducer/init"] = ya.init, t.prototype["@@transducer/result"] = ya.result, t.prototype["@@transducer/step"] = function (t, e) {
    var n = !1;
    return this.seenFirstValue ? this.pred(this.lastValue, e) && (n = !0) : this.seenFirstValue = !0, this.lastValue = e, n ? t : this.xf["@@transducer/step"](t, e);
  }, t;
}(),
    Mc = aa(function (t, e) {
  return new Fc(t, e);
}),
    Hc = aa(function (t, e) {
  var n = t < 0 ? e.length + t : t;
  return Ta(e) ? e.charAt(n) : e[n];
}),
    Bc = Hc(-1),
    Vc = aa(ga([], Mc, function (t, e) {
  var n = [],
      i = 1,
      r = e.length;
  if (0 !== r) for (n[0] = e[0]; i < r;) {
    t(Bc(n), e[i]) || (n[n.length] = e[i]), i += 1;
  }
  return n;
})),
    jc = na(ga([], Mc(Xs), Vc(Xs))),
    Uc = function () {
  function t(t, e) {
    this.xf = e, this.f = t;
  }

  return t.prototype["@@transducer/init"] = ya.init, t.prototype["@@transducer/result"] = ya.result, t.prototype["@@transducer/step"] = function (t, e) {
    if (this.f) {
      if (this.f(e)) return t;
      this.f = null;
    }

    return this.xf["@@transducer/step"](t, e);
  }, t;
}(),
    Gc = aa(ga(["dropWhile"], aa(function (t, e) {
  return new Uc(t, e);
}), function (t, e) {
  for (var n = 0, i = e.length; n < i && t(e[n]);) {
    n += 1;
  }

  return Ps(n, 1 / 0, e);
})),
    zc = aa(function (t, e) {
  return t || e;
}),
    Kc = aa(function (t, e) {
  return _s(t) ? function () {
    return t.apply(this, arguments) || e.apply(this, arguments);
  } : vs(zc)(t, e);
}),
    qc = na(function (t) {
  return null != t && "function" == typeof t["fantasy-land/empty"] ? t["fantasy-land/empty"]() : null != t && null != t.constructor && "function" == typeof t.constructor["fantasy-land/empty"] ? t.constructor["fantasy-land/empty"]() : null != t && "function" == typeof t.empty ? t.empty() : null != t && null != t.constructor && "function" == typeof t.constructor.empty ? t.constructor.empty() : ma(t) ? [] : Ta(t) ? "" : nc(t) ? {} : Ma(t) ? function () {
    return arguments;
  }() : void 0;
}),
    Wc = aa(function (t, e) {
  return Sc(t >= 0 ? e.length - t : 0, e);
}),
    Xc = aa(function (t, e) {
  return Xs(Wc(t.length, e), t);
}),
    Yc = pa(function (t, e, n) {
  return Xs(t(e), t(n));
}),
    $c = pa(function (t, e, n) {
  return Xs(e[t], n[t]);
}),
    Qc = aa(function t(e, n) {
  var i,
      r,
      o,
      a = {};

  for (r in n) {
    o = typeof (i = e[r]), a[r] = "function" === o ? i(n[r]) : i && "object" === o ? t(i, n[r]) : n[r];
  }

  return a;
}),
    Zc = function () {
  function t(t, e) {
    this.xf = e, this.f = t, this.found = !1;
  }

  return t.prototype["@@transducer/init"] = ya.init, t.prototype["@@transducer/result"] = function (t) {
    return this.found || (t = this.xf["@@transducer/step"](t, void 0)), this.xf["@@transducer/result"](t);
  }, t.prototype["@@transducer/step"] = function (t, e) {
    return this.f(e) && (this.found = !0, t = va(this.xf["@@transducer/step"](t, e))), t;
  }, t;
}(),
    Jc = aa(ga(["find"], aa(function (t, e) {
  return new Zc(t, e);
}), function (t, e) {
  for (var n = 0, i = e.length; n < i;) {
    if (t(e[n])) return e[n];
    n += 1;
  }
})),
    tu = function () {
  function t(t, e) {
    this.xf = e, this.f = t, this.idx = -1, this.found = !1;
  }

  return t.prototype["@@transducer/init"] = ya.init, t.prototype["@@transducer/result"] = function (t) {
    return this.found || (t = this.xf["@@transducer/step"](t, -1)), this.xf["@@transducer/result"](t);
  }, t.prototype["@@transducer/step"] = function (t, e) {
    return this.idx += 1, this.f(e) && (this.found = !0, t = va(this.xf["@@transducer/step"](t, this.idx))), t;
  }, t;
}(),
    eu = aa(ga([], aa(function (t, e) {
  return new tu(t, e);
}), function (t, e) {
  for (var n = 0, i = e.length; n < i;) {
    if (t(e[n])) return n;
    n += 1;
  }

  return -1;
})),
    nu = function () {
  function t(t, e) {
    this.xf = e, this.f = t;
  }

  return t.prototype["@@transducer/init"] = ya.init, t.prototype["@@transducer/result"] = function (t) {
    return this.xf["@@transducer/result"](this.xf["@@transducer/step"](t, this.last));
  }, t.prototype["@@transducer/step"] = function (t, e) {
    return this.f(e) && (this.last = e), t;
  }, t;
}(),
    iu = aa(ga([], aa(function (t, e) {
  return new nu(t, e);
}), function (t, e) {
  for (var n = e.length - 1; n >= 0;) {
    if (t(e[n])) return e[n];
    n -= 1;
  }
})),
    ru = function () {
  function t(t, e) {
    this.xf = e, this.f = t, this.idx = -1, this.lastIdx = -1;
  }

  return t.prototype["@@transducer/init"] = ya.init, t.prototype["@@transducer/result"] = function (t) {
    return this.xf["@@transducer/result"](this.xf["@@transducer/step"](t, this.lastIdx));
  }, t.prototype["@@transducer/step"] = function (t, e) {
    return this.idx += 1, this.f(e) && (this.lastIdx = this.idx), t;
  }, t;
}(),
    ou = aa(ga([], aa(function (t, e) {
  return new ru(t, e);
}), function (t, e) {
  for (var n = e.length - 1; n >= 0;) {
    if (t(e[n])) return n;
    n -= 1;
  }

  return -1;
})),
    au = na(Cs(!0)),
    su = na(function (t) {
  return da(t.length, function (e, n) {
    var i = Array.prototype.slice.call(arguments, 0);
    return i[0] = n, i[1] = e, t.apply(this, i);
  });
}),
    cu = aa(ks("forEach", function (t, e) {
  for (var n = e.length, i = 0; i < n;) {
    t(e[i]), i += 1;
  }

  return e;
})),
    uu = aa(function (t, e) {
  for (var n = Ua(e), i = 0; i < n.length;) {
    var r = n[i];
    t(e[r], r, e), i += 1;
  }

  return e;
}),
    lu = na(function (t) {
  for (var e = {}, n = 0; n < t.length;) {
    e[t[n][0]] = t[n][1], n += 1;
  }

  return e;
}),
    du = aa(ks("groupBy", fc(function (t, e) {
  return null == t && (t = []), t.push(e), t;
}, null))),
    hu = aa(function (t, e) {
  for (var n = [], i = 0, r = e.length; i < r;) {
    for (var o = i + 1; o < r && t(e[o - 1], e[o]);) {
      o += 1;
    }

    n.push(e.slice(i, o)), i = o;
  }

  return n;
}),
    pu = aa(function (t, e) {
  return t > e;
}),
    fu = aa(function (t, e) {
  return t >= e;
}),
    mu = aa(Pa),
    _u = aa(function (t, e) {
  return t in e;
}),
    gu = Hc(0);

function vu(t) {
  return t;
}

var yu = na(vu),
    bu = pa(function (t, e, n) {
  return da(Math.max(t.length, e.length, n.length), function () {
    return t.apply(this, arguments) ? e.apply(this, arguments) : n.apply(this, arguments);
  });
}),
    Eu = sa(1),
    Cu = fc(function (t, e) {
  return e;
}, null),
    Au = aa(function (t, e) {
  return "function" != typeof e.indexOf || ma(e) ? Ys(e, t, 0) : e.indexOf(t);
}),
    Tu = Ps(0, -1),
    Iu = pa(function (t, e, n) {
  return ec(function (e) {
    return zs(t, e, n);
  }, e);
}),
    Ou = pa(function (t, e, n) {
  t = t < n.length && t >= 0 ? t : n.length;
  var i = Array.prototype.slice.call(n, 0);
  return i.splice(t, 0, e), i;
}),
    Su = pa(function (t, e, n) {
  return t = t < n.length && t >= 0 ? t : n.length, [].concat(Array.prototype.slice.call(n, 0, t), e, Array.prototype.slice.call(n, t));
}),
    wu = function () {
  function t() {
    this._nativeSet = "function" == typeof Set ? new Set() : null, this._items = {};
  }

  return t.prototype.add = function (t) {
    return !xu(t, !0, this);
  }, t.prototype.has = function (t) {
    return xu(t, !1, this);
  }, t;
}();

function xu(t, e, n) {
  var i,
      r = typeof t;

  switch (r) {
    case "string":
    case "number":
      return 0 === t && 1 / t == -1 / 0 ? !!n._items["-0"] || (e && (n._items["-0"] = !0), !1) : null !== n._nativeSet ? e ? (i = n._nativeSet.size, n._nativeSet.add(t), n._nativeSet.size === i) : n._nativeSet.has(t) : r in n._items ? t in n._items[r] || (e && (n._items[r][t] = !0), !1) : (e && (n._items[r] = {}, n._items[r][t] = !0), !1);

    case "boolean":
      if (r in n._items) {
        var o = t ? 1 : 0;
        return !!n._items[r][o] || (e && (n._items[r][o] = !0), !1);
      }

      return e && (n._items[r] = t ? [!1, !0] : [!0, !1]), !1;

    case "function":
      return null !== n._nativeSet ? e ? (i = n._nativeSet.size, n._nativeSet.add(t), n._nativeSet.size === i) : n._nativeSet.has(t) : r in n._items ? !!$s(t, n._items[r]) || (e && n._items[r].push(t), !1) : (e && (n._items[r] = [t]), !1);

    case "undefined":
      return !!n._items[r] || (e && (n._items[r] = !0), !1);

    case "object":
      if (null === t) return !!n._items.null || (e && (n._items.null = !0), !1);

    default:
      return (r = Object.prototype.toString.call(t)) in n._items ? !!$s(t, n._items[r]) || (e && n._items[r].push(t), !1) : (e && (n._items[r] = [t]), !1);
  }
}

var Nu = aa(function (t, e) {
  for (var n, i, r = new wu(), o = [], a = 0; a < e.length;) {
    n = t(i = e[a]), r.add(n) && o.push(i), a += 1;
  }

  return o;
}),
    Ru = Nu(yu),
    Lu = aa(function (t, e) {
  var n, i;
  return t.length > e.length ? (n = t, i = e) : (n = e, i = t), Ru(ec(su($s)(n), i));
}),
    Du = aa(ks("intersperse", function (t, e) {
  for (var n = [], i = 0, r = e.length; i < r;) {
    i === r - 1 ? n.push(e[i]) : n.push(e[i], t), i += 1;
  }

  return n;
}));
var ku = "function" == typeof Object.assign ? Object.assign : function (t) {
  if (null == t) throw new TypeError("Cannot convert undefined or null to object");

  for (var e = Object(t), n = 1, i = arguments.length; n < i;) {
    var r = arguments[n];
    if (null != r) for (var o in r) {
      Pa(o, r) && (e[o] = r[o]);
    }
    n += 1;
  }

  return e;
},
    Pu = aa(function (t, e) {
  var n = {};
  return n[t] = e, n;
}),
    Fu = {
  "@@transducer/init": Array,
  "@@transducer/step": function transducerStep(t, e) {
    return t.push(e), t;
  },
  "@@transducer/result": vu
},
    Mu = {
  "@@transducer/init": String,
  "@@transducer/step": function transducerStep(t, e) {
    return t + e;
  },
  "@@transducer/result": vu
},
    Hu = {
  "@@transducer/init": Object,
  "@@transducer/step": function transducerStep(t, e) {
    return ku(t, Ia(e) ? Pu(e[0], e[1]) : e);
  },
  "@@transducer/result": vu
};
var Bu = pa(function (t, e, n) {
  return _a(t) ? La(e(t), t["@@transducer/init"](), n) : La(e(function (t) {
    if (_a(t)) return t;
    if (Ia(t)) return Fu;
    if ("string" == typeof t) return Mu;
    if ("object" == typeof t) return Hu;
    throw new Error("Cannot create transformer for " + t);
  }(t)), ws(t, [], [], !1), n);
}),
    Vu = na(function (t) {
  for (var e = Ua(t), n = e.length, i = 0, r = {}; i < n;) {
    var o = e[i],
        a = t[o],
        s = Pa(a, r) ? r[a] : r[a] = [];
    s[s.length] = o, i += 1;
  }

  return r;
}),
    ju = na(function (t) {
  for (var e = Ua(t), n = e.length, i = 0, r = {}; i < n;) {
    var o = e[i];
    r[t[o]] = o, i += 1;
  }

  return r;
}),
    Uu = aa(function (t, e) {
  return da(t + 1, function () {
    var n = arguments[t];
    if (null != n && _s(n[e])) return n[e].apply(n, Array.prototype.slice.call(arguments, 0, t));
    throw new TypeError(ac(n) + ' does not have a method named "' + e + '"');
  });
}),
    Gu = aa(function (t, e) {
  return null != e && e.constructor === t || e instanceof t;
}),
    zu = na(function (t) {
  return null != t && Xs(t, qc(t));
}),
    Ku = Uu(1, "join"),
    qu = na(function (t) {
  return hc(function () {
    return Array.prototype.slice.call(arguments, 0);
  }, t);
}),
    Wu = na(function (t) {
  var e,
      n = [];

  for (e in t) {
    n[n.length] = e;
  }

  return n;
}),
    Xu = aa(function (t, e) {
  if ("function" != typeof e.lastIndexOf || ma(e)) {
    for (var n = e.length - 1; n >= 0;) {
      if (Xs(e[n], t)) return n;
      n -= 1;
    }

    return -1;
  }

  return e.lastIndexOf(t);
});

function Yu(t) {
  return "[object Number]" === Object.prototype.toString.call(t);
}

var $u = na(function (t) {
  return null != t && Yu(t.length) ? t.length : NaN;
}),
    Qu = aa(function (t, e) {
  return function (n) {
    return function (i) {
      return Ga(function (t) {
        return e(t, i);
      }, n(t(i)));
    };
  };
}),
    Zu = na(function (t) {
  return Qu(Hc(t), Ac(t));
}),
    Ju = na(function (t) {
  return Qu(za(t), ps(t));
}),
    tl = na(function (t) {
  return Qu(Ka(t), ls(t));
}),
    el = aa(function (t, e) {
  return t < e;
}),
    nl = aa(function (t, e) {
  return t <= e;
}),
    il = pa(function (t, e, n) {
  for (var i = 0, r = n.length, o = [], a = [e]; i < r;) {
    a = t(a[0], n[i]), o[i] = a[1], i += 1;
  }

  return [a[0], o];
}),
    rl = pa(function (t, e, n) {
  for (var i = n.length - 1, r = [], o = [e]; i >= 0;) {
    o = t(n[i], o[0]), r[i] = o[1], i -= 1;
  }

  return [r, o[0]];
}),
    ol = aa(function (t, e) {
  return La(function (n, i) {
    return n[i] = t(e[i], i, e), n;
  }, {}, Ua(e));
}),
    al = aa(function (t, e) {
  return e.match(t) || [];
}),
    sl = aa(function (t, e) {
  return ds(t) ? !ds(e) || e < 1 ? NaN : (t % e + e) % e : NaN;
}),
    cl = pa(function (t, e, n) {
  return t(n) > t(e) ? n : e;
}),
    ul = Wa(sa, 0),
    ll = na(function (t) {
  return ul(t) / t.length;
}),
    dl = na(function (t) {
  var e = t.length;
  if (0 === e) return NaN;
  var n = 2 - e % 2,
      i = (e - n) / 2;
  return ll(Array.prototype.slice.call(t, 0).sort(function (t, e) {
    return t < e ? -1 : t > e ? 1 : 0;
  }).slice(i, i + n));
}),
    hl = aa(function (t, e) {
  var n = {};
  return ua(e.length, function () {
    var i = t.apply(this, arguments);
    return Pa(i, n) || (n[i] = e.apply(this, arguments)), n[i];
  });
}),
    pl = hl(function () {
  return ac(arguments);
}),
    fl = aa(function (t, e) {
  return ku({}, t, e);
}),
    ml = na(function (t) {
  return ku.apply(null, [{}].concat(t));
}),
    _l = pa(function (t, e, n) {
  var i,
      r = {};

  for (i in e) {
    Pa(i, e) && (r[i] = Pa(i, n) ? t(i, e[i], n[i]) : e[i]);
  }

  for (i in n) {
    Pa(i, n) && !Pa(i, r) && (r[i] = n[i]);
  }

  return r;
}),
    gl = pa(function t(e, n, i) {
  return _l(function (n, i, r) {
    return nc(i) && nc(r) ? t(e, i, r) : e(n, i, r);
  }, n, i);
}),
    vl = aa(function (t, e) {
  return gl(function (t, e, n) {
    return e;
  }, t, e);
}),
    yl = aa(function (t, e) {
  return gl(function (t, e, n) {
    return n;
  }, t, e);
}),
    bl = pa(function (t, e, n) {
  return gl(function (e, n, i) {
    return t(n, i);
  }, e, n);
}),
    El = pa(function (t, e, n) {
  return _l(function (e, n, i) {
    return t(n, i);
  }, e, n);
}),
    Cl = aa(function (t, e) {
  return e < t ? e : t;
}),
    Al = pa(function (t, e, n) {
  return t(n) < t(e) ? n : e;
}),
    Tl = aa(function (t, e) {
  return t % e;
}),
    Il = aa(function (t, e) {
  return t * e;
}),
    Ol = na(function (t) {
  return -t;
}),
    Sl = aa(tc(ga(["any"], Qa, Za))),
    wl = na(function (t) {
  return da(t < 0 ? 1 : t + 1, function () {
    return Hc(t, arguments);
  });
}),
    xl = pa(function (t, e, n) {
  return t(e(n));
});

function Nl(t) {
  return [t];
}

var Rl = na(Nl),
    Ll = aa(function (t, e) {
  for (var n = {}, i = {}, r = 0, o = t.length; r < o;) {
    i[t[r]] = 1, r += 1;
  }

  for (var a in e) {
    i.hasOwnProperty(a) || (n[a] = e[a]);
  }

  return n;
}),
    Dl = na(function (t) {
  var e,
      n = !1;
  return ua(t.length, function () {
    return n ? e : (n = !0, e = t.apply(this, arguments));
  });
}),
    kl = function kl(t) {
  return {
    value: t,
    map: function map(e) {
      return kl(e(t));
    }
  };
},
    Pl = pa(function (t, e, n) {
  return t(function (t) {
    return kl(e(t));
  })(n).value;
}),
    Fl = aa(function (t, e) {
  return [t, e];
});

function Ml(t) {
  return aa(function (e, n) {
    return ua(Math.max(0, e.length - n.length), function () {
      return e.apply(this, t(n, arguments));
    });
  });
}

var Hl = Ml(ca),
    Bl = Ml(su(ca)),
    Vl = qu([rc, oc]),
    jl = pa(function (t, e, n) {
  return Xs(za(t, n), e);
}),
    Ul = pa(function (t, e, n) {
  return gc(t, za(e, n));
}),
    Gl = pa(function (t, e, n) {
  return e.length > 0 && t(za(e, n));
}),
    zl = aa(function (t, e) {
  for (var n = {}, i = 0; i < t.length;) {
    t[i] in e && (n[t[i]] = e[t[i]]), i += 1;
  }

  return n;
}),
    Kl = aa(function (t, e) {
  for (var n = {}, i = 0, r = t.length; i < r;) {
    var o = t[i];
    n[o] = e[o], i += 1;
  }

  return n;
}),
    ql = aa(function (t, e) {
  var n = {};

  for (var i in e) {
    t(e[i], i, e) && (n[i] = e[i]);
  }

  return n;
});

var Wl = aa(function (t, e) {
  return ca([t], e);
}),
    Xl = Wa(Il, 1),
    Yl = aa(function (t, e) {
  return da(e.length, function () {
    for (var n = [], i = 0; i < e.length;) {
      n.push(e[i].call(this, arguments[i])), i += 1;
    }

    return t.apply(this, n.concat(Array.prototype.slice.call(arguments, e.length)));
  });
}),
    $l = Yl(Aa, [Kl, yu]),
    Ql = pa(function (t, e, n) {
  return Xs(e, n[t]);
}),
    Zl = pa(function (t, e, n) {
  return Gu(t, n[e]);
}),
    Jl = pa(function (t, e, n) {
  return null != n && Pa(e, n) ? n[e] : t;
}),
    td = pa(function (t, e, n) {
  return t(n[e]);
}),
    ed = aa(function (t, e) {
  for (var n = t.length, i = [], r = 0; r < n;) {
    i[r] = e[t[r]], r += 1;
  }

  return i;
}),
    nd = aa(function (t, e) {
  if (!Yu(t) || !Yu(e)) throw new TypeError("Both arguments to range must be numbers");

  for (var n = [], i = t; i < e;) {
    n.push(i), i += 1;
  }

  return n;
}),
    id = pa(function (t, e, n) {
  for (var i = n.length - 1; i >= 0;) {
    e = t(n[i], e), i -= 1;
  }

  return e;
}),
    rd = la(4, [], function (t, e, n, i) {
  return La(function (n, i) {
    return t(n, i) ? e(n, i) : va(n);
  }, n, i);
}),
    od = na(va),
    ad = aa(function (t, e) {
  var n,
      i = Number(e),
      r = 0;
  if (i < 0 || isNaN(i)) throw new RangeError("n must be a non-negative number");

  for (n = new Array(i); r < i;) {
    n[r] = t(r), r += 1;
  }

  return n;
}),
    sd = aa(function (t, e) {
  return ad(ia(t), e);
}),
    cd = pa(function (t, e, n) {
  return n.replace(t, e);
}),
    ud = pa(function (t, e, n) {
  for (var i = 0, r = n.length, o = [e]; i < r;) {
    e = t(e, n[i]), o[i + 1] = e, i += 1;
  }

  return o;
}),
    ld = aa(function (t, e) {
  return "function" == typeof e.sequence ? e.sequence(t) : id(function (t, e) {
    return ts(Ga(Wl, t), e);
  }, t([]), e);
}),
    dd = pa(function (t, e, n) {
  return Pl(t, ia(e), n);
}),
    hd = aa(function (t, e) {
  return Array.prototype.slice.call(e, 0).sort(t);
}),
    pd = aa(function (t, e) {
  return Array.prototype.slice.call(e, 0).sort(function (e, n) {
    var i = t(e),
        r = t(n);
    return i < r ? -1 : i > r ? 1 : 0;
  });
}),
    fd = aa(function (t, e) {
  return Array.prototype.slice.call(e, 0).sort(function (e, n) {
    for (var i = 0, r = 0; 0 === i && r < t.length;) {
      i = t[r](e, n), r += 1;
    }

    return i;
  });
}),
    md = Uu(1, "split"),
    _d = aa(function (t, e) {
  return [Ps(0, t, e), Ps(t, $u(e), e)];
}),
    gd = aa(function (t, e) {
  if (t <= 0) throw new Error("First argument to splitEvery must be a positive integer");

  for (var n = [], i = 0; i < e.length;) {
    n.push(Ps(i, i += t, e));
  }

  return n;
}),
    vd = aa(function (t, e) {
  for (var n = 0, i = e.length, r = []; n < i && !t(e[n]);) {
    r.push(e[n]), n += 1;
  }

  return [r, Array.prototype.slice.call(e, n)];
}),
    yd = aa(function (t, e) {
  return Xs(xc(t.length, e), t);
}),
    bd = aa(function (t, e) {
  return Number(t) - Number(e);
}),
    Ed = aa(function (t, e) {
  return sc(yc(t, e), yc(e, t));
}),
    Cd = pa(function (t, e, n) {
  return sc(bc(t, e, n), bc(t, n, e));
}),
    Ad = aa(function (t, e) {
  for (var n = e.length - 1; n >= 0 && t(e[n]);) {
    n -= 1;
  }

  return Ps(n + 1, 1 / 0, e);
}),
    Td = function () {
  function t(t, e) {
    this.xf = e, this.f = t;
  }

  return t.prototype["@@transducer/init"] = ya.init, t.prototype["@@transducer/result"] = ya.result, t.prototype["@@transducer/step"] = function (t, e) {
    return this.f(e) ? this.xf["@@transducer/step"](t, e) : va(t);
  }, t;
}(),
    Id = aa(ga(["takeWhile"], aa(function (t, e) {
  return new Td(t, e);
}), function (t, e) {
  for (var n = 0, i = e.length; n < i && t(e[n]);) {
    n += 1;
  }

  return Ps(0, n, e);
})),
    Od = function () {
  function t(t, e) {
    this.xf = e, this.f = t;
  }

  return t.prototype["@@transducer/init"] = ya.init, t.prototype["@@transducer/result"] = ya.result, t.prototype["@@transducer/step"] = function (t, e) {
    return this.f(e), this.xf["@@transducer/step"](t, e);
  }, t;
}(),
    Sd = aa(ga([], aa(function (t, e) {
  return new Od(t, e);
}), function (t, e) {
  return t(e), e;
}));

var wd = aa(function (t, e) {
  if (n = t, "[object RegExp]" !== Object.prototype.toString.call(n)) throw new TypeError("‘test’ requires a value of type RegExp as its first argument; received " + ac(t));
  var n;
  return Os(t).test(e);
}),
    xd = Uu(0, "toLowerCase"),
    Nd = na(function (t) {
  var e = [];

  for (var n in t) {
    Pa(n, t) && (e[e.length] = [n, t[n]]);
  }

  return e;
}),
    Rd = na(function (t) {
  var e = [];

  for (var n in t) {
    e[e.length] = [n, t[n]];
  }

  return e;
}),
    Ld = Uu(0, "toUpperCase"),
    Dd = da(4, function (t, e, n, i) {
  return La(t("function" == typeof e ? Sa(e) : e), n, i);
}),
    kd = na(function (t) {
  for (var e = 0, n = []; e < t.length;) {
    for (var i = t[e], r = 0; r < i.length;) {
      void 0 === n[r] && (n[r] = []), n[r].push(i[r]), r += 1;
    }

    e += 1;
  }

  return n;
}),
    Pd = pa(function (t, e, n) {
  return "function" == typeof n["fantasy-land/traverse"] ? n["fantasy-land/traverse"](e, t) : ld(t, Ga(e, n));
}),
    Fd = "\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF",
    Md = na("function" == typeof String.prototype.trim && !Fd.trim() && "​".trim() ? function (t) {
  return t.trim();
} : function (t) {
  var e = new RegExp("^[" + Fd + "][" + Fd + "]*"),
      n = new RegExp("[" + Fd + "][" + Fd + "]*$");
  return t.replace(e, "").replace(n, "");
}),
    Hd = aa(function (t, e) {
  return ua(t.length, function () {
    try {
      return t.apply(this, arguments);
    } catch (t) {
      return e.apply(this, ca([t], arguments));
    }
  });
}),
    Bd = na(function (t) {
  return function () {
    return t(Array.prototype.slice.call(arguments, 0));
  };
}),
    Vd = na(function (t) {
  return fs(1, t);
}),
    jd = aa(function (t, e) {
  return da(t, function () {
    for (var n, i = 1, r = e, o = 0; i <= t && "function" == typeof r;) {
      n = i === t ? arguments.length : o + r.length, r = r.apply(this, Array.prototype.slice.call(arguments, o, n)), i += 1, o = n;
    }

    return r;
  });
}),
    Ud = aa(function (t, e) {
  for (var n = t(e), i = []; n && n.length;) {
    i[i.length] = n[0], n = t(n[1]);
  }

  return i;
}),
    Gd = aa(Bs(Ru, ca)),
    zd = aa(function (t, e) {
  for (var n, i = 0, r = e.length, o = []; i < r;) {
    zs(t, n = e[i], o) || (o[o.length] = n), i += 1;
  }

  return o;
}),
    Kd = pa(function (t, e, n) {
  return zd(t, ca(e, n));
}),
    qd = pa(function (t, e, n) {
  return t(n) ? n : e(n);
}),
    Wd = Ts(vu),
    Xd = pa(function (t, e, n) {
  for (var i = n; !t(i);) {
    i = e(i);
  }

  return i;
}),
    Yd = na(function (t) {
  var e,
      n = [];

  for (e in t) {
    n[n.length] = t[e];
  }

  return n;
}),
    $d = function $d(t) {
  return {
    value: t,
    "fantasy-land/map": function fantasyLandMap() {
      return this;
    }
  };
},
    Qd = aa(function (t, e) {
  return t($d)(e).value;
}),
    Zd = pa(function (t, e, n) {
  return t(n) ? e(n) : n;
}),
    Jd = aa(function (t, e) {
  for (var n in t) {
    if (Pa(n, t) && !t[n](e[n])) return !1;
  }

  return !0;
}),
    th = aa(function (t, e) {
  return Jd(Ga(Xs, t), e);
}),
    eh = aa(function (t, e) {
  return oc(su($s)(t), e);
}),
    nh = aa(function (t, e) {
  for (var n, i = 0, r = t.length, o = e.length, a = []; i < r;) {
    for (n = 0; n < o;) {
      a[a.length] = [t[i], e[n]], n += 1;
    }

    i += 1;
  }

  return a;
}),
    ih = aa(function (t, e) {
  for (var n = [], i = 0, r = Math.min(t.length, e.length); i < r;) {
    n[i] = [t[i], e[i]], i += 1;
  }

  return n;
}),
    rh = aa(function (t, e) {
  for (var n = 0, i = Math.min(t.length, e.length), r = {}; n < i;) {
    r[t[n]] = e[n], n += 1;
  }

  return r;
}),
    oh = pa(function (t, e, n) {
  for (var i = [], r = 0, o = Math.min(e.length, n.length); r < o;) {
    i[r] = t(e[r], n[r]), r += 1;
  }

  return i;
}),
    ah = Object.freeze({
  F: ra,
  T: oa,
  __: {
    "@@functional/placeholder": !0
  },
  add: sa,
  addIndex: ha,
  adjust: fa,
  all: Ea,
  allPass: Xa,
  always: ia,
  and: Ya,
  any: Za,
  anyPass: Ja,
  ap: ts,
  aperture: is,
  append: rs,
  apply: os,
  applySpec: ss,
  applyTo: cs,
  ascend: us,
  assoc: ls,
  assocPath: ps,
  binary: ms,
  bind: wa,
  both: ys,
  call: Es,
  chain: Ts,
  clamp: Is,
  clone: xs,
  comparator: Ns,
  complement: Ls,
  compose: Bs,
  composeK: Vs,
  composeP: function composeP() {
    if (0 === arguments.length) throw new Error("composeP requires at least one argument");
    return Us.apply(this, Hs(arguments));
  },
  concat: sc,
  cond: cc,
  construct: lc,
  constructN: uc,
  contains: dc,
  converge: hc,
  countBy: mc,
  curry: bs,
  curryN: da,
  dec: _c,
  defaultTo: gc,
  descend: vc,
  difference: yc,
  differenceWith: bc,
  dissoc: Ec,
  dissocPath: Tc,
  divide: Ic,
  drop: Sc,
  dropLast: Lc,
  dropLastWhile: Pc,
  dropRepeats: jc,
  dropRepeatsWith: Vc,
  dropWhile: Gc,
  either: Kc,
  empty: qc,
  endsWith: Xc,
  eqBy: Yc,
  eqProps: $c,
  equals: Xs,
  evolve: Qc,
  filter: rc,
  find: Jc,
  findIndex: eu,
  findLast: iu,
  findLastIndex: ou,
  flatten: au,
  flip: su,
  forEach: cu,
  forEachObjIndexed: uu,
  fromPairs: lu,
  groupBy: du,
  groupWith: hu,
  gt: pu,
  gte: fu,
  has: mu,
  hasIn: _u,
  head: gu,
  identical: Ks,
  identity: yu,
  ifElse: bu,
  inc: Eu,
  indexBy: Cu,
  indexOf: Au,
  init: Tu,
  innerJoin: Iu,
  insert: Ou,
  insertAll: Su,
  intersection: Lu,
  intersperse: Du,
  into: Bu,
  invert: Vu,
  invertObj: ju,
  invoker: Uu,
  is: Gu,
  isEmpty: zu,
  isNil: hs,
  join: Ku,
  juxt: qu,
  keys: Ua,
  keysIn: Wu,
  last: Bc,
  lastIndexOf: Xu,
  length: $u,
  lens: Qu,
  lensIndex: Zu,
  lensPath: Ju,
  lensProp: tl,
  lift: vs,
  liftN: gs,
  lt: el,
  lte: nl,
  map: Ga,
  mapAccum: il,
  mapAccumRight: rl,
  mapObjIndexed: ol,
  match: al,
  mathMod: sl,
  max: Ca,
  maxBy: cl,
  mean: ll,
  median: dl,
  memoize: pl,
  memoizeWith: hl,
  merge: fl,
  mergeAll: ml,
  mergeDeepLeft: vl,
  mergeDeepRight: yl,
  mergeDeepWith: bl,
  mergeDeepWithKey: gl,
  mergeWith: El,
  mergeWithKey: _l,
  min: Cl,
  minBy: Al,
  modulo: Tl,
  multiply: Il,
  nAry: fs,
  negate: Ol,
  none: Sl,
  not: Rs,
  nth: Hc,
  nthArg: wl,
  o: xl,
  objOf: Pu,
  of: Rl,
  omit: Ll,
  once: Dl,
  or: zc,
  over: Pl,
  pair: Fl,
  partial: Hl,
  partialRight: Bl,
  partition: Vl,
  path: za,
  pathEq: jl,
  pathOr: Ul,
  pathSatisfies: Gl,
  pick: zl,
  pickAll: Kl,
  pickBy: ql,
  pipe: Ms,
  pipeK: function pipeK() {
    if (0 === arguments.length) throw new Error("pipeK requires at least one argument");
    return Vs.apply(this, Hs(arguments));
  },
  pipeP: Us,
  pluck: qa,
  prepend: Wl,
  product: Xl,
  project: $l,
  prop: Ka,
  propEq: Ql,
  propIs: Zl,
  propOr: Jl,
  propSatisfies: td,
  props: ed,
  range: nd,
  reduce: Wa,
  reduceBy: fc,
  reduceRight: id,
  reduceWhile: rd,
  reduced: od,
  reject: oc,
  remove: Cc,
  repeat: sd,
  replace: cd,
  reverse: Hs,
  scan: ud,
  sequence: ld,
  set: dd,
  slice: Ps,
  sort: hd,
  sortBy: pd,
  sortWith: fd,
  split: md,
  splitAt: _d,
  splitEvery: gd,
  splitWhen: vd,
  startsWith: yd,
  subtract: bd,
  sum: ul,
  symmetricDifference: Ed,
  symmetricDifferenceWith: Cd,
  tail: Fs,
  take: xc,
  takeLast: Wc,
  takeLastWhile: Ad,
  takeWhile: Id,
  tap: Sd,
  test: wd,
  times: ad,
  toLower: xd,
  toPairs: Nd,
  toPairsIn: Rd,
  toString: ac,
  toUpper: Ld,
  transduce: Dd,
  transpose: kd,
  traverse: Pd,
  trim: Md,
  tryCatch: Hd,
  type: Ss,
  unapply: Bd,
  unary: Vd,
  uncurryN: jd,
  unfold: Ud,
  union: Gd,
  unionWith: Kd,
  uniq: Ru,
  uniqBy: Nu,
  uniqWith: zd,
  unless: qd,
  unnest: Wd,
  until: Xd,
  update: Ac,
  useWith: Yl,
  values: as,
  valuesIn: Yd,
  view: Qd,
  when: Zd,
  where: Jd,
  whereEq: th,
  without: eh,
  xprod: nh,
  zip: ih,
  zipObj: rh,
  zipWith: oh
}),
    sh = po(function (t, e) {
  var n = lo && lo.__assign || Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  };

  function i(t, e, i) {
    void 0 === e && (e = "tag");

    var r = {},
        o = function o(t) {
      r[t] = function (r) {
        return i ? ((o = {})[e] = t, o[i] = r, o) : n({}, r, ((a = {})[e] = t, a));
        var o, a;
      };
    };

    for (var a in t) {
      o(a);
    }

    var s = {},
        c = function c(t) {
      s[t] = function (n) {
        return n[e] === t;
      };
    };

    for (var a in t) {
      c(a);
    }

    var u = {},
        l = function l(t) {
      var e;
      u[t] = h(((e = {})[t] = function (t) {
        return t;
      }, e), function (e) {
        throw new Error("Attempted to cast " + e + " as " + t);
      });
    };

    for (var d in t) {
      l(d);
    }

    function h(t, n) {
      return void 0 === n && (n = function n(t) {}), function (r) {
        var o = r[e];
        return o in t ? t[o](i ? r[i] : r) : n(o);
      };
    }

    return Object.assign({
      is: s,
      as: u,
      match: h,
      _Record: t
    }, r);
  }

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.unionize = i, e.ofType = function () {}, e.default = i;
});

ho(sh);
sh.unionize, sh.ofType;
var ch = po(function (t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.Explanation = sh.unionize({
    ObjectSame: sh.ofType(),
    ObjectDifferent: sh.ofType(),
    PropertiesSame: sh.ofType(),
    PropertiesDifferent: sh.ofType()
  }), e.ObjectDifferentExplanation = sh.unionize({
    NotObjectOrNull: sh.ofType(),
    NonMatchingKeys: sh.ofType()
  }), e.PropertyExplanation = sh.unionize({
    Same: sh.ofType(),
    Different: sh.ofType()
  });
});
ho(ch);
ch.Explanation, ch.ObjectDifferentExplanation, ch.PropertyExplanation;
var uh = po(function (t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.soundObjectKeys = function (t) {
    return Object.keys(t);
  };
});
ho(uh);
uh.soundObjectKeys;
var lh = po(function (t, e) {
  function n(t, e) {
    return t === e ? 0 !== t || 0 !== e || 1 / t == 1 / e : t != t && e != e;
  }

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.shallowEqualExplain = function (t, e) {
    if (n(t, e)) return ch.Explanation.ObjectSame({});
    if ("object" != typeof t || null === t || "object" != typeof e || null === e) return ch.Explanation.ObjectDifferent({
      explanation: ch.ObjectDifferentExplanation.NotObjectOrNull({})
    });
    var i = uh.soundObjectKeys(t),
        r = uh.soundObjectKeys(e);
    if (i.length !== r.length) return ch.Explanation.ObjectDifferent({
      explanation: ch.ObjectDifferentExplanation.NonMatchingKeys({})
    });
    var o = ah.fromPairs(i.map(function (i) {
      return [i, n(t[i], e[i]) ? ch.PropertyExplanation.Same({}) : ch.PropertyExplanation.Different({})];
    }));
    return ah.values(o).some(ch.PropertyExplanation.is.Different) ? ch.Explanation.PropertiesDifferent({
      explanation: o
    }) : ch.Explanation.PropertiesSame({});
  };
});
ho(lh);

var dh,
    hh,
    ph,
    fh,
    mh,
    _h,
    gh,
    vh = lh.shallowEqualExplain,
    yh = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAABGdBTUEAAK/INwWK6QAAABl0RVh0U29mdHdhcmUAQWRvYmUgSW1hZ2VSZWFkeXHJZTwAAAAwUExURfnWPv3tXufFdua/WP3xuP3QIee3N/3pJOe6QufDUP2zAP2+APvjcf3WO9imR////wev5K8AAAAQdFJOU////////////////////wDgI10ZAAAAZklEQVR42lyPgQ6AIAhEUTMrOPr/vw1NdHqbbjwf20nvFqqXejrQeFiEJGkHodz2nAIccNDG2QFCqkYZBmxfhDBBm2WCCIDtRB09ItfRe7QtZJ1NG3hOXQBvBiNvBq7V+L9q+QQYAK+tDOjbm9npAAAAAElFTkSuQmCC",
    bh = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAABGdBTUEAAK/INwWK6QAAABl0RVh0U29mdHdhcmUAQWRvYmUgSW1hZ2VSZWFkeXHJZTwAAAAVUExURafAfJe3U7i3re731MLhZ3SYO/////lcpoAAAAAHdFJOU////////wAaSwNGAAAASklEQVR42pSPSRIAEAwEh4j/P1mWCkE56Atp2aAfwA9WNkFEH0LLIQLWB/4auGiLhxCKBCV6VEGzWC9zrKXnPS5x/qVafRKLIcAAraEFAq5Ug8UAAAAASUVORK5CYII=";

!function (t) {
  t.left = "left", t.center = "center", t.right = "right";
}(dh || (dh = {})), function (t) {
  t.top = "top", t.middle = "middle", t.bottom = "bottom";
}(hh || (hh = {})), function (t) {
  t.rectangle = "rectangle", t.ellipse = "ellipse", t.doubleEllipse = "doubleEllipse", t.rhombus = "rhombus", t.line = "line", t.image = "image", t.arrow = "arrow", t.arrowConnector = "arrowConnector", t.label = "label", t.cylinder = "cylinder", t.swimlane = "swimlane", t.connector = "connector";
}(ph || (ph = {})), function (t) {
  t.RectanglePerimeter = "RectanglePerimeter", t.EllipsePerimeter = "EllipsePerimeter", t.RhombusPerimeter = "RhombusPerimeter", t.TrianglePerimeter = "TrianglePerimeter", t.HexagonPerimeter = "HexagonPerimeter";
}(fh || (fh = {})), function (t) {
  t[t.regular = 0] = "regular", t[t.bold = 1] = "bold", t[t.italic = 2] = "italic", t[t.underline = 4] = "underline";
}(mh || (mh = {})), function (t) {
  t.OrthConnector = "OrthConnector", t.SegmentConnector = "SegmentConnector", t.TopToBottom = "TopToBottom", t.SideToSide = "SideToSide", t.ElbowConnector = "ElbowConnector", t.Loop = "Loop", t.EntityRelation = "EntityRelation";
}(_h || (_h = {})), function (t) {
  t.none = "none", t.block = "block", t.blockThin = "blockThin";
}(gh || (gh = {}));

var Eh = function Eh(t, e) {
  _classCallCheck(this, Eh);

  this.horizontalCount = t, this.verticalCount = e;
};

var Ch = Object.freeze({
  get HorizontalAlignment() {
    return dh;
  },

  get VerticalAlignment() {
    return hh;
  },

  get BuiltInShapes() {
    return ph;
  },

  get Perimeter() {
    return fh;
  },

  get FontStyle() {
    return mh;
  },

  get EdgeStyleNames() {
    return _h;
  },

  get ArrowStyle() {
    return gh;
  },

  AnchorPoints: Eh
});

function Ah(t, e, n, i) {
  n && ("DefaultVertex" === i ? t.getStylesheet().putDefaultVertexStyle(Th(e, n)) : "DefaultEdge" === i ? t.getStylesheet().putDefaultEdgeStyle(Th(e, n)) : void 0 !== i && t.getStylesheet().putCellStyle(i, Th(e, n)));
}

function Th(t, e) {
  if (e.perimeter && (e.perimeter = t.mxPerimeter[e.perimeter]), e.edgeStyle && (e.edgeStyle = t.mxEdgeStyle[e.edgeStyle]), e.points instanceof Eh) {
    var _t25 = e.points,
        _n6 = [];

    for (var _e5 = 1; _e5 <= _t25.horizontalCount; _e5++) {
      var _i17 = _e5 / (_t25.horizontalCount + 1);

      _n6.push("[".concat(_i17, ",0]")), _n6.push("[".concat(_i17, ",1]"));
    }

    for (var _e6 = 1; _e6 <= _t25.verticalCount; _e6++) {
      var _i18 = _e6 / (_t25.verticalCount + 1);

      _n6.push("[0,".concat(_i18, "]")), _n6.push("[1,".concat(_i18, "]"));
    }

    e.points = "[".concat(_n6.join(), "]");
  }

  return e;
}

var Ih =
/*#__PURE__*/
function () {
  function Ih(t, e) {
    _classCallCheck(this, Ih);

    this.name = t, this.instanceClass = e, this.isHtmlLabel = !1, this.isMovable = !0, this.isLabelMovable = !0, this.isResizable = !0, this.isRoot = !1;
  }

  _createClass(Ih, [{
    key: "getStyles",
    value: function getStyles() {}
  }, {
    key: "getLayout",
    value: function getLayout(t, e) {
      return null;
    }
  }, {
    key: "getLabel",
    value: function getLabel(t) {
      return "No override defined";
    }
  }, {
    key: "init",
    value: function init() {}
  }, {
    key: "buildViewModel",
    value: function buildViewModel(t) {
      return new Rh(t, this.domainModel.getDomainClass(t.constructor.name));
    }
  }, {
    key: "buildPrototype",
    value: function buildPrototype() {
      return this.buildViewModel(this.createInstance());
    }
  }, {
    key: "canDrop",
    value: function canDrop(t) {
      return !1;
    }
  }, {
    key: "onDrop",
    value: function onDrop(t, e) {
      return this.buildPrototype();
    }
  }, {
    key: "htmlEntities",
    value: function htmlEntities(t) {
      return this.domainModel.mx.mxUtils.htmlEntities(t, !1);
    }
  }, {
    key: "mx",
    get: function get() {
      return this.domainModel.mx;
    }
  }, {
    key: "allowRootDrop",
    get: function get() {
      return this.isRoot;
    }
  }]);

  return Ih;
}();

var Oh =
/*#__PURE__*/
function () {
  function Oh(t) {
    var _this43 = this;

    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Oh);

    this.classes = t, this.props = e, this._instanceIdCounter = 0, this._isLoading = !1, this.onItemSelected = [], this._classesDict = new Map(), this._instancesDict = new Map(), t && t.forEach(function (t) {
      _this43._classesDict.set(t.name.toLocaleLowerCase(), t), t.name !== t.instanceClass.name && _this43._classesDict.set(t.instanceClass.name.toLocaleLowerCase(), t);
    });
  }

  _createClass(Oh, [{
    key: "addItemSelectedListener",
    value: function addItemSelectedListener(t) {
      this.onItemSelected.push(t);
    }
  }, {
    key: "getDomainClass",
    value: function getDomainClass(t) {
      var e = t.toLocaleLowerCase();
      if (this._classesDict.has(e)) return this._classesDict.get(e);
      throw new Error("No DomainClass \"".concat(t, "\" found."));
    }
  }, {
    key: "buildShape",
    value: function buildShape(t) {
      return t.class.buildShape(t);
    }
  }, {
    key: "init",
    value: function init(t, e) {
      var _this44 = this;

      this._mx = e, this._graph = t, this.registerCodec(e), void 0 !== !this.classes && (this.classes.forEach(function (t) {
        t.domainModel = _this44;
      }), this.registerStyles(this.classes, t), this.classes.forEach(function (t) {
        t.init();
      })), t.isHtmlLabel = this.isHtmlLabel.bind(this), t.getLabel = this.getLabel.bind(this), t.isCellRotatable = function () {
        return !1;
      }, t.enterStopsCellEditing = !0, t.convertValueToString = this.getLabelValue.bind(this), t.model.valueForCellChanged = this.setLabelValue.bind(this), t.addEdge = this.addEdge.bind(this);
      var n = this;
      t.getModel().addListener(e.mxEvent.CHANGE, function (t, i) {
        var r = i.getProperty("edit");
        var o = r.changes;
        r.undone && (o = o.map(function (t, e) {
          return o[o.length - 1 - e];
        })), o.forEach(function (t) {
          t.constructor === e.mxChildChange ? n.onChildChange(t.child, t.index, t.previousIndex, null == t.previous, t.parent) : t.constructor === e.mxTerminalChange ? n.onEdgeChange(t.cell, t.terminal, t.source) : t.constructor === e.mxValueChange && n.onValueChange(t.cell);
        });
      }), t.isCellSelectable = function (t, n) {
        return !(n && t.parent && n.includes(t.parent)) && (t && t.value instanceof Lh ? t.value.isSelectable : e.mxGraph.prototype.isCellSelectable.apply(this, arguments));
      }, t.isLabelMovable = function (t) {
        return t && t.value instanceof Rh ? t.value.class.isLabelMovable : !!(t && t.value instanceof Lh) && t.value.isMovable;
      }, t.isCellMovable = function (t) {
        return t && t.value instanceof Rh ? t.value.class.isMovable : !!(t && t.value instanceof Lh) && t.value.isMovable;
      }, t.isCellResizable = function (t) {
        return t && t.value instanceof Rh ? t.value.class.isResizable : !!(t && t.value instanceof Lh) && t.value.isResizable;
      }, t.getPrototype = function (t) {
        return t && t.value instanceof Rh ? n.buildShape(t.value.class.buildPrototype()) : void 0;
      }, t.getSelectionModel().addListener(e.mxEvent.CHANGE, function (t, e) {
        console.log(t, e), n.onSelectionChanged(n.mapCellsToClass(t.cells));
      }), e.mxClipboard.paste = function (t) {
        var i = null;

        if (!e.mxClipboard.isEmpty()) {
          i = t.getImportableCells(e.mxClipboard.getCells());
          var r = e.mxClipboard.insertCount * e.mxClipboard.STEPSIZE,
              o = t.getSelectionModel().cells,
              a = n.findClosestDropTarget(o && 1 == o.length ? o[0] : t.getDefaultParent(), i);
          a && (i = t.importCells(i, r, r, a), e.mxClipboard.insertCount++, t.setSelectionCells(i));
        }

        return i;
      };
    }
  }, {
    key: "registerStyles",
    value: function registerStyles(t, e) {
      var _this45 = this;

      var n = this._mx.mxPoint;
      Ah(e, this._mx, this.props.defaultVertexStyle, "DefaultVertex"), Ah(e, this._mx, this.props.defaultEdgeStyle, "DefaultEdge"), t.forEach(function (t) {
        var n = t.getStyles();
        Array.isArray(n) ? n.forEach(function (t) {
          Ah(e, _this45._mx, Object.values(t)[0], Object.keys(t)[0]);
        }) : void 0 !== n && Ah(e, _this45._mx, n, t.name.toLocaleLowerCase());
      });
    }
  }, {
    key: "onSelectionChanged",
    value: function onSelectionChanged(t) {
      t && 1 === t.length ? this.notifyItemSelected(t[0]) : this.notifyItemSelected(void 0);
    }
  }, {
    key: "notifyItemSelected",
    value: function notifyItemSelected(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var n = arguments.length > 2 ? arguments[2] : undefined;
      this.onItemSelected.forEach(function (i) {
        return i(t, e, n);
      });
    }
  }, {
    key: "mapCellsToClass",
    value: function mapCellsToClass(t) {
      return t.map(function (t) {
        return t.value instanceof Rh || t.value instanceof Lh ? t.value : void 0;
      }).filter(function (t) {
        return void 0 !== t;
      });
    }
  }, {
    key: "findClosestDropTarget",
    value: function findClosestDropTarget(t, e, n) {
      var i = t && t.value;
      return n || (n = this.mapCellsToClass(e)), n.every(function (t) {
        return t && (i && !1 !== i.class.canDrop(t.class) || !i && t.class.allowRootDrop);
      }) ? t : t.parent ? this.findClosestDropTarget(t.parent, e, n) : null;
    }
  }, {
    key: "findDomainClass",
    value: function findDomainClass(t) {
      return t && t.value instanceof Rh ? t.value.class : null;
    }
  }, {
    key: "notifyModelChange",
    value: function notifyModelChange(t, e) {
      if (console.log("DomainModel.notifyModelChange", t, "restructure", e.restructure), t.view && this.graph) if (e.wasRedone || e.wasUndone) e.restructure || this.updateView(t), this._lastAction = void 0;else if (e.restructure) this._lastAction = void 0, this.updateViewStructure(t, e);else if (this._lastAction && this._lastAction.merge(e)) this.updateView(t);else {
        this._lastAction = e;

        try {
          this.graph.model.beginUpdate(), this.updateView(t), this.graph.model.currentEdit.add(new Dh(e, t));
        } finally {
          this.graph.model.endUpdate();
        }
      }
    }
  }, {
    key: "updateView",
    value: function updateView(t) {
      var e = this.graph.view.getState(t.view);

      if (e) {
        e.invalid = !0, this.graph.view.validateCellState(t.view, !1);

        var _r5 = this.graph.getModel();

        for (var n = _r5.getChildCount(t.view), i = 0; i < n; i++) {
          var _n7 = _r5.getChildAt(t.view, i);

          (e = this.graph.view.getState(_n7)).invalid = !0, this.graph.view.validateCellState(_n7, !1);
        }
      }
    }
  }, {
    key: "updateViewStructure",
    value: function updateViewStructure(t, e) {
      var n = t.view,
          i = t.class.buildShape(t);
      this.graph.getCellStyle(i);
      this.graph.model.beginUpdate();

      try {
        var r = this.graph.getModel().getStyle(i),
            o = n,
            a = this.graph.view.getState(o);
        null != a ? a.style : this.graph.getCellStyle(o);
        this.graph.getModel().setStyle(o, r);

        var _s2 = this.graph.model.getChildCount(n),
            _c2 = this.graph.model.getChildCount(i),
            _u2 = function _u2(t, e, n, i, r) {
          var o = t.model.getChildAt(n, e);

          if (o.value instanceof Lh) {
            i.children && i.children.find(function (t) {
              return t.value instanceof Lh && t.value.name === o.value.name;
            }) || (r ? t.model.remove(o) : t.model.add(i, o));
          }
        };

        for (var _t26 = _s2 - 1; _t26 >= 0; _t26--) {
          _u2(this.graph, _t26, n, i, !0);
        }

        for (var _t27 = _c2 - 1; _t27 >= 0; _t27--) {
          _u2(this.graph, _t27, i, n, !1);
        }

        this.graph.model.currentEdit.add(new Dh(e, t));
      } finally {
        this.graph.model.endUpdate();
      }
    }
  }, {
    key: "registerCodec",
    value: function registerCodec(t) {
      var e = t.mxCodecRegistry,
          n = t.mxObjectCodec,
          i = t.mxCodec,
          r = t.mxGraphModel;
      var o = new n(new Rh({}, {}));
      var a = this;
      o.encode = function (t, e) {
        if (e instanceof Rh) {
          var _t28 = e;
          arguments[1] = new xh(_t28.class.name, _t28.id);
        }

        return n.prototype.encode.apply(this, arguments);
      }, o.decode = function (t, e, n) {
        var i = e.getAttribute("mid");
        if (i) return a._instancesDict.get(i);
        throw "ViewModel id not defined";
      }, e.register(o);
      var s = new n(new Lh({}, ""));
      s.encode = function (t, e) {
        if (e instanceof Lh) {
          var _t29 = e;
          arguments[1] = _t29.buildS();
        }

        return n.prototype.encode.apply(this, arguments);
      }, s.decode = function (t, e, n) {
        var i = e.getAttribute("mid"),
            r = e.getAttribute("name");
        if (!i || !r) throw "PropertyView id/name not defined";
        {
          var _t30 = a._instancesDict.get(i);

          if (_t30) return new Lh(_t30, r);
        }
        return e;
      }, e.register(s), i.prototype.getConstructorForNode = function (e) {
        if ("ViewModel" === e) return o.template.constructor;
        if ("PropertyView" === e) return s.template.constructor;
        if (void 0 !== t[e]) return t[e];
        throw "Decode not registered: " + e;
      };
    }
  }, {
    key: "onChildChange",
    value: function onChildChange(t, e, n, i, r) {
      var _this46 = this;

      if (t && t.value instanceof Rh) {
        var _o3 = t.value;

        var _a3 = void 0;

        r && r.value instanceof Rh && (_a3 = r.value);

        var _s3 = !i && void 0 !== _a3 && _o3.parent !== _a3,
            _c3 = !_s3 && !i && e !== n;

        if (console.log("reparent", _s3, "move", _c3, "isNew", i), i && (this.registerViewModel(_o3, t), t.children && t.children.forEach(function (t) {
          return t.value instanceof Rh && _this46.registerViewModel(t.value, t);
        })), _s3 && _o3.resetParent(), _a3) {
          var _t31 = _a3.class.canDrop(_o3.class);

          _t31 && (_c3 ? _a3.moveRelated(_o3, _t31, e) : _a3.insertRelated(_o3, _t31, e));
        }
      }
    }
  }, {
    key: "onEdgeChange",
    value: function onEdgeChange(t, e, n) {
      if (t && t.value instanceof Rh) {
        var _i19 = t.value;

        var _r6 = void 0;

        e && e.value instanceof Rh && (_r6 = e.value);

        var _o4 = !1;

        if (n && _i19.parent !== _r6) _i19.parent && _i19.resetParent(), _r6 && _r6.insertRelated(_i19, "relation"), _o4 = !0;else if (!n) {
          var _t32 = _i19.relatedOne("target");

          _t32 !== _r6 && (_t32 && _i19.removeRelated(_t32, "target"), _r6 && _i19.insertRelated(_r6, "target"), _o4 = !0);
        }
        console.log("onEdgeChange", _i19, "changed", _o4, "source", n, "terminal", _r6);
      }
    }
  }, {
    key: "onValueChange",
    value: function onValueChange(t) {
      if (t && t.value instanceof Rh) {
        var _e7 = t.value;
        this.notifyItemSelected(_e7, !0), console.log("onValueChange", _e7.class.name, "property");
      } else if (t && t.value instanceof Lh) {
        var _e8 = t.value;
        this.notifyItemSelected(_e8, !0, _e8.name), console.log("onValueChange", _e8.viewModel.class.name, "property", _e8.name);
      }
    }
  }, {
    key: "registerViewModel",
    value: function registerViewModel(t, e) {
      t.id || (t.attach((++this._instanceIdCounter).toString()), this._instancesDict.set(t.id, t), console.log("New ViewModel", t.class.name, t.id)), t.view = e;
    }
  }, {
    key: "isHtmlLabel",
    value: function isHtmlLabel(t) {
      var e = this.findDomainClass(t);
      return e && e.isHtmlLabel;
    }
  }, {
    key: "getLabel",
    value: function getLabel(t) {
      var e = this.mx.mxGraph,
          n = t.value;
      return n && n.class && n.class.isHtmlLabel ? n.class.getLabel(n.model) : e.prototype.getLabel.apply(this.graph, arguments);
    }
  }, {
    key: "getLabelValue",
    value: function getLabelValue(t) {
      var e = this.mx.mxGraph;
      return t.value instanceof Rh ? t.value.model.name : t.value instanceof Lh ? t.value.value : e.prototype.convertValueToString.apply(this.graph, arguments);
    }
  }, {
    key: "setLabelValue",
    value: function setLabelValue(t, e) {
      var n = this.mx.mxGraphModel;
      var i = null;
      return t.value instanceof Rh ? (i = t.value.model.name, t.value.model.name = e) : t.value instanceof Lh ? (i = t.value.value, t.value.value = e) : i = n.prototype.valueForCellChanged.apply(this.graph.model, arguments), i;
    }
  }, {
    key: "addEdge",
    value: function addEdge(t, e, n, i, r) {
      var o = this.graph.model;
      o.getChildCount(i);
      var a = this.getDomainClass("relation"),
          s = a.buildPrototype(),
          c = n && n.value;
      c && c.insertRelated(s, "relations");
      var u = i && i.value;
      u && s.insertRelated(u, "target"), arguments[0] = a.buildShape(s), o.beginUpdate();

      try {
        return this.mx.mxGraph.prototype.addEdge.apply(this.graph, arguments);
      } finally {
        o.endUpdate();
      }

      return null;
    }
  }, {
    key: "exportModel",
    value: function exportModel() {
      return Array.from(this._instancesDict.values()).filter(function (t) {
        return t.class.isRoot;
      }).map(function (t) {
        return new Sh(t);
      });
    }
  }, {
    key: "exportModelJson",
    value: function exportModelJson() {
      Array.from(this._instancesDict.values()).filter(function (t) {
        return t.class.isRoot;
      }).map(function (t) {
        return new Sh(t);
      });
      return JSON.stringify(this.exportModel(), null, 2);
    }
  }, {
    key: "openModel",
    value: function openModel(t, e) {
      return Kt(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = t.loaded;

                if (_context.t0) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return this.designer.loadDocument(t);

              case 4:
                try {
                  this.importModel(t.model), this._isLoading = !0, e.setGraphXml(t.diagram), e.undoManager.clear(), Object.values(e.graph.model.cells).forEach(function (t) {
                    return t.value instanceof Rh || t.value instanceof Lh ? t.value.view = t : void 0;
                  });
                } finally {
                  this._isLoading = !1, this.__currentDoc = t;
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "import",
    value: function _import(t, e, n) {
      this.importModel(t);

      try {
        this._isLoading = !0, e.graph.openGraphModel(n), e.undoManager.clear(), Object.values(e.graph.model.cells).forEach(function (t) {
          return t.value instanceof Rh || t.value instanceof Lh ? t.value.view = t : void 0;
        });
      } finally {
        this._isLoading = !1;
      }
    }
  }, {
    key: "importModel",
    value: function importModel(t) {
      var _this47 = this;

      this._instancesDict.clear(), this._instanceIdCounter = 0, t && t.forEach(function (t) {
        return _this47.importVertice(t);
      });
    }
  }, {
    key: "importVertice",
    value: function importVertice(t) {
      var _this48 = this;

      var e = this._instancesDict.get(t.id);

      e ? t.data && e.attach(t.id, t.data) : ((e = new Rh(t.data, this.getDomainClass(t.class))).attach(t.id, t.data), this._instancesDict.set(e.id, e));
      var n = Number.parseInt(t.id);
      return this._instanceIdCounter < n && (this._instanceIdCounter = n), t.edges && t.edges.forEach(function (t) {
        t.vertices && t.vertices.forEach(function (n) {
          e.insertRelated(_this48.importVertice(n), t.name);
        });
      }), e;
    }
  }, {
    key: "mx",
    get: function get() {
      return this._mx;
    }
  }, {
    key: "graph",
    get: function get() {
      return this._graph;
    }
  }, {
    key: "isLoading",
    get: function get() {
      return this._isLoading;
    }
  }]);

  return Oh;
}();

var Sh = function Sh(t) {
  var _this49 = this;

  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;

  _classCallCheck(this, Sh);

  this.id = t.id, this.class = t.class.name, e && (this.data = t.model, Object.keys(t.relations).forEach(function (e) {
    var n = t.relations[e];

    if (n && n.length > 0) {
      var _t33 = new wh(e, n);

      _this49.edges ? _this49.edges.push(_t33) : _this49.edges = [_t33];
    }
  }));
};

var wh = function wh(t, e) {
  _classCallCheck(this, wh);

  this.name = t, this.vertices = e.map(function (t) {
    return new Sh(t, !t.class.isRoot);
  });
};

var xh = function xh(t, e) {
  _classCallCheck(this, xh);

  this.type = t, this.mid = e;
};

var Nh = function Nh(t, e, n) {
  _classCallCheck(this, Nh);

  this.name = t, this.type = e, this.mid = n;
};

var Rh =
/*#__PURE__*/
function () {
  function Rh(t, e) {
    _classCallCheck(this, Rh);

    this._model = t, this._dc = e, this._instances = {};
  }

  _createClass(Rh, [{
    key: "resetParent",
    value: function resetParent() {
      this.parent && this._parentRelation && (this.parent.removeRelated(this, this._parentRelation), this._parent = void 0, this._parentRelation = void 0);
    }
  }, {
    key: "attach",
    value: function attach(t, e) {
      this._id = t, e && (this._model = new this.class.instanceClass("", e));
    }
  }, {
    key: "getProperty",
    value: function getProperty(t) {
      return this._model[t];
    }
  }, {
    key: "setProperty",
    value: function setProperty(t, e) {
      this._model[t] = e;
    }
  }, {
    key: "insertRelated",
    value: function insertRelated(t, e, n) {
      t instanceof Rh || (t = new Rh(t, this._dc.domainModel.getDomainClass(t.constructor.name))), void 0 === this._instances[e] && (this._instances[e] = []), t._parent = this, t._parentRelation = e, n ? this._instances[e].splice(n, 0, t) : this._instances[e].push(t);
    }
  }, {
    key: "removeRelated",
    value: function removeRelated(t, e) {
      var n = this._instances[e].indexOf(t);

      this._instances[e].splice(n, 1);
    }
  }, {
    key: "moveRelated",
    value: function moveRelated(t, e, n) {
      var i = this._instances[e].indexOf(t);

      this._instances[e].splice(i, 1), this._instances[e].splice(n, 0, t);
    }
  }, {
    key: "related",
    value: function related(t) {
      return void 0 !== this._instances[t] ? this._instances[t] : [];
    }
  }, {
    key: "relatedOne",
    value: function relatedOne(t) {
      var e = this.related(t);
      return e.length > 0 ? e[0] : void 0;
    }
  }, {
    key: "createPropertyRef",
    value: function createPropertyRef(t) {
      return new Lh(this, t);
    }
  }, {
    key: "clone",
    value: function clone() {
      return this._dc.domainModel.isLoading ? this : (console.log("clone", this._dc.name, this.id), new Rh(this._model, this._dc));
    }
  }, {
    key: "notifyChange",
    value: function notifyChange(t) {
      this.class.domainModel.notifyModelChange(this, t);
    }
  }, {
    key: "class",
    get: function get() {
      return this._dc;
    }
  }, {
    key: "id",
    get: function get() {
      return this._id;
    }
  }, {
    key: "relations",
    get: function get() {
      return this._instances;
    }
  }, {
    key: "parent",
    get: function get() {
      return this._parent;
    }
  }, {
    key: "model",
    get: function get() {
      return this._model;
    }
  }]);

  return Rh;
}();

var Lh =
/*#__PURE__*/
function () {
  function Lh(t, e) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
    var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !1;

    _classCallCheck(this, Lh);

    this.viewModel = t, this.name = e, this.isMovable = n, this.isSelectable = i, this.isResizable = r;
  }

  _createClass(Lh, [{
    key: "buildS",
    value: function buildS() {
      return new Nh(this.name, this.viewModel.class.name, this.viewModel.id);
    }
  }, {
    key: "notifyChange",
    value: function notifyChange(t) {
      this.viewModel.class.domainModel.notifyModelChange(this.viewModel, t);
    }
  }, {
    key: "model",
    get: function get() {
      return this.viewModel.model;
    }
  }, {
    key: "value",
    get: function get() {
      return this.viewModel.getProperty(this.name);
    },
    set: function set(t) {
      this.viewModel.setProperty(this.name, t);
    }
  }]);

  return Lh;
}();

var Dh =
/*#__PURE__*/
function () {
  function Dh(t, e) {
    _classCallCheck(this, Dh);

    this.action = t, this.viewModel = e;
  }

  _createClass(Dh, [{
    key: "undo",
    value: function undo() {
      this.action.undo();
    }
  }, {
    key: "redo",
    value: function redo() {
      this.action.redo();
    }
  }]);

  return Dh;
}();

var kh = Ch.BuiltInShapes,
    Ph = Ch.HorizontalAlignment,
    Fh = Ch.VerticalAlignment,
    Mh = Ch.FontStyle,
    Hh = Ch.Perimeter,
    Bh = Ch.EdgeStyleNames,
    Vh = Ch.AnchorPoints,
    jh = Ch.ArrowStyle,
    Uh = "var(--mdc-theme-primary, #6200ee)",
    Gh = "var(--mdc-theme-on-primary, #ffffff)",
    zh = "var(--mdc-theme-background, #ffffff)",
    Kh = "var(--mdc-theme-fontFamily, Roboto, sans-serif)";

var qh =
/*#__PURE__*/
function () {
  function qh() {
    _classCallCheck(this, qh);

    this.domainModel = new Oh([new Wh(), new Xh(), new Yh()], {
      defaultVertexStyle: {
        shape: kh.rectangle,
        align: Ph.left,
        spacingLeft: 4
      },
      defaultEdgeStyle: {
        edgeStyle: Bh.EntityRelation,
        labelBackgroundColor: "#FFFFFF",
        strokeColor: "var(--mdc-theme-primary, #6200ee)",
        strokeWidth: 2,
        rounded: !0
      }
    });
  }

  _createClass(qh, [{
    key: "setDesigner",
    value: function setDesigner(t) {
      this.domainModel.designer = t;
    }
  }, {
    key: "init",
    value: function init(t, e) {
      this.domainModel.init(t, e);
    }
  }, {
    key: "findDomainClass",
    value: function findDomainClass(t) {
      return this.domainModel.findDomainClass(t);
    }
  }, {
    key: "addItemSelectedListener",
    value: function addItemSelectedListener(t) {
      this.domainModel.addItemSelectedListener(t);
    }
  }, {
    key: "getDomainClass",
    value: function getDomainClass(t) {
      return this.domainModel.getDomainClass(t);
    }
  }]);

  return qh;
}();

var Wh =
/*#__PURE__*/
function (_Ih) {
  _inherits(Wh, _Ih);

  function Wh() {
    var _this50;

    _classCallCheck(this, Wh);

    _this50 = _possibleConstructorReturn(this, _getPrototypeOf(Wh).call(this, "class", Qh)), _this50.isHtmlLabel = !0, _this50.isRoot = !0;
    return _this50;
  }

  _createClass(Wh, [{
    key: "createInstance",
    value: function createInstance() {
      return new Qh("Class 1");
    }
  }, {
    key: "buildPrototype",
    value: function buildPrototype() {
      var t = this.buildViewModel(new Qh("Class 1")),
          e = new $h("ID");
      return e.primaryKey = !0, e.autoIncrement = !0, t.insertRelated(e, "properties"), t;
    }
  }, {
    key: "buildShape",
    value: function buildShape(t) {
      var _this51 = this;

      var _this$mx = this.mx,
          e = _this$mx.mxCell,
          n = _this$mx.mxGeometry,
          i = new e(t, new n(0, 0, 200, 34), "class");
      return i.setVertex(!0), t.related("properties").forEach(function (t) {
        return i.insert(_this51.domainModel.buildShape(t));
      }), i;
    }
  }, {
    key: "getStyles",
    value: function getStyles() {
      return {
        shape: kh.swimlane,
        points: new Vh(5, 3),
        perimeter: Hh.RectanglePerimeter,
        align: Ph.left,
        verticalAlign: Fh.top,
        fillColor: Uh,
        strokeColor: Uh,
        fontColor: Gh,
        swimlaneFillColor: zh,
        strokeWidth: 0,
        startSize: 34,
        fontSize: 12,
        fontStyle: Mh.regular,
        fontFamily: Kh,
        arcSize: 5,
        rounded: !0
      };
    }
  }, {
    key: "getLayout",
    value: function getLayout(t, e) {
      var n = e.mxStackLayout,
          i = new n(t, !1);
      return i.fill = !0, i.resizeParent = !0, i.isVertexMovable = function (t) {
        return !0;
      }, i;
    }
  }, {
    key: "getLabel",
    value: function getLabel(t) {
      return "<div class=\"swimlane-label\"><img src=\"".concat(yh, "\" width=\"16\" height=\"16\" align=\"top\"><span>").concat(this.htmlEntities(t.name), "</span><span>DomainRoot</span></div>");
    }
  }, {
    key: "canDrop",
    value: function canDrop(t) {
      return t instanceof Xh && "properties";
    }
  }]);

  return Wh;
}(Ih);

var Xh =
/*#__PURE__*/
function (_Ih2) {
  _inherits(Xh, _Ih2);

  function Xh() {
    var _this52;

    _classCallCheck(this, Xh);

    _this52 = _possibleConstructorReturn(this, _getPrototypeOf(Xh).call(this, "property", $h)), _this52.isHtmlLabel = !0, _this52.isResizable = !1, _this52.isLabelMovable = !1;
    return _this52;
  }

  _createClass(Xh, [{
    key: "createInstance",
    value: function createInstance() {
      return new $h("Property1");
    }
  }, {
    key: "buildShape",
    value: function buildShape(t) {
      var _this$mx2 = this.mx,
          e = _this$mx2.mxCell,
          n = _this$mx2.mxGeometry;
      var i = new e(t, new n(0, 0, 0, 20), this.name);
      return i.setVertex(!0), i.setConnectable(!1), i;
    }
  }, {
    key: "getLabel",
    value: function getLabel(t) {
      var e = "";
      return t.primaryKey ? e += "<img title=\"Primary Key\" src=\"".concat(yh, "\" width=\"16\" height=\"16\" align=\"top\">&nbsp;") : e += '<img src="images/spacer.gif" width="16" height="1">&nbsp;', t.autoIncrement ? e += "<img title=\"Auto Increment\" src=\"".concat(bh, "\" width=\"16\" height=\"16\" align=\"top\">&nbsp;") : e += '<img src="images/spacer.gif" width="16" height="1">&nbsp;', e + this.htmlEntities(t.name) + ": " + t.type;
    }
  }]);

  return Xh;
}(Ih);

var Yh =
/*#__PURE__*/
function (_Ih3) {
  _inherits(Yh, _Ih3);

  function Yh() {
    var _this53;

    _classCallCheck(this, Yh);

    _this53 = _possibleConstructorReturn(this, _getPrototypeOf(Yh).call(this, "relation", Zh)), _this53.isRoot = !1, _this53.isResizable = !0, _this53.isMovable = !1, _this53.isLabelMovable = !1;
    return _this53;
  }

  _createClass(Yh, [{
    key: "createInstance",
    value: function createInstance() {
      return new Zh("Relation1");
    }
  }, {
    key: "buildShape",
    value: function buildShape(t) {
      var _this$mx3 = this.mx,
          e = _this$mx3.mxCell,
          n = _this$mx3.mxGeometry,
          i = _this$mx3.mxPoint,
          r = "Relation" === t.model.type,
          o = "Relation" === t.model.type && ("Both" === t.model.direction || "Reverse" === t.model.direction),
          a = "Relation" === t.model.type && ("Both" === t.model.direction || "Forward" === t.model.direction),
          s = o && "One" === t.model.sourceMultiplicity,
          c = a && "One" === t.model.targetMultiplicity;
      var u = r ? "relation;dashed=".concat(t.model.embedding ? 0 : 1, ";startArrow=").concat(s ? "blockThin" : "none", ";endArrow=").concat(c ? "blockThin" : "none") : "inheritance;";
      var l = new e(t, new n(0, 0, 0, 0), u);

      if (l.geometry.setTerminalPoint(new i(0, 0), !0), l.geometry.setTerminalPoint(new i(160, 0), !1), l.geometry.relative = !0, l.edge = !0, r) {
        if (o) {
          var d = new e(t.createPropertyRef("sourceRole"), new n(-1, 0, 0, 0), "resizable=1;html=1;align=left;verticalAlign=top;spacingLeft=5;labelBackgroundColor=#ffffff;fontSize=10;");
          d.geometry.relative = !0, d.setConnectable(!1), d.vertex = !0, l.insert(d);
        }

        if (a) {
          var h = new e(t.createPropertyRef("targetRole"), new n(1, 0, 0, 0), "resizable=1;html=1;align=right;spacingRight=5;verticalAlign=bottom;labelBackgroundColor=#ffffff;fontSize=10;");
          h.geometry.relative = !0, h.setConnectable(!1), h.vertex = !0, l.insert(h);
        }
      }

      return l;
    }
  }, {
    key: "getStyles",
    value: function getStyles() {
      var t = {
        edgeStyle: Bh.OrthConnector,
        strokeColor: Uh,
        strokeWidth: 2,
        startSize: 14,
        startArrow: jh.block,
        startFill: !1,
        fontSize: 0,
        rounded: !0
      };
      return [{
        relation: {
          edgeStyle: Bh.OrthConnector,
          strokeColor: Uh,
          strokeWidth: 2,
          fontSize: 0,
          perimeterSpacing: 5,
          rounded: !0
        }
      }, {
        inheritance: t
      }];
    }
  }, {
    key: "allowRootDrop",
    get: function get() {
      return !0;
    }
  }]);

  return Yh;
}(Ih);

var $h = function $h(t, e) {
  _classCallCheck(this, $h);

  this.name = t, this.type = "TEXT", this.primaryKey = !1, this.autoIncrement = !1, e && (this.name = e.name, this.type = e.type, this.primaryKey = e.primaryKey, this.autoIncrement = e.autoIncrement);
};

var Qh =
/*#__PURE__*/
function () {
  function Qh(t, e) {
    _classCallCheck(this, Qh);

    this.name = t, e && (this.name = e.name);
  }

  _createClass(Qh, [{
    key: "selectionMargin",
    get: function get() {
      return 8;
    }
  }]);

  return Qh;
}();

var Zh =
/*#__PURE__*/
function () {
  function Zh(t, e) {
    _classCallCheck(this, Zh);

    this.name = t, this.type = "Relation", this.direction = "Both", this.sourceMultiplicity = "Many", this.targetMultiplicity = "Many", this.sourceRole = "source", this.targetRole = "target", this.embedding = !1, e && (this.name = e.name, this.type = e.type, this.sourceRole = e.sourceRole, this.targetRole = e.targetRole);
  }

  _createClass(Zh, null, [{
    key: "_typeDesc",
    get: function get() {
      return {
        type: Vn.string,
        category: "Core",
        sortOrder: 1,
        selectionOptions: ["Relation", "Inheritance"],
        requireParentRefresh: !0
      };
    }
  }, {
    key: "_nameDesc",
    get: function get() {
      return {
        category: "Core"
      };
    }
  }, {
    key: "_directionDesc",
    get: function get() {
      return {
        type: Vn.string,
        selectionOptions: ["Both", "Forward", "Reverse"],
        category: "Relation",
        requireParentRefresh: !0,
        customHandling: function customHandling(t) {
          t.visible = "Relation" === t.data.type;
        }
      };
    }
  }, {
    key: "_embeddingDesc",
    get: function get() {
      return {
        category: "Relation",
        requireParentRefresh: !0,
        customHandling: function customHandling(t) {
          t.visible = "Relation" === t.data.type;
        }
      };
    }
  }, {
    key: "_sourceMultiplicityDesc",
    get: function get() {
      return {
        type: Vn.string,
        selectionOptions: ["One", "Many"],
        category: "Relation",
        requireParentRefresh: !0,
        customHandling: function customHandling(t) {
          t.visible = "Relation" === t.data.type && ("Both" === t.data.direction || "Reverse" === t.data.direction);
        }
      };
    }
  }, {
    key: "_targetMultiplicityDesc",
    get: function get() {
      return {
        type: Vn.string,
        selectionOptions: ["One", "Many"],
        category: "Relation",
        requireParentRefresh: !0,
        customHandling: function customHandling(t) {
          t.visible = "Relation" === t.data.type && ("Both" === t.data.direction || "Forward" === t.data.direction);
        }
      };
    }
  }, {
    key: "_sourceRoleDesc",
    get: function get() {
      return {
        category: "Relation",
        customHandling: function customHandling(t) {
          t.visible = "Relation" === t.data.type && ("Both" === t.data.direction || "Reverse" === t.data.direction);
        }
      };
    }
  }, {
    key: "_targetRoleDesc",
    get: function get() {
      return {
        category: "Relation",
        customHandling: function customHandling(t) {
          t.visible = "Relation" === t.data.type && ("Both" === t.data.direction || "Forward" === t.data.direction);
        }
      };
    }
  }]);

  return Zh;
}();

var Jh = b("apolloService");

var tp = function tp(t) {
  _classCallCheck(this, tp);

  this.client = t;
};

var ep = "function" == typeof Symbol ? Symbol.for("nodejs.util.inspect.custom") : void 0;

function np(t) {
  return (np = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
    return typeof t;
  } : function (t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  })(t);
}

var ip = 10,
    rp = 2;

function op(t, e) {
  switch (np(t)) {
    case "string":
      return JSON.stringify(t);

    case "function":
      return t.name ? "[function ".concat(t.name, "]") : "[function]";

    case "object":
      return function (t, e) {
        if (-1 !== e.indexOf(t)) return "[Circular]";
        var n = [].concat(e, [t]);

        if (t) {
          var i = function (t) {
            var e = t[String(ep)];
            if ("function" == typeof e) return e;
            if ("function" == typeof t.inspect) return t.inspect;
          }(t);

          if (void 0 !== i) {
            var r = i.call(t);
            if (r !== t) return "string" == typeof r ? r : op(r, n);
          } else if (Array.isArray(t)) return function (t, e) {
            if (0 === t.length) return "[]";
            if (e.length > rp) return "[Array]";

            for (var n = Math.min(ip, t.length), i = t.length - n, r = [], o = 0; o < n; ++o) {
              r.push(op(t[o], e));
            }

            1 === i ? r.push("... 1 more item") : i > 1 && r.push("... ".concat(i, " more items"));
            return "[" + r.join(", ") + "]";
          }(t, n);

          return function (t, e) {
            var n = Object.keys(t);
            if (0 === n.length) return "{}";
            if (e.length > rp) return "[" + function (t) {
              var e = Object.prototype.toString.call(t).replace(/^\[object /, "").replace(/]$/, "");

              if ("Object" === e && "function" == typeof t.constructor) {
                var n = t.constructor.name;
                if ("string" == typeof n) return n;
              }

              return e;
            }(t) + "]";
            return "{ " + n.map(function (n) {
              var i = op(t[n], e);
              return n + ": " + i;
            }).join(", ") + " }";
          }(t, n);
        }

        return String(t);
      }(t, e);

    default:
      return String(t);
  }
}

function ap(t) {
  var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t.prototype.toString;
  t.prototype.toJSON = e, t.prototype.inspect = e, ep && (t.prototype[ep] = e);
}

function sp(t, e) {
  if (!Boolean(t)) throw new Error(e);
}

var cp,
    up = function up(t, e, n) {
  this.body = t, this.name = e || "GraphQL request", this.locationOffset = n || {
    line: 1,
    column: 1
  }, this.locationOffset.line > 0 || sp(0, "line in locationOffset is 1-indexed and must be positive"), this.locationOffset.column > 0 || sp(0, "column in locationOffset is 1-indexed and must be positive");
};

function lp(t, e) {
  for (var n, i = /\r\n|[\n\r]/g, r = 1, o = e + 1; (n = i.exec(t.body)) && n.index < e;) {
    r += 1, o = e + 1 - (n.index + n[0].length);
  }

  return {
    line: r,
    column: o
  };
}

function dp(t, e) {
  var n = t.locationOffset.column - 1,
      i = hp(n) + t.body,
      r = e.line - 1,
      o = t.locationOffset.line - 1,
      a = e.line + o,
      s = 1 === e.line ? n : 0,
      c = e.column + s,
      u = i.split(/\r\n|[\n\r]/g);
  return "".concat(t.name, " (").concat(a, ":").concat(c, ")\n") + function (t) {
    var e = t.filter(function (t) {
      t[0];
      var e = t[1];
      return void 0 !== e;
    }),
        n = 0,
        i = !0,
        r = !1,
        o = void 0;

    try {
      for (var a, s = e[Symbol.iterator](); !(i = (a = s.next()).done); i = !0) {
        var c = a.value,
            u = c[0];
        n = Math.max(n, u.length);
      }
    } catch (t) {
      r = !0, o = t;
    } finally {
      try {
        i || null == s.return || s.return();
      } finally {
        if (r) throw o;
      }
    }

    return e.map(function (t) {
      var e,
          i = t[0],
          r = t[1];
      return hp(n - (e = i).length) + e + r;
    }).join("\n");
  }([["".concat(a - 1, ": "), u[r - 1]], ["".concat(a, ": "), u[r]], ["", hp(c - 1) + "^"], ["".concat(a + 1, ": "), u[r + 1]]]);
}

function hp(t) {
  return Array(t + 1).join(" ");
}

function pp(t) {
  return (pp = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
    return typeof t;
  } : function (t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  })(t);
}

function fp(t, e, n, i, r, o, a) {
  var s = Array.isArray(e) ? 0 !== e.length ? e : void 0 : e ? [e] : void 0,
      c = n;

  if (!c && s) {
    var u = s[0];
    c = u && u.loc && u.loc.source;
  }

  var l,
      d = i;
  !d && s && (d = s.reduce(function (t, e) {
    return e.loc && t.push(e.loc.start), t;
  }, [])), d && 0 === d.length && (d = void 0), i && n ? l = i.map(function (t) {
    return lp(n, t);
  }) : s && (l = s.reduce(function (t, e) {
    return e.loc && t.push(lp(e.loc.source, e.loc.start)), t;
  }, []));
  var h = a;

  if (null == h && null != o) {
    var p = o.extensions;
    null != p && "object" === pp(p) && (h = p);
  }

  Object.defineProperties(this, {
    message: {
      value: t,
      enumerable: !0,
      writable: !0
    },
    locations: {
      value: l || void 0,
      enumerable: Boolean(l)
    },
    path: {
      value: r || void 0,
      enumerable: Boolean(r)
    },
    nodes: {
      value: s || void 0
    },
    source: {
      value: c || void 0
    },
    positions: {
      value: d || void 0
    },
    originalError: {
      value: o
    },
    extensions: {
      value: h || void 0,
      enumerable: Boolean(h)
    }
  }), o && o.stack ? Object.defineProperty(this, "stack", {
    value: o.stack,
    writable: !0,
    configurable: !0
  }) : Error.captureStackTrace ? Error.captureStackTrace(this, fp) : Object.defineProperty(this, "stack", {
    value: Error().stack,
    writable: !0,
    configurable: !0
  });
}

function mp(t, e, n) {
  return new fp("Syntax Error: ".concat(n), void 0, t, [e]);
}

function _p(t) {
  var e = t.split(/\r\n|[\n\r]/g),
      n = function (t) {
    for (var e = null, n = 1; n < t.length; n++) {
      var i = t[n],
          r = gp(i);
      if (r !== i.length && (null === e || r < e) && 0 === (e = r)) break;
    }

    return null === e ? 0 : e;
  }(e);

  if (0 !== n) for (var i = 1; i < e.length; i++) {
    e[i] = e[i].slice(n);
  }

  for (; e.length > 0 && vp(e[0]);) {
    e.shift();
  }

  for (; e.length > 0 && vp(e[e.length - 1]);) {
    e.pop();
  }

  return e.join("\n");
}

function gp(t) {
  for (var e = 0; e < t.length && (" " === t[e] || "\t" === t[e]);) {
    e++;
  }

  return e;
}

function vp(t) {
  return gp(t) === t.length;
}

function yp(t, e) {
  var n = new Tp(Cp.SOF, 0, 0, 0, 0, null);
  return {
    source: t,
    options: e,
    lastToken: n,
    token: n,
    line: 1,
    lineStart: 0,
    advance: bp,
    lookahead: Ep
  };
}

function bp() {
  return this.lastToken = this.token, this.token = this.lookahead();
}

function Ep() {
  var t = this.token;
  if (t.kind !== Cp.EOF) do {
    t = t.next || (t.next = Op(this, t));
  } while (t.kind === Cp.COMMENT);
  return t;
}

cp = up, "function" == typeof Symbol && Symbol.toStringTag && Object.defineProperty(cp.prototype, Symbol.toStringTag, {
  get: function get() {
    return this.constructor.name;
  }
}), fp.prototype = Object.create(Error.prototype, {
  constructor: {
    value: fp
  },
  name: {
    value: "GraphQLError"
  },
  toString: {
    value: function value() {
      return function (t) {
        var e = [];

        if (t.nodes) {
          var n = !0,
              i = !1,
              r = void 0;

          try {
            for (var o, a = t.nodes[Symbol.iterator](); !(n = (o = a.next()).done); n = !0) {
              var s = o.value;
              s.loc && e.push(dp(s.loc.source, lp(s.loc.source, s.loc.start)));
            }
          } catch (t) {
            i = !0, r = t;
          } finally {
            try {
              n || null == a.return || a.return();
            } finally {
              if (i) throw r;
            }
          }
        } else if (t.source && t.locations) {
          var c = t.source,
              u = !0,
              l = !1,
              d = void 0;

          try {
            for (var h, p = t.locations[Symbol.iterator](); !(u = (h = p.next()).done); u = !0) {
              var f = h.value;
              e.push(dp(c, f));
            }
          } catch (t) {
            l = !0, d = t;
          } finally {
            try {
              u || null == p.return || p.return();
            } finally {
              if (l) throw d;
            }
          }
        }

        return 0 === e.length ? t.message : [t.message].concat(e).join("\n\n") + "\n";
      }(this);
    }
  }
});
var Cp = Object.freeze({
  SOF: "<SOF>",
  EOF: "<EOF>",
  BANG: "!",
  DOLLAR: "$",
  AMP: "&",
  PAREN_L: "(",
  PAREN_R: ")",
  SPREAD: "...",
  COLON: ":",
  EQUALS: "=",
  AT: "@",
  BRACKET_L: "[",
  BRACKET_R: "]",
  BRACE_L: "{",
  PIPE: "|",
  BRACE_R: "}",
  NAME: "Name",
  INT: "Int",
  FLOAT: "Float",
  STRING: "String",
  BLOCK_STRING: "BlockString",
  COMMENT: "Comment"
});

function Ap(t) {
  var e = t.value;
  return e ? "".concat(t.kind, ' "').concat(e, '"') : t.kind;
}

function Tp(t, e, n, i, r, o, a) {
  this.kind = t, this.start = e, this.end = n, this.line = i, this.column = r, this.value = a, this.prev = o, this.next = null;
}

function Ip(t) {
  return isNaN(t) ? Cp.EOF : t < 127 ? JSON.stringify(String.fromCharCode(t)) : "\"\\u".concat(("00" + t.toString(16).toUpperCase()).slice(-4), '"');
}

function Op(t, e) {
  var n = t.source,
      i = n.body,
      r = i.length,
      o = function (t, e, n) {
    var i = t.length,
        r = e;

    for (; r < i;) {
      var o = t.charCodeAt(r);
      if (9 === o || 32 === o || 44 === o || 65279 === o) ++r;else if (10 === o) ++r, ++n.line, n.lineStart = r;else {
        if (13 !== o) break;
        10 === t.charCodeAt(r + 1) ? r += 2 : ++r, ++n.line, n.lineStart = r;
      }
    }

    return r;
  }(i, e.end, t),
      a = t.line,
      s = 1 + o - t.lineStart;

  if (o >= r) return new Tp(Cp.EOF, r, r, a, s, e);
  var c = i.charCodeAt(o);

  switch (c) {
    case 33:
      return new Tp(Cp.BANG, o, o + 1, a, s, e);

    case 35:
      return function (t, e, n, i, r) {
        var o,
            a = t.body,
            s = e;

        do {
          o = a.charCodeAt(++s);
        } while (!isNaN(o) && (o > 31 || 9 === o));

        return new Tp(Cp.COMMENT, e, s, n, i, r, a.slice(e + 1, s));
      }(n, o, a, s, e);

    case 36:
      return new Tp(Cp.DOLLAR, o, o + 1, a, s, e);

    case 38:
      return new Tp(Cp.AMP, o, o + 1, a, s, e);

    case 40:
      return new Tp(Cp.PAREN_L, o, o + 1, a, s, e);

    case 41:
      return new Tp(Cp.PAREN_R, o, o + 1, a, s, e);

    case 46:
      if (46 === i.charCodeAt(o + 1) && 46 === i.charCodeAt(o + 2)) return new Tp(Cp.SPREAD, o, o + 3, a, s, e);
      break;

    case 58:
      return new Tp(Cp.COLON, o, o + 1, a, s, e);

    case 61:
      return new Tp(Cp.EQUALS, o, o + 1, a, s, e);

    case 64:
      return new Tp(Cp.AT, o, o + 1, a, s, e);

    case 91:
      return new Tp(Cp.BRACKET_L, o, o + 1, a, s, e);

    case 93:
      return new Tp(Cp.BRACKET_R, o, o + 1, a, s, e);

    case 123:
      return new Tp(Cp.BRACE_L, o, o + 1, a, s, e);

    case 124:
      return new Tp(Cp.PIPE, o, o + 1, a, s, e);

    case 125:
      return new Tp(Cp.BRACE_R, o, o + 1, a, s, e);

    case 65:
    case 66:
    case 67:
    case 68:
    case 69:
    case 70:
    case 71:
    case 72:
    case 73:
    case 74:
    case 75:
    case 76:
    case 77:
    case 78:
    case 79:
    case 80:
    case 81:
    case 82:
    case 83:
    case 84:
    case 85:
    case 86:
    case 87:
    case 88:
    case 89:
    case 90:
    case 95:
    case 97:
    case 98:
    case 99:
    case 100:
    case 101:
    case 102:
    case 103:
    case 104:
    case 105:
    case 106:
    case 107:
    case 108:
    case 109:
    case 110:
    case 111:
    case 112:
    case 113:
    case 114:
    case 115:
    case 116:
    case 117:
    case 118:
    case 119:
    case 120:
    case 121:
    case 122:
      return function (t, e, n, i, r) {
        var o = t.body,
            a = o.length,
            s = e + 1,
            c = 0;

        for (; s !== a && !isNaN(c = o.charCodeAt(s)) && (95 === c || c >= 48 && c <= 57 || c >= 65 && c <= 90 || c >= 97 && c <= 122);) {
          ++s;
        }

        return new Tp(Cp.NAME, e, s, n, i, r, o.slice(e, s));
      }(n, o, a, s, e);

    case 45:
    case 48:
    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57:
      return function (t, e, n, i, r, o) {
        var a = t.body,
            s = n,
            c = e,
            u = !1;
        45 === s && (s = a.charCodeAt(++c));

        if (48 === s) {
          if ((s = a.charCodeAt(++c)) >= 48 && s <= 57) throw mp(t, c, "Invalid number, unexpected digit after 0: ".concat(Ip(s), "."));
        } else c = Sp(t, c, s), s = a.charCodeAt(c);

        46 === s && (u = !0, s = a.charCodeAt(++c), c = Sp(t, c, s), s = a.charCodeAt(c));
        69 !== s && 101 !== s || (u = !0, 43 !== (s = a.charCodeAt(++c)) && 45 !== s || (s = a.charCodeAt(++c)), c = Sp(t, c, s));
        return new Tp(u ? Cp.FLOAT : Cp.INT, e, c, i, r, o, a.slice(e, c));
      }(n, o, c, a, s, e);

    case 34:
      return 34 === i.charCodeAt(o + 1) && 34 === i.charCodeAt(o + 2) ? function (t, e, n, i, r, o) {
        var a = t.body,
            s = e + 3,
            c = s,
            u = 0,
            l = "";

        for (; s < a.length && !isNaN(u = a.charCodeAt(s));) {
          if (34 === u && 34 === a.charCodeAt(s + 1) && 34 === a.charCodeAt(s + 2)) return l += a.slice(c, s), new Tp(Cp.BLOCK_STRING, e, s + 3, n, i, r, _p(l));
          if (u < 32 && 9 !== u && 10 !== u && 13 !== u) throw mp(t, s, "Invalid character within String: ".concat(Ip(u), "."));
          10 === u ? (++s, ++o.line, o.lineStart = s) : 13 === u ? (10 === a.charCodeAt(s + 1) ? s += 2 : ++s, ++o.line, o.lineStart = s) : 92 === u && 34 === a.charCodeAt(s + 1) && 34 === a.charCodeAt(s + 2) && 34 === a.charCodeAt(s + 3) ? (l += a.slice(c, s) + '"""', c = s += 4) : ++s;
        }

        throw mp(t, s, "Unterminated string.");
      }(n, o, a, s, e, t) : function (t, e, n, i, r) {
        var o = t.body,
            a = e + 1,
            s = a,
            c = 0,
            u = "";

        for (; a < o.length && !isNaN(c = o.charCodeAt(a)) && 10 !== c && 13 !== c;) {
          if (34 === c) return u += o.slice(s, a), new Tp(Cp.STRING, e, a + 1, n, i, r, u);
          if (c < 32 && 9 !== c) throw mp(t, a, "Invalid character within String: ".concat(Ip(c), "."));

          if (++a, 92 === c) {
            switch (u += o.slice(s, a - 1), c = o.charCodeAt(a)) {
              case 34:
                u += '"';
                break;

              case 47:
                u += "/";
                break;

              case 92:
                u += "\\";
                break;

              case 98:
                u += "\b";
                break;

              case 102:
                u += "\f";
                break;

              case 110:
                u += "\n";
                break;

              case 114:
                u += "\r";
                break;

              case 116:
                u += "\t";
                break;

              case 117:
                var l = (d = o.charCodeAt(a + 1), h = o.charCodeAt(a + 2), p = o.charCodeAt(a + 3), f = o.charCodeAt(a + 4), wp(d) << 12 | wp(h) << 8 | wp(p) << 4 | wp(f));
                if (l < 0) throw mp(t, a, "Invalid character escape sequence: " + "\\u".concat(o.slice(a + 1, a + 5), "."));
                u += String.fromCharCode(l), a += 4;
                break;

              default:
                throw mp(t, a, "Invalid character escape sequence: \\".concat(String.fromCharCode(c), "."));
            }

            s = ++a;
          }
        }

        var d, h, p, f;
        throw mp(t, a, "Unterminated string.");
      }(n, o, a, s, e);
  }

  throw mp(n, o, function (t) {
    if (t < 32 && 9 !== t && 10 !== t && 13 !== t) return "Cannot contain the invalid character ".concat(Ip(t), ".");
    if (39 === t) return "Unexpected single quote character ('), did you mean to use a double quote (\")?";
    return "Cannot parse the unexpected character ".concat(Ip(t), ".");
  }(c));
}

function Sp(t, e, n) {
  var i = t.body,
      r = e,
      o = n;

  if (o >= 48 && o <= 57) {
    do {
      o = i.charCodeAt(++r);
    } while (o >= 48 && o <= 57);

    return r;
  }

  throw mp(t, r, "Invalid number, expected digit but got: ".concat(Ip(o), "."));
}

function wp(t) {
  return t >= 48 && t <= 57 ? t - 48 : t >= 65 && t <= 70 ? t - 55 : t >= 97 && t <= 102 ? t - 87 : -1;
}

ap(Tp, function () {
  return {
    kind: this.kind,
    value: this.value,
    line: this.line,
    column: this.column
  };
});
var xp = Object.freeze({
  NAME: "Name",
  DOCUMENT: "Document",
  OPERATION_DEFINITION: "OperationDefinition",
  VARIABLE_DEFINITION: "VariableDefinition",
  SELECTION_SET: "SelectionSet",
  FIELD: "Field",
  ARGUMENT: "Argument",
  FRAGMENT_SPREAD: "FragmentSpread",
  INLINE_FRAGMENT: "InlineFragment",
  FRAGMENT_DEFINITION: "FragmentDefinition",
  VARIABLE: "Variable",
  INT: "IntValue",
  FLOAT: "FloatValue",
  STRING: "StringValue",
  BOOLEAN: "BooleanValue",
  NULL: "NullValue",
  ENUM: "EnumValue",
  LIST: "ListValue",
  OBJECT: "ObjectValue",
  OBJECT_FIELD: "ObjectField",
  DIRECTIVE: "Directive",
  NAMED_TYPE: "NamedType",
  LIST_TYPE: "ListType",
  NON_NULL_TYPE: "NonNullType",
  SCHEMA_DEFINITION: "SchemaDefinition",
  OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
  SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
  OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
  FIELD_DEFINITION: "FieldDefinition",
  INPUT_VALUE_DEFINITION: "InputValueDefinition",
  INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
  UNION_TYPE_DEFINITION: "UnionTypeDefinition",
  ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
  ENUM_VALUE_DEFINITION: "EnumValueDefinition",
  INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
  DIRECTIVE_DEFINITION: "DirectiveDefinition",
  SCHEMA_EXTENSION: "SchemaExtension",
  SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
  OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
  INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
  UNION_TYPE_EXTENSION: "UnionTypeExtension",
  ENUM_TYPE_EXTENSION: "EnumTypeExtension",
  INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension"
}),
    Np = Object.freeze({
  QUERY: "QUERY",
  MUTATION: "MUTATION",
  SUBSCRIPTION: "SUBSCRIPTION",
  FIELD: "FIELD",
  FRAGMENT_DEFINITION: "FRAGMENT_DEFINITION",
  FRAGMENT_SPREAD: "FRAGMENT_SPREAD",
  INLINE_FRAGMENT: "INLINE_FRAGMENT",
  VARIABLE_DEFINITION: "VARIABLE_DEFINITION",
  SCHEMA: "SCHEMA",
  SCALAR: "SCALAR",
  OBJECT: "OBJECT",
  FIELD_DEFINITION: "FIELD_DEFINITION",
  ARGUMENT_DEFINITION: "ARGUMENT_DEFINITION",
  INTERFACE: "INTERFACE",
  UNION: "UNION",
  ENUM: "ENUM",
  ENUM_VALUE: "ENUM_VALUE",
  INPUT_OBJECT: "INPUT_OBJECT",
  INPUT_FIELD_DEFINITION: "INPUT_FIELD_DEFINITION"
});

function Rp(t) {
  var e = gf(t, Cp.NAME);
  return {
    kind: xp.NAME,
    value: e.value,
    loc: ff(t, e)
  };
}

function Lp(t) {
  if (_f(t, Cp.NAME)) switch (t.token.value) {
    case "query":
    case "mutation":
    case "subscription":
    case "fragment":
      return Dp(t);

    case "schema":
    case "scalar":
    case "type":
    case "interface":
    case "union":
    case "enum":
    case "input":
    case "directive":
      return Jp(t);

    case "extend":
      return function (t) {
        var e = t.lookahead();
        if (e.kind === Cp.NAME) switch (e.value) {
          case "schema":
            return function (t) {
              var e = t.token;
              yf(t, "extend"), yf(t, "schema");
              var n = Yp(t, !0),
                  i = _f(t, Cp.BRACE_L) ? Af(t, Cp.BRACE_L, nf, Cp.BRACE_R) : [];
              if (0 === n.length && 0 === i.length) throw Ef(t);
              return {
                kind: xp.SCHEMA_EXTENSION,
                directives: n,
                operationTypes: i,
                loc: ff(t, e)
              };
            }(t);

          case "scalar":
            return function (t) {
              var e = t.token;
              yf(t, "extend"), yf(t, "scalar");
              var n = Rp(t),
                  i = Yp(t, !0);
              if (0 === i.length) throw Ef(t);
              return {
                kind: xp.SCALAR_TYPE_EXTENSION,
                name: n,
                directives: i,
                loc: ff(t, e)
              };
            }(t);

          case "type":
            return function (t) {
              var e = t.token;
              yf(t, "extend"), yf(t, "type");
              var n = Rp(t),
                  i = rf(t),
                  r = Yp(t, !0),
                  o = of(t);
              if (0 === i.length && 0 === r.length && 0 === o.length) throw Ef(t);
              return {
                kind: xp.OBJECT_TYPE_EXTENSION,
                name: n,
                interfaces: i,
                directives: r,
                fields: o,
                loc: ff(t, e)
              };
            }(t);

          case "interface":
            return function (t) {
              var e = t.token;
              yf(t, "extend"), yf(t, "interface");
              var n = Rp(t),
                  i = Yp(t, !0),
                  r = of(t);
              if (0 === i.length && 0 === r.length) throw Ef(t);
              return {
                kind: xp.INTERFACE_TYPE_EXTENSION,
                name: n,
                directives: i,
                fields: r,
                loc: ff(t, e)
              };
            }(t);

          case "union":
            return function (t) {
              var e = t.token;
              yf(t, "extend"), yf(t, "union");
              var n = Rp(t),
                  i = Yp(t, !0),
                  r = uf(t);
              if (0 === i.length && 0 === r.length) throw Ef(t);
              return {
                kind: xp.UNION_TYPE_EXTENSION,
                name: n,
                directives: i,
                types: r,
                loc: ff(t, e)
              };
            }(t);

          case "enum":
            return function (t) {
              var e = t.token;
              yf(t, "extend"), yf(t, "enum");
              var n = Rp(t),
                  i = Yp(t, !0),
                  r = lf(t);
              if (0 === i.length && 0 === r.length) throw Ef(t);
              return {
                kind: xp.ENUM_TYPE_EXTENSION,
                name: n,
                directives: i,
                values: r,
                loc: ff(t, e)
              };
            }(t);

          case "input":
            return function (t) {
              var e = t.token;
              yf(t, "extend"), yf(t, "input");
              var n = Rp(t),
                  i = Yp(t, !0),
                  r = hf(t);
              if (0 === i.length && 0 === r.length) throw Ef(t);
              return {
                kind: xp.INPUT_OBJECT_TYPE_EXTENSION,
                name: n,
                directives: i,
                fields: r,
                loc: ff(t, e)
              };
            }(t);
        }
        throw Ef(t, e);
      }(t);
  } else {
    if (_f(t, Cp.BRACE_L)) return Dp(t);
    if (tf(t)) return Jp(t);
  }
  throw Ef(t);
}

function Dp(t) {
  if (_f(t, Cp.NAME)) switch (t.token.value) {
    case "query":
    case "mutation":
    case "subscription":
      return kp(t);

    case "fragment":
      return function (t) {
        var e = t.token;
        if (yf(t, "fragment"), t.options.experimentalFragmentVariables) return {
          kind: xp.FRAGMENT_DEFINITION,
          name: zp(t),
          variableDefinitions: Fp(t),
          typeCondition: (yf(t, "on"), Zp(t)),
          directives: Yp(t, !1),
          selectionSet: Bp(t),
          loc: ff(t, e)
        };
        return {
          kind: xp.FRAGMENT_DEFINITION,
          name: zp(t),
          typeCondition: (yf(t, "on"), Zp(t)),
          directives: Yp(t, !1),
          selectionSet: Bp(t),
          loc: ff(t, e)
        };
      }(t);
  } else if (_f(t, Cp.BRACE_L)) return kp(t);
  throw Ef(t);
}

function kp(t) {
  var e = t.token;
  if (_f(t, Cp.BRACE_L)) return {
    kind: xp.OPERATION_DEFINITION,
    operation: "query",
    name: void 0,
    variableDefinitions: [],
    directives: [],
    selectionSet: Bp(t),
    loc: ff(t, e)
  };
  var n,
      i = Pp(t);
  return _f(t, Cp.NAME) && (n = Rp(t)), {
    kind: xp.OPERATION_DEFINITION,
    operation: i,
    name: n,
    variableDefinitions: Fp(t),
    directives: Yp(t, !1),
    selectionSet: Bp(t),
    loc: ff(t, e)
  };
}

function Pp(t) {
  var e = gf(t, Cp.NAME);

  switch (e.value) {
    case "query":
      return "query";

    case "mutation":
      return "mutation";

    case "subscription":
      return "subscription";
  }

  throw Ef(t, e);
}

function Fp(t) {
  return _f(t, Cp.PAREN_L) ? Af(t, Cp.PAREN_L, Mp, Cp.PAREN_R) : [];
}

function Mp(t) {
  var e = t.token;
  return {
    kind: xp.VARIABLE_DEFINITION,
    variable: Hp(t),
    type: (gf(t, Cp.COLON), Qp(t)),
    defaultValue: vf(t, Cp.EQUALS) ? Kp(t, !0) : void 0,
    directives: Yp(t, !0),
    loc: ff(t, e)
  };
}

function Hp(t) {
  var e = t.token;
  return gf(t, Cp.DOLLAR), {
    kind: xp.VARIABLE,
    name: Rp(t),
    loc: ff(t, e)
  };
}

function Bp(t) {
  var e = t.token;
  return {
    kind: xp.SELECTION_SET,
    selections: Af(t, Cp.BRACE_L, Vp, Cp.BRACE_R),
    loc: ff(t, e)
  };
}

function Vp(t) {
  return _f(t, Cp.SPREAD) ? function (t) {
    var e = t.token;
    gf(t, Cp.SPREAD);
    var n = bf(t, "on");
    if (!n && _f(t, Cp.NAME)) return {
      kind: xp.FRAGMENT_SPREAD,
      name: zp(t),
      directives: Yp(t, !1),
      loc: ff(t, e)
    };
    return {
      kind: xp.INLINE_FRAGMENT,
      typeCondition: n ? Zp(t) : void 0,
      directives: Yp(t, !1),
      selectionSet: Bp(t),
      loc: ff(t, e)
    };
  }(t) : function (t) {
    var e,
        n,
        i = t.token,
        r = Rp(t);
    vf(t, Cp.COLON) ? (e = r, n = Rp(t)) : n = r;
    return {
      kind: xp.FIELD,
      alias: e,
      name: n,
      arguments: jp(t, !1),
      directives: Yp(t, !1),
      selectionSet: _f(t, Cp.BRACE_L) ? Bp(t) : void 0,
      loc: ff(t, i)
    };
  }(t);
}

function jp(t, e) {
  var n = e ? Gp : Up;
  return _f(t, Cp.PAREN_L) ? Af(t, Cp.PAREN_L, n, Cp.PAREN_R) : [];
}

function Up(t) {
  var e = t.token,
      n = Rp(t);
  return gf(t, Cp.COLON), {
    kind: xp.ARGUMENT,
    name: n,
    value: Kp(t, !1),
    loc: ff(t, e)
  };
}

function Gp(t) {
  var e = t.token;
  return {
    kind: xp.ARGUMENT,
    name: Rp(t),
    value: (gf(t, Cp.COLON), Wp(t)),
    loc: ff(t, e)
  };
}

function zp(t) {
  if ("on" === t.token.value) throw Ef(t);
  return Rp(t);
}

function Kp(t, e) {
  var n = t.token;

  switch (n.kind) {
    case Cp.BRACKET_L:
      return function (t, e) {
        var n = t.token,
            i = e ? Wp : Xp;
        return {
          kind: xp.LIST,
          values: Cf(t, Cp.BRACKET_L, i, Cp.BRACKET_R),
          loc: ff(t, n)
        };
      }(t, e);

    case Cp.BRACE_L:
      return function (t, e) {
        var n = t.token;
        return {
          kind: xp.OBJECT,
          fields: Cf(t, Cp.BRACE_L, function () {
            return function (t, e) {
              var n = t.token,
                  i = Rp(t);
              return gf(t, Cp.COLON), {
                kind: xp.OBJECT_FIELD,
                name: i,
                value: Kp(t, e),
                loc: ff(t, n)
              };
            }(t, e);
          }, Cp.BRACE_R),
          loc: ff(t, n)
        };
      }(t, e);

    case Cp.INT:
      return t.advance(), {
        kind: xp.INT,
        value: n.value,
        loc: ff(t, n)
      };

    case Cp.FLOAT:
      return t.advance(), {
        kind: xp.FLOAT,
        value: n.value,
        loc: ff(t, n)
      };

    case Cp.STRING:
    case Cp.BLOCK_STRING:
      return qp(t);

    case Cp.NAME:
      return "true" === n.value || "false" === n.value ? (t.advance(), {
        kind: xp.BOOLEAN,
        value: "true" === n.value,
        loc: ff(t, n)
      }) : "null" === n.value ? (t.advance(), {
        kind: xp.NULL,
        loc: ff(t, n)
      }) : (t.advance(), {
        kind: xp.ENUM,
        value: n.value,
        loc: ff(t, n)
      });

    case Cp.DOLLAR:
      if (!e) return Hp(t);
  }

  throw Ef(t);
}

function qp(t) {
  var e = t.token;
  return t.advance(), {
    kind: xp.STRING,
    value: e.value,
    block: e.kind === Cp.BLOCK_STRING,
    loc: ff(t, e)
  };
}

function Wp(t) {
  return Kp(t, !0);
}

function Xp(t) {
  return Kp(t, !1);
}

function Yp(t, e) {
  for (var n = []; _f(t, Cp.AT);) {
    n.push($p(t, e));
  }

  return n;
}

function $p(t, e) {
  var n = t.token;
  return gf(t, Cp.AT), {
    kind: xp.DIRECTIVE,
    name: Rp(t),
    arguments: jp(t, e),
    loc: ff(t, n)
  };
}

function Qp(t) {
  var e,
      n = t.token;
  return vf(t, Cp.BRACKET_L) ? (e = Qp(t), gf(t, Cp.BRACKET_R), e = {
    kind: xp.LIST_TYPE,
    type: e,
    loc: ff(t, n)
  }) : e = Zp(t), vf(t, Cp.BANG) ? {
    kind: xp.NON_NULL_TYPE,
    type: e,
    loc: ff(t, n)
  } : e;
}

function Zp(t) {
  var e = t.token;
  return {
    kind: xp.NAMED_TYPE,
    name: Rp(t),
    loc: ff(t, e)
  };
}

function Jp(t) {
  var e = tf(t) ? t.lookahead() : t.token;
  if (e.kind === Cp.NAME) switch (e.value) {
    case "schema":
      return function (t) {
        var e = t.token;
        yf(t, "schema");
        var n = Yp(t, !0),
            i = Af(t, Cp.BRACE_L, nf, Cp.BRACE_R);
        return {
          kind: xp.SCHEMA_DEFINITION,
          directives: n,
          operationTypes: i,
          loc: ff(t, e)
        };
      }(t);

    case "scalar":
      return function (t) {
        var e = t.token,
            n = ef(t);
        yf(t, "scalar");
        var i = Rp(t),
            r = Yp(t, !0);
        return {
          kind: xp.SCALAR_TYPE_DEFINITION,
          description: n,
          name: i,
          directives: r,
          loc: ff(t, e)
        };
      }(t);

    case "type":
      return function (t) {
        var e = t.token,
            n = ef(t);
        yf(t, "type");
        var i = Rp(t),
            r = rf(t),
            o = Yp(t, !0),
            a = of(t);
        return {
          kind: xp.OBJECT_TYPE_DEFINITION,
          description: n,
          name: i,
          interfaces: r,
          directives: o,
          fields: a,
          loc: ff(t, e)
        };
      }(t);

    case "interface":
      return function (t) {
        var e = t.token,
            n = ef(t);
        yf(t, "interface");
        var i = Rp(t),
            r = Yp(t, !0),
            o = of(t);
        return {
          kind: xp.INTERFACE_TYPE_DEFINITION,
          description: n,
          name: i,
          directives: r,
          fields: o,
          loc: ff(t, e)
        };
      }(t);

    case "union":
      return function (t) {
        var e = t.token,
            n = ef(t);
        yf(t, "union");
        var i = Rp(t),
            r = Yp(t, !0),
            o = uf(t);
        return {
          kind: xp.UNION_TYPE_DEFINITION,
          description: n,
          name: i,
          directives: r,
          types: o,
          loc: ff(t, e)
        };
      }(t);

    case "enum":
      return function (t) {
        var e = t.token,
            n = ef(t);
        yf(t, "enum");
        var i = Rp(t),
            r = Yp(t, !0),
            o = lf(t);
        return {
          kind: xp.ENUM_TYPE_DEFINITION,
          description: n,
          name: i,
          directives: r,
          values: o,
          loc: ff(t, e)
        };
      }(t);

    case "input":
      return function (t) {
        var e = t.token,
            n = ef(t);
        yf(t, "input");
        var i = Rp(t),
            r = Yp(t, !0),
            o = hf(t);
        return {
          kind: xp.INPUT_OBJECT_TYPE_DEFINITION,
          description: n,
          name: i,
          directives: r,
          fields: o,
          loc: ff(t, e)
        };
      }(t);

    case "directive":
      return function (t) {
        var e = t.token,
            n = ef(t);
        yf(t, "directive"), gf(t, Cp.AT);
        var i = Rp(t),
            r = sf(t);
        yf(t, "on");

        var o = function (t) {
          vf(t, Cp.PIPE);
          var e = [];

          do {
            e.push(pf(t));
          } while (vf(t, Cp.PIPE));

          return e;
        }(t);

        return {
          kind: xp.DIRECTIVE_DEFINITION,
          description: n,
          name: i,
          arguments: r,
          locations: o,
          loc: ff(t, e)
        };
      }(t);
  }
  throw Ef(t, e);
}

function tf(t) {
  return _f(t, Cp.STRING) || _f(t, Cp.BLOCK_STRING);
}

function ef(t) {
  if (tf(t)) return qp(t);
}

function nf(t) {
  var e = t.token,
      n = Pp(t);
  gf(t, Cp.COLON);
  var i = Zp(t);
  return {
    kind: xp.OPERATION_TYPE_DEFINITION,
    operation: n,
    type: i,
    loc: ff(t, e)
  };
}

function rf(t) {
  var e = [];

  if (bf(t, "implements")) {
    vf(t, Cp.AMP);

    do {
      e.push(Zp(t));
    } while (vf(t, Cp.AMP) || t.options.allowLegacySDLImplementsInterfaces && _f(t, Cp.NAME));
  }

  return e;
}

function of(t) {
  return t.options.allowLegacySDLEmptyFields && _f(t, Cp.BRACE_L) && t.lookahead().kind === Cp.BRACE_R ? (t.advance(), t.advance(), []) : _f(t, Cp.BRACE_L) ? Af(t, Cp.BRACE_L, af, Cp.BRACE_R) : [];
}

function af(t) {
  var e = t.token,
      n = ef(t),
      i = Rp(t),
      r = sf(t);
  gf(t, Cp.COLON);
  var o = Qp(t),
      a = Yp(t, !0);
  return {
    kind: xp.FIELD_DEFINITION,
    description: n,
    name: i,
    arguments: r,
    type: o,
    directives: a,
    loc: ff(t, e)
  };
}

function sf(t) {
  return _f(t, Cp.PAREN_L) ? Af(t, Cp.PAREN_L, cf, Cp.PAREN_R) : [];
}

function cf(t) {
  var e = t.token,
      n = ef(t),
      i = Rp(t);
  gf(t, Cp.COLON);
  var r,
      o = Qp(t);
  vf(t, Cp.EQUALS) && (r = Wp(t));
  var a = Yp(t, !0);
  return {
    kind: xp.INPUT_VALUE_DEFINITION,
    description: n,
    name: i,
    type: o,
    defaultValue: r,
    directives: a,
    loc: ff(t, e)
  };
}

function uf(t) {
  var e = [];

  if (vf(t, Cp.EQUALS)) {
    vf(t, Cp.PIPE);

    do {
      e.push(Zp(t));
    } while (vf(t, Cp.PIPE));
  }

  return e;
}

function lf(t) {
  return _f(t, Cp.BRACE_L) ? Af(t, Cp.BRACE_L, df, Cp.BRACE_R) : [];
}

function df(t) {
  var e = t.token,
      n = ef(t),
      i = Rp(t),
      r = Yp(t, !0);
  return {
    kind: xp.ENUM_VALUE_DEFINITION,
    description: n,
    name: i,
    directives: r,
    loc: ff(t, e)
  };
}

function hf(t) {
  return _f(t, Cp.BRACE_L) ? Af(t, Cp.BRACE_L, cf, Cp.BRACE_R) : [];
}

function pf(t) {
  var e = t.token,
      n = Rp(t);
  if (void 0 !== Np[n.value]) return n;
  throw Ef(t, e);
}

function ff(t, e) {
  if (!t.options.noLocation) return new mf(e, t.lastToken, t.source);
}

function mf(t, e, n) {
  this.start = t.start, this.end = e.end, this.startToken = t, this.endToken = e, this.source = n;
}

function _f(t, e) {
  return t.token.kind === e;
}

function gf(t, e) {
  var n = t.token;
  if (n.kind === e) return t.advance(), n;
  throw mp(t.source, n.start, "Expected ".concat(e, ", found ").concat(Ap(n)));
}

function vf(t, e) {
  var n = t.token;
  if (n.kind === e) return t.advance(), n;
}

function yf(t, e) {
  var n = t.token;
  if (n.kind === Cp.NAME && n.value === e) return t.advance(), n;
  throw mp(t.source, n.start, 'Expected "'.concat(e, '", found ').concat(Ap(n)));
}

function bf(t, e) {
  var n = t.token;
  if (n.kind === Cp.NAME && n.value === e) return t.advance(), n;
}

function Ef(t, e) {
  var n = e || t.token;
  return mp(t.source, n.start, "Unexpected ".concat(Ap(n)));
}

function Cf(t, e, n, i) {
  gf(t, e);

  for (var r = []; !vf(t, i);) {
    r.push(n(t));
  }

  return r;
}

function Af(t, e, n, i) {
  gf(t, e);

  for (var r = [n(t)]; !vf(t, i);) {
    r.push(n(t));
  }

  return r;
}

ap(mf, function () {
  return {
    start: this.start,
    end: this.end
  };
});
var Tf,
    If = ((Tf = Object.freeze({
  parse: function parse(t, e) {
    var n = "string" == typeof t ? new up(t) : t;
    if (!(n instanceof up)) throw new TypeError("Must provide Source. Received: ".concat(op(n, [])));
    return function (t) {
      var e = t.token;
      return {
        kind: xp.DOCUMENT,
        definitions: Af(t, Cp.SOF, Lp, Cp.EOF),
        loc: ff(t, e)
      };
    }(yp(n, e || {}));
  },
  parseValue: function parseValue(t, e) {
    var n = yp("string" == typeof t ? new up(t) : t, e || {});
    gf(n, Cp.SOF);
    var i = Kp(n, !1);
    return gf(n, Cp.EOF), i;
  },
  parseType: function parseType(t, e) {
    var n = yp("string" == typeof t ? new up(t) : t, e || {});
    gf(n, Cp.SOF);
    var i = Qp(n);
    return gf(n, Cp.EOF), i;
  },
  parseConstValue: Wp,
  parseTypeReference: Qp,
  parseNamedType: Zp
})) && Tf.default || Tf).parse;

function Of(t) {
  return t.replace(/[\s,]+/g, " ").trim();
}

var Sf = {},
    wf = {};

function xf(t) {
  return Of(t.source.body.substring(t.start, t.end));
}

var Nf = !0;
var Rf = !1;

function Lf(t) {
  var e = Of(t);
  if (Sf[e]) return Sf[e];
  var n = If(t, {
    experimentalFragmentVariables: Rf
  });
  if (!n || "Document" !== n.kind) throw new Error("Not a valid GraphQL document.");
  return n = function t(e, n) {
    var i = Object.prototype.toString.call(e);
    if ("[object Array]" === i) return e.map(function (e) {
      return t(e, n);
    });
    if ("[object Object]" !== i) throw new Error("Unexpected input.");
    n && e.loc && delete e.loc, e.loc && (delete e.loc.startToken, delete e.loc.endToken);
    var r,
        o,
        a,
        s = Object.keys(e);

    for (r in s) {
      s.hasOwnProperty(r) && (o = e[s[r]], "[object Object]" !== (a = Object.prototype.toString.call(o)) && "[object Array]" !== a || (e[s[r]] = t(o, !0)));
    }

    return e;
  }(n = function (t) {
    for (var e = {}, n = [], i = 0; i < t.definitions.length; i++) {
      var r = t.definitions[i];

      if ("FragmentDefinition" === r.kind) {
        var o = r.name.value,
            a = xf(r.loc);
        wf.hasOwnProperty(o) && !wf[o][a] ? (Nf && console.warn("Warning: fragment with name " + o + " already exists.\ngraphql-tag enforces all fragment names across your application to be unique; read more about\nthis in the docs: http://dev.apollodata.com/core/fragments.html#unique-names"), wf[o][a] = !0) : wf.hasOwnProperty(o) || (wf[o] = {}, wf[o][a] = !0), e[a] || (e[a] = !0, n.push(r));
      } else n.push(r);
    }

    return t.definitions = n, t;
  }(n), !1), Sf[e] = n, n;
}

function Df() {
  for (var t = Array.prototype.slice.call(arguments), e = t[0], n = "string" == typeof e ? e : e[0], i = 1; i < t.length; i++) {
    t[i] && t[i].kind && "Document" === t[i].kind ? n += t[i].loc.source.body : n += t[i], n += e[i];
  }

  return Lf(n);
}

Df.default = Df, Df.resetCaches = function () {
  Sf = {}, wf = {};
}, Df.disableFragmentWarnings = function () {
  Nf = !1;
}, Df.enableExperimentalFragmentVariables = function () {
  Rf = !0;
}, Df.disableExperimentalFragmentVariables = function () {
  Rf = !1;
};

var kf = Df(_templateObject()),
    Pf = function Pf(t, e) {
  return e.query({
    query: kf,
    variables: {
      args: {
        id: t
      }
    }
  }).then(function (t) {
    return t && t.data && t.data.lang && t.data.lang.models ? t.data.lang.models.map(function (t) {
      return {
        id: t.id,
        type: t.type,
        data: t.data,
        diagram: t.diagram
      };
    }) : [];
  });
},
    Ff = Df(_templateObject2()),
    Mf = Df(_templateObject3()),
    Hf = Df(_templateObject4()),
    Bf = {
  LangInfo: {
    text: function text(t, e, n, i) {
      return console.error("langResolver.text", t), t.name;
    }
  }
},
    Vf = function Vf(t, e) {
  var n = e ? "network-only" : "cache-only";
  return t.query({
    query: Ff,
    variables: {},
    fetchPolicy: n
  }).then(function (t) {
    return t && t.data && t.data.langs && t.data.langs.langs ? t.data.langs.langs : [];
  });
},
    jf = b("designerService");

var Uf;

function Gf(t) {
  return t && void 0 !== t.category;
}

!function (t) {
  t[t.Organization = 0] = "Organization";
}(Uf || (Uf = {}));
var zf = new E("catSel", !1),
    Kf = new E("mixedSel", !1);
var qf = j;

function Wf(t, e) {
  var n = function (t) {
    var e = u();
    return l(function () {
      e.current = t;
    }), e.current;
  }(t),
      i = vh(n, t);

  console.log(e, {
    prev: n,
    current: t,
    shallowEqualExplanation: i
  });
}

var Xf = b("monitorService"),
    Yf = new E("heaveTask", !1),
    $f = new E("task", !1);

var Qf =
/*#__PURE__*/
function () {
  function Qf(t) {
    var _this54 = this;

    _classCallCheck(this, Qf);

    this.notificationService = t, this._onDidStateChange = new A(), this._onStateChangeObservable = new V(function (t) {
      t.next(_this54.state);

      var e = _this54._onDidStateChange.event(function () {
        t.next(_this54.state);
      });

      return function () {
        e.dispose();
      };
    }), this.currentTask = Promise.resolve(), this._currentTaskState = !1;
  }

  _createClass(Qf, [{
    key: "observeStateChanges",
    value: function observeStateChanges(t) {
      return this._onStateChangeObservable.subscribe(t);
    }
  }, {
    key: "runBatch",
    value: function runBatch(t, e, n) {
      return Kt(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _this55 = this;

        var i;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                i = "Batch of '".concat(n, "'");
                return _context3.abrupt("return", this.runHeavyTask(function () {
                  return Kt(_this55, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee2() {
                    var n, _i20, _r7, _o5;

                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            n = this.notificationService.notify({
                              body: "Running '".concat(i, "'."),
                              severity: T.Info,
                              handle: !0,
                              sticky: !0
                            });
                            n.progress.total(e.length);
                            _i20 = 0;

                          case 3:
                            if (!(_i20 < e.length)) {
                              _context2.next = 16;
                              break;
                            }

                            _r7 = e[_i20];
                            n.progress.worked(_i20);
                            _context2.next = 8;
                            return this.runTask({
                              asyncTask: t(_r7)
                            });

                          case 8:
                            _o5 = _context2.sent;
                            _context2.t0 = _o5 instanceof Promise;

                            if (!_context2.t0) {
                              _context2.next = 13;
                              break;
                            }

                            _context2.next = 13;
                            return _o5;

                          case 13:
                            _i20++;
                            _context2.next = 3;
                            break;

                          case 16:
                            n.progress.done(), console.log("Batch completed:", i), setTimeout(function () {
                              n.close();
                            }, 500);

                          case 17:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, this);
                  }));
                }, "Batch of '".concat(n, "'")));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "runHeavyTask",
    value: function runHeavyTask(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "notifyOnly";
      return Kt(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var _this56 = this;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.runningHeavyTask ? (this.notificationService.notify({
                  message: "Unable to run heavy task: Task '".concat(this.runningHeavyTask, "' is still running."),
                  severity: T.Info
                }), Promise.resolve(void 0)) : (this.runningHeavyTask = e, this._onDidStateChange.fire(), this.runTask({
                  asyncTask: t,
                  onError: n
                }).finally(function () {
                  _this56.runningHeavyTask = void 0, _this56._onDidStateChange.fire();
                })));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "handleAsyncTaskError",
    value: function handleAsyncTaskError(t, e, n, i) {
      if (("ignoreHandled" !== n || !i) && ("notifyOnly" === n && this.notificationService.notify({
        message: t,
        severity: T.Error
      }), "logOnly" !== n && "throwAndLog" !== n || this.notificationService.error(t), e || "throwOnly" === n || "throwAndLog" === n)) return t;
    }
  }, {
    key: "queueDependentTask",
    value: function queueDependentTask(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ignore";
      return Kt(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.queueTask(t, e, "throwOnly"));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "SetCurrentTaskState",
    value: function SetCurrentTaskState(t) {
      this._currentTaskState !== t ? (this._currentTaskState = t, this._onDidStateChange.fire()) : console.log("SetCurrentTaskState ignored", t);
    }
  }, {
    key: "SetCurrentTask",
    value: function SetCurrentTask(t) {
      var _this57 = this;

      var e;
      this._currentTaskObserver && this._currentTaskObserver.unsubscribe(), this.currentTask = t, this.SetCurrentTaskState(!0), this._currentTaskObserver = (e = t, new qf(function (t) {
        var n = !0;
        return e.then(function (e) {
          n && t.next(e), t.complete();
        }).catch(function (e) {
          return t.error(e);
        }), function () {
          return n = !1;
        };
      })).subscribe(function () {
        _this57.SetCurrentTaskState(!1);
      });
    }
  }, {
    key: "queueTask",
    value: function queueTask(t) {
      var _this58 = this;

      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "notifyOnly";
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "ignoreHandled";
      return this.runTask({
        asyncTask: t,
        onError: e,
        onErrorPrevious: n,
        queue: this.currentTask,
        queueSetter: function queueSetter(t) {
          _this58.SetCurrentTask(t);
        }
      });
    }
  }, {
    key: "runTask",
    value: function runTask(_ref) {
      var t = _ref.asyncTask,
          _ref$onError = _ref.onError,
          e = _ref$onError === void 0 ? "notifyOnly" : _ref$onError,
          _ref$onErrorPrevious = _ref.onErrorPrevious,
          n = _ref$onErrorPrevious === void 0 ? "ignoreHandled" : _ref$onErrorPrevious,
          i = _ref.queue,
          r = _ref.queueSetter;
      return Kt(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var _this59 = this;

        var o;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                o = i || Promise.resolve();
                return _context6.abrupt("return", (o = o.then(function (i) {
                  if (i) {
                    var _i21 = _slicedToArray(i, 2),
                        _t34 = _i21[0],
                        _r8 = _i21[1];

                    if (_t34 && _this59.handleAsyncTaskError(_t34, !0, n, _r8)) {
                      return [_t34, !_this59.handleAsyncTaskError(_t34, !1, e)];
                    }
                  }

                  return t().catch(function (t) {
                    return [t, !_this59.handleAsyncTaskError(t, !1, e)];
                  });
                }), r && r(o), o.then(function (t) {
                  if (!(Array.isArray(t) && 2 === t.length && t[0] instanceof Error)) return t;
                  {
                    var _t35 = _slicedToArray(t, 2),
                        _e9 = _t35[0],
                        _n8 = _t35[1];

                    if (_e9 instanceof Error && !_n8) throw _e9;
                  }
                })));

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
    }
  }, {
    key: "state",
    get: function get() {
      return {
        heavyTask: !!this.runningHeavyTask,
        task: this._currentTaskState
      };
    }
  }]);

  return Qf;
}();

Qf = Gt([zt(0, C)], Qf);

var Zf =
/*#__PURE__*/
function () {
  function Zf(t, e) {
    _classCallCheck(this, Zf);

    this.type = t, this.name = e, this.category = !0, this.id = "org_".concat(e);
  }

  _createClass(Zf, [{
    key: "loaded",
    get: function get() {
      return !!this.children;
    }
  }]);

  return Zf;
}();

var Jf = function Jf(t, e) {
  return new Zf(t, e);
};

var tm =
/*#__PURE__*/
function (_ref2) {
  _inherits(tm, _ref2);

  function tm(t, e, n) {
    var _this60;

    _classCallCheck(this, tm);

    _this60 = _possibleConstructorReturn(this, _getPrototypeOf(tm).call(this, new qh(), t, e, n)), t.client.addResolvers(Bf), console.log("LanguageDesignerService.created");

    var i = _assertThisInitialized(_this60);

    _this60.disposables.push(I({
      id: "NEW_FILE_COMMAND_ID",
      title: {
        value: "New Language",
        original: "New Language"
      },
      handler: function handler(t) {
        i.newDocument();
      },
      menu: {
        menuId: 11,
        when: O.and(Kf.toNegated(), zf),
        group: "file"
      },
      keybinding: {
        keys: {
          primary: 2092
        },
        when: zf
      }
    })), _this60.disposables.push(I({
      id: "Delete_FILE_COMMAND_ID",
      title: {
        value: "Delete Language",
        original: "Delete Language"
      },
      handler: function handler(t, e) {
        var _this61 = this;

        var n = "?";
        var r = i.explorerView.getSelection();
        console.log(e, i.explorerView.getSelection());
        var o = [];

        if (r.length > 1) {
          if (!e || r.includes(e)) {
            var _t36 = void 0;

            n = "all ".concat((o = r.reduce(function (e, n) {
              if (Gf(n)) {
                if (!1 === _t36) return [];
                n.loaded && e.push.apply(e, _toConsumableArray(n.children)), _t36 = !0;
              } else {
                if (_t36) return [];
                e.push(n), _t36 = !1;
              }

              return e;
            }, [])).length, " selected models");
          }
        } else e || 1 !== r.length || (e = r[0]);

        if (e && 0 === o.length) if (Gf(e)) {
          var _o6;

          if (!e.loaded) return;
          (_o6 = o).push.apply(_o6, _toConsumableArray(e.children)), n = "all ".concat(o.length, " models of '").concat(e.name, "'");
        } else o.push(e), n = "model '".concat(e.name, "'");
        o.length > 0 && i.notificationService.confirm("delete", "Are you positive?", "Delete ".concat(n, " !"), {
          label: "yes",
          run: function run() {
            return Kt(_this61, void 0, void 0,
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee7() {
              return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) {
                  switch (_context7.prev = _context7.next) {
                    case 0:
                      if (!(1 === o.length)) {
                        _context7.next = 5;
                        break;
                      }

                      _context7.next = 3;
                      return i.deleteDocument(o[0]);

                    case 3:
                      _context7.next = 7;
                      break;

                    case 5:
                      _context7.next = 7;
                      return i.taskMonitorService.runBatch(function (t) {
                        return function () {
                          return i.deleteDocument(t);
                        };
                      }, o, "Delete models");

                    case 7:
                      i.onRefresh();

                    case 8:
                    case "end":
                      return _context7.stop();
                  }
                }
              }, _callee7);
            }));
          }
        });
      },
      menu: {
        menuId: 11,
        when: Kf.toNegated(),
        group: "file"
      },
      keybinding: {
        keys: {
          primary: 20
        },
        when: S
      }
    })), _this60.disposables.push(I({
      id: "SayHi_TEST_COMMAND_ID",
      title: {
        value: "Say hi",
        original: "Say hi"
      },
      handler: function handler() {
        i.notificationService.notify({
          body: "Hello awesome ! (@:".concat(Date.now(), ")")
        });
      },
      menu: {
        menuId: 11,
        group: "test"
      },
      keybinding: {
        keys: {
          primary: 1093
        },
        when: S
      }
    })), _this60.disposables.push(I({
      id: "SayHiSticky_TEST_COMMAND_ID",
      title: {
        value: "Say hi (sticky)",
        original: "Say hi (sticky)"
      },
      handler: function handler() {
        i.notificationService.notify({
          body: "Hello awesome ! (@:".concat(Date.now(), ")"),
          severity: T.Info,
          title: "Greeting",
          sticky: !0
        });
      },
      menu: {
        menuId: 11,
        group: "test"
      }
    })), _this60.disposables.push(I({
      id: "HeavyTask_TEST_COMMAND_ID",
      title: {
        value: "Heavy work",
        original: "Heavy work"
      },
      precondition: Yf.toNegated(),
      handler: function handler(t, e) {
        var _this62 = this;

        var n = function n(t) {
          return function () {
            return Kt(_this62, void 0, void 0,
            /*#__PURE__*/
            _regeneratorRuntime.mark(function _callee8() {
              var e;
              return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                while (1) {
                  switch (_context8.prev = _context8.next) {
                    case 0:
                      console.log("Doin' heavy duty for: ", t);
                      _context8.next = 3;
                      return e = 5e3, new Promise(function (t, n) {
                        setTimeout(function () {
                          t();
                        }, e);
                      });

                    case 3:
                      return _context8.abrupt("return", 5e3);

                    case 4:
                    case "end":
                      return _context8.stop();
                  }
                }
              }, _callee8);
            }));
          };
        },
            r = i.explorerView.getSelection();

        e && !r.includes(e) && r.push(e), 1 === r.length ? i.taskMonitorService.runHeavyTask(n(r[0].name), "HeavyTask").then(function (t) {
          console.log("HeavyTask.completed after ".concat(t || 0, "ms"));
        }) : r.length > 0 && i.taskMonitorService.runBatch(function (t) {
          return n(t.name);
        }, r, "HeavyTask").then(function (t) {
          console.log("HeavyTask.completed (Batch)");
        });
      },
      menu: {
        menuId: 11,
        group: "test",
        when: S
      },
      keybinding: {
        keys: {
          primary: 1094
        }
      }
    }));
    return _this60;
  }

  _createClass(tm, [{
    key: "newDocument",
    value: function newDocument() {
      var _this63 = this;

      var t = this.taskMonitorService.queueTask(function () {
        return function (t, e) {
          return t.mutate({
            mutation: Mf,
            variables: {
              args: Object.assign({}, e, {
                noSession: !0
              })
            }
          }).then(function (t) {
            if (t && t.data && t.data.createLang) return t.data.createLang;
            throw new Error("createLangMutation: " + t);
          });
        }(_this63.apolloService.client, {
          name: "newLanguage1"
        });
      }).then(function (t) {
        return console.log("newLang created", t), t;
      }),
          e = this._rootNodes.get("org_core"),
          n = function n() {
        return Kt(_this63, void 0, void 0,
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee9() {
          var e;
          return _regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  e = this.apolloService.client.readQuery({
                    query: Ff
                  });
                  _context9.t0 = [];
                  _context9.t1 = _toConsumableArray(e.langs.langs);
                  _context9.next = 5;
                  return t;

                case 5:
                  _context9.t2 = _context9.sent;
                  _context9.t3 = [_context9.t2];
                  e.langs.langs = _context9.t0.concat.call(_context9.t0, _context9.t1, _context9.t3);
                  this.apolloService.client.writeQuery({
                    query: Ff,
                    data: e
                  });
                  console.log("addedToCache", e);

                case 10:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9, this);
        }));
      };

      e.loaded ? this.taskMonitorService.queueDependentTask(n) : this.taskMonitorService.queueDependentTask(function () {
        return Vf(_this63.apolloService.client, !0);
      }).then(function (t) {
        e.children = t || [], console.log("parent.loaded");
      }), this.onAddNew({
        newItem: t,
        parent: e
      });
    }
  }, {
    key: "refresh",
    value: function refresh() {
      return Kt(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        var _this64 = this;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", this.taskMonitorService.queueTask(function () {
                  return Vf(_this64.apolloService.client, !0);
                }).then(function () {
                  return _this64.onRefresh();
                }));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "deleteDocument",
    value: function deleteDocument(t) {
      return Kt(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12() {
        var _this65 = this;

        var e;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                e = function e() {
                  return Kt(_this65, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee11() {
                    var e;
                    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
                      while (1) {
                        switch (_context11.prev = _context11.next) {
                          case 0:
                            e = this.apolloService.client.readQuery({
                              query: Ff
                            });
                            e.langs.langs = e.langs.langs.filter(function (e) {
                              return e.id !== t.id;
                            }), this.apolloService.client.writeQuery({
                              query: Ff,
                              data: e
                            });

                          case 2:
                          case "end":
                            return _context11.stop();
                        }
                      }
                    }, _callee11, this);
                  }));
                };

                return _context12.abrupt("return", this.taskMonitorService.queueTask(function () {
                  return function (t, e) {
                    return t.mutate({
                      mutation: Hf,
                      variables: {
                        args: Object.assign({}, e, {
                          noSession: !0,
                          physical: !0
                        })
                      }
                    });
                  }(_this65.apolloService.client, {
                    id: t.id,
                    cid: t.cid
                  }).then(e);
                }));

              case 2:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));
    }
  }]);

  return tm;
}(
/*#__PURE__*/
function () {
  function _class(t, e, n, i) {
    _classCallCheck(this, _class);

    this.domainModel = t, this.apolloService = e, this.notificationService = n, this.taskMonitorService = i, this._rootNodes = new Map(), this.disposables = [], this._onDidAddNew = new A(), this._onDidRefresh = new A(), t.setDesigner(this);
  }

  _createClass(_class, [{
    key: "loadDocument",
    value: function loadDocument(t) {
      return Kt(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee13() {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.abrupt("return", Pf(t.id, this.apolloService.client).then(function (t) {
                  console.error("models", t);
                }));

              case 1:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));
    }
  }, {
    key: "newDocument",
    value: function newDocument() {}
  }, {
    key: "refresh",
    value: function refresh() {}
  }, {
    key: "registerRootNode",
    value: function registerRootNode(t, e) {
      var n = Jf(t, e);

      this._rootNodes.set(n.id, n);
    }
  }, {
    key: "onAddNew",
    value: function onAddNew(t) {
      this._explorerView && this._explorerView.refreshAndFocusNode(t.newItem, t.parent), this._onDidAddNew.fire(t);
    }
  }, {
    key: "onRefresh",
    value: function onRefresh() {
      this._explorerView && this._explorerView.updateChildren(), this._onDidRefresh.fire({});
    }
  }, {
    key: "registerExplorerView",
    value: function registerExplorerView(t) {
      if (this._explorerView) throw new Error("ExplorerView can only be registered once.");
      this._explorerView = t;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      w(this.disposables);
    }
  }, {
    key: "onDidAddNew",
    get: function get() {
      return this._onDidAddNew.event;
    }
  }, {
    key: "onDidRefresh",
    get: function get() {
      return this._onDidRefresh.event;
    }
  }, {
    key: "explorerView",
    get: function get() {
      return this._explorerView;
    }
  }, {
    key: "rootNodes",
    get: function get() {
      return Array.from(this._rootNodes.values());
    }
  }]);

  return _class;
}());

tm = Gt([zt(0, Jh), zt(1, C), zt(2, Xf)], tm);
var em = b("editorService");
var nm;
!function (t) {
  t[t.LanguageDesigner = 0] = "LanguageDesigner";
}(nm || (nm = {}));

var im =
/*#__PURE__*/
function () {
  function im(t, e, n, i) {
    _classCallCheck(this, im);

    this.designerType = t, this._workbenchVSCode = e, this.designerService = n, this._instantiationService = i, this._disposables = [], console.log("EditorService.created", t, n.domainModel), this._disposables.push(this.designerService);
  }

  _createClass(im, [{
    key: "initExplorerView",
    value: function initExplorerView(t, e, n) {
      return void 0 === this._treeView && (this._treeView = this._workbenchVSCode.createTree(t, e, this._instantiationService, n, {
        _serviceBrand: null,
        getTextLabel: function getTextLabel(t) {
          return t.name;
        }
      }), this._disposables.push(this._treeView), this.designerService.registerExplorerView(this._treeView)), this._treeView;
    }
  }, {
    key: "invokeFunction",
    value: function invokeFunction(t) {
      return this._instantiationService.invokeFunction(t);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      w(this._disposables);
    }
  }]);

  return im;
}();

im = Gt([zt(2, jf), zt(3, x)], im);

var rm =
/*#__PURE__*/
function (_R) {
  _inherits(rm, _R);

  function rm(t, e) {
    var _this66;

    _classCallCheck(this, rm);

    _this66 = _possibleConstructorReturn(this, _getPrototypeOf(rm).call(this, t)), _this66.taskMonitorService = e, _this66._HeavyTaskContextKey = Yf.bindTo(_assertThisInitialized(_this66)), _this66._TaskContextKey = $f.bindTo(_assertThisInitialized(_this66));
    var n = e.observeStateChanges(function (t) {
      _this66._HeavyTaskContextKey.set(!!t.heavyTask), _this66._TaskContextKey.set(!!t.task);
    });

    _this66._toDispose.push({
      dispose: function dispose() {
        return n.unsubscribe();
      }
    });

    return _this66;
  }

  return rm;
}(R);

rm = Gt([zt(0, N), zt(1, Xf)], rm);

var om =
/*#__PURE__*/
function () {
  function om(t, e) {
    _classCallCheck(this, om);

    this.node = e, this._disposables = [], this._apolloService = new tp(t);
    this._vscodeWB = L(e, {}), this._vscodeWB.registerService(Jh, this._apolloService), this._vscodeWB.registerService(Xf, Qf), this._disposables.push(this._vscodeWB);
  }

  _createClass(om, [{
    key: "registerService",
    value: function registerService(t, e) {
      this._vscodeWB.registerService(t, e);
    }
  }, {
    key: "createEditorService",
    value: function createEditorService(t) {
      var e;
      if (t !== nm.LanguageDesigner) throw "Unsupported Designer Type: " + t;
      {
        var _n9 = new D();

        _n9.set(k, new P(rm)), _n9.set(F, new P(M, [this.node]));

        var _i22 = this._vscodeWB.InstantiationService.createChild(_n9),
            _r9 = _i22.createInstance(tm);

        _n9.set(jf, _r9), e = _i22.createInstance(im, t, this._vscodeWB), _n9.set(em, e);
      }
      return e;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      w(this._disposables);
    }
  }]);

  return om;
}();

var am = e({});

function sm(t) {
  t.contextType = am;
}

am.displayName = "WorkbenchContext";

var cm =
/*#__PURE__*/
function () {
  function cm(t) {
    _classCallCheck(this, cm);

    this.editorService = t;
  }

  _createClass(cm, [{
    key: "initialize",
    value: function initialize(t, e) {
      this._lib = t, this._editor = e, console.log("EditorContext.initialize");
    }
  }, {
    key: "editorUI",
    set: function set(t) {
      this._editorUI = t;
    },
    get: function get() {
      return this._editorUI;
    }
  }, {
    key: "isInitialized",
    get: function get() {
      return void 0 !== this._lib && !!this.mxDiagramRef && !!this.mxDiagramRef.current && !!this._editorUI;
    }
  }, {
    key: "mxMenubarRef",
    set: function set(t) {
      this._mxMenubarRef = t;
    },
    get: function get() {
      return this._mxMenubarRef;
    }
  }, {
    key: "lib",
    get: function get() {
      return this._lib;
    }
  }, {
    key: "editor",
    get: function get() {
      return this._editor;
    }
  }, {
    key: "graph",
    get: function get() {
      return this.editor && this.editor.graph;
    }
  }, {
    key: "mx",
    get: function get() {
      return this.lib && this.lib.mx;
    }
  }]);

  return cm;
}();

var um = e({});
um.displayName = "EditorContext";

var lm =
/*#__PURE__*/
function (_i23) {
  _inherits(lm, _i23);

  function lm() {
    _classCallCheck(this, lm);

    return _possibleConstructorReturn(this, _getPrototypeOf(lm).apply(this, arguments));
  }

  _createClass(lm, [{
    key: "render",
    value: function render() {
      var _this67 = this;

      return console.log("GraphEditor.Render"), n(Jo.Consumer, null, function (t) {
        return n(am.Consumer, null, function (e) {
          return n(dm, Object.assign({}, Object.assign({}, _this67.props, {
            graph: t,
            workbench: e
          })));
        });
      });
    }
  }]);

  return lm;
}(i);

var dm =
/*#__PURE__*/
function (_i24) {
  _inherits(dm, _i24);

  function dm(t) {
    var _this68;

    _classCallCheck(this, dm);

    _this68 = _possibleConstructorReturn(this, _getPrototypeOf(dm).call(this, t)), _this68.ContainerRef = c();

    var e = _this68.props.workbench.workbench.createEditorService(nm.LanguageDesigner);

    _this68._editorContext = new cm(e);
    return _this68;
  }

  _createClass(dm, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._editorContext && this._editorContext.editorService && this._editorContext.editorService.dispose();
    }
  }, {
    key: "initDslContext",
    value: function initDslContext() {
      if (!this._editorContext.isInitialized) {
        var _t37 = this.props.graph,
            _e10 = this._editorContext.editorService.designerService;

        if (_t37) {
          var _n10 = new v(!1, null, null, null, !0, _t37.mx);

          _t37.registerLayoutManager(_n10.graph, _e10.domainModel, _t37.mx), _t37.fixDecoder(), _t37.fixSelectionModel(), _t37.fixDynamicTextAlign(), this._editorContext.initialize(_t37, _n10);
        }
      }
    }
  }, {
    key: "handleGraphSettings",
    value: function handleGraphSettings(t, e, n) {
      var i = t.mx;
      e.expandedIcon && (i.mxGraph.prototype.expandedImage = new i.mxImage(e.expandedIcon, 20, 20)), e.collapsedIcon && (i.mxGraph.prototype.collapsedImage = new i.mxImage(e.collapsedIcon, 20, 20)), e.selectionStrokeWidth && (i.mxConstants.VERTEX_SELECTION_STROKEWIDTH = e.selectionStrokeWidth), e.onConfigure && e.onConfigure(n);
    }
  }, {
    key: "loadDocument",
    value: function loadDocument(t) {
      return Kt(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee14() {
        var _this69 = this;

        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                this._editorContext.loading = !0, this.forceUpdate(), this._editorContext.editorService.designerService.loadDocument(t).catch(function (t) {
                  console.error("loadDocument", t);
                }).finally(function () {
                  _this69._editorContext.loading = !1, _this69.forceUpdate();
                });

              case 1:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));
    }
  }, {
    key: "newDocument",
    value: function newDocument() {
      return Kt(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee15() {
        var t;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                t = this._editorContext.editorService.designerService.newDocument();
                console.warn(t);

              case 2:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(t) {
      var e = this.props,
          n = vh(t, e);
      console.log("GraphEditor.componentDidUpdate", {
        prevProps: t,
        currentProps: e,
        shallowEqualExplanation: n
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props8 = this.props,
          t = _this$props8.onInit,
          e = _this$props8.graphSettings;
      this.initDslContext();
      var _this$_editorContext = this._editorContext,
          n = _this$_editorContext.lib,
          i = _this$_editorContext.editor,
          r = _this$_editorContext.mx;
      if (!r) return;
      var o = e && e.resources ? e.resources : "",
          a = e && e.styles ? e.styles : "",
          s = this.ContainerRef.current,
          _this$_editorContext2 = this._editorContext,
          c = _this$_editorContext2.mxMenubarRef,
          u = _this$_editorContext2.mxToolbarRef,
          l = _this$_editorContext2.mxDiagramRef,
          d = this._editorContext,
          h = l.current;
      if (!h) return;
      var p = this;
      n.mxUtils.getAll([o, a], function (o) {
        n.mxResources.parse(o[0].getText()), new Object().default = o[1].getDocumentElement();
        var a = new y(i, s, h, u && u.current, c && c.current, null);
        a.setScrollbars(!0);
        var l = a.editor.graph;
        e && p.handleGraphSettings(n, e, l), d.editorService.designerService.domainModel.init(l, r), n.alignFoldingHandleRight(), d.editorUI = a, t && t(a, r, d.editorService.designerService), p.forceUpdate();
      }, function () {
        document.body.innerHTML = '<center style="margin-top:10%;">Error loading resource files. Please check browser console.</center>';
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props9 = this.props,
          t = _this$props9.children,
          e = _this$props9.style;
      return console.log("GraphEditor.Render inititalized:", this._editorContext.isInitialized, this._editorContext.loading), n("div", {
        ref: this.ContainerRef,
        className: "mdc-menu-surface--anchor",
        style: {
          width: "100%",
          height: "100%"
        }
      }, n(um.Provider, {
        value: {
          editorContext: this._editorContext
        }
      }, this.props.children));
    }
  }]);

  return dm;
}(i);

var hm = function hm(t) {
  return function (e) {
    return n(um.Consumer, null, function (i) {
      return i.editorContext && i.editorContext.isInitialized ? n(t, Object.assign({}, e, {
        editorContext: i.editorContext
      })) : null;
    });
  };
};

function pm(t) {
  var e = d(um);
  var n;
  return e && e.editorContext && (n = t(e.editorContext)), n;
}

var fm = function fm(t) {
  var e = t.className,
      i = t.style,
      r = pm(function (t) {
    return t.mxMenubarRef || (t.mxMenubarRef = c()), t.mxMenubarRef;
  });
  return n("div", {
    className: m("geMenubarContainer", e),
    ref: r,
    style: Object.assign({
      position: "unset"
    }, i)
  });
},
    mm = function mm(t) {
  var e = t.className,
      i = t.style,
      r = pm(function (t) {
    return t.mxToolbarRef || (t.mxToolbarRef = c()), t.mxToolbarRef;
  });
  return n("div", {
    className: m("geToolbarContainer", e),
    ref: r,
    style: Object.assign({
      position: "unset"
    }, i)
  });
},
    _m = function _m(t) {
  var e = t.className,
      i = t.style,
      r = pm(function (t) {
    return t.mxDiagramRef || (t.mxDiagramRef = c()), t.mxDiagramRef;
  }),
      o = d(um);
  return n("div", {
    className: m(Zo.diagram, e),
    style: i
  }, o.editorContext && o.editorContext.loading && n($o, {
    overlay: !0
  }), n("div", {
    ref: r,
    style: {
      height: "100%"
    }
  }));
},
    gm = hm(function (t) {
  return n(vm, Object.assign({}, t));
});

var vm =
/*#__PURE__*/
function (_i25) {
  _inherits(vm, _i25);

  function vm(t) {
    var _this70;

    _classCallCheck(this, vm);

    _this70 = _possibleConstructorReturn(this, _getPrototypeOf(vm).call(this, t)), _this70._myRef = c(), _this70.mounting = new Bn({
      privateStyles: Zo,
      privateClassNames: ["sidebar"]
    });
    return _this70;
  }

  _createClass(vm, [{
    key: "render",
    value: function render() {
      var _this$props10 = this.props,
          t = _this$props10.editorContext,
          e = _this$props10.children;
      return n("div", {
        ref: this._myRef,
        className: this.mounting.classnames(this.props)
      }, e);
    }
  }]);

  return vm;
}(i);

var ym =
/*#__PURE__*/
function (_i26) {
  _inherits(ym, _i26);

  function ym(t) {
    var _this71;

    _classCallCheck(this, ym);

    _this71 = _possibleConstructorReturn(this, _getPrototypeOf(ym).call(this, t)), _this71._myRef = c(), _this71.mounting = new Bn({
      privateStyles: Zo,
      privateClassNames: function privateClassNames(t) {
        return [["panel"], {
          expanded: t.expanded
        }];
      }
    }), _this71.state = {
      expanded: t.expanded
    };
    return _this71;
  }

  _createClass(ym, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "render",
    value: function render() {
      var _this72 = this;

      return n("div", {
        ref: this._myRef,
        className: this.mounting.classnames(this.state),
        onClick: function onClick() {
          return _this72.setState({
            expanded: !_this72.state.expanded
          });
        }
      }, this.props.children);
    }
  }]);

  return ym;
}(i);

var bm = hm(function (t) {
  return n(Em, Object.assign({}, t));
});

var Em =
/*#__PURE__*/
function (_i27) {
  _inherits(Em, _i27);

  function Em(t) {
    var _this73;

    _classCallCheck(this, Em);

    _this73 = _possibleConstructorReturn(this, _getPrototypeOf(Em).call(this, t)), _this73._ref = c();
    return _this73;
  }

  _createClass(Em, [{
    key: "onDrop",
    value: function onDrop(t, e, n, i, r) {
      e.stopEditing(!1);
      var o = null,
          a = this.findDropTarget(i, [t], t.domainModel);

      if (a) {
        t.domainModel.findDomainClass(a) && (o = t.buildShape(t.buildPrototype()));
      } else t.allowRootDrop && (a = e.getDefaultParent(), o = t.buildShape(t.buildPrototype()));

      var s = e.getPointForEvent(n),
          c = e.getModel();
      t.name;

      if (null !== o) {
        c.beginUpdate();

        try {
          o.geometry.x = s.x, o.geometry.y = s.y, e.addCell(o, a);
        } finally {
          c.endUpdate();
        }

        e.setSelectionCell(o);
      }
    }
  }, {
    key: "findDropTarget",
    value: function findDropTarget(t, e, n) {
      var _loop = function _loop() {
        var i = n.findDomainClass(t);
        if (i && e.every(function (t) {
          return null != t && !1 !== i.canDrop(t);
        })) return {
          v: t
        };
        t = t ? t.parent : null;
      };

      do {
        var _ret = _loop();

        if (typeof _ret === "object") return _ret.v;
      } while (t);

      return null;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this74 = this;

      if (this._ref) {
        var _this$props$editorCon = this.props.editorContext,
            _n11 = _this$props$editorCon.lib,
            _i28 = _this$props$editorCon.mx,
            _r10 = _this$props$editorCon.graph,
            _o7 = _this$props$editorCon.editorService,
            _a4 = _o7.designerService.domainModel,
            _this$props11 = this.props,
            _s4 = _this$props11.onDrop,
            _c4 = _this$props11.domainClassName,
            _u3 = _a4.getDomainClass(_c4);

        var t = this._ref.current.cloneNode(!0),
            e = _n11.mxUtils.makeDraggable(this._ref.current, _r10, function (t, e, n) {
          return _this74.onDrop(_u3, t, e, n, _i28);
        }, t);

        this._ref.current;

        var _l2 = this;

        _r10.checkDropTarget = function (t, e, n) {
          var i = this.getDefaultParent();
          return !t || !t.some(function (t) {
            return t.value instanceof Rh && (null !== e && t.parent !== e || null === e && t.parent !== i);
          }) || _l2.isValidDropTarget(e, t, _a4, this);
        }, e.highlightDropTargets = !0, e.getDropTarget = function (t, e, n, i) {
          return _this74.findDropTarget(t.getCellAt(e, n), [_u3], _a4);
        };
      }
    }
  }, {
    key: "isValidDropTarget",
    value: function isValidDropTarget(t, e, n, i) {
      var r = e.map(function (t) {
        return n.findDomainClass(t);
      });
      var o = !1;
      if (null === t || i.getDefaultParent() === t) o = r.every(function (t) {
        return null !== t && t.allowRootDrop;
      });else {
        var _e11 = n.findDomainClass(t);

        o = !(!_e11 || !r.every(function (t) {
          return null != t && !1 !== _e11.canDrop(t);
        }));
      }
      return console.log("isValidDropTarget", t && t.value, o), o;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props12 = this.props,
          t = _this$props12.image,
          e = _this$props12.height,
          i = _this$props12.width;
      return n("img", {
        ref: this._ref,
        src: t,
        width: i,
        height: e
      });
    }
  }]);

  return Em;
}(i);

var Cm = hm(function (t) {
  return n(Am, Object.assign({}, t));
});

var Am =
/*#__PURE__*/
function (_i29) {
  _inherits(Am, _i29);

  function Am(t) {
    var _this75;

    _classCallCheck(this, Am);

    _this75 = _possibleConstructorReturn(this, _getPrototypeOf(Am).call(this, t)), _this75.mounting = new Bn({
      privateStyles: Zo,
      privateClassNames: ["toolbar"]
    }), _this75.state = {};
    return _this75;
  }

  _createClass(Am, [{
    key: "onDomainModelItemSelected",
    value: function onDomainModelItemSelected(t) {
      this.setState({
        selectedItem: t
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this76 = this;

      var _this$props$editorCon2 = this.props.editorContext,
          t = _this$props$editorCon2.editorService,
          e = _this$props$editorCon2.editorUI;
      t.designerService.domainModel.addItemSelectedListener(this.onDomainModelItemSelected.bind(this)), e && (e.actions.get("undo").addListener("stateChanged", function () {
        return _this76.forceUpdate();
      }), e.actions.get("redo").addListener("stateChanged", function () {
        return _this76.forceUpdate();
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$editorCon3 = this.props.editorContext,
          t = _this$props$editorCon3.editorUI,
          e = _this$props$editorCon3.graph;
      return n(ko, {
        theme: this.props.theme,
        className: this.mounting.classnames(this.props)
      }, n(Fo, null, n(Po, {
        align: "end"
      }, n(Lo, {
        icon: "undo",
        disabled: !t.canUndo(),
        onClick: function onClick() {
          return t.undo();
        }
      }), n(Lo, {
        icon: "redo",
        disabled: !t.canRedo(),
        onClick: function onClick() {
          return t.redo();
        }
      }), n(Lo, {
        icon: "zoom_in",
        onClick: function onClick() {
          return e.zoomIn();
        }
      }), n(Lo, {
        icon: "zoom_out",
        onClick: function onClick() {
          return e.zoomOut();
        }
      }), n(Lo, {
        icon: "delete",
        disabled: e.isSelectionEmpty(),
        onClick: function onClick() {
          return t.actions.get("delete").funct();
        }
      }))));
    }
  }]);

  return Am;
}(i);

var Tm = hm(function (t) {
  return n(Im, Object.assign({}, t));
});

var Im =
/*#__PURE__*/
function (_i30) {
  _inherits(Im, _i30);

  function Im(t) {
    var _this77;

    _classCallCheck(this, Im);

    _this77 = _possibleConstructorReturn(this, _getPrototypeOf(Im).call(this, t)), _this77.mounting = new Bn({
      privateStyles: Zo,
      privateClassNames: ["props"]
    }), _this77.state = {};
    return _this77;
  }

  _createClass(Im, [{
    key: "onDomainModelItemSelected",
    value: function onDomainModelItemSelected(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var n = arguments.length > 2 ? arguments[2] : undefined;
      this.setState({
        selectedItem: t,
        forceRefresh: e,
        refreshMember: n
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.editorContext.isInitialized) return;
      var t = this.props.editorContext.editorService.designerService;
      t.domainModel.addItemSelectedListener(this.onDomainModelItemSelected.bind(this));
    }
  }, {
    key: "render",
    value: function render() {
      var _this78 = this;

      var _this$state = this.state,
          t = _this$state.selectedItem,
          e = _this$state.forceRefresh,
          i = _this$state.refreshMember;
      return n(Qo, {
        loading: this.props.editorContext.loading,
        className: this.mounting.classnames(this.state),
        theme: this.props.theme,
        allowSearch: !1,
        data: t && t.model,
        forceRefresh: e,
        refreshMember: i,
        onPropertyChanged: function onPropertyChanged(t) {
          return _this78.state.selectedItem && _this78.state.selectedItem.notifyChange(t);
        }
      });
    }
  }]);

  return Im;
}(i);

var Om;
!function (t) {
  t[t.LanguageInfo = 0] = "LanguageInfo", t[t.ModelInfo = 1] = "ModelInfo";
}(Om || (Om = {}));

var Sm = function Sm(t, e) {
  _classCallCheck(this, Sm);

  this.id = t, this.type = e;
};

var wm =
/*#__PURE__*/
function () {
  function wm(t) {
    _classCallCheck(this, wm);

    this._info = t, this.loaded = !1;
  }

  _createClass(wm, [{
    key: "id",
    get: function get() {
      return this._info.id;
    }
  }, {
    key: "name",
    get: function get() {
      return this._info.name;
    }
  }, {
    key: "namespace",
    get: function get() {
      return this._info.namespace;
    }
  }, {
    key: "version",
    get: function get() {
      return this._info.version;
    }
  }, {
    key: "document",
    get: function get() {
      return this._document || (this._document = new Sm(this.id, Om.LanguageInfo)), this._document;
    }
  }, {
    key: "text",
    get: function get() {
      return this.name;
    }
  }, {
    key: "element",
    get: function get() {
      return this.id;
    }
  }]);

  return wm;
}();

wm.__idCounter = 0;
var xm = Object.freeze({
  LanguageInfoVM: wm,
  DomainModel: function DomainModel(t) {
    _classCallCheck(this, DomainModel);

    this.url = t;
  },
  DomainModelView: function DomainModelView(t) {
    _classCallCheck(this, DomainModelView);

    this.url = t;
  }
});

var Nm = function Nm(t) {
  var e = t.barSize,
      i = t.children,
      r = t.style,
      o = t.disabled,
      a = t.minSize,
      s = t.maxSize,
      c = Ut(t, ["barSize", "children", "style", "disabled", "minSize", "maxSize"]),
      u = o ? t.defaultSize : a,
      l = o ? t.defaultSize : s;
  Wf(t, "ResizableSection.Render");
  var d = e || 5;
  return n(U, Object.assign({}, c, {
    minSize: u,
    maxSize: l,
    style: Object.assign({
      position: "relative"
    }, r)
  }), i, n(G, {
    size: d,
    hidden: o,
    style: {
      background: "transparent",
      cursor: "col-resize",
      position: "absolute",
      right: 0,
      top: 0,
      bottom: 0,
      width: d
    }
  }));
};

var Rm =
/*#__PURE__*/
function () {
  function Rm() {
    _classCallCheck(this, Rm);

    this._open = !1;
  }

  _createClass(Rm, [{
    key: "setSelectedItem",
    value: function setSelectedItem(t, e) {
      var n = (e !== this._open || this._selectedItem !== t) && (this._selectedItem || !t.selected);
      this._open = e, this._selectedItem = t, n && this.notifyStateChange && this.notifyStateChange(this);
    }
  }, {
    key: "open",
    get: function get() {
      return this._open;
    }
  }, {
    key: "selectedItem",
    get: function get() {
      return this._selectedItem;
    }
  }]);

  return Rm;
}();

var Lm = e({
  contentMode: !1,
  selection: new Rm()
});
Lm.displayName = "DismissibleSidebarContext";

var Dm = function Dm(t) {
  var e = t.children,
      i = t.content,
      _t$theme = t.theme,
      r = _t$theme === void 0 ? mo.primary : _t$theme,
      _h2 = h({
    selection: new Rm()
  }),
      _h3 = _slicedToArray(_h2, 2),
      o = _h3[0],
      a = _h3[1],
      s = u({}),
      c = u(null);

  o.selection.notifyStateChange = function (t) {
    return a({
      selection: t
    });
  };

  var _o$selection = o.selection,
      l = _o$selection.selectedItem,
      d = _o$selection.open;

  if (console.log("DismissibleSidebar.Render", d), Wf(t, "DismissibleSidebar.Render"), c.current && void 0 !== l) {
    var _t38 = c.current.getResizer(),
        _e12 = function (t) {
      return d ? t || l && l.defaultSize : 0;
    }(s.current[l.icon]);

    console.log("DismissibleSidebar.resize init", _e12), _t38.resizeSection(0, {
      toSize: _e12
    }), s.current.initializing = !0, c.current.applyResizer(_t38), s.current.initializing = !1;
  }

  return n("div", {
    style: {
      height: "100%",
      width: "100%",
      position: "relative",
      display: "flex"
    }
  }, n(Lm.Provider, {
    value: {
      selection: o.selection,
      contentMode: !1
    }
  }, n(ko, {
    theme: r,
    vertical: !0,
    style: {
      zIndex: 7,
      minWidth: 62
    }
  }, n(Fo, null, e))), n(z, {
    style: {
      width: "100%"
    },
    ref: c,
    beforeApplyResizer: function (t) {
      return function (e) {
        if (t.selectedItem && !s.current.initializing) {
          var _n12 = t.selectedItem,
              _i31 = _n12.minSize ? _n12.minSize : _n12.defaultSize,
              _r11 = e.getSectionSize(0);

          s.current[_n12.icon] = _r11 < _i31 ? _i31 : _n12.maxSize && _r11 > _n12.maxSize ? _n12.maxSize : _r11;

          var _o8 = void 0;

          _r11 < _i31 / 2 ? (_o8 = 0, t.setSelectedItem(t.selectedItem, !1)) : _r11 < _i31 ? (_o8 = _i31, t.setSelectedItem(t.selectedItem, !0)) : _n12.maxSize && _r11 > _n12.maxSize && (_o8 = _n12.maxSize), void 0 !== _o8 && (console.log("DismissibleSidebar.resize fix", _o8), e.resizeSection(0, {
            toSize: _o8
          }));
        }
      };
    }(o.selection)
  }, n(Lm.Provider, {
    value: {
      selection: o.selection,
      contentMode: !0
    }
  }, n(km, {
    theme: r
  }, e)), n(U, null, i)));
},
    km = function km(t) {
  Wf(t, "CollapsibleSection.Render");
  var _d$selection = d(Lm).selection,
      e = _d$selection.open,
      i = _d$selection.selectedItem,
      r = {
    defaultSize: e ? i && i.defaultSize : 0,
    disabled: i && !i.resizable
  };
  return n(Nm, Object.assign({}, r, {
    style: {
      borderRightStyle: "solid",
      borderColor: To(t.theme)
    }
  }), t.children);
},
    Pm = function Pm(t) {
  var e = t.icon,
      i = t.selected,
      r = t.children,
      _d2 = d(Lm),
      o = _d2.selection,
      a = _d2.contentMode;

  !o.selectedItem && i && (console.log("SidebarItem.Render setSelectedItem", t), o.setSelectedItem(t, !0));
  var s = o.selectedItem,
      c = o.setSelectedItem,
      u = o.open,
      l = s && s.icon !== e || !u,
      h = s && s.icon === e && u;
  return Wf(t, "SidebarItem.Render"), a ? n("div", {
    style: {
      height: "100%",
      width: "100%",
      display: h ? "flex" : "none",
      flexGrow: 1,
      flexDirection: "column"
    }
  }, r) : n(Lo, {
    icon: e,
    fab: h,
    style: {
      minHeight: 56,
      alignItems: "center"
    },
    onClick: function onClick() {
      c.bind(o)(t, l);
    }
  });
},
    Fm = function Fm(t) {
  var e = t.align,
      i = t.children,
      _d3 = d(Lm),
      r = _d3.contentMode,
      o = _d3.selection;

  return Wf(t, "SidebarItemSection.Render"), r ? n("div", {
    style: {
      height: "100%",
      display: o.open ? "flex" : "none"
    }
  }, i) : n(Po, {
    align: e
  }, i);
},
    Mm = function Mm(t) {
  var e = t.barSize,
      i = t.children,
      r = t.style,
      o = t.disabled,
      a = t.minSize,
      s = t.maxSize,
      c = Ut(t, ["barSize", "children", "style", "disabled", "minSize", "maxSize"]),
      u = o ? t.defaultSize : a,
      l = o ? t.defaultSize : s;
  Wf(t, "ResizableSection.Render");
  var d = e || 5;
  return n(U, Object.assign({}, c, {
    minSize: u,
    maxSize: l,
    style: Object.assign({
      position: "relative"
    }, r)
  }), i, n(G, {
    size: d,
    hidden: o,
    style: {
      background: "transparent",
      cursor: "col-resize",
      position: "absolute",
      right: 0,
      top: 0,
      bottom: 0,
      width: d
    }
  }));
};

var Hm =
/*#__PURE__*/
function () {
  function Hm(t, e) {
    _classCallCheck(this, Hm);

    this.apolloService = t, this.taskMonitorService = e;
  }

  _createClass(Hm, [{
    key: "hasChildren",
    value: function hasChildren(t) {
      return Array.isArray(t) || Gf(t);
    }
  }, {
    key: "getChildren",
    value: function getChildren(t) {
      var _this79 = this;

      return Array.isArray(t) ? Promise.resolve(t) : Gf(t) && t.type === Uf.Organization ? (console.log("TreeViewDataSource", t), this.taskMonitorService.queueTask(function () {
        return Kt(_this79, void 0, void 0,
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee16() {
          return _regeneratorRuntime.wrap(function _callee16$(_context16) {
            while (1) {
              switch (_context16.prev = _context16.next) {
                case 0:
                  return _context16.abrupt("return", (console.log("TreeViewDataSource.enlistQuery"), Vf(this.apolloService.client, !t.loaded)));

                case 1:
                case "end":
                  return _context16.stop();
              }
            }
          }, _callee16, this);
        }));
      }, "notifyOnly").then(function (e) {
        return t.children = e || [];
      })) : Promise.resolve([]);
    }
  }]);

  return Hm;
}();

Hm = Gt([zt(0, Jh), zt(1, Xf)], Hm);
var Bm = new P(Hm);

var Vm = function Vm(t) {
  console.log("ContextMenu.Render");

  var e = t.menuService,
      i = t.contextKeyService,
      r = t.keyBindingService,
      o = t.menuId,
      a = t.focusedItem,
      s = t.position,
      c = t.onClose,
      _ref3 = function (t, e, n, i) {
    var _h4 = h(),
        _h5 = _slicedToArray(_h4, 2),
        r = _h5[1],
        o = t.createMenu(n, e).getActions({
      arg: i
    });

    return o && o.length > 0 ? [o, e.onDidChangeContext(function () {
      r({});
    })] : [o, void 0];
  }(e, i, o, a),
      _ref4 = _slicedToArray(_ref3, 2),
      u = _ref4[0],
      d = _ref4[1];

  return l(function () {
    return function () {
      return d && d.dispose();
    };
  }), 0 === u.length ? null : n(no, {
    fixed: !0,
    open: !0,
    onClose: c,
    style: {
      top: s.y,
      left: s.x
    }
  }, u.reduce(function (t, e) {
    var _e13 = _slicedToArray(e, 2),
        i = _e13[0],
        o = _e13[1];

    return console.log(e), t.length > 0 && t.push(n(Nr, {
      key: i
    })), t.push.apply(t, _toConsumableArray(o.map(function (t) {
      var e = r.lookupKeybinding(t.id);
      return e && console.log(e.getLabel()), n(eo, {
        selected: !1,
        key: t.id,
        disabled: !t.enabled,
        onClick: function onClick() {
          return t.run();
        }
      }, n("div", {
        style: {
          width: "100%"
        }
      }, n("div", {
        style: {
          float: "left"
        }
      }, t.label), n("div", {
        style: {
          float: "right",
          marginLeft: 30
        }
      }, e && e.getLabel())));
    }))), t;
  }, []));
};

var jm =
/*#__PURE__*/
function (_i32) {
  _inherits(jm, _i32);

  function jm(t) {
    var _this80;

    _classCallCheck(this, jm);

    _this80 = _possibleConstructorReturn(this, _getPrototypeOf(jm).call(this, t)), _this80._root = c(), _this80.state = {
      open: !1,
      pos: {
        x: 0,
        y: 0
      },
      element: void 0
    };
    return _this80;
  }

  _createClass(jm, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(t) {
      var e = this.props,
          n = vh(t, e);
      console.log("TreeView.componentDidUpdate", {
        prevProps: t,
        currentProps: e,
        shallowEqualExplanation: n
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this81 = this;

      if (!this._tree) {
        var _this$props13 = this.props,
            _t39 = _this$props13.onItemsSelected,
            _e14 = _this$props13.onItemSelected,
            _n13 = _this$props13.selectedItems,
            _this$props13$theme = _this$props13.theme,
            _i33 = _this$props13$theme === void 0 ? mo.primary : _this$props13$theme,
            _r12 = {
          listFocusBackground: To(mo.secondary, go.light),
          listFocusForeground: Oo(mo.secondary, go.light),
          listActiveSelectionBackground: To(mo.secondary),
          listActiveSelectionForeground: Oo(mo.secondary),
          listFocusAndSelectionBackground: To(mo.secondary),
          listFocusAndSelectionForeground: Oo(mo.secondary),
          listInactiveSelectionBackground: To(_i33, go.dark),
          listInactiveSelectionForeground: Oo(_i33, go.dark),
          listHoverBackground: To(_i33, go.light),
          listHoverForeground: Oo(_i33, go.light)
        };

        this._tree = this.context.editorContext.editorService.initExplorerView(this._root.current, Bm, _r12), this._CategorySelectedContextKey = zf.bindTo(this._tree.contextkeyService), function (t) {
          var e = _this81.props.selectedItems;
          return e === t || t && e && e.length === t.length && t.every(function (t) {
            return e.includes(t);
          });
        }.bind(this), this._tree.onDidChangeSelection(function (n) {
          var i = n.elements;
          console.log("TreeView.onItemsSelected", i), _this81._CategorySelectedContextKey.set(1 === i.length && Gf(i[0])), _t39 && _t39(i), _e14 && 1 === i.length && _e14(i[0]);
        }), this._tree.onContextMenu(function (t) {
          t.browserEvent.preventDefault(), _this81.setState({
            open: !0,
            pos: Object.assign({}, t.anchor),
            element: t.element
          }), console.log("OnContextMenu", t);
        });

        var _o9 = !this.props.data || Array.isArray(this.props.data) ? this.props.data : [this.props.data];

        _o9 ? this._tree.setInput(_o9).then(function () {}) : (this.context.editorContext.editorService.designerService.registerRootNode(Uf.Organization, "core"), this._tree.setInput(this.context.editorContext.editorService.designerService.rootNodes)), this._services = this.context.editorContext.editorService.invokeFunction(function (t) {
          return {
            menu: t.get(H),
            keyBinding: t.get(F)
          };
        });
      }
    }
  }, {
    key: "getContextMenuProps",
    value: function getContextMenuProps() {
      var _this82 = this;

      var t = this._tree.contextkeyService.createScoped(),
          e = Kf.bindTo(t),
          n = zf.bindTo(t),
          i = this._tree.getSelection();

      return e.set(i.some(function (t) {
        return Gf(t);
      }) && i.some(function (t) {
        return !Gf(t);
      })), n.set(Gf(K)), {
        menuService: this._services.menu,
        keyBindingService: this._services.keyBinding,
        contextKeyService: t,
        menuId: 11,
        position: this.state.pos,
        focusedItem: this.state.element,
        onClose: function onClose() {
          return _this82.setState({
            open: !1
          });
        }
      };
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._tree && this._tree.dispose();
    }
  }, {
    key: "render",
    value: function render() {
      return console.log("TreeView.Render", this.props.selectedItems), this._tree && this.props.collapseAll && this._tree.collapseAll(), n("div", {
        style: {
          height: "100%",
          position: "relative"
        }
      }, n("div", {
        style: Object.assign({
          outline: "none",
          position: "absolute",
          width: "100%",
          height: "100%"
        }, this.props.style),
        className: "mdc-menu-surface--anchorX",
        ref: this._root
      }, this.state.open && n(Vm, Object.assign({}, this.getContextMenuProps()))));
    }
  }]);

  return jm;
}(i);

jm = Gt([function (t) {
  t.contextType = um;
}], jm);
var Um = {
  snack: "mib-notification-snack-2NRyV",
  header: "mib-notification-header-3MCwS",
  actions: "mib-notification-actions-21npo",
  msg: "mib-notification-msg-2j0n9",
  dismiss: "mib-notification-dismiss-6GIZu",
  body: "mib-notification-body-2E0Kq",
  title: "mib-notification-title-13HRj",
  icon: "mib-notification-icon-3Y-dv",
  errorDetails: "mib-notification-errorDetails-30r5Q",
  progress: "mib-notification-progress-1gl4f"
};
var Gm,
    zm,
    Km = {
  BG_FOCUSED: "mdc-ripple-upgraded--background-focused",
  FG_ACTIVATION: "mdc-ripple-upgraded--foreground-activation",
  FG_DEACTIVATION: "mdc-ripple-upgraded--foreground-deactivation",
  ROOT: "mdc-ripple-upgraded",
  UNBOUNDED: "mdc-ripple-upgraded--unbounded"
},
    qm = {
  VAR_FG_SCALE: "--mdc-ripple-fg-scale",
  VAR_FG_SIZE: "--mdc-ripple-fg-size",
  VAR_FG_TRANSLATE_END: "--mdc-ripple-fg-translate-end",
  VAR_FG_TRANSLATE_START: "--mdc-ripple-fg-translate-start",
  VAR_LEFT: "--mdc-ripple-left",
  VAR_TOP: "--mdc-ripple-top"
},
    Wm = {
  DEACTIVATION_TIMEOUT_MS: 225,
  FG_DEACTIVATION_MS: 150,
  INITIAL_ORIGIN_SCALE: .6,
  PADDING: 10,
  TAP_DELAY_MS: 300
};

function Xm(t, e) {
  if (void 0 === t && (t = window), void 0 === e && (e = !1), void 0 === zm || e) {
    var n = !1;

    try {
      t.document.addEventListener("test", function () {}, {
        get passive() {
          return n = !0;
        }

      });
    } catch (t) {}

    zm = n;
  }

  return !!zm && {
    passive: !0
  };
}

var Ym,
    $m,
    Qm = ["touchstart", "pointerdown", "mousedown", "keydown"],
    Zm = ["touchend", "pointerup", "mouseup", "contextmenu"],
    Jm = [],
    t_ = function (t) {
  function e(n) {
    var i = t.call(this, _jt({}, e.defaultAdapter, n)) || this;
    return i.activationAnimationHasEnded_ = !1, i.activationTimer_ = 0, i.fgDeactivationRemovalTimer_ = 0, i.fgScale_ = "0", i.frame_ = {
      width: 0,
      height: 0
    }, i.initialSize_ = 0, i.layoutFrame_ = 0, i.maxRadius_ = 0, i.unboundedCoords_ = {
      left: 0,
      top: 0
    }, i.activationState_ = i.defaultActivationState_(), i.activationTimerCallback_ = function () {
      i.activationAnimationHasEnded_ = !0, i.runDeactivationUXLogicIfReady_();
    }, i.activateHandler_ = function (t) {
      return i.activate_(t);
    }, i.deactivateHandler_ = function () {
      return i.deactivate_();
    }, i.focusHandler_ = function () {
      return i.handleFocus();
    }, i.blurHandler_ = function () {
      return i.handleBlur();
    }, i.resizeHandler_ = function () {
      return i.layout();
    }, i;
  }

  return Vt(e, t), Object.defineProperty(e, "cssClasses", {
    get: function get() {
      return Km;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "strings", {
    get: function get() {
      return qm;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "numbers", {
    get: function get() {
      return Wm;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultAdapter", {
    get: function get() {
      return {
        addClass: function addClass() {},
        browserSupportsCssVars: function browserSupportsCssVars() {
          return !0;
        },
        computeBoundingRect: function computeBoundingRect() {
          return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            width: 0,
            height: 0
          };
        },
        containsEventTarget: function containsEventTarget() {
          return !0;
        },
        deregisterDocumentInteractionHandler: function deregisterDocumentInteractionHandler() {},
        deregisterInteractionHandler: function deregisterInteractionHandler() {},
        deregisterResizeHandler: function deregisterResizeHandler() {},
        getWindowPageOffset: function getWindowPageOffset() {
          return {
            x: 0,
            y: 0
          };
        },
        isSurfaceActive: function isSurfaceActive() {
          return !0;
        },
        isSurfaceDisabled: function isSurfaceDisabled() {
          return !0;
        },
        isUnbounded: function isUnbounded() {
          return !0;
        },
        registerDocumentInteractionHandler: function registerDocumentInteractionHandler() {},
        registerInteractionHandler: function registerInteractionHandler() {},
        registerResizeHandler: function registerResizeHandler() {},
        removeClass: function removeClass() {},
        updateCssVariable: function updateCssVariable() {}
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.init = function () {
    var t = this,
        n = this.supportsPressRipple_();

    if (this.registerRootHandlers_(n), n) {
      var i = e.cssClasses,
          r = i.ROOT,
          o = i.UNBOUNDED;
      requestAnimationFrame(function () {
        t.adapter_.addClass(r), t.adapter_.isUnbounded() && (t.adapter_.addClass(o), t.layoutInternal_());
      });
    }
  }, e.prototype.destroy = function () {
    var t = this;

    if (this.supportsPressRipple_()) {
      this.activationTimer_ && (clearTimeout(this.activationTimer_), this.activationTimer_ = 0, this.adapter_.removeClass(e.cssClasses.FG_ACTIVATION)), this.fgDeactivationRemovalTimer_ && (clearTimeout(this.fgDeactivationRemovalTimer_), this.fgDeactivationRemovalTimer_ = 0, this.adapter_.removeClass(e.cssClasses.FG_DEACTIVATION));
      var n = e.cssClasses,
          i = n.ROOT,
          r = n.UNBOUNDED;
      requestAnimationFrame(function () {
        t.adapter_.removeClass(i), t.adapter_.removeClass(r), t.removeCssVars_();
      });
    }

    this.deregisterRootHandlers_(), this.deregisterDeactivationHandlers_();
  }, e.prototype.activate = function (t) {
    this.activate_(t);
  }, e.prototype.deactivate = function () {
    this.deactivate_();
  }, e.prototype.layout = function () {
    var t = this;
    this.layoutFrame_ && cancelAnimationFrame(this.layoutFrame_), this.layoutFrame_ = requestAnimationFrame(function () {
      t.layoutInternal_(), t.layoutFrame_ = 0;
    });
  }, e.prototype.setUnbounded = function (t) {
    var n = e.cssClasses.UNBOUNDED;
    t ? this.adapter_.addClass(n) : this.adapter_.removeClass(n);
  }, e.prototype.handleFocus = function () {
    var t = this;
    requestAnimationFrame(function () {
      return t.adapter_.addClass(e.cssClasses.BG_FOCUSED);
    });
  }, e.prototype.handleBlur = function () {
    var t = this;
    requestAnimationFrame(function () {
      return t.adapter_.removeClass(e.cssClasses.BG_FOCUSED);
    });
  }, e.prototype.supportsPressRipple_ = function () {
    return this.adapter_.browserSupportsCssVars();
  }, e.prototype.defaultActivationState_ = function () {
    return {
      activationEvent: void 0,
      hasDeactivationUXRun: !1,
      isActivated: !1,
      isProgrammatic: !1,
      wasActivatedByPointer: !1,
      wasElementMadeActive: !1
    };
  }, e.prototype.registerRootHandlers_ = function (t) {
    var e = this;
    t && (Qm.forEach(function (t) {
      e.adapter_.registerInteractionHandler(t, e.activateHandler_);
    }), this.adapter_.isUnbounded() && this.adapter_.registerResizeHandler(this.resizeHandler_)), this.adapter_.registerInteractionHandler("focus", this.focusHandler_), this.adapter_.registerInteractionHandler("blur", this.blurHandler_);
  }, e.prototype.registerDeactivationHandlers_ = function (t) {
    var e = this;
    "keydown" === t.type ? this.adapter_.registerInteractionHandler("keyup", this.deactivateHandler_) : Zm.forEach(function (t) {
      e.adapter_.registerDocumentInteractionHandler(t, e.deactivateHandler_);
    });
  }, e.prototype.deregisterRootHandlers_ = function () {
    var t = this;
    Qm.forEach(function (e) {
      t.adapter_.deregisterInteractionHandler(e, t.activateHandler_);
    }), this.adapter_.deregisterInteractionHandler("focus", this.focusHandler_), this.adapter_.deregisterInteractionHandler("blur", this.blurHandler_), this.adapter_.isUnbounded() && this.adapter_.deregisterResizeHandler(this.resizeHandler_);
  }, e.prototype.deregisterDeactivationHandlers_ = function () {
    var t = this;
    this.adapter_.deregisterInteractionHandler("keyup", this.deactivateHandler_), Zm.forEach(function (e) {
      t.adapter_.deregisterDocumentInteractionHandler(e, t.deactivateHandler_);
    });
  }, e.prototype.removeCssVars_ = function () {
    var t = this,
        n = e.strings;
    Object.keys(n).forEach(function (e) {
      0 === e.indexOf("VAR_") && t.adapter_.updateCssVariable(n[e], null);
    });
  }, e.prototype.activate_ = function (t) {
    var e = this;

    if (!this.adapter_.isSurfaceDisabled()) {
      var n = this.activationState_;

      if (!n.isActivated) {
        var i = this.previousActivationEvent_;
        if (!(i && void 0 !== t && i.type !== t.type)) n.isActivated = !0, n.isProgrammatic = void 0 === t, n.activationEvent = t, n.wasActivatedByPointer = !n.isProgrammatic && void 0 !== t && ("mousedown" === t.type || "touchstart" === t.type || "pointerdown" === t.type), void 0 !== t && Jm.length > 0 && Jm.some(function (t) {
          return e.adapter_.containsEventTarget(t);
        }) ? this.resetActivationState_() : (void 0 !== t && (Jm.push(t.target), this.registerDeactivationHandlers_(t)), n.wasElementMadeActive = this.checkElementMadeActive_(t), n.wasElementMadeActive && this.animateActivation_(), requestAnimationFrame(function () {
          Jm = [], n.wasElementMadeActive || void 0 === t || " " !== t.key && 32 !== t.keyCode || (n.wasElementMadeActive = e.checkElementMadeActive_(t), n.wasElementMadeActive && e.animateActivation_()), n.wasElementMadeActive || (e.activationState_ = e.defaultActivationState_());
        }));
      }
    }
  }, e.prototype.checkElementMadeActive_ = function (t) {
    return void 0 === t || "keydown" !== t.type || this.adapter_.isSurfaceActive();
  }, e.prototype.animateActivation_ = function () {
    var t = this,
        n = e.strings,
        i = n.VAR_FG_TRANSLATE_START,
        r = n.VAR_FG_TRANSLATE_END,
        o = e.cssClasses,
        a = o.FG_DEACTIVATION,
        s = o.FG_ACTIVATION,
        c = e.numbers.DEACTIVATION_TIMEOUT_MS;
    this.layoutInternal_();
    var u = "",
        l = "";

    if (!this.adapter_.isUnbounded()) {
      var d = this.getFgTranslationCoordinates_(),
          h = d.startPoint,
          p = d.endPoint;
      u = h.x + "px, " + h.y + "px", l = p.x + "px, " + p.y + "px";
    }

    this.adapter_.updateCssVariable(i, u), this.adapter_.updateCssVariable(r, l), clearTimeout(this.activationTimer_), clearTimeout(this.fgDeactivationRemovalTimer_), this.rmBoundedActivationClasses_(), this.adapter_.removeClass(a), this.adapter_.computeBoundingRect(), this.adapter_.addClass(s), this.activationTimer_ = setTimeout(function () {
      return t.activationTimerCallback_();
    }, c);
  }, e.prototype.getFgTranslationCoordinates_ = function () {
    var t,
        e = this.activationState_,
        n = e.activationEvent;
    return {
      startPoint: t = {
        x: (t = e.wasActivatedByPointer ? function (t, e, n) {
          if (!t) return {
            x: 0,
            y: 0
          };
          var i,
              r,
              o = e.x,
              a = e.y,
              s = o + n.left,
              c = a + n.top;

          if ("touchstart" === t.type) {
            var u = t;
            i = u.changedTouches[0].pageX - s, r = u.changedTouches[0].pageY - c;
          } else {
            var l = t;
            i = l.pageX - s, r = l.pageY - c;
          }

          return {
            x: i,
            y: r
          };
        }(n, this.adapter_.getWindowPageOffset(), this.adapter_.computeBoundingRect()) : {
          x: this.frame_.width / 2,
          y: this.frame_.height / 2
        }).x - this.initialSize_ / 2,
        y: t.y - this.initialSize_ / 2
      },
      endPoint: {
        x: this.frame_.width / 2 - this.initialSize_ / 2,
        y: this.frame_.height / 2 - this.initialSize_ / 2
      }
    };
  }, e.prototype.runDeactivationUXLogicIfReady_ = function () {
    var t = this,
        n = e.cssClasses.FG_DEACTIVATION,
        i = this.activationState_,
        r = i.hasDeactivationUXRun,
        o = i.isActivated;
    (r || !o) && this.activationAnimationHasEnded_ && (this.rmBoundedActivationClasses_(), this.adapter_.addClass(n), this.fgDeactivationRemovalTimer_ = setTimeout(function () {
      t.adapter_.removeClass(n);
    }, Wm.FG_DEACTIVATION_MS));
  }, e.prototype.rmBoundedActivationClasses_ = function () {
    var t = e.cssClasses.FG_ACTIVATION;
    this.adapter_.removeClass(t), this.activationAnimationHasEnded_ = !1, this.adapter_.computeBoundingRect();
  }, e.prototype.resetActivationState_ = function () {
    var t = this;
    this.previousActivationEvent_ = this.activationState_.activationEvent, this.activationState_ = this.defaultActivationState_(), setTimeout(function () {
      return t.previousActivationEvent_ = void 0;
    }, e.numbers.TAP_DELAY_MS);
  }, e.prototype.deactivate_ = function () {
    var t = this,
        e = this.activationState_;

    if (e.isActivated) {
      var n = _jt({}, e);

      e.isProgrammatic ? (requestAnimationFrame(function () {
        return t.animateDeactivation_(n);
      }), this.resetActivationState_()) : (this.deregisterDeactivationHandlers_(), requestAnimationFrame(function () {
        t.activationState_.hasDeactivationUXRun = !0, t.animateDeactivation_(n), t.resetActivationState_();
      }));
    }
  }, e.prototype.animateDeactivation_ = function (t) {
    var e = t.wasActivatedByPointer,
        n = t.wasElementMadeActive;
    (e || n) && this.runDeactivationUXLogicIfReady_();
  }, e.prototype.layoutInternal_ = function () {
    var t = this;
    this.frame_ = this.adapter_.computeBoundingRect();
    var n = Math.max(this.frame_.height, this.frame_.width);
    this.maxRadius_ = this.adapter_.isUnbounded() ? n : Math.sqrt(Math.pow(t.frame_.width, 2) + Math.pow(t.frame_.height, 2)) + e.numbers.PADDING, this.initialSize_ = Math.floor(n * e.numbers.INITIAL_ORIGIN_SCALE), this.fgScale_ = "" + this.maxRadius_ / this.initialSize_, this.updateLayoutCssVars_();
  }, e.prototype.updateLayoutCssVars_ = function () {
    var t = e.strings,
        n = t.VAR_FG_SIZE,
        i = t.VAR_LEFT,
        r = t.VAR_TOP,
        o = t.VAR_FG_SCALE;
    this.adapter_.updateCssVariable(n, this.initialSize_ + "px"), this.adapter_.updateCssVariable(o, this.fgScale_), this.adapter_.isUnbounded() && (this.unboundedCoords_ = {
      left: Math.round(this.frame_.width / 2 - this.initialSize_ / 2),
      top: Math.round(this.frame_.height / 2 - this.initialSize_ / 2)
    }, this.adapter_.updateCssVariable(i, this.unboundedCoords_.left + "px"), this.adapter_.updateCssVariable(r, this.unboundedCoords_.top + "px"));
  }, e;
}(Yt),
    e_ = function (t) {
  function e() {
    var e = null !== t && t.apply(this, arguments) || this;
    return e.disabled = !1, e;
  }

  return Vt(e, t), e.attachTo = function (t, n) {
    void 0 === n && (n = {
      isUnbounded: void 0
    });
    var i = new e(t);
    return void 0 !== n.isUnbounded && (i.unbounded = n.isUnbounded), i;
  }, e.createAdapter = function (t) {
    return {
      addClass: function addClass(e) {
        return t.root_.classList.add(e);
      },
      browserSupportsCssVars: function browserSupportsCssVars() {
        return function (t, e) {
          void 0 === e && (e = !1);
          var n = t.CSS,
              i = Gm;
          if ("boolean" == typeof Gm && !e) return Gm;
          if (!n || "function" != typeof n.supports) return !1;
          var r = n.supports("--css-vars", "yes"),
              o = n.supports("(--css-vars: yes)") && n.supports("color", "#00000000");
          return i = !(!r && !o || function (t) {
            var e = t.document,
                n = e.createElement("div");
            n.className = "mdc-ripple-surface--test-edge-var-bug", e.body.appendChild(n);
            var i = t.getComputedStyle(n),
                r = null !== i && "solid" === i.borderTopStyle;
            return n.parentNode && n.parentNode.removeChild(n), r;
          }(t)), e || (Gm = i), i;
        }(window);
      },
      computeBoundingRect: function computeBoundingRect() {
        return t.root_.getBoundingClientRect();
      },
      containsEventTarget: function containsEventTarget(e) {
        return t.root_.contains(e);
      },
      deregisterDocumentInteractionHandler: function deregisterDocumentInteractionHandler(t, e) {
        return document.documentElement.removeEventListener(t, e, Xm());
      },
      deregisterInteractionHandler: function deregisterInteractionHandler(e, n) {
        return t.root_.removeEventListener(e, n, Xm());
      },
      deregisterResizeHandler: function deregisterResizeHandler(t) {
        return window.removeEventListener("resize", t);
      },
      getWindowPageOffset: function getWindowPageOffset() {
        return {
          x: window.pageXOffset,
          y: window.pageYOffset
        };
      },
      isSurfaceActive: function isSurfaceActive() {
        return Zt(t.root_, ":active");
      },
      isSurfaceDisabled: function isSurfaceDisabled() {
        return Boolean(t.disabled);
      },
      isUnbounded: function isUnbounded() {
        return Boolean(t.unbounded);
      },
      registerDocumentInteractionHandler: function registerDocumentInteractionHandler(t, e) {
        return document.documentElement.addEventListener(t, e, Xm());
      },
      registerInteractionHandler: function registerInteractionHandler(e, n) {
        return t.root_.addEventListener(e, n, Xm());
      },
      registerResizeHandler: function registerResizeHandler(t) {
        return window.addEventListener("resize", t);
      },
      removeClass: function removeClass(e) {
        return t.root_.classList.remove(e);
      },
      updateCssVariable: function updateCssVariable(e, n) {
        return t.root_.style.setProperty(e, n);
      }
    };
  }, Object.defineProperty(e.prototype, "unbounded", {
    get: function get() {
      return Boolean(this.unbounded_);
    },
    set: function set(t) {
      this.unbounded_ = Boolean(t), this.setUnbounded_();
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.activate = function () {
    this.foundation_.activate();
  }, e.prototype.deactivate = function () {
    this.foundation_.deactivate();
  }, e.prototype.layout = function () {
    this.foundation_.layout();
  }, e.prototype.getDefaultFoundation = function () {
    return new t_(e.createAdapter(this));
  }, e.prototype.initialSyncWithDOM = function () {
    var t = this.root_;
    this.unbounded = "mdcRippleIsUnbounded" in t.dataset;
  }, e.prototype.setUnbounded_ = function () {
    this.foundation_.setUnbounded(Boolean(this.unbounded_));
  }, e;
}($t),
    n_ = {
  CLOSING: "mdc-dialog--closing",
  OPEN: "mdc-dialog--open",
  OPENING: "mdc-dialog--opening",
  SCROLLABLE: "mdc-dialog--scrollable",
  SCROLL_LOCK: "mdc-dialog-scroll-lock",
  STACKED: "mdc-dialog--stacked"
},
    i_ = {
  ACTION_ATTRIBUTE: "data-mdc-dialog-action",
  BUTTON_SELECTOR: ".mdc-dialog__button",
  CLOSED_EVENT: "MDCDialog:closed",
  CLOSE_ACTION: "close",
  CLOSING_EVENT: "MDCDialog:closing",
  CONTAINER_SELECTOR: ".mdc-dialog__container",
  CONTENT_SELECTOR: ".mdc-dialog__content",
  DEFAULT_BUTTON_SELECTOR: ".mdc-dialog__button--default",
  DESTROY_ACTION: "destroy",
  OPENED_EVENT: "MDCDialog:opened",
  OPENING_EVENT: "MDCDialog:opening",
  SCRIM_SELECTOR: ".mdc-dialog__scrim",
  SUPPRESS_DEFAULT_PRESS_SELECTOR: ["textarea", ".mdc-menu .mdc-list-item"].join(", "),
  SURFACE_SELECTOR: ".mdc-dialog__surface"
},
    r_ = {
  DIALOG_ANIMATION_CLOSE_TIME_MS: 75,
  DIALOG_ANIMATION_OPEN_TIME_MS: 150
},
    o_ = function (t) {
  function e(n) {
    var i = t.call(this, _jt({}, e.defaultAdapter, n)) || this;
    return i.isOpen_ = !1, i.animationFrame_ = 0, i.animationTimer_ = 0, i.layoutFrame_ = 0, i.escapeKeyAction_ = i_.CLOSE_ACTION, i.scrimClickAction_ = i_.CLOSE_ACTION, i.autoStackButtons_ = !0, i.areButtonsStacked_ = !1, i;
  }

  return Vt(e, t), Object.defineProperty(e, "cssClasses", {
    get: function get() {
      return n_;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "strings", {
    get: function get() {
      return i_;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "numbers", {
    get: function get() {
      return r_;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultAdapter", {
    get: function get() {
      return {
        addBodyClass: function addBodyClass() {},
        addClass: function addClass() {},
        areButtonsStacked: function areButtonsStacked() {
          return !1;
        },
        clickDefaultButton: function clickDefaultButton() {},
        eventTargetMatches: function eventTargetMatches() {
          return !1;
        },
        getActionFromEvent: function getActionFromEvent() {
          return "";
        },
        hasClass: function hasClass() {
          return !1;
        },
        isContentScrollable: function isContentScrollable() {
          return !1;
        },
        notifyClosed: function notifyClosed() {},
        notifyClosing: function notifyClosing() {},
        notifyOpened: function notifyOpened() {},
        notifyOpening: function notifyOpening() {},
        releaseFocus: function releaseFocus() {},
        removeBodyClass: function removeBodyClass() {},
        removeClass: function removeClass() {},
        reverseButtons: function reverseButtons() {},
        trapFocus: function trapFocus() {}
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.init = function () {
    this.adapter_.hasClass(n_.STACKED) && this.setAutoStackButtons(!1);
  }, e.prototype.destroy = function () {
    this.isOpen_ && this.close(i_.DESTROY_ACTION), this.animationTimer_ && (clearTimeout(this.animationTimer_), this.handleAnimationTimerEnd_()), this.layoutFrame_ && (cancelAnimationFrame(this.layoutFrame_), this.layoutFrame_ = 0);
  }, e.prototype.open = function () {
    var t = this;
    this.isOpen_ = !0, this.adapter_.notifyOpening(), this.adapter_.addClass(n_.OPENING), this.runNextAnimationFrame_(function () {
      t.adapter_.addClass(n_.OPEN), t.adapter_.addBodyClass(n_.SCROLL_LOCK), t.layout(), t.animationTimer_ = setTimeout(function () {
        t.handleAnimationTimerEnd_(), t.adapter_.trapFocus(), t.adapter_.notifyOpened();
      }, r_.DIALOG_ANIMATION_OPEN_TIME_MS);
    });
  }, e.prototype.close = function (t) {
    var e = this;
    void 0 === t && (t = ""), this.isOpen_ && (this.isOpen_ = !1, this.adapter_.notifyClosing(t), this.adapter_.addClass(n_.CLOSING), this.adapter_.removeClass(n_.OPEN), this.adapter_.removeBodyClass(n_.SCROLL_LOCK), cancelAnimationFrame(this.animationFrame_), this.animationFrame_ = 0, clearTimeout(this.animationTimer_), this.animationTimer_ = setTimeout(function () {
      e.adapter_.releaseFocus(), e.handleAnimationTimerEnd_(), e.adapter_.notifyClosed(t);
    }, r_.DIALOG_ANIMATION_CLOSE_TIME_MS));
  }, e.prototype.isOpen = function () {
    return this.isOpen_;
  }, e.prototype.getEscapeKeyAction = function () {
    return this.escapeKeyAction_;
  }, e.prototype.setEscapeKeyAction = function (t) {
    this.escapeKeyAction_ = t;
  }, e.prototype.getScrimClickAction = function () {
    return this.scrimClickAction_;
  }, e.prototype.setScrimClickAction = function (t) {
    this.scrimClickAction_ = t;
  }, e.prototype.getAutoStackButtons = function () {
    return this.autoStackButtons_;
  }, e.prototype.setAutoStackButtons = function (t) {
    this.autoStackButtons_ = t;
  }, e.prototype.layout = function () {
    var t = this;
    this.layoutFrame_ && cancelAnimationFrame(this.layoutFrame_), this.layoutFrame_ = requestAnimationFrame(function () {
      t.layoutInternal_(), t.layoutFrame_ = 0;
    });
  }, e.prototype.handleInteraction = function (t) {
    var e = "click" === t.type,
        n = "Enter" === t.key || 13 === t.keyCode,
        i = "Space" === t.key || 32 === t.keyCode,
        r = this.adapter_.eventTargetMatches(t.target, i_.SCRIM_SELECTOR),
        o = !this.adapter_.eventTargetMatches(t.target, i_.SUPPRESS_DEFAULT_PRESS_SELECTOR);
    if (e && r && "" !== this.scrimClickAction_) this.close(this.scrimClickAction_);else if (e || i || n) {
      var a = this.adapter_.getActionFromEvent(t);
      a ? this.close(a) : n && o && this.adapter_.clickDefaultButton();
    }
  }, e.prototype.handleDocumentKeydown = function (t) {
    ("Escape" === t.key || 27 === t.keyCode) && "" !== this.escapeKeyAction_ && this.close(this.escapeKeyAction_);
  }, e.prototype.layoutInternal_ = function () {
    this.autoStackButtons_ && this.detectStackedButtons_(), this.detectScrollableContent_();
  }, e.prototype.handleAnimationTimerEnd_ = function () {
    this.animationTimer_ = 0, this.adapter_.removeClass(n_.OPENING), this.adapter_.removeClass(n_.CLOSING);
  }, e.prototype.runNextAnimationFrame_ = function (t) {
    var e = this;
    cancelAnimationFrame(this.animationFrame_), this.animationFrame_ = requestAnimationFrame(function () {
      e.animationFrame_ = 0, clearTimeout(e.animationTimer_), e.animationTimer_ = setTimeout(t, 0);
    });
  }, e.prototype.detectStackedButtons_ = function () {
    this.adapter_.removeClass(n_.STACKED);
    var t = this.adapter_.areButtonsStacked();
    t && this.adapter_.addClass(n_.STACKED), t !== this.areButtonsStacked_ && (this.adapter_.reverseButtons(), this.areButtonsStacked_ = t);
  }, e.prototype.detectScrollableContent_ = function () {
    this.adapter_.removeClass(n_.SCROLLABLE), this.adapter_.isContentScrollable() && this.adapter_.addClass(n_.SCROLLABLE);
  }, e;
}(Yt),
    a_ = o_.strings,
    s_ = (function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  Vt(e, t), Object.defineProperty(e.prototype, "isOpen", {
    get: function get() {
      return this.foundation_.isOpen();
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "escapeKeyAction", {
    get: function get() {
      return this.foundation_.getEscapeKeyAction();
    },
    set: function set(t) {
      this.foundation_.setEscapeKeyAction(t);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "scrimClickAction", {
    get: function get() {
      return this.foundation_.getScrimClickAction();
    },
    set: function set(t) {
      this.foundation_.setScrimClickAction(t);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "autoStackButtons", {
    get: function get() {
      return this.foundation_.getAutoStackButtons();
    },
    set: function set(t) {
      this.foundation_.setAutoStackButtons(t);
    },
    enumerable: !0,
    configurable: !0
  }), e.attachTo = function (t) {
    return new e(t);
  }, e.prototype.initialize = function (t, e) {
    var n,
        i,
        r = this.root_.querySelector(a_.CONTAINER_SELECTOR);
    if (!r) throw new Error("Dialog component requires a " + a_.CONTAINER_SELECTOR + " container element");
    this.container_ = r, this.content_ = this.root_.querySelector(a_.CONTENT_SELECTOR), this.buttons_ = [].slice.call(this.root_.querySelectorAll(a_.BUTTON_SELECTOR)), this.defaultButton_ = this.root_.querySelector(a_.DEFAULT_BUTTON_SELECTOR), this.focusTrapFactory_ = t, this.initialFocusEl_ = e, this.buttonRipples_ = [];

    try {
      for (var o = qt(this.buttons_), a = o.next(); !a.done; a = o.next()) {
        var s = a.value;
        this.buttonRipples_.push(new e_(s));
      }
    } catch (t) {
      n = {
        error: t
      };
    } finally {
      try {
        a && !a.done && (i = o.return) && i.call(o);
      } finally {
        if (n) throw n.error;
      }
    }
  }, e.prototype.initialSyncWithDOM = function () {
    var t,
        e,
        n,
        i = this;
    this.focusTrap_ = (t = this.container_, e = this.focusTrapFactory_, n = this.initialFocusEl_, void 0 === e && (e = dt), e(t, {
      clickOutsideDeactivates: !0,
      escapeDeactivates: !1,
      initialFocus: n
    })), this.handleInteraction_ = this.foundation_.handleInteraction.bind(this.foundation_), this.handleDocumentKeydown_ = this.foundation_.handleDocumentKeydown.bind(this.foundation_), this.handleLayout_ = this.layout.bind(this);
    var r = ["resize", "orientationchange"];
    this.handleOpening_ = function () {
      r.forEach(function (t) {
        return window.addEventListener(t, i.handleLayout_);
      }), document.addEventListener("keydown", i.handleDocumentKeydown_);
    }, this.handleClosing_ = function () {
      r.forEach(function (t) {
        return window.removeEventListener(t, i.handleLayout_);
      }), document.removeEventListener("keydown", i.handleDocumentKeydown_);
    }, this.listen("click", this.handleInteraction_), this.listen("keydown", this.handleInteraction_), this.listen(a_.OPENING_EVENT, this.handleOpening_), this.listen(a_.CLOSING_EVENT, this.handleClosing_);
  }, e.prototype.destroy = function () {
    this.unlisten("click", this.handleInteraction_), this.unlisten("keydown", this.handleInteraction_), this.unlisten(a_.OPENING_EVENT, this.handleOpening_), this.unlisten(a_.CLOSING_EVENT, this.handleClosing_), this.handleClosing_(), this.buttonRipples_.forEach(function (t) {
      return t.destroy();
    }), t.prototype.destroy.call(this);
  }, e.prototype.layout = function () {
    this.foundation_.layout();
  }, e.prototype.open = function () {
    this.foundation_.open();
  }, e.prototype.close = function (t) {
    void 0 === t && (t = ""), this.foundation_.close(t);
  }, e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new o_({
      addBodyClass: function addBodyClass(t) {
        return document.body.classList.add(t);
      },
      addClass: function addClass(e) {
        return t.root_.classList.add(e);
      },
      areButtonsStacked: function areButtonsStacked() {
        return e = t.buttons_, n = new Set(), [].forEach.call(e, function (t) {
          return n.add(t.offsetTop);
        }), n.size > 1;
        var e, n;
      },
      clickDefaultButton: function clickDefaultButton() {
        return t.defaultButton_ && t.defaultButton_.click();
      },
      eventTargetMatches: function eventTargetMatches(t, e) {
        return !!t && Zt(t, e);
      },
      getActionFromEvent: function getActionFromEvent(t) {
        if (!t.target) return "";
        var e = Qt(t.target, "[" + a_.ACTION_ATTRIBUTE + "]");
        return e && e.getAttribute(a_.ACTION_ATTRIBUTE);
      },
      hasClass: function hasClass(e) {
        return t.root_.classList.contains(e);
      },
      isContentScrollable: function isContentScrollable() {
        return !!(e = t.content_) && e.scrollHeight > e.offsetHeight;
        var e;
      },
      notifyClosed: function notifyClosed(e) {
        return t.emit(a_.CLOSED_EVENT, e ? {
          action: e
        } : {});
      },
      notifyClosing: function notifyClosing(e) {
        return t.emit(a_.CLOSING_EVENT, e ? {
          action: e
        } : {});
      },
      notifyOpened: function notifyOpened() {
        return t.emit(a_.OPENED_EVENT, {});
      },
      notifyOpening: function notifyOpening() {
        return t.emit(a_.OPENING_EVENT, {});
      },
      releaseFocus: function releaseFocus() {
        return t.focusTrap_.deactivate();
      },
      removeBodyClass: function removeBodyClass(t) {
        return document.body.classList.remove(t);
      },
      removeClass: function removeClass(e) {
        return t.root_.classList.remove(e);
      },
      reverseButtons: function reverseButtons() {
        t.buttons_.reverse(), t.buttons_.forEach(function (t) {
          t.parentElement.appendChild(t);
        });
      },
      trapFocus: function trapFocus() {
        return t.focusTrap_.activate();
      }
    });
  };
}($t), function () {
  return (s_ = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
}),
    c_ = function c_(t, e) {
  var n = {};

  for (var i in t) {
    Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
  }

  if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
    var r = 0;

    for (i = Object.getOwnPropertySymbols(t); r < i.length; r++) {
      e.indexOf(i[r]) < 0 && (n[i[r]] = t[i[r]]);
    }
  }

  return n;
},
    u_ = Ln({
  surface: !1
})(Mt({
  displayName: "Button",
  tag: "button",
  classNames: function classNames(t) {
    return ["mdc-button", {
      "mdc-button--dense": t.dense,
      "mdc-button--raised": t.raised,
      "mdc-button--unelevated": t.unelevated,
      "mdc-button--outlined": t.outlined
    }];
  },
  consumeProps: ["dense", "unelevated", "outlined", "primary", "accent", "unbounded"],
  render: function render(t, e, i) {
    var r = t.icon,
        o = t.trailingIcon,
        a = t.label,
        s = t.children,
        c = (t.raised, t.danger),
        u = c_(t, ["icon", "trailingIcon", "label", "children", "raised", "danger"]);

    if (c) {
      var l = u.style || {};
      u.style = s_({}, {
        "--mdc-theme-primary": "var(--mdc-theme-error)",
        "--mdc-theme-on-primary": "var(--mdc-theme-on-error)"
      }, l);
    }

    return n(i, s_({}, u, {
      ref: e
    }), !!r && n(l_, {
      icon: r
    }), n("span", {
      className: "mdc-button__label"
    }, a, s), !!o && n(l_, {
      icon: o
    }));
  }
})),
    l_ = Mt({
  displayName: "ButtonIcon",
  tag: mn,
  classNames: ["mdc-button__icon"]
}),
    d_ = function () {
  var _t40 = function t(e, n) {
    return (_t40 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var n in e) {
        e.hasOwnProperty(n) && (t[n] = e[n]);
      }
    })(e, n);
  };

  return function (e, n) {
    function i() {
      this.constructor = e;
    }

    _t40(e, n), e.prototype = null === n ? Object.create(n) : (i.prototype = n.prototype, new i());
  };
}(),
    _h_ = function h_() {
  return (_h_ = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    p_ = function p_(t, e) {
  var n = {};

  for (var i in t) {
    Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
  }

  if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
    var r = 0;

    for (i = Object.getOwnPropertySymbols(t); r < i.length; r++) {
      e.indexOf(i[r]) < 0 && (n[i[r]] = t[i[r]]);
    }
  }

  return n;
},
    f_ = Mt({
  displayName: "DialogRoot",
  defaultProps: {
    role: "alertdialog",
    "aria-modal": !0
  },
  classNames: ["mdc-dialog"]
}),
    m_ = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return d_(e, t), e.prototype.shouldComponentUpdate = function (t) {
    return this.props.disableInteraction !== t.disableInteraction;
  }, e.prototype.render = function () {
    var t = this.props.disableInteraction ? {
      pointerEvents: "none"
    } : {};
    return n("div", {
      className: "mdc-dialog__scrim",
      style: t
    });
  }, e;
}(i),
    __ = Mt({
  displayName: "DialogTitle",
  tag: "h2",
  classNames: ["mdc-dialog__title"]
}),
    g_ = Mt({
  displayName: "DialogContent",
  classNames: ["mdc-dialog__content"]
}),
    v_ = Mt({
  displayName: "DialogActions",
  classNames: ["mdc-dialog__actions"]
}),
    y_ = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return d_(e, t), e.prototype.render = function () {
    var t = this.props,
        e = t.action,
        i = void 0 === e ? "" : e,
        r = t.className,
        o = t.isDefaultAction,
        a = p_(t, ["action", "className", "isDefaultAction"]);
    return n(u_, _h_({}, a, {
      "data-mdc-dialog-action": i,
      className: [r, "mdc-dialog__button", o && "mdc-dialog__button--default"].filter(Boolean).join(" ")
    }));
  }, e.displayName = "DialogButton", e;
}(i),
    b_ = function (t) {
  function e(e) {
    var n = t.call(this, e) || this;
    return n.root = n.createElement("root"), n.container = null, n.content = null, n.buttons = null, n.defaultButton = null, n.focusTrap = null, n.handleDocumentKeydown = function () {}, n.handleInteraction = n.handleInteraction.bind(n), n;
  }

  return d_(e, t), e.prototype.open = function () {
    var t = this;
    this.foundation.isOpen() || (document.addEventListener("keydown", this.handleDocumentKeydown), this.foundation.open(), setTimeout(function () {
      t.defaultButton && document.activeElement !== t.defaultButton && document.activeElement && document.activeElement.classList.contains("mdc-dialog__button") && t.defaultButton.focus();
    }, 180));
  }, e.prototype.close = function () {
    this.foundation.isOpen() && (document.removeEventListener("keydown", this.handleDocumentKeydown), this.foundation.close());
  }, e.prototype.componentDidMount = function () {
    t.prototype.componentDidMount.call(this), this.container = this.root.ref && this.root.ref.querySelector(o_.strings.CONTAINER_SELECTOR), this.content = this.root.ref && this.root.ref.querySelector(o_.strings.CONTENT_SELECTOR), this.buttons = this.root.ref && [].slice.call(this.root.ref.querySelectorAll(o_.strings.BUTTON_SELECTOR)), this.defaultButton = this.root.ref && this.root.ref.querySelector(o_.strings.DEFAULT_BUTTON_SELECTOR), this.container && (this.focusTrap = Ht(this.container, {
      initialFocus: void 0,
      escapeDeactivates: !1,
      clickOutsideDeactivates: !0
    })), this.handleDocumentKeydown = this.foundation.handleDocumentKeydown.bind(this.foundation), document.addEventListener("keydown", this.handleDocumentKeydown);
  }, e.prototype.componentWillUnmount = function () {
    t.prototype.componentWillUnmount.call(this), document.removeEventListener("keydown", this.handleDocumentKeydown);
  }, e.prototype.sync = function (t) {
    this.props.open ? this.open() : this.close();
  }, e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new o_({
      addClass: function addClass(e) {
        return t.root.addClass(e);
      },
      removeClass: function removeClass(e) {
        return t.root.removeClass(e);
      },
      hasClass: function hasClass(e) {
        return t.root.hasClass(e);
      },
      addBodyClass: function addBodyClass(t) {
        return document.body && document.body.classList.add(t);
      },
      removeBodyClass: function removeBodyClass(t) {
        return document.body && document.body.classList.remove(t);
      },
      eventTargetMatches: function eventTargetMatches(t, e) {
        return yt(t, e);
      },
      trapFocus: function trapFocus() {
        try {
          t.focusTrap && t.focusTrap.activate();
        } catch (t) {}
      },
      releaseFocus: function releaseFocus() {
        return t.focusTrap && t.focusTrap.deactivate();
      },
      isContentScrollable: function isContentScrollable() {
        return !!t.content && (e = t.content).scrollHeight > e.offsetHeight;
        var e;
      },
      areButtonsStacked: function areButtonsStacked() {
        return e = t.buttons, n = new Set(), [].forEach.call(e, function (t) {
          return n.add(t.offsetTop);
        }), n.size > 1;
        var e, n;
      },
      getActionFromEvent: function getActionFromEvent(t) {
        var e = vt(t.target, "[" + o_.strings.ACTION_ATTRIBUTE + "]");
        return e && e.getAttribute(o_.strings.ACTION_ATTRIBUTE);
      },
      clickDefaultButton: function clickDefaultButton() {
        t.defaultButton && t.defaultButton.click();
      },
      reverseButtons: function reverseButtons() {
        t.buttons && t.buttons.reverse(), t.buttons && t.buttons.forEach(function (t) {
          return t.parentElement && t.parentElement.appendChild(t);
        });
      },
      notifyOpening: function notifyOpening() {
        t.emit("onOpen", {}), t.props.onStateChange && t.props.onStateChange("opening");
      },
      notifyOpened: function notifyOpened() {
        t.emit("onOpened", {}), t.props.onStateChange && t.props.onStateChange("opened");
      },
      notifyClosing: function notifyClosing(e) {
        t.emit("onClose", e ? {
          action: e
        } : {}), t.props.onStateChange && t.props.onStateChange("closing");
      },
      notifyClosed: function notifyClosed(e) {
        t.emit("onClosed", e ? {
          action: e
        } : {}), t.props.onStateChange && t.props.onStateChange("closed");
      }
    });
  }, e.prototype.handleInteraction = function (t) {
    return "click" === t.type && this.props.onClick && this.props.onClick(t), "keydown" === t.type && this.props.onKeyDown && this.props.onKeyDown(t), this.foundation.handleInteraction(t);
  }, e.prototype.render = function () {
    var t = this.props,
        e = t.children,
        i = (t.open, t.onOpen, t.onClose, t.onStateChange, t.preventOutsideDismiss),
        r = p_(t, ["children", "open", "onOpen", "onClose", "onStateChange", "preventOutsideDismiss"]);
    return n(f_, _h_({}, this.root.props(r), {
      ref: this.root.setRef,
      onClick: this.handleInteraction,
      onKeyDown: this.handleInteraction
    }), n("div", {
      className: "mdc-dialog__container"
    }, n("div", {
      className: "mdc-dialog__surface"
    }, e)), n(m_, {
      disableInteraction: i
    }));
  }, e.displayName = "Dialog", e;
}(Rt),
    E_ = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return d_(e, t), e.prototype.render = function () {
    var t = this.props,
        e = t.title,
        i = t.header,
        r = t.body,
        o = t.footer,
        a = t.acceptLabel,
        s = t.cancelLabel,
        c = t.children,
        u = t.open,
        l = p_(t, ["title", "header", "body", "footer", "acceptLabel", "cancelLabel", "children", "open"]);
    return n(b_, _h_({
      open: u
    }, l), (!!e || !!i) && n(__, null, !!e && e, !!i && i), (!!r || c) && n(g_, null, r, c), (!!s || !!a || !!o) && n(v_, null, !!o && o, !!s && n(y_, {
      action: "close"
    }, s), !!a && n(y_, {
      action: "accept",
      isDefaultAction: !0
    }, a)));
  }, e.displayName = "SimpleDialog", e.defaultProps = {
    title: void 0,
    header: void 0,
    body: void 0,
    footer: void 0,
    acceptLabel: "Accept",
    cancelLabel: "Cancel",
    open: !1,
    children: void 0
  }, e;
}(i),
    C_ = {
  LABEL_FLOAT_ABOVE: "mdc-floating-label--float-above",
  LABEL_SHAKE: "mdc-floating-label--shake",
  ROOT: "mdc-floating-label"
},
    A_ = function (t) {
  function e(n) {
    var i = t.call(this, _jt({}, e.defaultAdapter, n)) || this;
    return i.shakeAnimationEndHandler_ = function () {
      return i.handleShakeAnimationEnd_();
    }, i;
  }

  return Vt(e, t), Object.defineProperty(e, "cssClasses", {
    get: function get() {
      return C_;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultAdapter", {
    get: function get() {
      return {
        addClass: function addClass() {},
        removeClass: function removeClass() {},
        getWidth: function getWidth() {
          return 0;
        },
        registerInteractionHandler: function registerInteractionHandler() {},
        deregisterInteractionHandler: function deregisterInteractionHandler() {}
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.init = function () {
    this.adapter_.registerInteractionHandler("animationend", this.shakeAnimationEndHandler_);
  }, e.prototype.destroy = function () {
    this.adapter_.deregisterInteractionHandler("animationend", this.shakeAnimationEndHandler_);
  }, e.prototype.getWidth = function () {
    return this.adapter_.getWidth();
  }, e.prototype.shake = function (t) {
    var n = e.cssClasses.LABEL_SHAKE;
    t ? this.adapter_.addClass(n) : this.adapter_.removeClass(n);
  }, e.prototype.float = function (t) {
    var n = e.cssClasses,
        i = n.LABEL_FLOAT_ABOVE,
        r = n.LABEL_SHAKE;
    t ? this.adapter_.addClass(i) : (this.adapter_.removeClass(i), this.adapter_.removeClass(r));
  }, e.prototype.handleShakeAnimationEnd_ = function () {
    var t = e.cssClasses.LABEL_SHAKE;
    this.adapter_.removeClass(t);
  }, e;
}(Yt),
    T_ = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return Vt(e, t), e.attachTo = function (t) {
    return new e(t);
  }, e.prototype.shake = function (t) {
    this.foundation_.shake(t);
  }, e.prototype.float = function (t) {
    this.foundation_.float(t);
  }, e.prototype.getWidth = function () {
    return this.foundation_.getWidth();
  }, e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new A_({
      addClass: function addClass(e) {
        return t.root_.classList.add(e);
      },
      removeClass: function removeClass(e) {
        return t.root_.classList.remove(e);
      },
      getWidth: function getWidth() {
        return t.root_.scrollWidth;
      },
      registerInteractionHandler: function registerInteractionHandler(e, n) {
        return t.listen(e, n);
      },
      deregisterInteractionHandler: function deregisterInteractionHandler(e, n) {
        return t.unlisten(e, n);
      }
    });
  }, e;
}($t),
    I_ = {
  LINE_RIPPLE_ACTIVE: "mdc-line-ripple--active",
  LINE_RIPPLE_DEACTIVATING: "mdc-line-ripple--deactivating"
},
    O_ = function (t) {
  function e(n) {
    var i = t.call(this, _jt({}, e.defaultAdapter, n)) || this;
    return i.transitionEndHandler_ = function (t) {
      return i.handleTransitionEnd(t);
    }, i;
  }

  return Vt(e, t), Object.defineProperty(e, "cssClasses", {
    get: function get() {
      return I_;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultAdapter", {
    get: function get() {
      return {
        addClass: function addClass() {},
        removeClass: function removeClass() {},
        hasClass: function hasClass() {
          return !1;
        },
        setStyle: function setStyle() {},
        registerEventHandler: function registerEventHandler() {},
        deregisterEventHandler: function deregisterEventHandler() {}
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.init = function () {
    this.adapter_.registerEventHandler("transitionend", this.transitionEndHandler_);
  }, e.prototype.destroy = function () {
    this.adapter_.deregisterEventHandler("transitionend", this.transitionEndHandler_);
  }, e.prototype.activate = function () {
    this.adapter_.removeClass(I_.LINE_RIPPLE_DEACTIVATING), this.adapter_.addClass(I_.LINE_RIPPLE_ACTIVE);
  }, e.prototype.setRippleCenter = function (t) {
    this.adapter_.setStyle("transform-origin", t + "px center");
  }, e.prototype.deactivate = function () {
    this.adapter_.addClass(I_.LINE_RIPPLE_DEACTIVATING);
  }, e.prototype.handleTransitionEnd = function (t) {
    var e = this.adapter_.hasClass(I_.LINE_RIPPLE_DEACTIVATING);
    "opacity" === t.propertyName && e && (this.adapter_.removeClass(I_.LINE_RIPPLE_ACTIVE), this.adapter_.removeClass(I_.LINE_RIPPLE_DEACTIVATING));
  }, e;
}(Yt),
    S_ = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return Vt(e, t), e.attachTo = function (t) {
    return new e(t);
  }, e.prototype.activate = function () {
    this.foundation_.activate();
  }, e.prototype.deactivate = function () {
    this.foundation_.deactivate();
  }, e.prototype.setRippleCenter = function (t) {
    this.foundation_.setRippleCenter(t);
  }, e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new O_({
      addClass: function addClass(e) {
        return t.root_.classList.add(e);
      },
      removeClass: function removeClass(e) {
        return t.root_.classList.remove(e);
      },
      hasClass: function hasClass(e) {
        return t.root_.classList.contains(e);
      },
      setStyle: function setStyle(e, n) {
        return t.root_.style.setProperty(e, n);
      },
      registerEventHandler: function registerEventHandler(e, n) {
        return t.listen(e, n);
      },
      deregisterEventHandler: function deregisterEventHandler(e, n) {
        return t.unlisten(e, n);
      }
    });
  }, e;
}($t),
    w_ = {
  NOTCH_ELEMENT_SELECTOR: ".mdc-notched-outline__notch"
},
    x_ = {
  NOTCH_ELEMENT_PADDING: 8
},
    N_ = {
  NO_LABEL: "mdc-notched-outline--no-label",
  OUTLINE_NOTCHED: "mdc-notched-outline--notched",
  OUTLINE_UPGRADED: "mdc-notched-outline--upgraded"
},
    R_ = function (t) {
  function e(n) {
    return t.call(this, _jt({}, e.defaultAdapter, n)) || this;
  }

  return Vt(e, t), Object.defineProperty(e, "strings", {
    get: function get() {
      return w_;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "cssClasses", {
    get: function get() {
      return N_;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "numbers", {
    get: function get() {
      return x_;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultAdapter", {
    get: function get() {
      return {
        addClass: function addClass() {},
        removeClass: function removeClass() {},
        setNotchWidthProperty: function setNotchWidthProperty() {},
        removeNotchWidthProperty: function removeNotchWidthProperty() {}
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.notch = function (t) {
    var n = e.cssClasses.OUTLINE_NOTCHED;
    t > 0 && (t += x_.NOTCH_ELEMENT_PADDING), this.adapter_.setNotchWidthProperty(t), this.adapter_.addClass(n);
  }, e.prototype.closeNotch = function () {
    var t = e.cssClasses.OUTLINE_NOTCHED;
    this.adapter_.removeClass(t), this.adapter_.removeNotchWidthProperty();
  }, e;
}(Yt),
    L_ = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return Vt(e, t), e.attachTo = function (t) {
    return new e(t);
  }, e.prototype.initialSyncWithDOM = function () {
    this.notchElement_ = this.root_.querySelector(w_.NOTCH_ELEMENT_SELECTOR);
    var t = this.root_.querySelector("." + A_.cssClasses.ROOT);
    t ? (t.style.transitionDuration = "0s", this.root_.classList.add(N_.OUTLINE_UPGRADED), requestAnimationFrame(function () {
      t.style.transitionDuration = "";
    })) : this.root_.classList.add(N_.NO_LABEL);
  }, e.prototype.notch = function (t) {
    this.foundation_.notch(t);
  }, e.prototype.closeNotch = function () {
    this.foundation_.closeNotch();
  }, e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new R_({
      addClass: function addClass(e) {
        return t.root_.classList.add(e);
      },
      removeClass: function removeClass(e) {
        return t.root_.classList.remove(e);
      },
      setNotchWidthProperty: function setNotchWidthProperty(e) {
        return t.notchElement_.style.setProperty("width", e + "px");
      },
      removeNotchWidthProperty: function removeNotchWidthProperty() {
        return t.notchElement_.style.removeProperty("width");
      }
    });
  }, e;
}($t),
    D_ = {
  BG_FOCUSED: "mdc-ripple-upgraded--background-focused",
  FG_ACTIVATION: "mdc-ripple-upgraded--foreground-activation",
  FG_DEACTIVATION: "mdc-ripple-upgraded--foreground-deactivation",
  ROOT: "mdc-ripple-upgraded",
  UNBOUNDED: "mdc-ripple-upgraded--unbounded"
},
    k_ = {
  VAR_FG_SCALE: "--mdc-ripple-fg-scale",
  VAR_FG_SIZE: "--mdc-ripple-fg-size",
  VAR_FG_TRANSLATE_END: "--mdc-ripple-fg-translate-end",
  VAR_FG_TRANSLATE_START: "--mdc-ripple-fg-translate-start",
  VAR_LEFT: "--mdc-ripple-left",
  VAR_TOP: "--mdc-ripple-top"
},
    P_ = {
  DEACTIVATION_TIMEOUT_MS: 225,
  FG_DEACTIVATION_MS: 150,
  INITIAL_ORIGIN_SCALE: .6,
  PADDING: 10,
  TAP_DELAY_MS: 300
};

function F_(t, e) {
  if (void 0 === t && (t = window), void 0 === e && (e = !1), void 0 === $m || e) {
    var n = !1;

    try {
      t.document.addEventListener("test", function () {}, {
        get passive() {
          return n = !0;
        }

      });
    } catch (t) {}

    $m = n;
  }

  return !!$m && {
    passive: !0
  };
}

var M_ = ["touchstart", "pointerdown", "mousedown", "keydown"],
    H_ = ["touchend", "pointerup", "mouseup", "contextmenu"],
    B_ = [],
    V_ = function (t) {
  function e(n) {
    var i = t.call(this, _jt({}, e.defaultAdapter, n)) || this;
    return i.activationAnimationHasEnded_ = !1, i.activationTimer_ = 0, i.fgDeactivationRemovalTimer_ = 0, i.fgScale_ = "0", i.frame_ = {
      width: 0,
      height: 0
    }, i.initialSize_ = 0, i.layoutFrame_ = 0, i.maxRadius_ = 0, i.unboundedCoords_ = {
      left: 0,
      top: 0
    }, i.activationState_ = i.defaultActivationState_(), i.activationTimerCallback_ = function () {
      i.activationAnimationHasEnded_ = !0, i.runDeactivationUXLogicIfReady_();
    }, i.activateHandler_ = function (t) {
      return i.activate_(t);
    }, i.deactivateHandler_ = function () {
      return i.deactivate_();
    }, i.focusHandler_ = function () {
      return i.handleFocus();
    }, i.blurHandler_ = function () {
      return i.handleBlur();
    }, i.resizeHandler_ = function () {
      return i.layout();
    }, i;
  }

  return Vt(e, t), Object.defineProperty(e, "cssClasses", {
    get: function get() {
      return D_;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "strings", {
    get: function get() {
      return k_;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "numbers", {
    get: function get() {
      return P_;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultAdapter", {
    get: function get() {
      return {
        addClass: function addClass() {},
        browserSupportsCssVars: function browserSupportsCssVars() {
          return !0;
        },
        computeBoundingRect: function computeBoundingRect() {
          return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            width: 0,
            height: 0
          };
        },
        containsEventTarget: function containsEventTarget() {
          return !0;
        },
        deregisterDocumentInteractionHandler: function deregisterDocumentInteractionHandler() {},
        deregisterInteractionHandler: function deregisterInteractionHandler() {},
        deregisterResizeHandler: function deregisterResizeHandler() {},
        getWindowPageOffset: function getWindowPageOffset() {
          return {
            x: 0,
            y: 0
          };
        },
        isSurfaceActive: function isSurfaceActive() {
          return !0;
        },
        isSurfaceDisabled: function isSurfaceDisabled() {
          return !0;
        },
        isUnbounded: function isUnbounded() {
          return !0;
        },
        registerDocumentInteractionHandler: function registerDocumentInteractionHandler() {},
        registerInteractionHandler: function registerInteractionHandler() {},
        registerResizeHandler: function registerResizeHandler() {},
        removeClass: function removeClass() {},
        updateCssVariable: function updateCssVariable() {}
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.init = function () {
    var t = this,
        n = this.supportsPressRipple_();

    if (this.registerRootHandlers_(n), n) {
      var i = e.cssClasses,
          r = i.ROOT,
          o = i.UNBOUNDED;
      requestAnimationFrame(function () {
        t.adapter_.addClass(r), t.adapter_.isUnbounded() && (t.adapter_.addClass(o), t.layoutInternal_());
      });
    }
  }, e.prototype.destroy = function () {
    var t = this;

    if (this.supportsPressRipple_()) {
      this.activationTimer_ && (clearTimeout(this.activationTimer_), this.activationTimer_ = 0, this.adapter_.removeClass(e.cssClasses.FG_ACTIVATION)), this.fgDeactivationRemovalTimer_ && (clearTimeout(this.fgDeactivationRemovalTimer_), this.fgDeactivationRemovalTimer_ = 0, this.adapter_.removeClass(e.cssClasses.FG_DEACTIVATION));
      var n = e.cssClasses,
          i = n.ROOT,
          r = n.UNBOUNDED;
      requestAnimationFrame(function () {
        t.adapter_.removeClass(i), t.adapter_.removeClass(r), t.removeCssVars_();
      });
    }

    this.deregisterRootHandlers_(), this.deregisterDeactivationHandlers_();
  }, e.prototype.activate = function (t) {
    this.activate_(t);
  }, e.prototype.deactivate = function () {
    this.deactivate_();
  }, e.prototype.layout = function () {
    var t = this;
    this.layoutFrame_ && cancelAnimationFrame(this.layoutFrame_), this.layoutFrame_ = requestAnimationFrame(function () {
      t.layoutInternal_(), t.layoutFrame_ = 0;
    });
  }, e.prototype.setUnbounded = function (t) {
    var n = e.cssClasses.UNBOUNDED;
    t ? this.adapter_.addClass(n) : this.adapter_.removeClass(n);
  }, e.prototype.handleFocus = function () {
    var t = this;
    requestAnimationFrame(function () {
      return t.adapter_.addClass(e.cssClasses.BG_FOCUSED);
    });
  }, e.prototype.handleBlur = function () {
    var t = this;
    requestAnimationFrame(function () {
      return t.adapter_.removeClass(e.cssClasses.BG_FOCUSED);
    });
  }, e.prototype.supportsPressRipple_ = function () {
    return this.adapter_.browserSupportsCssVars();
  }, e.prototype.defaultActivationState_ = function () {
    return {
      activationEvent: void 0,
      hasDeactivationUXRun: !1,
      isActivated: !1,
      isProgrammatic: !1,
      wasActivatedByPointer: !1,
      wasElementMadeActive: !1
    };
  }, e.prototype.registerRootHandlers_ = function (t) {
    var e = this;
    t && (M_.forEach(function (t) {
      e.adapter_.registerInteractionHandler(t, e.activateHandler_);
    }), this.adapter_.isUnbounded() && this.adapter_.registerResizeHandler(this.resizeHandler_)), this.adapter_.registerInteractionHandler("focus", this.focusHandler_), this.adapter_.registerInteractionHandler("blur", this.blurHandler_);
  }, e.prototype.registerDeactivationHandlers_ = function (t) {
    var e = this;
    "keydown" === t.type ? this.adapter_.registerInteractionHandler("keyup", this.deactivateHandler_) : H_.forEach(function (t) {
      e.adapter_.registerDocumentInteractionHandler(t, e.deactivateHandler_);
    });
  }, e.prototype.deregisterRootHandlers_ = function () {
    var t = this;
    M_.forEach(function (e) {
      t.adapter_.deregisterInteractionHandler(e, t.activateHandler_);
    }), this.adapter_.deregisterInteractionHandler("focus", this.focusHandler_), this.adapter_.deregisterInteractionHandler("blur", this.blurHandler_), this.adapter_.isUnbounded() && this.adapter_.deregisterResizeHandler(this.resizeHandler_);
  }, e.prototype.deregisterDeactivationHandlers_ = function () {
    var t = this;
    this.adapter_.deregisterInteractionHandler("keyup", this.deactivateHandler_), H_.forEach(function (e) {
      t.adapter_.deregisterDocumentInteractionHandler(e, t.deactivateHandler_);
    });
  }, e.prototype.removeCssVars_ = function () {
    var t = this,
        n = e.strings;
    Object.keys(n).forEach(function (e) {
      0 === e.indexOf("VAR_") && t.adapter_.updateCssVariable(n[e], null);
    });
  }, e.prototype.activate_ = function (t) {
    var e = this;

    if (!this.adapter_.isSurfaceDisabled()) {
      var n = this.activationState_;

      if (!n.isActivated) {
        var i = this.previousActivationEvent_;
        if (!(i && void 0 !== t && i.type !== t.type)) n.isActivated = !0, n.isProgrammatic = void 0 === t, n.activationEvent = t, n.wasActivatedByPointer = !n.isProgrammatic && void 0 !== t && ("mousedown" === t.type || "touchstart" === t.type || "pointerdown" === t.type), void 0 !== t && B_.length > 0 && B_.some(function (t) {
          return e.adapter_.containsEventTarget(t);
        }) ? this.resetActivationState_() : (void 0 !== t && (B_.push(t.target), this.registerDeactivationHandlers_(t)), n.wasElementMadeActive = this.checkElementMadeActive_(t), n.wasElementMadeActive && this.animateActivation_(), requestAnimationFrame(function () {
          B_ = [], n.wasElementMadeActive || void 0 === t || " " !== t.key && 32 !== t.keyCode || (n.wasElementMadeActive = e.checkElementMadeActive_(t), n.wasElementMadeActive && e.animateActivation_()), n.wasElementMadeActive || (e.activationState_ = e.defaultActivationState_());
        }));
      }
    }
  }, e.prototype.checkElementMadeActive_ = function (t) {
    return void 0 === t || "keydown" !== t.type || this.adapter_.isSurfaceActive();
  }, e.prototype.animateActivation_ = function () {
    var t = this,
        n = e.strings,
        i = n.VAR_FG_TRANSLATE_START,
        r = n.VAR_FG_TRANSLATE_END,
        o = e.cssClasses,
        a = o.FG_DEACTIVATION,
        s = o.FG_ACTIVATION,
        c = e.numbers.DEACTIVATION_TIMEOUT_MS;
    this.layoutInternal_();
    var u = "",
        l = "";

    if (!this.adapter_.isUnbounded()) {
      var d = this.getFgTranslationCoordinates_(),
          h = d.startPoint,
          p = d.endPoint;
      u = h.x + "px, " + h.y + "px", l = p.x + "px, " + p.y + "px";
    }

    this.adapter_.updateCssVariable(i, u), this.adapter_.updateCssVariable(r, l), clearTimeout(this.activationTimer_), clearTimeout(this.fgDeactivationRemovalTimer_), this.rmBoundedActivationClasses_(), this.adapter_.removeClass(a), this.adapter_.computeBoundingRect(), this.adapter_.addClass(s), this.activationTimer_ = setTimeout(function () {
      return t.activationTimerCallback_();
    }, c);
  }, e.prototype.getFgTranslationCoordinates_ = function () {
    var t,
        e = this.activationState_,
        n = e.activationEvent;
    return {
      startPoint: t = {
        x: (t = e.wasActivatedByPointer ? function (t, e, n) {
          if (!t) return {
            x: 0,
            y: 0
          };
          var i,
              r,
              o = e.x,
              a = e.y,
              s = o + n.left,
              c = a + n.top;

          if ("touchstart" === t.type) {
            var u = t;
            i = u.changedTouches[0].pageX - s, r = u.changedTouches[0].pageY - c;
          } else {
            var l = t;
            i = l.pageX - s, r = l.pageY - c;
          }

          return {
            x: i,
            y: r
          };
        }(n, this.adapter_.getWindowPageOffset(), this.adapter_.computeBoundingRect()) : {
          x: this.frame_.width / 2,
          y: this.frame_.height / 2
        }).x - this.initialSize_ / 2,
        y: t.y - this.initialSize_ / 2
      },
      endPoint: {
        x: this.frame_.width / 2 - this.initialSize_ / 2,
        y: this.frame_.height / 2 - this.initialSize_ / 2
      }
    };
  }, e.prototype.runDeactivationUXLogicIfReady_ = function () {
    var t = this,
        n = e.cssClasses.FG_DEACTIVATION,
        i = this.activationState_,
        r = i.hasDeactivationUXRun,
        o = i.isActivated;
    (r || !o) && this.activationAnimationHasEnded_ && (this.rmBoundedActivationClasses_(), this.adapter_.addClass(n), this.fgDeactivationRemovalTimer_ = setTimeout(function () {
      t.adapter_.removeClass(n);
    }, P_.FG_DEACTIVATION_MS));
  }, e.prototype.rmBoundedActivationClasses_ = function () {
    var t = e.cssClasses.FG_ACTIVATION;
    this.adapter_.removeClass(t), this.activationAnimationHasEnded_ = !1, this.adapter_.computeBoundingRect();
  }, e.prototype.resetActivationState_ = function () {
    var t = this;
    this.previousActivationEvent_ = this.activationState_.activationEvent, this.activationState_ = this.defaultActivationState_(), setTimeout(function () {
      return t.previousActivationEvent_ = void 0;
    }, e.numbers.TAP_DELAY_MS);
  }, e.prototype.deactivate_ = function () {
    var t = this,
        e = this.activationState_;

    if (e.isActivated) {
      var n = _jt({}, e);

      e.isProgrammatic ? (requestAnimationFrame(function () {
        return t.animateDeactivation_(n);
      }), this.resetActivationState_()) : (this.deregisterDeactivationHandlers_(), requestAnimationFrame(function () {
        t.activationState_.hasDeactivationUXRun = !0, t.animateDeactivation_(n), t.resetActivationState_();
      }));
    }
  }, e.prototype.animateDeactivation_ = function (t) {
    var e = t.wasActivatedByPointer,
        n = t.wasElementMadeActive;
    (e || n) && this.runDeactivationUXLogicIfReady_();
  }, e.prototype.layoutInternal_ = function () {
    var t = this;
    this.frame_ = this.adapter_.computeBoundingRect();
    var n = Math.max(this.frame_.height, this.frame_.width);
    this.maxRadius_ = this.adapter_.isUnbounded() ? n : Math.sqrt(Math.pow(t.frame_.width, 2) + Math.pow(t.frame_.height, 2)) + e.numbers.PADDING, this.initialSize_ = Math.floor(n * e.numbers.INITIAL_ORIGIN_SCALE), this.fgScale_ = "" + this.maxRadius_ / this.initialSize_, this.updateLayoutCssVars_();
  }, e.prototype.updateLayoutCssVars_ = function () {
    var t = e.strings,
        n = t.VAR_FG_SIZE,
        i = t.VAR_LEFT,
        r = t.VAR_TOP,
        o = t.VAR_FG_SCALE;
    this.adapter_.updateCssVariable(n, this.initialSize_ + "px"), this.adapter_.updateCssVariable(o, this.fgScale_), this.adapter_.isUnbounded() && (this.unboundedCoords_ = {
      left: Math.round(this.frame_.width / 2 - this.initialSize_ / 2),
      top: Math.round(this.frame_.height / 2 - this.initialSize_ / 2)
    }, this.adapter_.updateCssVariable(i, this.unboundedCoords_.left + "px"), this.adapter_.updateCssVariable(r, this.unboundedCoords_.top + "px"));
  }, e;
}(Yt),
    j_ = function (t) {
  function e() {
    var e = null !== t && t.apply(this, arguments) || this;
    return e.disabled = !1, e;
  }

  return Vt(e, t), e.attachTo = function (t, n) {
    void 0 === n && (n = {
      isUnbounded: void 0
    });
    var i = new e(t);
    return void 0 !== n.isUnbounded && (i.unbounded = n.isUnbounded), i;
  }, e.createAdapter = function (t) {
    return {
      addClass: function addClass(e) {
        return t.root_.classList.add(e);
      },
      browserSupportsCssVars: function browserSupportsCssVars() {
        return function (t, e) {
          void 0 === e && (e = !1);
          var n = t.CSS,
              i = Ym;
          if ("boolean" == typeof Ym && !e) return Ym;
          if (!n || "function" != typeof n.supports) return !1;
          var r = n.supports("--css-vars", "yes"),
              o = n.supports("(--css-vars: yes)") && n.supports("color", "#00000000");
          return i = !(!r && !o || function (t) {
            var e = t.document,
                n = e.createElement("div");
            n.className = "mdc-ripple-surface--test-edge-var-bug", e.body.appendChild(n);
            var i = t.getComputedStyle(n),
                r = null !== i && "solid" === i.borderTopStyle;
            return n.parentNode && n.parentNode.removeChild(n), r;
          }(t)), e || (Ym = i), i;
        }(window);
      },
      computeBoundingRect: function computeBoundingRect() {
        return t.root_.getBoundingClientRect();
      },
      containsEventTarget: function containsEventTarget(e) {
        return t.root_.contains(e);
      },
      deregisterDocumentInteractionHandler: function deregisterDocumentInteractionHandler(t, e) {
        return document.documentElement.removeEventListener(t, e, F_());
      },
      deregisterInteractionHandler: function deregisterInteractionHandler(e, n) {
        return t.root_.removeEventListener(e, n, F_());
      },
      deregisterResizeHandler: function deregisterResizeHandler(t) {
        return window.removeEventListener("resize", t);
      },
      getWindowPageOffset: function getWindowPageOffset() {
        return {
          x: window.pageXOffset,
          y: window.pageYOffset
        };
      },
      isSurfaceActive: function isSurfaceActive() {
        return Zt(t.root_, ":active");
      },
      isSurfaceDisabled: function isSurfaceDisabled() {
        return Boolean(t.disabled);
      },
      isUnbounded: function isUnbounded() {
        return Boolean(t.unbounded);
      },
      registerDocumentInteractionHandler: function registerDocumentInteractionHandler(t, e) {
        return document.documentElement.addEventListener(t, e, F_());
      },
      registerInteractionHandler: function registerInteractionHandler(e, n) {
        return t.root_.addEventListener(e, n, F_());
      },
      registerResizeHandler: function registerResizeHandler(t) {
        return window.addEventListener("resize", t);
      },
      removeClass: function removeClass(e) {
        return t.root_.classList.remove(e);
      },
      updateCssVariable: function updateCssVariable(e, n) {
        return t.root_.style.setProperty(e, n);
      }
    };
  }, Object.defineProperty(e.prototype, "unbounded", {
    get: function get() {
      return Boolean(this.unbounded_);
    },
    set: function set(t) {
      this.unbounded_ = Boolean(t), this.setUnbounded_();
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.activate = function () {
    this.foundation_.activate();
  }, e.prototype.deactivate = function () {
    this.foundation_.deactivate();
  }, e.prototype.layout = function () {
    this.foundation_.layout();
  }, e.prototype.getDefaultFoundation = function () {
    return new V_(e.createAdapter(this));
  }, e.prototype.initialSyncWithDOM = function () {
    var t = this.root_;
    this.unbounded = "mdcRippleIsUnbounded" in t.dataset;
  }, e.prototype.setUnbounded_ = function () {
    this.foundation_.setUnbounded(Boolean(this.unbounded_));
  }, e;
}($t),
    U_ = {
  ROOT: "mdc-text-field-character-counter"
},
    G_ = {
  ROOT_SELECTOR: "." + U_.ROOT
},
    z_ = function (t) {
  function e(n) {
    return t.call(this, _jt({}, e.defaultAdapter, n)) || this;
  }

  return Vt(e, t), Object.defineProperty(e, "cssClasses", {
    get: function get() {
      return U_;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "strings", {
    get: function get() {
      return G_;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultAdapter", {
    get: function get() {
      return {
        setContent: function setContent() {}
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.setCounterValue = function (t, e) {
    t = Math.min(t, e), this.adapter_.setContent(t + " / " + e);
  }, e;
}(Yt),
    K_ = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return Vt(e, t), e.attachTo = function (t) {
    return new e(t);
  }, Object.defineProperty(e.prototype, "foundation", {
    get: function get() {
      return this.foundation_;
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new z_({
      setContent: function setContent(e) {
        t.root_.textContent = e;
      }
    });
  }, e;
}($t),
    q_ = {
  ARIA_CONTROLS: "aria-controls",
  ICON_SELECTOR: ".mdc-text-field__icon",
  INPUT_SELECTOR: ".mdc-text-field__input",
  LABEL_SELECTOR: ".mdc-floating-label",
  LINE_RIPPLE_SELECTOR: ".mdc-line-ripple",
  OUTLINE_SELECTOR: ".mdc-notched-outline"
},
    W_ = {
  DENSE: "mdc-text-field--dense",
  DISABLED: "mdc-text-field--disabled",
  FOCUSED: "mdc-text-field--focused",
  FULLWIDTH: "mdc-text-field--fullwidth",
  HELPER_LINE: "mdc-text-field-helper-line",
  INVALID: "mdc-text-field--invalid",
  NO_LABEL: "mdc-text-field--no-label",
  OUTLINED: "mdc-text-field--outlined",
  ROOT: "mdc-text-field",
  TEXTAREA: "mdc-text-field--textarea",
  WITH_LEADING_ICON: "mdc-text-field--with-leading-icon",
  WITH_TRAILING_ICON: "mdc-text-field--with-trailing-icon"
},
    X_ = {
  DENSE_LABEL_SCALE: .923,
  LABEL_SCALE: .75
},
    Y_ = ["pattern", "min", "max", "required", "step", "minlength", "maxlength"],
    $_ = ["color", "date", "datetime-local", "month", "range", "time", "week"],
    Q_ = ["mousedown", "touchstart"],
    Z_ = ["click", "keydown"],
    J_ = function (t) {
  function e(n, i) {
    void 0 === i && (i = {});
    var r = t.call(this, _jt({}, e.defaultAdapter, n)) || this;
    return r.isFocused_ = !1, r.receivedUserInput_ = !1, r.isValid_ = !0, r.useNativeValidation_ = !0, r.helperText_ = i.helperText, r.characterCounter_ = i.characterCounter, r.leadingIcon_ = i.leadingIcon, r.trailingIcon_ = i.trailingIcon, r.inputFocusHandler_ = function () {
      return r.activateFocus();
    }, r.inputBlurHandler_ = function () {
      return r.deactivateFocus();
    }, r.inputInputHandler_ = function () {
      return r.handleInput();
    }, r.setPointerXOffset_ = function (t) {
      return r.setTransformOrigin(t);
    }, r.textFieldInteractionHandler_ = function () {
      return r.handleTextFieldInteraction();
    }, r.validationAttributeChangeHandler_ = function (t) {
      return r.handleValidationAttributeChange(t);
    }, r;
  }

  return Vt(e, t), Object.defineProperty(e, "cssClasses", {
    get: function get() {
      return W_;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "strings", {
    get: function get() {
      return q_;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "numbers", {
    get: function get() {
      return X_;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "shouldAlwaysFloat_", {
    get: function get() {
      var t = this.getNativeInput_().type;
      return $_.indexOf(t) >= 0;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "shouldFloat", {
    get: function get() {
      return this.shouldAlwaysFloat_ || this.isFocused_ || Boolean(this.getValue()) || this.isBadInput_();
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "shouldShake", {
    get: function get() {
      return !this.isFocused_ && !this.isValid() && Boolean(this.getValue());
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultAdapter", {
    get: function get() {
      return {
        addClass: function addClass() {},
        removeClass: function removeClass() {},
        hasClass: function hasClass() {
          return !0;
        },
        registerTextFieldInteractionHandler: function registerTextFieldInteractionHandler() {},
        deregisterTextFieldInteractionHandler: function deregisterTextFieldInteractionHandler() {},
        registerInputInteractionHandler: function registerInputInteractionHandler() {},
        deregisterInputInteractionHandler: function deregisterInputInteractionHandler() {},
        registerValidationAttributeChangeHandler: function registerValidationAttributeChangeHandler() {
          return new MutationObserver(function () {});
        },
        deregisterValidationAttributeChangeHandler: function deregisterValidationAttributeChangeHandler() {},
        getNativeInput: function getNativeInput() {
          return null;
        },
        isFocused: function isFocused() {
          return !1;
        },
        activateLineRipple: function activateLineRipple() {},
        deactivateLineRipple: function deactivateLineRipple() {},
        setLineRippleTransformOrigin: function setLineRippleTransformOrigin() {},
        shakeLabel: function shakeLabel() {},
        floatLabel: function floatLabel() {},
        hasLabel: function hasLabel() {
          return !1;
        },
        getLabelWidth: function getLabelWidth() {
          return 0;
        },
        hasOutline: function hasOutline() {
          return !1;
        },
        notchOutline: function notchOutline() {},
        closeOutline: function closeOutline() {}
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.init = function () {
    var t = this;
    this.adapter_.isFocused() ? this.inputFocusHandler_() : this.adapter_.hasLabel() && this.shouldFloat && (this.notchOutline(!0), this.adapter_.floatLabel(!0)), this.adapter_.registerInputInteractionHandler("focus", this.inputFocusHandler_), this.adapter_.registerInputInteractionHandler("blur", this.inputBlurHandler_), this.adapter_.registerInputInteractionHandler("input", this.inputInputHandler_), Q_.forEach(function (e) {
      t.adapter_.registerInputInteractionHandler(e, t.setPointerXOffset_);
    }), Z_.forEach(function (e) {
      t.adapter_.registerTextFieldInteractionHandler(e, t.textFieldInteractionHandler_);
    }), this.validationObserver_ = this.adapter_.registerValidationAttributeChangeHandler(this.validationAttributeChangeHandler_), this.setCharacterCounter_(this.getValue().length);
  }, e.prototype.destroy = function () {
    var t = this;
    this.adapter_.deregisterInputInteractionHandler("focus", this.inputFocusHandler_), this.adapter_.deregisterInputInteractionHandler("blur", this.inputBlurHandler_), this.adapter_.deregisterInputInteractionHandler("input", this.inputInputHandler_), Q_.forEach(function (e) {
      t.adapter_.deregisterInputInteractionHandler(e, t.setPointerXOffset_);
    }), Z_.forEach(function (e) {
      t.adapter_.deregisterTextFieldInteractionHandler(e, t.textFieldInteractionHandler_);
    }), this.adapter_.deregisterValidationAttributeChangeHandler(this.validationObserver_);
  }, e.prototype.handleTextFieldInteraction = function () {
    var t = this.adapter_.getNativeInput();
    t && t.disabled || (this.receivedUserInput_ = !0);
  }, e.prototype.handleValidationAttributeChange = function (t) {
    var e = this;
    t.some(function (t) {
      return Y_.indexOf(t) > -1 && (e.styleValidity_(!0), !0);
    }), t.indexOf("maxlength") > -1 && this.setCharacterCounter_(this.getValue().length);
  }, e.prototype.notchOutline = function (t) {
    if (this.adapter_.hasOutline()) if (t) {
      var e = this.adapter_.hasClass(W_.DENSE) ? X_.DENSE_LABEL_SCALE : X_.LABEL_SCALE,
          n = this.adapter_.getLabelWidth() * e;
      this.adapter_.notchOutline(n);
    } else this.adapter_.closeOutline();
  }, e.prototype.activateFocus = function () {
    this.isFocused_ = !0, this.styleFocused_(this.isFocused_), this.adapter_.activateLineRipple(), this.adapter_.hasLabel() && (this.notchOutline(this.shouldFloat), this.adapter_.floatLabel(this.shouldFloat), this.adapter_.shakeLabel(this.shouldShake)), this.helperText_ && this.helperText_.showToScreenReader();
  }, e.prototype.setTransformOrigin = function (t) {
    var e = t.touches,
        n = e ? e[0] : t,
        i = n.target.getBoundingClientRect(),
        r = n.clientX - i.left;
    this.adapter_.setLineRippleTransformOrigin(r);
  }, e.prototype.handleInput = function () {
    this.autoCompleteFocus(), this.setCharacterCounter_(this.getValue().length);
  }, e.prototype.autoCompleteFocus = function () {
    this.receivedUserInput_ || this.activateFocus();
  }, e.prototype.deactivateFocus = function () {
    this.isFocused_ = !1, this.adapter_.deactivateLineRipple();
    var t = this.isValid();
    this.styleValidity_(t), this.styleFocused_(this.isFocused_), this.adapter_.hasLabel() && (this.notchOutline(this.shouldFloat), this.adapter_.floatLabel(this.shouldFloat), this.adapter_.shakeLabel(this.shouldShake)), this.shouldFloat || (this.receivedUserInput_ = !1);
  }, e.prototype.getValue = function () {
    return this.getNativeInput_().value;
  }, e.prototype.setValue = function (t) {
    this.getValue() !== t && (this.getNativeInput_().value = t), this.setCharacterCounter_(t.length);
    var e = this.isValid();
    this.styleValidity_(e), this.adapter_.hasLabel() && (this.notchOutline(this.shouldFloat), this.adapter_.floatLabel(this.shouldFloat), this.adapter_.shakeLabel(this.shouldShake));
  }, e.prototype.isValid = function () {
    return this.useNativeValidation_ ? this.isNativeInputValid_() : this.isValid_;
  }, e.prototype.setValid = function (t) {
    this.isValid_ = t, this.styleValidity_(t);
    var e = !t && !this.isFocused_;
    this.adapter_.hasLabel() && this.adapter_.shakeLabel(e);
  }, e.prototype.setUseNativeValidation = function (t) {
    this.useNativeValidation_ = t;
  }, e.prototype.isDisabled = function () {
    return this.getNativeInput_().disabled;
  }, e.prototype.setDisabled = function (t) {
    this.getNativeInput_().disabled = t, this.styleDisabled_(t);
  }, e.prototype.setHelperTextContent = function (t) {
    this.helperText_ && this.helperText_.setContent(t);
  }, e.prototype.setLeadingIconAriaLabel = function (t) {
    this.leadingIcon_ && this.leadingIcon_.setAriaLabel(t);
  }, e.prototype.setLeadingIconContent = function (t) {
    this.leadingIcon_ && this.leadingIcon_.setContent(t);
  }, e.prototype.setTrailingIconAriaLabel = function (t) {
    this.trailingIcon_ && this.trailingIcon_.setAriaLabel(t);
  }, e.prototype.setTrailingIconContent = function (t) {
    this.trailingIcon_ && this.trailingIcon_.setContent(t);
  }, e.prototype.setCharacterCounter_ = function (t) {
    if (this.characterCounter_) {
      var e = this.getNativeInput_().maxLength;
      if (-1 === e) throw new Error("MDCTextFieldFoundation: Expected maxlength html property on text input or textarea.");
      this.characterCounter_.setCounterValue(t, e);
    }
  }, e.prototype.isBadInput_ = function () {
    return this.getNativeInput_().validity.badInput || !1;
  }, e.prototype.isNativeInputValid_ = function () {
    return this.getNativeInput_().validity.valid;
  }, e.prototype.styleValidity_ = function (t) {
    var n = e.cssClasses.INVALID;
    t ? this.adapter_.removeClass(n) : this.adapter_.addClass(n), this.helperText_ && this.helperText_.setValidity(t);
  }, e.prototype.styleFocused_ = function (t) {
    var n = e.cssClasses.FOCUSED;
    t ? this.adapter_.addClass(n) : this.adapter_.removeClass(n);
  }, e.prototype.styleDisabled_ = function (t) {
    var n = e.cssClasses,
        i = n.DISABLED,
        r = n.INVALID;
    t ? (this.adapter_.addClass(i), this.adapter_.removeClass(r)) : this.adapter_.removeClass(i), this.leadingIcon_ && this.leadingIcon_.setDisabled(t), this.trailingIcon_ && this.trailingIcon_.setDisabled(t);
  }, e.prototype.getNativeInput_ = function () {
    return (this.adapter_ ? this.adapter_.getNativeInput() : null) || {
      disabled: !1,
      maxLength: -1,
      type: "input",
      validity: {
        badInput: !1,
        valid: !0
      },
      value: ""
    };
  }, e;
}(Yt),
    tg = {
  HELPER_TEXT_PERSISTENT: "mdc-text-field-helper-text--persistent",
  HELPER_TEXT_VALIDATION_MSG: "mdc-text-field-helper-text--validation-msg",
  ROOT: "mdc-text-field-helper-text"
},
    eg = {
  ARIA_HIDDEN: "aria-hidden",
  ROLE: "role",
  ROOT_SELECTOR: "." + tg.ROOT
},
    ng = function (t) {
  function e(n) {
    return t.call(this, _jt({}, e.defaultAdapter, n)) || this;
  }

  return Vt(e, t), Object.defineProperty(e, "cssClasses", {
    get: function get() {
      return tg;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "strings", {
    get: function get() {
      return eg;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultAdapter", {
    get: function get() {
      return {
        addClass: function addClass() {},
        removeClass: function removeClass() {},
        hasClass: function hasClass() {
          return !1;
        },
        setAttr: function setAttr() {},
        removeAttr: function removeAttr() {},
        setContent: function setContent() {}
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.setContent = function (t) {
    this.adapter_.setContent(t);
  }, e.prototype.setPersistent = function (t) {
    t ? this.adapter_.addClass(tg.HELPER_TEXT_PERSISTENT) : this.adapter_.removeClass(tg.HELPER_TEXT_PERSISTENT);
  }, e.prototype.setValidation = function (t) {
    t ? this.adapter_.addClass(tg.HELPER_TEXT_VALIDATION_MSG) : this.adapter_.removeClass(tg.HELPER_TEXT_VALIDATION_MSG);
  }, e.prototype.showToScreenReader = function () {
    this.adapter_.removeAttr(eg.ARIA_HIDDEN);
  }, e.prototype.setValidity = function (t) {
    var e = this.adapter_.hasClass(tg.HELPER_TEXT_PERSISTENT),
        n = this.adapter_.hasClass(tg.HELPER_TEXT_VALIDATION_MSG) && !t;
    n ? this.adapter_.setAttr(eg.ROLE, "alert") : this.adapter_.removeAttr(eg.ROLE), e || n || this.hide_();
  }, e.prototype.hide_ = function () {
    this.adapter_.setAttr(eg.ARIA_HIDDEN, "true");
  }, e;
}(Yt),
    ig = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return Vt(e, t), e.attachTo = function (t) {
    return new e(t);
  }, Object.defineProperty(e.prototype, "foundation", {
    get: function get() {
      return this.foundation_;
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new ng({
      addClass: function addClass(e) {
        return t.root_.classList.add(e);
      },
      removeClass: function removeClass(e) {
        return t.root_.classList.remove(e);
      },
      hasClass: function hasClass(e) {
        return t.root_.classList.contains(e);
      },
      setAttr: function setAttr(e, n) {
        return t.root_.setAttribute(e, n);
      },
      removeAttr: function removeAttr(e) {
        return t.root_.removeAttribute(e);
      },
      setContent: function setContent(e) {
        t.root_.textContent = e;
      }
    });
  }, e;
}($t),
    rg = {
  ICON_EVENT: "MDCTextField:icon",
  ICON_ROLE: "button"
},
    og = {
  ROOT: "mdc-text-field__icon"
},
    ag = ["click", "keydown"],
    sg = function (t) {
  function e(n) {
    var i = t.call(this, _jt({}, e.defaultAdapter, n)) || this;
    return i.savedTabIndex_ = null, i.interactionHandler_ = function (t) {
      return i.handleInteraction(t);
    }, i;
  }

  return Vt(e, t), Object.defineProperty(e, "strings", {
    get: function get() {
      return rg;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "cssClasses", {
    get: function get() {
      return og;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultAdapter", {
    get: function get() {
      return {
        getAttr: function getAttr() {
          return null;
        },
        setAttr: function setAttr() {},
        removeAttr: function removeAttr() {},
        setContent: function setContent() {},
        registerInteractionHandler: function registerInteractionHandler() {},
        deregisterInteractionHandler: function deregisterInteractionHandler() {},
        notifyIconAction: function notifyIconAction() {}
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.init = function () {
    var t = this;
    this.savedTabIndex_ = this.adapter_.getAttr("tabindex"), ag.forEach(function (e) {
      t.adapter_.registerInteractionHandler(e, t.interactionHandler_);
    });
  }, e.prototype.destroy = function () {
    var t = this;
    ag.forEach(function (e) {
      t.adapter_.deregisterInteractionHandler(e, t.interactionHandler_);
    });
  }, e.prototype.setDisabled = function (t) {
    this.savedTabIndex_ && (t ? (this.adapter_.setAttr("tabindex", "-1"), this.adapter_.removeAttr("role")) : (this.adapter_.setAttr("tabindex", this.savedTabIndex_), this.adapter_.setAttr("role", rg.ICON_ROLE)));
  }, e.prototype.setAriaLabel = function (t) {
    this.adapter_.setAttr("aria-label", t);
  }, e.prototype.setContent = function (t) {
    this.adapter_.setContent(t);
  }, e.prototype.handleInteraction = function (t) {
    var e = "Enter" === t.key || 13 === t.keyCode;
    ("click" === t.type || e) && this.adapter_.notifyIconAction();
  }, e;
}(Yt),
    cg = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return Vt(e, t), e.attachTo = function (t) {
    return new e(t);
  }, Object.defineProperty(e.prototype, "foundation", {
    get: function get() {
      return this.foundation_;
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new sg({
      getAttr: function getAttr(e) {
        return t.root_.getAttribute(e);
      },
      setAttr: function setAttr(e, n) {
        return t.root_.setAttribute(e, n);
      },
      removeAttr: function removeAttr(e) {
        return t.root_.removeAttribute(e);
      },
      setContent: function setContent(e) {
        t.root_.textContent = e;
      },
      registerInteractionHandler: function registerInteractionHandler(e, n) {
        return t.listen(e, n);
      },
      deregisterInteractionHandler: function deregisterInteractionHandler(e, n) {
        return t.unlisten(e, n);
      },
      notifyIconAction: function notifyIconAction() {
        return t.emit(sg.strings.ICON_EVENT, {}, !0);
      }
    });
  }, e;
}($t),
    ug = (function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  Vt(e, t), e.attachTo = function (t) {
    return new e(t);
  }, e.prototype.initialize = function (t, e, n, i, r, o, a) {
    void 0 === t && (t = function t(_t41, e) {
      return new j_(_t41, e);
    }), void 0 === e && (e = function e(t) {
      return new S_(t);
    }), void 0 === n && (n = function n(t) {
      return new ig(t);
    }), void 0 === i && (i = function i(t) {
      return new K_(t);
    }), void 0 === r && (r = function r(t) {
      return new cg(t);
    }), void 0 === o && (o = function o(t) {
      return new T_(t);
    }), void 0 === a && (a = function a(t) {
      return new L_(t);
    }), this.input_ = this.root_.querySelector(q_.INPUT_SELECTOR);
    var s = this.root_.querySelector(q_.LABEL_SELECTOR);
    this.label_ = s ? o(s) : null;
    var c = this.root_.querySelector(q_.LINE_RIPPLE_SELECTOR);
    this.lineRipple_ = c ? e(c) : null;
    var u = this.root_.querySelector(q_.OUTLINE_SELECTOR);
    this.outline_ = u ? a(u) : null;
    var l = ng.strings,
        d = this.root_.nextElementSibling,
        h = d && d.classList.contains(W_.HELPER_LINE),
        p = h && d && d.querySelector(l.ROOT_SELECTOR);
    this.helperText_ = p ? n(p) : null;
    var f = z_.strings,
        m = this.root_.querySelector(f.ROOT_SELECTOR);
    !m && h && d && (m = d.querySelector(f.ROOT_SELECTOR)), this.characterCounter_ = m ? i(m) : null, this.leadingIcon_ = null, this.trailingIcon_ = null;

    var _ = this.root_.querySelectorAll(q_.ICON_SELECTOR);

    _.length > 0 && (_.length > 1 ? (this.leadingIcon_ = r(_[0]), this.trailingIcon_ = r(_[1])) : this.root_.classList.contains(W_.WITH_LEADING_ICON) ? this.leadingIcon_ = r(_[0]) : this.trailingIcon_ = r(_[0])), this.ripple = this.createRipple_(t);
  }, e.prototype.destroy = function () {
    this.ripple && this.ripple.destroy(), this.lineRipple_ && this.lineRipple_.destroy(), this.helperText_ && this.helperText_.destroy(), this.characterCounter_ && this.characterCounter_.destroy(), this.leadingIcon_ && this.leadingIcon_.destroy(), this.trailingIcon_ && this.trailingIcon_.destroy(), this.label_ && this.label_.destroy(), this.outline_ && this.outline_.destroy(), t.prototype.destroy.call(this);
  }, e.prototype.initialSyncWithDOM = function () {
    this.disabled = this.input_.disabled;
  }, Object.defineProperty(e.prototype, "value", {
    get: function get() {
      return this.foundation_.getValue();
    },
    set: function set(t) {
      this.foundation_.setValue(t);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "disabled", {
    get: function get() {
      return this.foundation_.isDisabled();
    },
    set: function set(t) {
      this.foundation_.setDisabled(t);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "valid", {
    get: function get() {
      return this.foundation_.isValid();
    },
    set: function set(t) {
      this.foundation_.setValid(t);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "required", {
    get: function get() {
      return this.input_.required;
    },
    set: function set(t) {
      this.input_.required = t;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "pattern", {
    get: function get() {
      return this.input_.pattern;
    },
    set: function set(t) {
      this.input_.pattern = t;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "minLength", {
    get: function get() {
      return this.input_.minLength;
    },
    set: function set(t) {
      this.input_.minLength = t;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "maxLength", {
    get: function get() {
      return this.input_.maxLength;
    },
    set: function set(t) {
      t < 0 ? this.input_.removeAttribute("maxLength") : this.input_.maxLength = t;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "min", {
    get: function get() {
      return this.input_.min;
    },
    set: function set(t) {
      this.input_.min = t;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "max", {
    get: function get() {
      return this.input_.max;
    },
    set: function set(t) {
      this.input_.max = t;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "step", {
    get: function get() {
      return this.input_.step;
    },
    set: function set(t) {
      this.input_.step = t;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "helperTextContent", {
    set: function set(t) {
      this.foundation_.setHelperTextContent(t);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "leadingIconAriaLabel", {
    set: function set(t) {
      this.foundation_.setLeadingIconAriaLabel(t);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "leadingIconContent", {
    set: function set(t) {
      this.foundation_.setLeadingIconContent(t);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "trailingIconAriaLabel", {
    set: function set(t) {
      this.foundation_.setTrailingIconAriaLabel(t);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "trailingIconContent", {
    set: function set(t) {
      this.foundation_.setTrailingIconContent(t);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "useNativeValidation", {
    set: function set(t) {
      this.foundation_.setUseNativeValidation(t);
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.focus = function () {
    this.input_.focus();
  }, e.prototype.layout = function () {
    var t = this.foundation_.shouldFloat;
    this.foundation_.notchOutline(t);
  }, e.prototype.getDefaultFoundation = function () {
    var t = _jt({}, this.getRootAdapterMethods_(), this.getInputAdapterMethods_(), this.getLabelAdapterMethods_(), this.getLineRippleAdapterMethods_(), this.getOutlineAdapterMethods_());

    return new J_(t, this.getFoundationMap_());
  }, e.prototype.getRootAdapterMethods_ = function () {
    var t = this;
    return {
      addClass: function addClass(e) {
        return t.root_.classList.add(e);
      },
      removeClass: function removeClass(e) {
        return t.root_.classList.remove(e);
      },
      hasClass: function hasClass(e) {
        return t.root_.classList.contains(e);
      },
      registerTextFieldInteractionHandler: function registerTextFieldInteractionHandler(e, n) {
        return t.listen(e, n);
      },
      deregisterTextFieldInteractionHandler: function deregisterTextFieldInteractionHandler(e, n) {
        return t.unlisten(e, n);
      },
      registerValidationAttributeChangeHandler: function registerValidationAttributeChangeHandler(e) {
        var n = new MutationObserver(function (t) {
          return e(function (t) {
            return t.map(function (t) {
              return t.attributeName;
            }).filter(function (t) {
              return t;
            });
          }(t));
        });
        return n.observe(t.input_, {
          attributes: !0
        }), n;
      },
      deregisterValidationAttributeChangeHandler: function deregisterValidationAttributeChangeHandler(t) {
        return t.disconnect();
      }
    };
  }, e.prototype.getInputAdapterMethods_ = function () {
    var t = this;
    return {
      getNativeInput: function getNativeInput() {
        return t.input_;
      },
      isFocused: function isFocused() {
        return document.activeElement === t.input_;
      },
      registerInputInteractionHandler: function registerInputInteractionHandler(e, n) {
        return t.input_.addEventListener(e, n);
      },
      deregisterInputInteractionHandler: function deregisterInputInteractionHandler(e, n) {
        return t.input_.removeEventListener(e, n);
      }
    };
  }, e.prototype.getLabelAdapterMethods_ = function () {
    var t = this;
    return {
      floatLabel: function floatLabel(e) {
        return t.label_ && t.label_.float(e);
      },
      getLabelWidth: function getLabelWidth() {
        return t.label_ ? t.label_.getWidth() : 0;
      },
      hasLabel: function hasLabel() {
        return Boolean(t.label_);
      },
      shakeLabel: function shakeLabel(e) {
        return t.label_ && t.label_.shake(e);
      }
    };
  }, e.prototype.getLineRippleAdapterMethods_ = function () {
    var t = this;
    return {
      activateLineRipple: function activateLineRipple() {
        t.lineRipple_ && t.lineRipple_.activate();
      },
      deactivateLineRipple: function deactivateLineRipple() {
        t.lineRipple_ && t.lineRipple_.deactivate();
      },
      setLineRippleTransformOrigin: function setLineRippleTransformOrigin(e) {
        t.lineRipple_ && t.lineRipple_.setRippleCenter(e);
      }
    };
  }, e.prototype.getOutlineAdapterMethods_ = function () {
    var t = this;
    return {
      closeOutline: function closeOutline() {
        return t.outline_ && t.outline_.closeNotch();
      },
      hasOutline: function hasOutline() {
        return Boolean(t.outline_);
      },
      notchOutline: function notchOutline(e) {
        return t.outline_ && t.outline_.notch(e);
      }
    };
  }, e.prototype.getFoundationMap_ = function () {
    return {
      characterCounter: this.characterCounter_ ? this.characterCounter_.foundation : void 0,
      helperText: this.helperText_ ? this.helperText_.foundation : void 0,
      leadingIcon: this.leadingIcon_ ? this.leadingIcon_.foundation : void 0,
      trailingIcon: this.trailingIcon_ ? this.trailingIcon_.foundation : void 0
    };
  }, e.prototype.createRipple_ = function (t) {
    var e = this,
        n = this.root_.classList.contains(W_.TEXTAREA),
        i = this.root_.classList.contains(W_.OUTLINED);
    if (n || i) return null;

    var r = _jt({}, j_.createAdapter(this), {
      isSurfaceActive: function isSurfaceActive() {
        return Zt(e.input_, ":active");
      },
      registerInteractionHandler: function registerInteractionHandler(t, n) {
        return e.input_.addEventListener(t, n);
      },
      deregisterInteractionHandler: function deregisterInteractionHandler(t, n) {
        return e.input_.removeEventListener(t, n);
      }
    });

    return t(this.root_, new V_(r));
  };
}($t), {
  LABEL_FLOAT_ABOVE: "mdc-floating-label--float-above",
  LABEL_SHAKE: "mdc-floating-label--shake",
  ROOT: "mdc-floating-label"
}),
    lg = function (t) {
  function e(n) {
    var i = t.call(this, _jt({}, e.defaultAdapter, n)) || this;
    return i.shakeAnimationEndHandler_ = function () {
      return i.handleShakeAnimationEnd_();
    }, i;
  }

  return Vt(e, t), Object.defineProperty(e, "cssClasses", {
    get: function get() {
      return ug;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultAdapter", {
    get: function get() {
      return {
        addClass: function addClass() {},
        removeClass: function removeClass() {},
        getWidth: function getWidth() {
          return 0;
        },
        registerInteractionHandler: function registerInteractionHandler() {},
        deregisterInteractionHandler: function deregisterInteractionHandler() {}
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.init = function () {
    this.adapter_.registerInteractionHandler("animationend", this.shakeAnimationEndHandler_);
  }, e.prototype.destroy = function () {
    this.adapter_.deregisterInteractionHandler("animationend", this.shakeAnimationEndHandler_);
  }, e.prototype.getWidth = function () {
    return this.adapter_.getWidth();
  }, e.prototype.shake = function (t) {
    var n = e.cssClasses.LABEL_SHAKE;
    t ? this.adapter_.addClass(n) : this.adapter_.removeClass(n);
  }, e.prototype.float = function (t) {
    var n = e.cssClasses,
        i = n.LABEL_FLOAT_ABOVE,
        r = n.LABEL_SHAKE;
    t ? this.adapter_.addClass(i) : (this.adapter_.removeClass(i), this.adapter_.removeClass(r));
  }, e.prototype.handleShakeAnimationEnd_ = function () {
    var t = e.cssClasses.LABEL_SHAKE;
    this.adapter_.removeClass(t);
  }, e;
}(Yt),
    dg = (function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  Vt(e, t), e.attachTo = function (t) {
    return new e(t);
  }, e.prototype.shake = function (t) {
    this.foundation_.shake(t);
  }, e.prototype.float = function (t) {
    this.foundation_.float(t);
  }, e.prototype.getWidth = function () {
    return this.foundation_.getWidth();
  }, e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new lg({
      addClass: function addClass(e) {
        return t.root_.classList.add(e);
      },
      removeClass: function removeClass(e) {
        return t.root_.classList.remove(e);
      },
      getWidth: function getWidth() {
        return t.root_.scrollWidth;
      },
      registerInteractionHandler: function registerInteractionHandler(e, n) {
        return t.listen(e, n);
      },
      deregisterInteractionHandler: function deregisterInteractionHandler(e, n) {
        return t.unlisten(e, n);
      }
    });
  };
}($t), function () {
  var _t42 = function t(e, n) {
    return (_t42 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var n in e) {
        e.hasOwnProperty(n) && (t[n] = e[n]);
      }
    })(e, n);
  };

  return function (e, n) {
    function i() {
      this.constructor = e;
    }

    _t42(e, n), e.prototype = null === n ? Object.create(n) : (i.prototype = n.prototype, new i());
  };
}()),
    _hg = function hg() {
  return (_hg = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    pg = function pg(t, e) {
  var n = {};

  for (var i in t) {
    Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
  }

  if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
    var r = 0;

    for (i = Object.getOwnPropertySymbols(t); r < i.length; r++) {
      e.indexOf(i[r]) < 0 && (n[i[r]] = t[i[r]]);
    }
  }

  return n;
},
    fg = function (t) {
  function e() {
    var e = null !== t && t.apply(this, arguments) || this;
    return e.root = e.createElement("root"), e;
  }

  return dg(e, t), e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new lg({
      addClass: function addClass(e) {
        return t.root.addClass(e);
      },
      removeClass: function removeClass(e) {
        return t.root.removeClass(e);
      },
      getWidth: function getWidth() {
        return t.root.ref ? t.root.ref.scrollWidth : 0;
      },
      registerInteractionHandler: function registerInteractionHandler(e, n) {
        return t.root.addEventListener(e, n);
      },
      deregisterInteractionHandler: function deregisterInteractionHandler(e, n) {
        return t.root.removeEventListener(e, n);
      }
    });
  }, e.prototype.sync = function (t, e) {
    var n = this;
    this.syncProp(t.shake, e.shake, function () {
      n.foundation.shake(!!t.shake);
    }), this.syncProp(t.float, e.float, function () {
      n.foundation.float(!!t.float);
    });
  }, e.prototype.getWidth = function () {
    return this.foundation.getWidth();
  }, e.prototype.render = function () {
    var t = this.props,
        e = (t.shake, t.float, pg(t, ["shake", "float"]));
    return n("label", _hg({}, this.root.props(_hg({}, e, {
      className: "mdc-floating-label"
    })), {
      ref: this.root.setRef
    }));
  }, e.displayName = "FloatingLabel", e;
}(Rt),
    mg = {
  NOTCH_ELEMENT_SELECTOR: ".mdc-notched-outline__notch"
},
    _g = {
  NOTCH_ELEMENT_PADDING: 8
},
    gg = {
  NO_LABEL: "mdc-notched-outline--no-label",
  OUTLINE_NOTCHED: "mdc-notched-outline--notched",
  OUTLINE_UPGRADED: "mdc-notched-outline--upgraded"
},
    vg = function (t) {
  function e(n) {
    return t.call(this, _jt({}, e.defaultAdapter, n)) || this;
  }

  return Vt(e, t), Object.defineProperty(e, "strings", {
    get: function get() {
      return mg;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "cssClasses", {
    get: function get() {
      return gg;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "numbers", {
    get: function get() {
      return _g;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultAdapter", {
    get: function get() {
      return {
        addClass: function addClass() {},
        removeClass: function removeClass() {},
        setNotchWidthProperty: function setNotchWidthProperty() {},
        removeNotchWidthProperty: function removeNotchWidthProperty() {}
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.notch = function (t) {
    var n = e.cssClasses.OUTLINE_NOTCHED;
    t > 0 && (t += _g.NOTCH_ELEMENT_PADDING), this.adapter_.setNotchWidthProperty(t), this.adapter_.addClass(n);
  }, e.prototype.closeNotch = function () {
    var t = e.cssClasses.OUTLINE_NOTCHED;
    this.adapter_.removeClass(t), this.adapter_.removeNotchWidthProperty();
  }, e;
}(Yt),
    yg = (function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  Vt(e, t), e.attachTo = function (t) {
    return new e(t);
  }, e.prototype.initialSyncWithDOM = function () {
    this.notchElement_ = this.root_.querySelector(mg.NOTCH_ELEMENT_SELECTOR);
    var t = this.root_.querySelector("." + lg.cssClasses.ROOT);
    t ? (t.style.transitionDuration = "0s", this.root_.classList.add(gg.OUTLINE_UPGRADED), requestAnimationFrame(function () {
      t.style.transitionDuration = "";
    })) : this.root_.classList.add(gg.NO_LABEL);
  }, e.prototype.notch = function (t) {
    this.foundation_.notch(t);
  }, e.prototype.closeNotch = function () {
    this.foundation_.closeNotch();
  }, e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new vg({
      addClass: function addClass(e) {
        return t.root_.classList.add(e);
      },
      removeClass: function removeClass(e) {
        return t.root_.classList.remove(e);
      },
      setNotchWidthProperty: function setNotchWidthProperty(e) {
        return t.notchElement_.style.setProperty("width", e + "px");
      },
      removeNotchWidthProperty: function removeNotchWidthProperty() {
        return t.notchElement_.style.removeProperty("width");
      }
    });
  };
}($t), function () {
  var _t43 = function t(e, n) {
    return (_t43 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var n in e) {
        e.hasOwnProperty(n) && (t[n] = e[n]);
      }
    })(e, n);
  };

  return function (e, n) {
    function i() {
      this.constructor = e;
    }

    _t43(e, n), e.prototype = null === n ? Object.create(n) : (i.prototype = n.prototype, new i());
  };
}()),
    _bg = function bg() {
  return (_bg = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    Eg = function Eg(t, e) {
  var n = {};

  for (var i in t) {
    Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
  }

  if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
    var r = 0;

    for (i = Object.getOwnPropertySymbols(t); r < i.length; r++) {
      e.indexOf(i[r]) < 0 && (n[i[r]] = t[i[r]]);
    }
  }

  return n;
},
    Cg = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return yg(e, t), e.prototype.shouldComponentUpdate = function () {
    return !1;
  }, e.prototype.render = function () {
    return n("div", {
      className: "mdc-notched-outline__leading"
    });
  }, e;
}(i),
    Ag = function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  return yg(e, t), e.prototype.shouldComponentUpdate = function () {
    return !1;
  }, e.prototype.render = function () {
    return n("div", {
      className: "mdc-notched-outline__trailing"
    });
  }, e;
}(i),
    Tg = function (t) {
  function e() {
    var e = null !== t && t.apply(this, arguments) || this;
    return e.root = e.createElement("root"), e.notchElement = e.createElement("root"), e.label = null, e;
  }

  return yg(e, t), e.prototype.componentDidMount = function () {
    var e = this;
    t.prototype.componentDidMount.call(this), this.label = this.root.ref && this.root.ref.querySelector("label"), this.label ? (this.label.style.transitionDuration = "0s", this.root.addClass(vg.cssClasses.OUTLINE_UPGRADED), requestAnimationFrame(function () {
      e.label && (e.label.style.transitionDuration = "");
    })) : this.root.addClass(vg.cssClasses.NO_LABEL);
  }, e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new vg({
      addClass: function addClass(e) {
        return t.root.addClass(e);
      },
      removeClass: function removeClass(e) {
        return t.root.removeClass(e);
      },
      setNotchWidthProperty: function setNotchWidthProperty(e) {
        return t.notchElement.setStyle("width", e + "px");
      },
      removeNotchWidthProperty: function removeNotchWidthProperty() {
        return t.notchElement.setStyle("width", "");
      }
    });
  }, e.prototype.sync = function (t, e) {
    var n = this;
    this.syncProp(t.notch, e.notch, function () {
      t.notch ? n.foundation.notch(t.notch) : n.foundation.closeNotch();
    });
  }, e.prototype.render = function () {
    var t = this.props,
        e = t.children,
        i = Eg(t, ["children"]);
    return n("div", _bg({}, this.root.props(_bg({}, i, {
      className: "mdc-notched-outline"
    })), {
      ref: this.root.setRef
    }), n(Cg, null), n("div", _bg({}, this.notchElement.props({}), {
      className: "mdc-notched-outline__notch",
      ref: this.notchElement.setRef
    }), e), n(Ag, null));
  }, e.displayName = "NotchedOutline", e;
}(Rt),
    Ig = function () {
  var _t44 = function t(e, n) {
    return (_t44 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var n in e) {
        e.hasOwnProperty(n) && (t[n] = e[n]);
      }
    })(e, n);
  };

  return function (e, n) {
    function i() {
      this.constructor = e;
    }

    _t44(e, n), e.prototype = null === n ? Object.create(n) : (i.prototype = n.prototype, new i());
  };
}(),
    _Og = function Og() {
  return (_Og = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    Sg = function Sg(t, e) {
  var n = {};

  for (var i in t) {
    Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
  }

  if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
    var r = 0;

    for (i = Object.getOwnPropertySymbols(t); r < i.length; r++) {
      e.indexOf(i[r]) < 0 && (n[i[r]] = t[i[r]]);
    }
  }

  return n;
},
    wg = Ln()(Mt({
  displayName: "TextFieldRoot",
  deprecate: {
    box: ""
  },
  classNames: function classNames(t) {
    return ["mdc-text-field", "mdc-text-field--upgraded", {
      "mdc-text-field--textarea": t.textarea,
      "mdc-text-field--fullwidth": t.fullwidth,
      "mdc-text-field--outlined": t.outlined,
      "mdc-text-field--dense": t.dense,
      "mdc-text-field--invalid": t.invalid,
      "mdc-text-field--disabled": t.disabled,
      "mdc-text-field--with-leading-icon": !!t.icon,
      "mdc-text-field--with-trailing-icon": !!t.trailingIcon,
      "mdc-text-field--no-label": !t.label
    }];
  },
  consumeProps: ["textarea", "fullwidth", "outlined", "dense", "invalid", "disabled", "icon", "trailingIcon", "label"]
})),
    xg = Mt({
  displayName: "TextFieldInput",
  defaultProps: {
    type: "text"
  },
  tag: "input",
  classNames: ["mdc-text-field__input"]
}),
    Ng = Mt({
  displayName: "TextFieldTextarea",
  tag: "textarea",
  classNames: ["mdc-text-field__input"]
}),
    Rg = function (t) {
  function e(e) {
    var n = t.call(this, e) || this;
    return n.generatedId = bt("textfield"), n.root = n.createElement("root"), n.input = n.createElement("input"), n.label = n.createElement("label"), n.lineRipple = n.createElement("lineRipple"), n.characterCounter = null, n.leadingIcon = null, n.trailingIcon = null, n.valueNeedsUpdate = !1, n.handleOnChange = n.handleOnChange.bind(n), n;
  }

  return Ig(e, t), e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new J_(_Og({
      addClass: function addClass(e) {
        return t.root.addClass(e);
      },
      removeClass: function removeClass(e) {
        return t.root.removeClass(e);
      },
      hasClass: function hasClass(e) {
        return t.root.hasClass(e);
      },
      registerTextFieldInteractionHandler: function registerTextFieldInteractionHandler(e, n) {
        return t.root.addEventListener(e, n);
      },
      deregisterTextFieldInteractionHandler: function deregisterTextFieldInteractionHandler(e, n) {
        return t.root.removeEventListener(e, n);
      },
      registerValidationAttributeChangeHandler: function registerValidationAttributeChangeHandler(e) {
        if (t.input.ref) {
          var n = new MutationObserver(function (t) {
            return e(function (t) {
              return t.map(function (t) {
                return t.attributeName;
              });
            }(t));
          }),
              i = t.input.ref;
          return i && n.observe(i, {
            attributes: !0
          }), n;
        }

        return {};
      },
      deregisterValidationAttributeChangeHandler: function deregisterValidationAttributeChangeHandler(t) {
        t && t.disconnect();
      },
      isFocused: function isFocused() {
        return document.activeElement === t.input.ref;
      }
    }, this.getInputAdapterMethods(), this.getLabelAdapterMethods(), this.getLineRippleAdapterMethods(), this.getOutlineAdapterMethods()), this.getFoundationMap());
  }, e.prototype.getLabelAdapterMethods = function () {
    var t = this;
    return {
      shakeLabel: function shakeLabel(e) {
        return t.label.setProp("shake", e);
      },
      floatLabel: function floatLabel(e) {
        return t.label.setProp("float", e);
      },
      hasLabel: function hasLabel() {
        return !!t.props.label;
      },
      getLabelWidth: function getLabelWidth() {
        return t.label.ref ? t.label.ref.getWidth() : 0;
      }
    };
  }, e.prototype.getLineRippleAdapterMethods = function () {
    var t = this;
    return {
      activateLineRipple: function activateLineRipple() {
        t.lineRipple && t.lineRipple.setProp("active", !0);
      },
      deactivateLineRipple: function deactivateLineRipple() {
        t.lineRipple && t.lineRipple.setProp("active", !1);
      },
      setLineRippleTransformOrigin: function setLineRippleTransformOrigin(e) {
        t.lineRipple && t.lineRipple.setProp("center", e);
      }
    };
  }, e.prototype.getOutlineAdapterMethods = function () {
    var t = this;
    return {
      notchOutline: function notchOutline(e) {
        t.outline && t.outline.notch(e);
      },
      closeOutline: function closeOutline() {
        return t.outline && t.outline.closeNotch();
      },
      hasOutline: function hasOutline() {
        return !!t.outline;
      }
    };
  }, e.prototype.getInputAdapterMethods = function () {
    var t = this;
    return {
      registerInputInteractionHandler: function registerInputInteractionHandler(e, n) {
        return t.input.addEventListener(e, n);
      },
      deregisterInputInteractionHandler: function deregisterInputInteractionHandler(e, n) {
        return t.input.removeEventListener(e, n);
      },
      getNativeInput: function getNativeInput() {
        return t.input.ref;
      }
    };
  }, e.prototype.getFoundationMap = function () {
    return {
      characterCounter: this.characterCounter ? this.characterCounter.foundation : void 0,
      helperText: void 0,
      leadingIcon: this.leadingIcon ? this.leadingIcon.foundation : void 0,
      trailingIcon: this.trailingIcon ? this.trailingIcon.foundation : void 0
    };
  }, e.prototype.renderIcon = function (t, e) {
    var i = this;
    return n(kg, {
      ref: function ref(t) {
        "leadingIcon" === e ? i.leadingIcon = t : i.trailingIcon = t;
      },
      tabIndex: "trailingIcon" === e ? 0 : void 0,
      icon: t
    });
  }, e.prototype.sync = function (t) {
    this.valueNeedsUpdate && (this.foundation.setValue(String(t.value)), this.valueNeedsUpdate = !1);
  }, e.prototype.handleOnChange = function (t) {}, e.prototype.renderHelpText = function (t) {
    var e = this.props,
        i = e.helpText,
        r = e.characterCount,
        o = e.textarea;
    if (!(!!i || r && !o)) return null;
    var s = "object" == typeof i && !a(i);
    return n("div", {
      className: "mdc-text-field-helper-line"
    }, i && s ? n(Dg, _Og({}, i)) : n(Dg, null, i), !o && t);
  }, e.prototype.render = function () {
    var t = this,
        e = this.props,
        i = e.label,
        r = e.className,
        o = e.style,
        a = e.outlined,
        s = e.fullwidth,
        c = e.dense,
        u = e.invalid,
        l = e.disabled,
        d = (e.helpText, e.children),
        h = e.textarea,
        f = e.inputRef,
        m = e.characterCount,
        _ = (e.icon, e.trailingIcon, e.withLeadingIcon, e.withTrailingIcon, e.rootProps),
        g = void 0 === _ ? {} : _,
        v = Sg(e, ["label", "className", "style", "outlined", "fullwidth", "dense", "invalid", "disabled", "helpText", "children", "textarea", "inputRef", "characterCount", "icon", "trailingIcon", "withLeadingIcon", "withTrailingIcon", "rootProps"]),
        y = this.props,
        b = y.icon,
        E = y.trailingIcon,
        C = y.withLeadingIcon,
        A = y.withTrailingIcon;

    void 0 !== c && ft("Textfield prop 'dense' is being removed in a future release by material-components-web."), void 0 !== C && (ft("Textfield prop 'withLeadingIcon' is now 'icon'."), b = C), void 0 !== A && (ft("Textfield prop 'withTrailingIcon' is now 'trailingIcon'."), E = A), void 0 !== this.props.value && this.foundation && this.props.value !== this.foundation.getValue() && (this.valueNeedsUpdate = !0);

    var T = _Og({}, this.input.props(v), {
      disabled: l,
      ref: function ref(e) {
        t.input.setRef(e), f && f(e);
      },
      id: v.id || this.generatedId
    }),
        I = n(h ? Ng : xg, _Og({}, T)),
        O = i ? n(fg, _Og({}, this.label.props({}), {
      ref: this.label.setRef,
      htmlFor: T.id
    }), i) : null,
        S = m ? n(Lg, {
      ref: function ref(e) {
        t.characterCounter = e;
      }
    }, "F") : null;

    return n(p, null, n(wg, _Og({}, this.root.props(_Og({}, g, {
      className: r,
      style: o
    })), {
      label: i,
      invalid: u,
      icon: !!b,
      trailingIcon: !!E,
      textarea: h,
      dense: c,
      disabled: l,
      outlined: a,
      fullwidth: s,
      ref: this.root.setRef
    }), !!b && this.renderIcon(b, "leadingIcon"), d, !!h && S, I, a ? n(p, null, n(Tg, {
      ref: function ref(e) {
        return t.outline = e && e.foundation;
      }
    }, O), !!E && this.renderIcon(E, "trailingIcon")) : n(p, null, O, !!E && this.renderIcon(E, "trailingIcon"), n(Wn, _Og({}, this.lineRipple.props({}))))), this.renderHelpText(S));
  }, e.displayName = "TextField", e;
}(Rt),
    Lg = function (t) {
  function e() {
    var e = null !== t && t.apply(this, arguments) || this;
    return e.state = {
      content: ""
    }, e;
  }

  return Ig(e, t), e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new z_({
      setContent: function setContent(e) {
        t.setState({
          content: e
        });
      }
    });
  }, e.prototype.render = function () {
    return n("div", {
      className: "mdc-text-field-character-counter"
    }, this.state.content);
  }, e.displayName = "TextFieldCharacterCount", e;
}(Rt),
    Dg = Mt({
  displayName: "TextFieldHelperText",
  classNames: function classNames(t) {
    return ["mdc-text-field-helper-text", {
      "mdc-text-field-helper-text--persistent": t.persistent,
      "mdc-text-field-helper-text--validation-msg": t.validationMsg
    }];
  },
  consumeProps: ["persistent", "validationMsg"]
}),
    kg = function (t) {
  function e() {
    var e = null !== t && t.apply(this, arguments) || this;
    return e.root = e.createElement("root"), e;
  }

  return Ig(e, t), e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new sg({
      getAttr: function getAttr(e) {
        return t.root.getProp(e);
      },
      setAttr: function setAttr(e, n) {
        return t.root.setProp(e, n);
      },
      removeAttr: function removeAttr(e) {
        return t.root.removeProp(e);
      },
      setContent: function setContent(e) {
        t.root.setProp("icon", e);
      },
      registerInteractionHandler: function registerInteractionHandler(e, n) {
        return t.root.addEventListener(e, n);
      },
      deregisterInteractionHandler: function deregisterInteractionHandler(e, n) {
        return t.root.removeEventListener(e, n);
      },
      notifyIconAction: function notifyIconAction() {
        return t.emit("onClick", {}, !0);
      }
    });
  }, e.prototype.render = function () {
    return n(mn, _Og({}, this.root.props(_Og({}, this.props, {
      className: "mdc-text-field__icon"
    }))));
  }, e.displayName = "TextFieldIcon", e;
}(Rt),
    Pg = function () {
  var _t45 = function t(e, n) {
    return (_t45 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var n in e) {
        e.hasOwnProperty(n) && (t[n] = e[n]);
      }
    })(e, n);
  };

  return function (e, n) {
    function i() {
      this.constructor = e;
    }

    _t45(e, n), e.prototype = null === n ? Object.create(n) : (i.prototype = n.prototype, new i());
  };
}(),
    _Fg = function Fg() {
  return (_Fg = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    Mg = function Mg(t, e) {
  var n = {};

  for (var i in t) {
    Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
  }

  if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
    var r = 0;

    for (i = Object.getOwnPropertySymbols(t); r < i.length; r++) {
      e.indexOf(i[r]) < 0 && (n[i[r]] = t[i[r]]);
    }
  }

  return n;
},
    Hg = function (t) {
  function e(e) {
    var n = t.call(this, e) || this;
    return n.state = {
      closingDialogs: {}
    }, n.forceUpdate = n.forceUpdate.bind(n), n.props.dialogs.on("change", n.forceUpdate), n;
  }

  return Pg(e, t), e.prototype.componentWillUnmount = function () {
    this.props.dialogs.off("change", this.forceUpdate);
  }, e.prototype.removeDialog = function (t, e) {
    var n,
        i = this;
    this.setState({
      closingDialogs: _Fg({}, this.state.closingDialogs, (n = {}, n[e.id] = !0, n))
    }, function () {
      e.resolve(t), setTimeout(function () {
        var t = i.props.dialogs.array.indexOf(e);
        ~t && i.props.dialogs.array.splice(t, 1);
        var n = i.state.closingDialogs;
        delete n[e.id], i.setState({
          closingDialogs: n
        });
      }, 150);
    });
  }, e.prototype.render = function () {
    var t = this,
        e = this.props,
        i = e.dialogs,
        r = Mg(e, ["dialogs"]),
        o = !1;
    return i.array.map(function (e) {
      e.resolve, e.reject;
      var i = e.id,
          a = (e.inputProps, Mg(e, ["resolve", "reject", "id", "inputProps"])),
          s = n(E_, _Fg({}, r, a, {
        key: i,
        open: !t.state.closingDialogs[i] && !o,
        onClose: function onClose(n) {
          t.removeDialog(n, e), e.onClose && e.onClose(n);
        }
      }));
      return t.state.closingDialogs[i] || (o = !0), s;
    });
  }, e.displayName = "DialogQueue", e;
}(i),
    Bg = function Bg(t, e) {
  return function (n) {
    return new Promise(function (i, r) {
      var o = t(_Fg({
        id: bt()
      }, n, {
        resolve: i,
        reject: r
      }));
      e.push(o);
    });
  };
},
    Vg = function (t) {
  function e() {
    var e = null !== t && t.apply(this, arguments) || this;
    return e.state = {
      value: ""
    }, e;
  }

  return Pg(e, t), e.prototype.componentDidMount = function () {
    var t = this;
    this.props.apiRef(function () {
      return t.state.value;
    });
  }, e.prototype.render = function () {
    var t = this;
    return n("div", null, !!this.props.body && n("div", {
      style: {
        marginBottom: "1rem"
      }
    }, this.props.body), n(Rg, _Fg({
      style: {
        width: "100%"
      },
      autoFocus: !0
    }, this.props.inputProps, {
      value: this.state.value,
      onChange: function onChange(e) {
        return t.setState({
          value: e.currentTarget.value
        });
      }
    })));
  }, e.displayName = "PromptBody", e;
}(i),
    jg = function jg(t) {
  var e = function e() {
    return "";
  },
      i = n(Vg, {
    body: t.body,
    inputProps: t.inputProps,
    apiRef: function apiRef(t) {
      return e = t;
    }
  });

  return _Fg({
    title: "Prompt"
  }, t, {
    body: i,
    resolve: function resolve(n) {
      t.resolve("accept" === n.detail.action ? e() : null), e = void 0;
    }
  });
},
    Ug = function Ug(t) {
  return _Fg({
    title: "Alert",
    body: "You have been alerted!",
    acceptLabel: "OK",
    cancelLabel: null
  }, t, {
    resolve: function resolve(e) {
      return t.resolve(e.detail.action);
    }
  });
},
    Gg = function Gg(t) {
  return _Fg({
    title: "Confirm",
    body: "Are you sure you want do that?",
    acceptLabel: "OK",
    cancelLabel: "Cancel"
  }, t, {
    resolve: function resolve(e) {
      return t.resolve("accept" === e.detail.action);
    }
  });
},
    zg = function zg() {
  var t = new Tt();
  return {
    dialogs: t,
    alert: Bg(Ug, t),
    confirm: Bg(Gg, t),
    prompt: Bg(jg, t)
  };
},
    Kg = {
  CLOSING: "mdc-snackbar--closing",
  OPEN: "mdc-snackbar--open",
  OPENING: "mdc-snackbar--opening"
},
    qg = {
  ACTION_SELECTOR: ".mdc-snackbar__action",
  ARIA_LIVE_LABEL_TEXT_ATTR: "data-mdc-snackbar-label-text",
  CLOSED_EVENT: "MDCSnackbar:closed",
  CLOSING_EVENT: "MDCSnackbar:closing",
  DISMISS_SELECTOR: ".mdc-snackbar__dismiss",
  LABEL_SELECTOR: ".mdc-snackbar__label",
  OPENED_EVENT: "MDCSnackbar:opened",
  OPENING_EVENT: "MDCSnackbar:opening",
  REASON_ACTION: "action",
  REASON_DISMISS: "dismiss",
  SURFACE_SELECTOR: ".mdc-snackbar__surface"
},
    Wg = {
  DEFAULT_AUTO_DISMISS_TIMEOUT_MS: 5e3,
  MAX_AUTO_DISMISS_TIMEOUT_MS: 1e4,
  MIN_AUTO_DISMISS_TIMEOUT_MS: 4e3,
  SNACKBAR_ANIMATION_CLOSE_TIME_MS: 75,
  SNACKBAR_ANIMATION_OPEN_TIME_MS: 150,
  ARIA_LIVE_DELAY_MS: 1e3
},
    Xg = Wg.ARIA_LIVE_DELAY_MS,
    Yg = qg.ARIA_LIVE_LABEL_TEXT_ATTR;

function $g(t, e) {
  void 0 === e && (e = t);
  var n = t.getAttribute("aria-live"),
      i = e.textContent.trim();
  i && n && (t.setAttribute("aria-live", "off"), e.textContent = "", e.innerHTML = '<span style="display: inline-block; width: 0; height: 1px;">&nbsp;</span>', e.setAttribute(Yg, i), setTimeout(function () {
    t.setAttribute("aria-live", n), e.removeAttribute(Yg), e.textContent = i;
  }, Xg));
}

var Qg,
    Zg,
    Jg = Kg.OPENING,
    tv = Kg.OPEN,
    ev = Kg.CLOSING,
    nv = qg.REASON_ACTION,
    iv = qg.REASON_DISMISS,
    rv = function (t) {
  function e(n) {
    var i = t.call(this, _jt({}, e.defaultAdapter, n)) || this;
    return i.isOpen_ = !1, i.animationFrame_ = 0, i.animationTimer_ = 0, i.autoDismissTimer_ = 0, i.autoDismissTimeoutMs_ = Wg.DEFAULT_AUTO_DISMISS_TIMEOUT_MS, i.closeOnEscape_ = !0, i;
  }

  return Vt(e, t), Object.defineProperty(e, "cssClasses", {
    get: function get() {
      return Kg;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "strings", {
    get: function get() {
      return qg;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "numbers", {
    get: function get() {
      return Wg;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultAdapter", {
    get: function get() {
      return {
        addClass: function addClass() {},
        announce: function announce() {},
        notifyClosed: function notifyClosed() {},
        notifyClosing: function notifyClosing() {},
        notifyOpened: function notifyOpened() {},
        notifyOpening: function notifyOpening() {},
        removeClass: function removeClass() {}
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.destroy = function () {
    this.clearAutoDismissTimer_(), cancelAnimationFrame(this.animationFrame_), this.animationFrame_ = 0, clearTimeout(this.animationTimer_), this.animationTimer_ = 0, this.adapter_.removeClass(Jg), this.adapter_.removeClass(tv), this.adapter_.removeClass(ev);
  }, e.prototype.open = function () {
    var t = this;
    this.clearAutoDismissTimer_(), this.isOpen_ = !0, this.adapter_.notifyOpening(), this.adapter_.removeClass(ev), this.adapter_.addClass(Jg), this.adapter_.announce(), this.runNextAnimationFrame_(function () {
      t.adapter_.addClass(tv), t.animationTimer_ = setTimeout(function () {
        t.handleAnimationTimerEnd_(), t.adapter_.notifyOpened(), t.autoDismissTimer_ = setTimeout(function () {
          t.close(iv);
        }, t.getTimeoutMs());
      }, Wg.SNACKBAR_ANIMATION_OPEN_TIME_MS);
    });
  }, e.prototype.close = function (t) {
    var e = this;
    void 0 === t && (t = ""), this.isOpen_ && (cancelAnimationFrame(this.animationFrame_), this.animationFrame_ = 0, this.clearAutoDismissTimer_(), this.isOpen_ = !1, this.adapter_.notifyClosing(t), this.adapter_.addClass(Kg.CLOSING), this.adapter_.removeClass(Kg.OPEN), this.adapter_.removeClass(Kg.OPENING), clearTimeout(this.animationTimer_), this.animationTimer_ = setTimeout(function () {
      e.handleAnimationTimerEnd_(), e.adapter_.notifyClosed(t);
    }, Wg.SNACKBAR_ANIMATION_CLOSE_TIME_MS));
  }, e.prototype.isOpen = function () {
    return this.isOpen_;
  }, e.prototype.getTimeoutMs = function () {
    return this.autoDismissTimeoutMs_;
  }, e.prototype.setTimeoutMs = function (t) {
    var e = Wg.MIN_AUTO_DISMISS_TIMEOUT_MS,
        n = Wg.MAX_AUTO_DISMISS_TIMEOUT_MS;
    if (!(t <= n && t >= e)) throw new Error("timeoutMs must be an integer in the range " + e + "–" + n + ", but got '" + t + "'");
    this.autoDismissTimeoutMs_ = t;
  }, e.prototype.getCloseOnEscape = function () {
    return this.closeOnEscape_;
  }, e.prototype.setCloseOnEscape = function (t) {
    this.closeOnEscape_ = t;
  }, e.prototype.handleKeyDown = function (t) {
    ("Escape" === t.key || 27 === t.keyCode) && this.getCloseOnEscape() && this.close(iv);
  }, e.prototype.handleActionButtonClick = function (t) {
    this.close(nv);
  }, e.prototype.handleActionIconClick = function (t) {
    this.close(iv);
  }, e.prototype.clearAutoDismissTimer_ = function () {
    clearTimeout(this.autoDismissTimer_), this.autoDismissTimer_ = 0;
  }, e.prototype.handleAnimationTimerEnd_ = function () {
    this.animationTimer_ = 0, this.adapter_.removeClass(Kg.OPENING), this.adapter_.removeClass(Kg.CLOSING);
  }, e.prototype.runNextAnimationFrame_ = function (t) {
    var e = this;
    cancelAnimationFrame(this.animationFrame_), this.animationFrame_ = requestAnimationFrame(function () {
      e.animationFrame_ = 0, clearTimeout(e.animationTimer_), e.animationTimer_ = setTimeout(t, 0);
    });
  }, e;
}(Yt),
    ov = qg.SURFACE_SELECTOR,
    av = qg.LABEL_SELECTOR,
    sv = qg.ACTION_SELECTOR,
    cv = qg.DISMISS_SELECTOR,
    uv = qg.OPENING_EVENT,
    lv = qg.OPENED_EVENT,
    dv = qg.CLOSING_EVENT,
    hv = qg.CLOSED_EVENT,
    pv = (function (t) {
  function e() {
    return null !== t && t.apply(this, arguments) || this;
  }

  Vt(e, t), e.attachTo = function (t) {
    return new e(t);
  }, e.prototype.initialize = function (t) {
    void 0 === t && (t = function t() {
      return $g;
    }), this.announce_ = t();
  }, e.prototype.initialSyncWithDOM = function () {
    var t = this;
    this.surfaceEl_ = this.root_.querySelector(ov), this.labelEl_ = this.root_.querySelector(av), this.actionEl_ = this.root_.querySelector(sv), this.handleKeyDown_ = function (e) {
      return t.foundation_.handleKeyDown(e);
    }, this.handleSurfaceClick_ = function (e) {
      var n = e.target;
      t.isActionButton_(n) ? t.foundation_.handleActionButtonClick(e) : t.isActionIcon_(n) && t.foundation_.handleActionIconClick(e);
    }, this.registerKeyDownHandler_(this.handleKeyDown_), this.registerSurfaceClickHandler_(this.handleSurfaceClick_);
  }, e.prototype.destroy = function () {
    t.prototype.destroy.call(this), this.deregisterKeyDownHandler_(this.handleKeyDown_), this.deregisterSurfaceClickHandler_(this.handleSurfaceClick_);
  }, e.prototype.open = function () {
    this.foundation_.open();
  }, e.prototype.close = function (t) {
    void 0 === t && (t = ""), this.foundation_.close(t);
  }, e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new rv({
      addClass: function addClass(e) {
        return t.root_.classList.add(e);
      },
      announce: function announce() {
        return t.announce_(t.labelEl_);
      },
      notifyClosed: function notifyClosed(e) {
        return t.emit(hv, e ? {
          reason: e
        } : {});
      },
      notifyClosing: function notifyClosing(e) {
        return t.emit(dv, e ? {
          reason: e
        } : {});
      },
      notifyOpened: function notifyOpened() {
        return t.emit(lv, {});
      },
      notifyOpening: function notifyOpening() {
        return t.emit(uv, {});
      },
      removeClass: function removeClass(e) {
        return t.root_.classList.remove(e);
      }
    });
  }, Object.defineProperty(e.prototype, "timeoutMs", {
    get: function get() {
      return this.foundation_.getTimeoutMs();
    },
    set: function set(t) {
      this.foundation_.setTimeoutMs(t);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "closeOnEscape", {
    get: function get() {
      return this.foundation_.getCloseOnEscape();
    },
    set: function set(t) {
      this.foundation_.setCloseOnEscape(t);
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "isOpen", {
    get: function get() {
      return this.foundation_.isOpen();
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "labelText", {
    get: function get() {
      return this.labelEl_.textContent;
    },
    set: function set(t) {
      this.labelEl_.textContent = t;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "actionButtonText", {
    get: function get() {
      return this.actionEl_.textContent;
    },
    set: function set(t) {
      this.actionEl_.textContent = t;
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.registerKeyDownHandler_ = function (t) {
    this.listen("keydown", t);
  }, e.prototype.deregisterKeyDownHandler_ = function (t) {
    this.unlisten("keydown", t);
  }, e.prototype.registerSurfaceClickHandler_ = function (t) {
    this.surfaceEl_.addEventListener("click", t);
  }, e.prototype.deregisterSurfaceClickHandler_ = function (t) {
    this.surfaceEl_.removeEventListener("click", t);
  }, e.prototype.isActionButton_ = function (t) {
    return Boolean(Qt(t, sv));
  }, e.prototype.isActionIcon_ = function (t) {
    return Boolean(Qt(t, cv));
  };
}($t), {
  BG_FOCUSED: "mdc-ripple-upgraded--background-focused",
  FG_ACTIVATION: "mdc-ripple-upgraded--foreground-activation",
  FG_DEACTIVATION: "mdc-ripple-upgraded--foreground-deactivation",
  ROOT: "mdc-ripple-upgraded",
  UNBOUNDED: "mdc-ripple-upgraded--unbounded"
}),
    fv = {
  VAR_FG_SCALE: "--mdc-ripple-fg-scale",
  VAR_FG_SIZE: "--mdc-ripple-fg-size",
  VAR_FG_TRANSLATE_END: "--mdc-ripple-fg-translate-end",
  VAR_FG_TRANSLATE_START: "--mdc-ripple-fg-translate-start",
  VAR_LEFT: "--mdc-ripple-left",
  VAR_TOP: "--mdc-ripple-top"
},
    mv = {
  DEACTIVATION_TIMEOUT_MS: 225,
  FG_DEACTIVATION_MS: 150,
  INITIAL_ORIGIN_SCALE: .6,
  PADDING: 10,
  TAP_DELAY_MS: 300
};

function _v(t, e) {
  if (void 0 === t && (t = window), void 0 === e && (e = !1), void 0 === Zg || e) {
    var n = !1;

    try {
      t.document.addEventListener("test", function () {}, {
        get passive() {
          return n = !0;
        }

      });
    } catch (t) {}

    Zg = n;
  }

  return !!Zg && {
    passive: !0
  };
}

var gv = ["touchstart", "pointerdown", "mousedown", "keydown"],
    vv = ["touchend", "pointerup", "mouseup", "contextmenu"],
    yv = [],
    bv = function (t) {
  function e(n) {
    var i = t.call(this, _jt({}, e.defaultAdapter, n)) || this;
    return i.activationAnimationHasEnded_ = !1, i.activationTimer_ = 0, i.fgDeactivationRemovalTimer_ = 0, i.fgScale_ = "0", i.frame_ = {
      width: 0,
      height: 0
    }, i.initialSize_ = 0, i.layoutFrame_ = 0, i.maxRadius_ = 0, i.unboundedCoords_ = {
      left: 0,
      top: 0
    }, i.activationState_ = i.defaultActivationState_(), i.activationTimerCallback_ = function () {
      i.activationAnimationHasEnded_ = !0, i.runDeactivationUXLogicIfReady_();
    }, i.activateHandler_ = function (t) {
      return i.activate_(t);
    }, i.deactivateHandler_ = function () {
      return i.deactivate_();
    }, i.focusHandler_ = function () {
      return i.handleFocus();
    }, i.blurHandler_ = function () {
      return i.handleBlur();
    }, i.resizeHandler_ = function () {
      return i.layout();
    }, i;
  }

  return Vt(e, t), Object.defineProperty(e, "cssClasses", {
    get: function get() {
      return pv;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "strings", {
    get: function get() {
      return fv;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "numbers", {
    get: function get() {
      return mv;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultAdapter", {
    get: function get() {
      return {
        addClass: function addClass() {},
        browserSupportsCssVars: function browserSupportsCssVars() {
          return !0;
        },
        computeBoundingRect: function computeBoundingRect() {
          return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            width: 0,
            height: 0
          };
        },
        containsEventTarget: function containsEventTarget() {
          return !0;
        },
        deregisterDocumentInteractionHandler: function deregisterDocumentInteractionHandler() {},
        deregisterInteractionHandler: function deregisterInteractionHandler() {},
        deregisterResizeHandler: function deregisterResizeHandler() {},
        getWindowPageOffset: function getWindowPageOffset() {
          return {
            x: 0,
            y: 0
          };
        },
        isSurfaceActive: function isSurfaceActive() {
          return !0;
        },
        isSurfaceDisabled: function isSurfaceDisabled() {
          return !0;
        },
        isUnbounded: function isUnbounded() {
          return !0;
        },
        registerDocumentInteractionHandler: function registerDocumentInteractionHandler() {},
        registerInteractionHandler: function registerInteractionHandler() {},
        registerResizeHandler: function registerResizeHandler() {},
        removeClass: function removeClass() {},
        updateCssVariable: function updateCssVariable() {}
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.init = function () {
    var t = this,
        n = this.supportsPressRipple_();

    if (this.registerRootHandlers_(n), n) {
      var i = e.cssClasses,
          r = i.ROOT,
          o = i.UNBOUNDED;
      requestAnimationFrame(function () {
        t.adapter_.addClass(r), t.adapter_.isUnbounded() && (t.adapter_.addClass(o), t.layoutInternal_());
      });
    }
  }, e.prototype.destroy = function () {
    var t = this;

    if (this.supportsPressRipple_()) {
      this.activationTimer_ && (clearTimeout(this.activationTimer_), this.activationTimer_ = 0, this.adapter_.removeClass(e.cssClasses.FG_ACTIVATION)), this.fgDeactivationRemovalTimer_ && (clearTimeout(this.fgDeactivationRemovalTimer_), this.fgDeactivationRemovalTimer_ = 0, this.adapter_.removeClass(e.cssClasses.FG_DEACTIVATION));
      var n = e.cssClasses,
          i = n.ROOT,
          r = n.UNBOUNDED;
      requestAnimationFrame(function () {
        t.adapter_.removeClass(i), t.adapter_.removeClass(r), t.removeCssVars_();
      });
    }

    this.deregisterRootHandlers_(), this.deregisterDeactivationHandlers_();
  }, e.prototype.activate = function (t) {
    this.activate_(t);
  }, e.prototype.deactivate = function () {
    this.deactivate_();
  }, e.prototype.layout = function () {
    var t = this;
    this.layoutFrame_ && cancelAnimationFrame(this.layoutFrame_), this.layoutFrame_ = requestAnimationFrame(function () {
      t.layoutInternal_(), t.layoutFrame_ = 0;
    });
  }, e.prototype.setUnbounded = function (t) {
    var n = e.cssClasses.UNBOUNDED;
    t ? this.adapter_.addClass(n) : this.adapter_.removeClass(n);
  }, e.prototype.handleFocus = function () {
    var t = this;
    requestAnimationFrame(function () {
      return t.adapter_.addClass(e.cssClasses.BG_FOCUSED);
    });
  }, e.prototype.handleBlur = function () {
    var t = this;
    requestAnimationFrame(function () {
      return t.adapter_.removeClass(e.cssClasses.BG_FOCUSED);
    });
  }, e.prototype.supportsPressRipple_ = function () {
    return this.adapter_.browserSupportsCssVars();
  }, e.prototype.defaultActivationState_ = function () {
    return {
      activationEvent: void 0,
      hasDeactivationUXRun: !1,
      isActivated: !1,
      isProgrammatic: !1,
      wasActivatedByPointer: !1,
      wasElementMadeActive: !1
    };
  }, e.prototype.registerRootHandlers_ = function (t) {
    var e = this;
    t && (gv.forEach(function (t) {
      e.adapter_.registerInteractionHandler(t, e.activateHandler_);
    }), this.adapter_.isUnbounded() && this.adapter_.registerResizeHandler(this.resizeHandler_)), this.adapter_.registerInteractionHandler("focus", this.focusHandler_), this.adapter_.registerInteractionHandler("blur", this.blurHandler_);
  }, e.prototype.registerDeactivationHandlers_ = function (t) {
    var e = this;
    "keydown" === t.type ? this.adapter_.registerInteractionHandler("keyup", this.deactivateHandler_) : vv.forEach(function (t) {
      e.adapter_.registerDocumentInteractionHandler(t, e.deactivateHandler_);
    });
  }, e.prototype.deregisterRootHandlers_ = function () {
    var t = this;
    gv.forEach(function (e) {
      t.adapter_.deregisterInteractionHandler(e, t.activateHandler_);
    }), this.adapter_.deregisterInteractionHandler("focus", this.focusHandler_), this.adapter_.deregisterInteractionHandler("blur", this.blurHandler_), this.adapter_.isUnbounded() && this.adapter_.deregisterResizeHandler(this.resizeHandler_);
  }, e.prototype.deregisterDeactivationHandlers_ = function () {
    var t = this;
    this.adapter_.deregisterInteractionHandler("keyup", this.deactivateHandler_), vv.forEach(function (e) {
      t.adapter_.deregisterDocumentInteractionHandler(e, t.deactivateHandler_);
    });
  }, e.prototype.removeCssVars_ = function () {
    var t = this,
        n = e.strings;
    Object.keys(n).forEach(function (e) {
      0 === e.indexOf("VAR_") && t.adapter_.updateCssVariable(n[e], null);
    });
  }, e.prototype.activate_ = function (t) {
    var e = this;

    if (!this.adapter_.isSurfaceDisabled()) {
      var n = this.activationState_;

      if (!n.isActivated) {
        var i = this.previousActivationEvent_;
        if (!(i && void 0 !== t && i.type !== t.type)) n.isActivated = !0, n.isProgrammatic = void 0 === t, n.activationEvent = t, n.wasActivatedByPointer = !n.isProgrammatic && void 0 !== t && ("mousedown" === t.type || "touchstart" === t.type || "pointerdown" === t.type), void 0 !== t && yv.length > 0 && yv.some(function (t) {
          return e.adapter_.containsEventTarget(t);
        }) ? this.resetActivationState_() : (void 0 !== t && (yv.push(t.target), this.registerDeactivationHandlers_(t)), n.wasElementMadeActive = this.checkElementMadeActive_(t), n.wasElementMadeActive && this.animateActivation_(), requestAnimationFrame(function () {
          yv = [], n.wasElementMadeActive || void 0 === t || " " !== t.key && 32 !== t.keyCode || (n.wasElementMadeActive = e.checkElementMadeActive_(t), n.wasElementMadeActive && e.animateActivation_()), n.wasElementMadeActive || (e.activationState_ = e.defaultActivationState_());
        }));
      }
    }
  }, e.prototype.checkElementMadeActive_ = function (t) {
    return void 0 === t || "keydown" !== t.type || this.adapter_.isSurfaceActive();
  }, e.prototype.animateActivation_ = function () {
    var t = this,
        n = e.strings,
        i = n.VAR_FG_TRANSLATE_START,
        r = n.VAR_FG_TRANSLATE_END,
        o = e.cssClasses,
        a = o.FG_DEACTIVATION,
        s = o.FG_ACTIVATION,
        c = e.numbers.DEACTIVATION_TIMEOUT_MS;
    this.layoutInternal_();
    var u = "",
        l = "";

    if (!this.adapter_.isUnbounded()) {
      var d = this.getFgTranslationCoordinates_(),
          h = d.startPoint,
          p = d.endPoint;
      u = h.x + "px, " + h.y + "px", l = p.x + "px, " + p.y + "px";
    }

    this.adapter_.updateCssVariable(i, u), this.adapter_.updateCssVariable(r, l), clearTimeout(this.activationTimer_), clearTimeout(this.fgDeactivationRemovalTimer_), this.rmBoundedActivationClasses_(), this.adapter_.removeClass(a), this.adapter_.computeBoundingRect(), this.adapter_.addClass(s), this.activationTimer_ = setTimeout(function () {
      return t.activationTimerCallback_();
    }, c);
  }, e.prototype.getFgTranslationCoordinates_ = function () {
    var t,
        e = this.activationState_,
        n = e.activationEvent;
    return {
      startPoint: t = {
        x: (t = e.wasActivatedByPointer ? function (t, e, n) {
          if (!t) return {
            x: 0,
            y: 0
          };
          var i,
              r,
              o = e.x,
              a = e.y,
              s = o + n.left,
              c = a + n.top;

          if ("touchstart" === t.type) {
            var u = t;
            i = u.changedTouches[0].pageX - s, r = u.changedTouches[0].pageY - c;
          } else {
            var l = t;
            i = l.pageX - s, r = l.pageY - c;
          }

          return {
            x: i,
            y: r
          };
        }(n, this.adapter_.getWindowPageOffset(), this.adapter_.computeBoundingRect()) : {
          x: this.frame_.width / 2,
          y: this.frame_.height / 2
        }).x - this.initialSize_ / 2,
        y: t.y - this.initialSize_ / 2
      },
      endPoint: {
        x: this.frame_.width / 2 - this.initialSize_ / 2,
        y: this.frame_.height / 2 - this.initialSize_ / 2
      }
    };
  }, e.prototype.runDeactivationUXLogicIfReady_ = function () {
    var t = this,
        n = e.cssClasses.FG_DEACTIVATION,
        i = this.activationState_,
        r = i.hasDeactivationUXRun,
        o = i.isActivated;
    (r || !o) && this.activationAnimationHasEnded_ && (this.rmBoundedActivationClasses_(), this.adapter_.addClass(n), this.fgDeactivationRemovalTimer_ = setTimeout(function () {
      t.adapter_.removeClass(n);
    }, mv.FG_DEACTIVATION_MS));
  }, e.prototype.rmBoundedActivationClasses_ = function () {
    var t = e.cssClasses.FG_ACTIVATION;
    this.adapter_.removeClass(t), this.activationAnimationHasEnded_ = !1, this.adapter_.computeBoundingRect();
  }, e.prototype.resetActivationState_ = function () {
    var t = this;
    this.previousActivationEvent_ = this.activationState_.activationEvent, this.activationState_ = this.defaultActivationState_(), setTimeout(function () {
      return t.previousActivationEvent_ = void 0;
    }, e.numbers.TAP_DELAY_MS);
  }, e.prototype.deactivate_ = function () {
    var t = this,
        e = this.activationState_;

    if (e.isActivated) {
      var n = _jt({}, e);

      e.isProgrammatic ? (requestAnimationFrame(function () {
        return t.animateDeactivation_(n);
      }), this.resetActivationState_()) : (this.deregisterDeactivationHandlers_(), requestAnimationFrame(function () {
        t.activationState_.hasDeactivationUXRun = !0, t.animateDeactivation_(n), t.resetActivationState_();
      }));
    }
  }, e.prototype.animateDeactivation_ = function (t) {
    var e = t.wasActivatedByPointer,
        n = t.wasElementMadeActive;
    (e || n) && this.runDeactivationUXLogicIfReady_();
  }, e.prototype.layoutInternal_ = function () {
    var t = this;
    this.frame_ = this.adapter_.computeBoundingRect();
    var n = Math.max(this.frame_.height, this.frame_.width);
    this.maxRadius_ = this.adapter_.isUnbounded() ? n : Math.sqrt(Math.pow(t.frame_.width, 2) + Math.pow(t.frame_.height, 2)) + e.numbers.PADDING, this.initialSize_ = Math.floor(n * e.numbers.INITIAL_ORIGIN_SCALE), this.fgScale_ = "" + this.maxRadius_ / this.initialSize_, this.updateLayoutCssVars_();
  }, e.prototype.updateLayoutCssVars_ = function () {
    var t = e.strings,
        n = t.VAR_FG_SIZE,
        i = t.VAR_LEFT,
        r = t.VAR_TOP,
        o = t.VAR_FG_SCALE;
    this.adapter_.updateCssVariable(n, this.initialSize_ + "px"), this.adapter_.updateCssVariable(o, this.fgScale_), this.adapter_.isUnbounded() && (this.unboundedCoords_ = {
      left: Math.round(this.frame_.width / 2 - this.initialSize_ / 2),
      top: Math.round(this.frame_.height / 2 - this.initialSize_ / 2)
    }, this.adapter_.updateCssVariable(i, this.unboundedCoords_.left + "px"), this.adapter_.updateCssVariable(r, this.unboundedCoords_.top + "px"));
  }, e;
}(Yt),
    Ev = function (t) {
  function e() {
    var e = null !== t && t.apply(this, arguments) || this;
    return e.disabled = !1, e;
  }

  return Vt(e, t), e.attachTo = function (t, n) {
    void 0 === n && (n = {
      isUnbounded: void 0
    });
    var i = new e(t);
    return void 0 !== n.isUnbounded && (i.unbounded = n.isUnbounded), i;
  }, e.createAdapter = function (t) {
    return {
      addClass: function addClass(e) {
        return t.root_.classList.add(e);
      },
      browserSupportsCssVars: function browserSupportsCssVars() {
        return function (t, e) {
          void 0 === e && (e = !1);
          var n = t.CSS,
              i = Qg;
          if ("boolean" == typeof Qg && !e) return Qg;
          if (!n || "function" != typeof n.supports) return !1;
          var r = n.supports("--css-vars", "yes"),
              o = n.supports("(--css-vars: yes)") && n.supports("color", "#00000000");
          return i = !(!r && !o || function (t) {
            var e = t.document,
                n = e.createElement("div");
            n.className = "mdc-ripple-surface--test-edge-var-bug", e.body.appendChild(n);
            var i = t.getComputedStyle(n),
                r = null !== i && "solid" === i.borderTopStyle;
            return n.parentNode && n.parentNode.removeChild(n), r;
          }(t)), e || (Qg = i), i;
        }(window);
      },
      computeBoundingRect: function computeBoundingRect() {
        return t.root_.getBoundingClientRect();
      },
      containsEventTarget: function containsEventTarget(e) {
        return t.root_.contains(e);
      },
      deregisterDocumentInteractionHandler: function deregisterDocumentInteractionHandler(t, e) {
        return document.documentElement.removeEventListener(t, e, _v());
      },
      deregisterInteractionHandler: function deregisterInteractionHandler(e, n) {
        return t.root_.removeEventListener(e, n, _v());
      },
      deregisterResizeHandler: function deregisterResizeHandler(t) {
        return window.removeEventListener("resize", t);
      },
      getWindowPageOffset: function getWindowPageOffset() {
        return {
          x: window.pageXOffset,
          y: window.pageYOffset
        };
      },
      isSurfaceActive: function isSurfaceActive() {
        return Zt(t.root_, ":active");
      },
      isSurfaceDisabled: function isSurfaceDisabled() {
        return Boolean(t.disabled);
      },
      isUnbounded: function isUnbounded() {
        return Boolean(t.unbounded);
      },
      registerDocumentInteractionHandler: function registerDocumentInteractionHandler(t, e) {
        return document.documentElement.addEventListener(t, e, _v());
      },
      registerInteractionHandler: function registerInteractionHandler(e, n) {
        return t.root_.addEventListener(e, n, _v());
      },
      registerResizeHandler: function registerResizeHandler(t) {
        return window.addEventListener("resize", t);
      },
      removeClass: function removeClass(e) {
        return t.root_.classList.remove(e);
      },
      updateCssVariable: function updateCssVariable(e, n) {
        return t.root_.style.setProperty(e, n);
      }
    };
  }, Object.defineProperty(e.prototype, "unbounded", {
    get: function get() {
      return Boolean(this.unbounded_);
    },
    set: function set(t) {
      this.unbounded_ = Boolean(t), this.setUnbounded_();
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.activate = function () {
    this.foundation_.activate();
  }, e.prototype.deactivate = function () {
    this.foundation_.deactivate();
  }, e.prototype.layout = function () {
    this.foundation_.layout();
  }, e.prototype.getDefaultFoundation = function () {
    return new bv(e.createAdapter(this));
  }, e.prototype.initialSyncWithDOM = function () {
    var t = this.root_;
    this.unbounded = "mdcRippleIsUnbounded" in t.dataset;
  }, e.prototype.setUnbounded_ = function () {
    this.foundation_.setUnbounded(Boolean(this.unbounded_));
  }, e;
}($t),
    Cv = {
  ICON_BUTTON_ON: "mdc-icon-button--on",
  ROOT: "mdc-icon-button"
},
    Av = {
  ARIA_PRESSED: "aria-pressed",
  CHANGE_EVENT: "MDCIconButtonToggle:change"
},
    Tv = function (t) {
  function e(n) {
    return t.call(this, _jt({}, e.defaultAdapter, n)) || this;
  }

  return Vt(e, t), Object.defineProperty(e, "cssClasses", {
    get: function get() {
      return Cv;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "strings", {
    get: function get() {
      return Av;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e, "defaultAdapter", {
    get: function get() {
      return {
        addClass: function addClass() {},
        hasClass: function hasClass() {
          return !1;
        },
        notifyChange: function notifyChange() {},
        removeClass: function removeClass() {},
        setAttr: function setAttr() {}
      };
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.init = function () {
    this.adapter_.setAttr(Av.ARIA_PRESSED, "" + this.isOn());
  }, e.prototype.handleClick = function () {
    this.toggle(), this.adapter_.notifyChange({
      isOn: this.isOn()
    });
  }, e.prototype.isOn = function () {
    return this.adapter_.hasClass(Cv.ICON_BUTTON_ON);
  }, e.prototype.toggle = function (t) {
    void 0 === t && (t = !this.isOn()), t ? this.adapter_.addClass(Cv.ICON_BUTTON_ON) : this.adapter_.removeClass(Cv.ICON_BUTTON_ON), this.adapter_.setAttr(Av.ARIA_PRESSED, "" + t);
  }, e;
}(Yt),
    Iv = Tv.strings,
    Ov = (function (t) {
  function e() {
    var e = null !== t && t.apply(this, arguments) || this;
    return e.ripple_ = e.createRipple_(), e;
  }

  Vt(e, t), e.attachTo = function (t) {
    return new e(t);
  }, e.prototype.initialSyncWithDOM = function () {
    var t = this;
    this.handleClick_ = function () {
      return t.foundation_.handleClick();
    }, this.listen("click", this.handleClick_);
  }, e.prototype.destroy = function () {
    this.unlisten("click", this.handleClick_), this.ripple_.destroy(), t.prototype.destroy.call(this);
  }, e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new Tv({
      addClass: function addClass(e) {
        return t.root_.classList.add(e);
      },
      hasClass: function hasClass(e) {
        return t.root_.classList.contains(e);
      },
      notifyChange: function notifyChange(e) {
        return t.emit(Iv.CHANGE_EVENT, e);
      },
      removeClass: function removeClass(e) {
        return t.root_.classList.remove(e);
      },
      setAttr: function setAttr(e, n) {
        return t.root_.setAttribute(e, n);
      }
    });
  }, Object.defineProperty(e.prototype, "ripple", {
    get: function get() {
      return this.ripple_;
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(e.prototype, "on", {
    get: function get() {
      return this.foundation_.isOn();
    },
    set: function set(t) {
      this.foundation_.toggle(t);
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.createRipple_ = function () {
    var t = new Ev(this.root_);
    return t.unbounded = !0, t;
  };
}($t), function () {
  var _t46 = function t(e, n) {
    return (_t46 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var n in e) {
        e.hasOwnProperty(n) && (t[n] = e[n]);
      }
    })(e, n);
  };

  return function (e, n) {
    function i() {
      this.constructor = e;
    }

    _t46(e, n), e.prototype = null === n ? Object.create(n) : (i.prototype = n.prototype, new i());
  };
}()),
    _Sv = function Sv() {
  return (_Sv = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    wv = function wv(t, e) {
  var n = {};

  for (var i in t) {
    Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
  }

  if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
    var r = 0;

    for (i = Object.getOwnPropertySymbols(t); r < i.length; r++) {
      e.indexOf(i[r]) < 0 && (n[i[r]] = t[i[r]]);
    }
  }

  return n;
},
    xv = Ln({
  surface: !1,
  unbounded: !0
})(Mt({
  displayName: "IconButtonRoot",
  tag: mn,
  classNames: function classNames(t) {
    return ["mdc-icon-button", {
      "mdc-icon-button--on": t.checked
    }];
  },
  defaultProps: {
    role: "button",
    tabIndex: "0"
  },
  consumeProps: ["checked"]
})),
    Nv = Ln({
  surface: !1,
  unbounded: !0
})(Mt({
  displayName: "IconButtonRoot",
  tag: "button",
  classNames: function classNames(t) {
    return ["mdc-icon-button", {
      "mdc-icon-button--on": t.checked
    }];
  },
  defaultProps: {
    role: "button",
    tabIndex: "0"
  },
  consumeProps: ["checked"]
})),
    Rv = Mt({
  displayName: "IconButtonIcon",
  tag: mn,
  classNames: function classNames(t) {
    return ["mdc-icon-button__icon", {
      "mdc-icon-button__icon--on": t.on
    }];
  },
  consumeProps: ["on"]
}),
    Lv = function (t) {
  function e(e) {
    var n = t.call(this, e) || this;
    return n.root = n.createElement("root"), n.handleClick = n.handleClick.bind(n), n;
  }

  return Ov(e, t), Object.defineProperty(e.prototype, "on", {
    get: function get() {
      return this.foundation && this.foundation.isOn();
    },
    set: function set(t) {
      this.foundation.toggle(t);
    },
    enumerable: !0,
    configurable: !0
  }), e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new Tv({
      addClass: function addClass(e) {
        return t.root.addClass(e);
      },
      removeClass: function removeClass(e) {
        return t.root.removeClass(e);
      },
      hasClass: function hasClass(e) {
        return t.root.hasClass(e);
      },
      setAttr: function setAttr(e, n) {
        return t.root.setProp(e, n);
      },
      notifyChange: function notifyChange(e) {
        return t.emit("onChange", e);
      }
    });
  }, e.prototype.isOn = function () {
    return void 0 !== this.props.checked ? this.props.checked : this.on;
  }, e.prototype.sync = function (t) {
    void 0 !== t.checked && this.on !== t.checked && (this.on = !!t.checked);
  }, e.prototype.handleClick = function (t) {
    this.props.onClick && this.props.onClick(t), this.foundation.handleClick();
  }, e.prototype.render = function () {
    var t = this.props,
        e = t.icon,
        i = t.iconOptions,
        r = t.onIcon,
        o = t.onIconOptions,
        a = wv(t, ["icon", "iconOptions", "onIcon", "onIconOptions"]);
    return (i || o) && ft("IconButton component props iconOptions and onIconOptions must be passed directly to the icon and onIcon prop. This issue has NOT been automatically fixed for you, please update your code."), n(Nv, _Sv({
      "aria-pressed": this.isOn(),
      "aria-hidden": "true"
    }, this.root.props(a), {
      tag: "button",
      onClick: this.handleClick
    }), n(Rv, {
      icon: e
    }), n(Rv, {
      icon: r,
      on: !0
    }));
  }, e.displayName = "IconButton", e;
}(Rt),
    Dv = function Dv(t) {
  var e = wv(t, []);
  return e.onIcon ? n(Lv, _Sv({}, e)) : n(xv, _Sv({
    "aria-hidden": "true",
    tag: "button"
  }, e));
};

Dv.displayName = "IconButton";

var kv = function () {
  var _t47 = function t(e, n) {
    return (_t47 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var n in e) {
        e.hasOwnProperty(n) && (t[n] = e[n]);
      }
    })(e, n);
  };

  return function (e, n) {
    function i() {
      this.constructor = e;
    }

    _t47(e, n), e.prototype = null === n ? Object.create(n) : (i.prototype = n.prototype, new i());
  };
}(),
    _Pv = function Pv() {
  return (_Pv = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    Fv = function Fv(t, e) {
  var n = {};

  for (var i in t) {
    Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
  }

  if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
    var r = 0;

    for (i = Object.getOwnPropertySymbols(t); r < i.length; r++) {
      e.indexOf(i[r]) < 0 && (n[i[r]] = t[i[r]]);
    }
  }

  return n;
};

rv.prototype.handleActionButtonClick = function (t, e) {
  this.close(e);
};

var Mv = Mt({
  displayName: "SnackbarRoot",
  classNames: function classNames(t) {
    return ["mdc-snackbar", {
      "mdc-snackbar--leading": t.leading,
      "mdc-snackbar--stacked": t.stacked
    }];
  },
  defaultProps: {
    leading: !1,
    "aria-live": "assertive",
    "aria-atomic": !0,
    "aria-hidden": !0
  },
  consumeProps: ["leading", "stacked"]
}),
    Hv = Mt({
  displayName: "SnackbarText",
  classNames: ["mdc-snackbar__label"],
  defaultProps: {
    role: "status",
    "aria-live": "polite"
  }
}),
    Bv = Mt({
  displayName: "SnackbarActions",
  classNames: ["mdc-snackbar__actions"]
}),
    Vv = Mt({
  displayName: "SnackbarAction",
  tag: u_,
  classNames: ["mdc-snackbar__action"],
  render: function render(t, e, i) {
    var r = t.action,
        o = void 0 === r ? rv.strings.REASON_ACTION : r,
        a = Fv(t, ["action"]);
    return n(i, _Pv({}, a, {
      ref: e,
      "data-mdc-snackbar-action": o
    }));
  }
}),
    jv = Mt({
  displayName: "SnackbarDismiss",
  tag: Dv,
  classNames: ["mdc-snackbar__dismiss"]
}),
    Uv = function (t) {
  function e(e) {
    var n = t.call(this, e) || this;
    return n.root = n.createElement("root"), n.isShowing_ = !1, n.labelEl = null, n.announce = $g, n.handleKeyDown = n.handleKeyDown.bind(n), n.handleSurfaceClick = n.handleSurfaceClick.bind(n), n;
  }

  return kv(e, t), e.prototype.getDefaultFoundation = function () {
    var t = this;
    return new rv({
      addClass: function addClass(e) {
        return t.root.addClass(e);
      },
      removeClass: function removeClass(e) {
        return t.root.removeClass(e);
      },
      announce: function announce() {
        return t.labelEl && t.announce(t.labelEl);
      },
      notifyOpening: function notifyOpening() {
        return t.emit("onOpen", {});
      },
      notifyOpened: function notifyOpened() {
        return t.emit("onOpened", {});
      },
      notifyClosing: function notifyClosing(e) {
        return t.emit("onClose", e ? {
          reason: e
        } : {});
      },
      notifyClosed: function notifyClosed(e) {
        return t.emit("onClosed", e ? {
          reason: e
        } : {});
      }
    });
  }, e.prototype.sync = function (t, e) {
    t = this.getPropsWithDeprecations(t), e = this.getPropsWithDeprecations(e), t.open !== e.open && t.open && this.foundation.open(), t.timeout !== e.timeout && (this.foundation.autoDismissTimeoutMs_ = t.timeout);
  }, e.prototype.getPropsWithDeprecations = function (t) {
    return mt(t, {
      show: "open",
      onShow: "onOpen",
      onHide: "onClose",
      alignStart: "leading",
      multiline: "",
      actionOnBottom: "stacked",
      actionHandler: "",
      actionText: ""
    }, "Snackbar");
  }, e.prototype.handleKeyDown = function (t) {
    this.props.onKeyDown && this.props.onKeyDown(t), this.foundation.handleKeyDown(t);
  }, e.prototype.handleSurfaceClick = function (t) {
    if (t.target instanceof Element) {
      var e = t.target,
          n = vt(e, ".mdc-button");
      n && (e = n), this.props.dismissesOnAction && e.classList.contains("mdc-snackbar__action") ? this.foundation.handleActionButtonClick(t, e.dataset.mdcSnackbarAction) : e.classList.contains("mdc-snackbar__dismiss") && this.foundation.handleActionIconClick(t);
    }
  }, e.prototype.render = function () {
    var t = this,
        e = this.props,
        i = e.actionText,
        r = e.actionHandler,
        o = this.getPropsWithDeprecations(this.props),
        a = (o.open, o.message),
        s = (o.timeout, o.dismissIcon),
        c = (o.onOpen, o.onClose, o.children),
        u = o.action,
        l = o.icon,
        d = (o.dismissesOnAction, Fv(o, ["open", "message", "timeout", "dismissIcon", "onOpen", "onClose", "children", "action", "icon", "dismissesOnAction"])),
        h = Array.isArray(u) ? u : u ? [u] : [];
    return n(Mv, _Pv({}, this.root.props(d), {
      ref: this.root.setRef,
      onKeyDown: this.handleKeyDown
    }), n("div", {
      className: "mdc-snackbar__surface",
      onClick: this.handleSurfaceClick
    }, !!l && n(mn, {
      style: {
        color: "rgba(255, 255, 255, 0.87)",
        fill: "currentColor",
        marginLeft: "1rem"
      },
      icon: l
    }), n(Hv, null, a, n("div", {
      style: {
        display: "none"
      },
      ref: function ref(e) {
        return t.labelEl = e;
      }
    })), n(Bv, null, !!i && n(Vv, {
      onClick: r
    }, i), h.map(function (t, e) {
      return n(p, {
        key: e
      }, t);
    }), s && n(jv, {
      icon: !0 === s ? "close" : s
    })), c));
  }, e.displayName = "Snackbar", e.defaultProps = {
    dismissesOnAction: !0
  }, e;
}(Rt),
    Gv = function () {
  var _t48 = function t(e, n) {
    return (_t48 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var n in e) {
        e.hasOwnProperty(n) && (t[n] = e[n]);
      }
    })(e, n);
  };

  return function (e, n) {
    function i() {
      this.constructor = e;
    }

    _t48(e, n), e.prototype = null === n ? Object.create(n) : (i.prototype = n.prototype, new i());
  };
}(),
    _zv = function zv() {
  return (_zv = Object.assign || function (t) {
    for (var e, n = 1, i = arguments.length; n < i; n++) {
      for (var r in e = arguments[n]) {
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    Kv = function Kv(t, e) {
  var n = {};

  for (var i in t) {
    Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
  }

  if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
    var r = 0;

    for (i = Object.getOwnPropertySymbols(t); r < i.length; r++) {
      e.indexOf(i[r]) < 0 && (n[i[r]] = t[i[r]]);
    }
  }

  return n;
};

!function (t) {
  function e(e) {
    var n = t.call(this, e) || this;
    return n.state = {
      message: n.props.messages.array[0]
    }, n.getMessage = n.getMessage.bind(n), n.props.messages.on("change", n.getMessage), n;
  }

  Gv(e, t), e.prototype.componentWillUnmount = function () {
    this.props.messages.off("change", this.getMessage);
  }, e.prototype.getMessage = function () {
    this.props.messages.array[0] !== this.state.message && this.setState({
      message: this.props.messages.array[0]
    });
  }, e.prototype.removeMessage = function (t) {
    var e = this;
    t && setTimeout(function () {
      var n = e.props.messages.array.indexOf(t);
      ~n && e.props.messages.array.splice(n, 1), e.setState({
        message: void 0
      }, e.getMessage);
    }, 75);
  }, e.prototype.render = function () {
    var t = this,
        e = this.props,
        i = (e.messages, Kv(e, ["messages"])),
        r = this.state.message,
        o = r || {},
        a = o.body,
        s = void 0 === a ? "" : a,
        c = o.image,
        u = o.title,
        l = void 0 === u ? "" : u,
        d = o.onClose,
        h = o.actions,
        f = Kv(o, ["body", "image", "title", "onClose", "actions"]),
        m = h ? h.map(function (t) {
      var e = t.title,
          i = t.label,
          r = Kv(t, ["title", "label"]);
      return n(Vv, _zv({}, r, {
        label: i || e
      }));
    }) : null;
    return n(Uv, _zv({}, i, f, {
      open: !!r,
      message: n(p, null, l, !!l && !!s && n("br", null), s, !!c && n("div", {
        className: "rmwc-snackbar__image",
        style: {
          margin: "1rem auto",
          textAlign: "center"
        }
      }, n("img", {
        src: c,
        alt: "" + c,
        style: {
          maxWidth: "100%",
          maxHeight: "18rem"
        }
      }))),
      onClose: function onClose(e) {
        d && d(e), t.removeMessage(r);
      },
      action: m
    }));
  }, e.displayName = "SnackbarQueue";
}(i);

function qv(t) {
  return t && void 0 !== t.body;
}

var Wv =
/*#__PURE__*/
function () {
  function Wv() {
    var _this83 = this;

    _classCallCheck(this, Wv);

    this._disposables = [], this.dialogQueue = zg(), this.snackQueue = function () {
      var t;
      return {
        observable: new qf(function (e) {
          if (!e) throw new Error("SnackbarQueue already has a subscription. Only one is allowed.");
          return t = e, function () {
            e.complete(), t = void 0;
          };
        }),
        notify: function notify(e) {
          t && (console.log("Snackbar.notify(next)"), t.next(e));
        }
      };
    }();
    var t = B.addListener(function (t) {
      return _this83.error(t);
    });

    this._disposables.push({
      dispose: function dispose() {
        return t();
      }
    });
  }

  _createClass(Wv, [{
    key: "notify",
    value: function notify(t) {
      var e;
      !(e = qv(t) ? t : {
        body: t.message,
        sticky: t.sticky,
        severity: t.severity
      }).icon && e.severity && (e.icon = ey(e.severity)), !e.sticky || e.dismissIcon || e.handle || e.actions && !e.actions.some(function (t) {
        return !!t.dismiss;
      }) || (e.dismissIcon = !0);
      var n = this;
      return e.body instanceof Error ? (this.error(e.body), this.snackQueue.notify({
        body: e.body.message,
        sticky: !0,
        dismissIcon: !0,
        icon: ey(T.Error),
        themeColorIcon: _o.error,
        actions: [ry(e.body, n)]
      })) : (e.handle && (e.handleObj = new Jv(e)), this.snackQueue.notify(e)), e.handleObj;
    }
  }, {
    key: "info",
    value: function info(t) {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "warn",
    value: function warn(t) {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "error",
    value: function error(t) {
      console.error("Error:", t);
    }
  }, {
    key: "prompt",
    value: function prompt(t, e, n, i) {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "confirm",
    value: function confirm(t, e, n, i) {
      var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !0;
      var o = ey(t);
      this.dialogQueue.confirm({
        title: ny(e, o),
        body: iy(n, o),
        acceptLabel: i.label,
        cancelLabel: r ? void 0 : null
      }).then(function (t) {
        return t && i.run && i.run();
      });
    }
  }, {
    key: "dispose",
    value: function dispose() {
      w(this._disposables);
    }
  }]);

  return Wv;
}();

var Xv = function Xv() {
  console.log("Notification.Render");

  var t = d(am),
      _h6 = h(function () {
    var e = new Wv();
    return t.workbench.registerService(C, e), e;
  }),
      _h7 = _slicedToArray(_h6, 1),
      e = _h7[0];

  return n(p, null, n(Hg, {
    dialogs: e.dialogQueue.dialogs,
    preventOutsideDismiss: !0
  }), n(ty, {
    queue: e.snackQueue.observable
  }));
},
    Yv = yo(mn),
    $v = function $v(t) {
  return n(Dv, {
    icon: t.icon,
    className: Um.dismiss,
    label: "Dismiss",
    onClick: t.onClick
  });
},
    Qv = function Qv(t) {
  var e = t.data,
      i = Ut(t, ["data"]);
  return e.progressState === Zv.done ? n(Yv, Object.assign({
    icon: "done"
  }, i, {
    themeColor: _o.primary
  })) : e.progressState === Zv.infinite ? n(Yo, Object.assign({}, i)) : n("div", Object.assign({}, i), n(Yo, null), n("span", null, e._progressTotal - e._progressWorked));
};

var Zv;
!function (t) {
  t[t.none = 0] = "none", t[t.infinite = 1] = "infinite", t[t.worked = 2] = "worked", t[t.done = 3] = "done";
}(Zv || (Zv = {}));

var Jv =
/*#__PURE__*/
function () {
  function Jv(t) {
    _classCallCheck(this, Jv);

    this.message = t, this._progressState = Zv.none, this._progressTotal = 0;
  }

  _createClass(Jv, [{
    key: "infinite",
    value: function infinite() {
      this._progressState = Zv.infinite, this.triggerRefresh();
    }
  }, {
    key: "total",
    value: function total(t) {
      this._progressTotal = t;
    }
  }, {
    key: "worked",
    value: function worked(t) {
      this._progressWorked = t, this._progressState = Zv.worked, this.triggerRefresh();
    }
  }, {
    key: "done",
    value: function done() {
      this._progressState = Zv.done, this.message.sticky = !1, this.triggerRefresh();
    }
  }, {
    key: "updateSeverity",
    value: function updateSeverity(t) {
      this.message.severity = t, this.triggerRefresh();
    }
  }, {
    key: "updateMessage",
    value: function updateMessage(t) {
      qv(t) ? (this.message.body = t.body, this.message.title = t.title) : this.message.body = t, this.triggerRefresh();
    }
  }, {
    key: "updateActions",
    value: function updateActions(t) {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "close",
    value: function close() {
      this.triggerRefresh(!0);
    }
  }, {
    key: "triggerRefresh",
    value: function triggerRefresh(t) {
      this._trigger && this._trigger(this.message, t);
    }
  }, {
    key: "progress",
    get: function get() {
      return this;
    }
  }, {
    key: "progressState",
    get: function get() {
      return this._progressState;
    }
  }, {
    key: "refreshTrigger",
    set: function set(t) {
      this._trigger = t;
    }
  }]);

  return Jv;
}();

var ty = function ty(t) {
  var e = u(),
      i = u([]).current,
      _h8 = h({}),
      _h9 = _slicedToArray(_h8, 2),
      r = _h9[0],
      o = _h9[1],
      a = i.length > 0 && r ? i[0] : void 0;

  console.log("SnackbarQueue.Render", a);

  var s = function s() {
    return e.current && (e.current.foundation.isOpen_ = !0) && e.current.foundation.close();
  };

  l(function () {
    var e = t.queue.subscribe(function (t) {
      (function (t) {
        var e = 0;

        var n = function n(t) {
          return t.sticky ? t.handle ? 1 : 0 : 2;
        },
            r = i.length > 0 ? i[0] : null;

        for (; e < i.length;) {
          var _r13 = i[e];
          if (n(t) > n(_r13)) break;
          e++;
        }

        i.splice(e, 0, t), console.log("Snackbar.enqueueMessage", e, i.length), 0 === e && r ? (r.keep = !0, s()) : o({});
      })(t);
    });
    return function () {
      return e.unsubscribe();
    };
  }, [t.queue]), l(function () {
    !r && i.length > 0 && o({});
  }, [r]), a && a.handleObj && (a.handleObj.refreshTrigger = function (t, e) {
    t && t == t && (console.log("Snackbar.refreshTrigger", t), e ? s() : o({}));
  });

  var _ref5 = a || {},
      _ref5$body = _ref5.body,
      c = _ref5$body === void 0 ? "" : _ref5$body,
      d = _ref5.icon,
      f = _ref5.title,
      _ref5$themeColorIcon = _ref5.themeColorIcon,
      m = _ref5$themeColorIcon === void 0 ? _o.default : _ref5$themeColorIcon,
      _ref5$themeBGIcon = _ref5.themeBGIcon,
      _ = _ref5$themeBGIcon === void 0 ? mo.dark : _ref5$themeBGIcon,
      g = _ref5.handleObj,
      v = _ref5.actions,
      y = a && (!0 === a.dismissIcon ? "close" : a.dismissIcon),
      b = v ? v.map(function (t) {
    var e = t.label,
        i = t.onRun,
        r = t.dismiss,
        o = Ut(t, ["label", "onRun", "dismiss"]);
    return n(Vv, Object.assign({
      key: "label"
    }, o, {
      label: e,
      onClick: function onClick() {
        r && s(), i();
      }
    }));
  }) : [],
      E = !f;

  return E && y && b.push(n($v, {
    key: "_dismiss",
    icon: y,
    onClick: s
  })), n(Uv, {
    ref: e,
    style: {
      justifyContent: "flex-end"
    },
    open: !!a,
    message: n(p, null, n("div", {
      className: Um.snack
    }, n("div", {
      className: Um.header
    }, g && g.progressState > Zv.none && n(Qv, {
      className: Um.progress,
      style: {
        alignSelf: E ? "center" : "start"
      },
      data: g
    }), !!d && n(Yv, {
      icon: d,
      className: Um.icon,
      style: {
        alignSelf: E ? "center" : "start"
      },
      themeColor: m,
      themeBG: _
    }), n("div", {
      className: Um.msg
    }, n("div", {
      className: Um.title
    }, f), n("div", {
      className: Um.body
    }, c)), !!y && !E && n($v, {
      icon: y,
      onClick: s
    })), !E && n("div", {
      className: Um.actions
    }, b))),
    onClose: function onClose(t) {
      (function (t) {
        t && setTimeout(function () {
          if (t.keep) t.keep = void 0;else {
            var _e15 = i.indexOf(t);

            ~_e15 && i.splice(_e15, 1), console.log("Snackbar.RemoveMessage", t);
          }
          o(void 0);
        }, 75);
      })(a);
    },
    onOpen: function onOpen() {
      a && a.sticky && e.current && (e.current.foundation.isOpen_ = !1);
    },
    action: E && b.length > 0 && b
  });
};

function ey(t) {
  if (!t || "string" == typeof t) return t;

  switch (t) {
    case T.Info:
      return "info_outlined";

    case T.Warning:
      return "warning_outlined";

    case T.Error:
      return "error_outlined";

    default:
      return;
  }
}

function ny(t, e) {
  return e ? n("div", {
    className: Um.title
  }, n(mn, {
    icon: e,
    className: Um.icon
  }), n("b", null, t)) : t;
}

function iy(t, e) {
  return e && "string" == typeof t ? n("span", {
    className: Um.body
  }, t) : t;
}

function ry(t, e) {
  var _this84 = this;

  return {
    label: "Details",
    onRun: function onRun() {
      return Kt(_this84, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee17() {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                e.confirm(T.Error, "Error Details (".concat(t.name, ")"), n("pre", {
                  className: Um.errorDetails
                }, "$", t.stack), {
                  label: "OK",
                  run: function run() {}
                }, !1);

              case 1:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17);
      }));
    }
  };
}

var oy = function oy(t) {
  console.log("Workbench.Render");

  var _ref6 = function (t) {
    var _h10 = h(null),
        _h11 = _slicedToArray(_h10, 2),
        e = _h11[0],
        n = _h11[1];

    var i = f(function (i) {
      null === e && null != i && (e = new om(t, i), n(e));
    }, []);
    return [e, i];
  }(t.apolloClient),
      _ref7 = _slicedToArray(_ref6, 2),
      e = _ref7[0],
      i = _ref7[1];

  return l(function () {
    return function () {
      console.log("Workbench.Cleanup"), e && e.dispose();
    };
  }), n("div", {
    ref: i
  }, e && n(am.Provider, {
    value: {
      workbench: e
    }
  }, n(Xv, null), t.children));
};

var ay = ti,
    sy = Bn;

var cy =
/*#__PURE__*/
function () {
  function cy() {
    _classCallCheck(this, cy);

    this.fieldProperty = !0, this._getSetProperty = "can read write me";
  }

  _createClass(cy, [{
    key: "getSetProperty",
    get: function get() {
      return this._getSetProperty;
    },
    set: function set(t) {
      this._getSetProperty = t;
    }
  }, {
    key: "getProperty",
    get: function get() {
      return this._getProperty;
    }
  }]);

  return cy;
}();

export { No as BuiltInThemes, cy as CustomClass, ay as Descriptor, Dm as DismissibleSidebar, Ih as DomainClass, Oh as DomainModel, _m as GraphDiagram, lm as GraphEditor, Tm as GraphPropertyEditor, ta as GraphProvider, gm as GraphSidebar, ym as GraphSidebarPanel, bm as GraphStencil, Ch as GraphStyling, Cm as GraphToolbar, jf as IModelDesignerService, xm as Modeling, sy as Mounting, fm as MxMenubar, mm as MxToolbar, Mm as PartView, Qo as PropertyGrid, Nm as ResizableSection, Pm as SidebarItem, Fm as SidebarSection, _o as ThemeColor, mo as ThemeColorBG, ko as Toolbar, Lo as ToolbarButton, Mo as ToolbarLabel, Fo as ToolbarRow, Po as ToolbarSection, jm as TreeView, Rh as ViewModel, oy as Workbench, om as WorkbenchService, Ro as getTheme, sm as useWorkbench, bo as withThemeBG, yo as withThemeColor };